

import { EventEmitter, Injectable, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DemoService } from './../demo.service';
import { DatePipe, Location } from '@angular/common';

import { HttpClient } from '@angular/common/http';

// Models
import { SystemLog } from './../shared/models/sysLog.model';
import { Router } from '@angular/router';

import { MysqlService } from './mysql.service';
import { Observable ,  delay,  retry,  throwError } from 'rxjs';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
// Environmental Variables
import { environment } from '../../environments/environment';
import { HotToastService } from '@ngneat/hot-toast';
import { UserPasswordExpiredModalComponent } from '../components/users/user-password-expired-modal/user-password-expired-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { LegalDateTimeService } from './legal-datetime.service';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import { columnSelectionComplete } from '@syncfusion/ej2-angular-grids';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadDiagnosticsService } from './upload-diagnostics.service';


import * as moment from 'moment';
import { DataUtil } from '@syncfusion/ej2-data';

@Injectable()

export class GlobalFunctionsService implements OnInit, OnChanges {
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  sessionUsername: any;
  sessionUserLevel: any;
  sessionUserFullName: string;
  sessionUserFirstName: any;
  system_log_created_response: Object;
  sessionUserName: any;
  system_log_type_data_sector: Object;
  allResolutions: any;
  subject_service_resolution_outcomes: Object;
  ssot: Object;

  // public today = Date.now();
  public get today(): Date {
    return new Date();
  }

  public get todayDate(): Date {
    return new Date();
  }


  // today = new Date();
  get today_ISO(): string {
    return this.legalDate.nowAuditIso();
  }
  get today_name_file(): string {
    return this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss') || '';
  }

  get action_day(): string {
    return this.datepipe.transform(this.today, 'ddMMyyyy') || '';
  }

  get action_day_words(): string {
    return this.datepipe.transform(this.today, 'EEEEMMMd-y') || '';
  }

  get today_date_time_words(): string {
    return this.datepipe.transform(this.today, 'EEEE, d MMMM, y, h:mm a') || '';
  }

  get safeDateTimeForFileName(): string {
    return this.datepipe.transform(this.today, 'dd_MMM_yyyy_HHmmss') || '';
  }

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
@Output('closeParentModel2') closeParentModel2: EventEmitter<any> = new EventEmitter();

  @Input() log_data: SystemLog;
  log: SystemLog[] = [];
  ipAddress: any;

  // :: BASE DIRECTORY VARS SETUP.
  // SYSTEM
  // public system_URL = 'https://sop.nickbowen.com.au'; // set in function logins. // no ending Traing slashes.
  // public nodeJS_URL = null; // node js api express server
  user_brand: Object;
  sessionBrandName: string;
  sessionBrandTypeId: any;
  current_base_route: string; // basic at one level
  all_router_details: string;
  created_file_name: string;
  file_edit_level: string;
  file_created_response: any;
  returned_created_file_id: any;
  allAttachments: any = [];
  feature = 'Feature 1';
  selectedFeatures: any = [];
  selectedFeaturesJobFiles: any = [];
  allAttachedFiles: any = [];

  current_invoice_id: any;
  DialogObj: any;
  sent_email_widget_response: any;
  get_latest_subject_note_id: any;
  subject_communication_history_created_response: Object;
  assignedAgentsList: Object;
  allRecipients: any;
  
  // Set Global Variables
  // these will always be constants set in the appropriate .envoriment files.
  title = environment.title;
  appURL = environment.appURL;
  system_URL= environment.system_URL;
  apiURL = environment.apiURL;
  php_apiURL = environment.php_apiURL;
  php_apiURL_SSL = environment.php_apiURL_SSL;
  sopNodeURL = environment.sopNodeURL;
  sopDocServerURL = environment.sopDocServerURL;
  sopDocxServerURL = environment.sopDocxServerURL;

  // Current Local Dev
  api_get_url = environment.$api_get_url;
  api_get_sopNode = environment.$api_get_sopNode;
  // File Locations
  fileURL = environment.$fileURL;
  fileFolderDocs = environment.$fileFolderDocs;

  // Docx Template System
  baseUploadURL = environment.baseUploadURL;
  baseUploadURL_SSL = environment.baseUploadURL_SSL;
  baseUploadURLOriginalWordTemplates = environment.baseUploadURLOriginalWordTemplates;
  baseUploadURLEmailTemplates = environment.baseUploadURLEmailTemplates;
  baseUploadURLEmailTemplatesSSL = environment.baseUploadURLEmailTemplatesSSL;
  baseUploadURLEmailTemplatesNOHTTP = environment.baseUploadURLEmailTemplatesNOHTTP;
  baseUploadURLDocxThemeTemplates = environment.baseUploadURLDocxThemeTemplates;
  baseUploadURL_UserAssets = environment.baseUploadURL_UserAssets;
  baseUploadURL_BrandAssets = environment.baseUploadURL_BrandAssets;
  baseUploadURL_JobAssets = environment.baseUploadURL_JobAssets;
  file_folder_jobAssets = environment.file_folder_jobAssets;
  file_server_location_JobAssets = environment.file_server_location_JobAssets;
  // Azure: Hosing Locations - New Document and File Sever
  azure_webRootPath = environment.azure_webRootPath; 
  WordTemplates_webRootPath = environment.WordTemplates_webRootPath; 
  created_documents_webRootPath = environment.created_documents_webRootPath; 
  TsxTSA_Websocket = environment.TsxTSA_Websocket;

// MYOB DEFAULTS USED IN SCRIPTS AND MYOB INTITIAL STUP.
    myobCustomeID = environment.myobCustomeID // default customer card for checks.MUST EXIST.
    myob_api_key = environment.myob_api_key
    myob_api_secret = environment.myob_api_secret
    redirect_URL = environment.redirect_URL
    myob_TaxCode = environment.myob_TaxCode;
    myob_FreightTaxCode = environment.myob_FreightTaxCode;
    myob_DefaultPaymentsAccount = environment.myob_DefaultPaymentsAccount;
    company_customer_id_for_check = environment.company_customer_id_for_check;
    myob_developer_email = environment.myob_developer_email;

    googleAuthURL = environment.googleAuthURL;

    app_title = environment.title;
    app_build = environment.build;



// Wordpress
brand_wordpress_URL = environment.brand_wordpress_URL
brand_api_key = environment.brand_api_key
brand_api_secret = environment.brand_api_secret

WebHookAPI_Website  = environment.WebHookAPI_Website
WebHookAPI_WebsiteSSL  = environment.WebHookAPI_WebsiteSSL
WebHookAPI = environment.WebHookAPI
WebHook_username = environment.WebHook_username
WebHook_password = environment.WebHook_password
WebHookAPI_PHP_Assets = environment.WebHookAPI_PHP_Assets




  brand_type: Object;
  sessionBrandTypeName: any;
  createdInvoiceName: Object;
  invoice_name_data: string;

  modalRef: BsModalRef;
  bsModalRef: BsModalRef; // for components
  user_password_date_status_expired: number;
  system_log_type: Object;
  system_automation: Object;
  current_subject_template_doc: Object;
  current_subject_com_type_id: any;
  assignedAgentsList2: Object;
  allAgentRecipients: any[];
  system_conditions_array: any;
  current_system_log_data_sector_condition: any;
  condition_compare_result: any;
  true_count: number = 0;
  false_count: number = 0;
  system_automation2: Object;
  run_automations_from_conditions: any;
  run_currnent_system_automation_name: any;
  compare_result: any;
  get_latest_app_route_id: Object;
  job_data_paragraphs: any;
  registry_name: any;
  job_registry_name_Upper: any;
  job_type_paragraphs: any;
  job_type_name: any;
  job_type_name_Upper: any;
  job_type_location_paragraphs: any;
  job_type_location_name: any;
  job_type_location_name_Upper: any;
  job_type_court_paragraphs: any;
  job_type_court_name: any;
  job_type_court_name_Upper: any;
  job_type_document_type_paragraphs: any;
  job_type_document_type_name: any;
  job_type_document_type_name_Upper: any;
  job_service_rule_paragraphs: any;
  job_service_rule_name: any;
  job_service_rule_description: any;
  job_service_timeframe_paragraphs: any;
  job_service_timeframe_name: any;
  job_service_timeframe_text: any;
  subject_service_type_model_paragraphs: any;
  subject_service_type_name: any;
  subject_service_type_description: any;
  subject_service_type_staff_instructions: any;
  subject_service_type_agent_instructions: any;
  subject_service_type_instructions: any;
  job_type_affidavit_type_name: any;
  job_type_affidavit_type_paragraphs: any;
  job_type_affidavit_type_name_Upper: any;
  job_subject_type_name: any;
  job_subject_type_name_Upper: any;
  subject_gender_descriptor: string;
  message_subject_var: string;
  subject_number: string;
  client_reference: string;
  doc_name_var: any;
  doc_check: any;
  brand_data: any;
  job_invoice_client_paragraphs: any;
  job_owner_client_paragraphs: any;
  job_report_client_user_paragraphs: any;
  current_user_paragraphs: any;
  assignedBrandList_paragraphs: any;
  attempts_paragraphs_model: any;
  var_subject_attempt_type_name_Upper: any;
  person_spoken_with_advised_HTML: any;
  vehicles_notes_HTML: any;
  neighbours_notes_HTML: any;
  calling_card_notes_HTML: any;
  postal_mail_notes_HTML: any;
  phone_call_notes_HTML: any;
  attempts_notes_HTML: any;
  email_contents_HTML: any;
  set_general_notes: any;
  property_forsale_or_lease_sign_details_HTML: any;
  property_mail_details_HTML: any;
  property_vehicles_sighted_details_HTML: any;
  property_pets_details_HTML: any;
  property_occupancy_details_HTML: any;
  property_condition_HTML: any;
  property_occupied_details_HTML: any;
  set_property_type_details_HTML: any;
  service_under_order_HTML: any;
  set_service_paragraph_rendered: string;
  property_images: any;
  propery_image_0: string;
  gfunc: any;
  propery_image_1: string;
  propery_image_2: string;
  propery_image_3: string;
  propery_image_4: string;
  propery_image_5: string;
  propery_image_6: string;
  propery_image_7: string;
  propery_image_8: string;
  propery_image_9: string;
  propery_image_10: string;
  propery_image_11: string;
  propery_image_12: string;
  propery_image_13: string;
  propery_image_14: string;
  propery_image_15: string;
  propery_image_16: string;
  propery_image_17: string;
  propery_image_18: string;
  propery_image_19: string;
  propery_image_20: string;
  propery_image_21: string;
  propery_image_22: string;
  propery_image_23: string;
  propery_image_24: string;
  propery_image_25: string;
  property_sign_images: any;
  property_sign_image_0: string;
  property_sign_image_1: string;
  property_sign_image_2: string;
  property_sign_image_3: string;
  property_sign_image_4: string;
  property_sign_image_5: string;
  property_sign_image_6: string;
  property_sign_image_7: string;
  property_sign_image_8: string;
  property_sign_image_9: string;
  property_sign_image_10: string;
  property_sign_image_11: string;
  property_sign_image_12: string;
  property_sign_image_13: string;
  property_sign_image_14: string;
  property_sign_image_15: string;
  property_sign_image_16: string;
  property_sign_image_17: string;
  property_sign_image_18: string;
  property_sign_image_19: string;
  property_sign_image_20: string;
  property_sign_image_21: string;
  property_sign_image_22: string;
  property_sign_image_23: string;
  property_sign_image_24: string;
  property_sign_image_25: string;
  property_mail_images: any;
  property_mail_image_0: string;
  property_mail_image_1: string;
  property_mail_image_2: string;
  property_mail_image_3: string;
  property_mail_image_4: string;
  property_mail_image_5: string;
  property_mail_image_6: string;
  property_mail_image_7: string;
  property_mail_image_8: string;
  property_mail_image_9: string;
  property_mail_image_10: string;
  property_mail_image_11: string;
  property_mail_image_12: string;
  property_mail_image_13: string;
  property_mail_image_14: string;
  property_mail_image_15: string;
  property_mail_image_16: string;
  property_mail_image_17: string;
  property_mail_image_18: string;
  property_mail_image_19: string;
  property_mail_image_20: string;
  property_mail_image_21: string;
  property_mail_image_22: string;
  property_mail_image_23: string;
  property_mail_image_24: string;
  property_mail_image_25: string;
  property_vehicles_images: any;
  property_vehicles_image_0: string;
  property_vehicles_image_1: string;
  property_vehicles_image_2: string;
  property_vehicles_image_3: string;
  property_vehicles_image_4: string;
  property_vehicles_image_5: string;
  property_vehicles_image_6: string;
  property_vehicles_image_7: string;
  property_vehicles_image_8: string;
  property_vehicles_image_9: string;
  property_vehicles_image_10: string;
  property_vehicles_image_11: string;
  property_vehicles_image_12: string;
  property_vehicles_image_13: string;
  property_vehicles_image_14: string;
  property_vehicles_image_15: string;
  property_vehicles_image_16: string;
  property_vehicles_image_17: string;
  property_vehicles_image_18: string;
  property_vehicles_image_19: string;
  property_vehicles_image_20: string;
  property_vehicles_image_21: string;
  property_vehicles_image_22: string;
  property_vehicles_image_23: string;
  property_vehicles_image_24: string;
  property_vehicles_image_25: string;
  property_pets_images: any;
  property_pets_image_0: string;
  property_pets_image_1: string;
  property_pets_image_2: string;
  property_pets_image_3: string;
  property_pets_image_4: string;
  property_pets_image_5: string;
  property_pets_image_6: string;
  property_pets_image_7: string;
  property_pets_image_8: string;
  property_pets_image_9: string;
  property_pets_image_10: string;
  property_pets_image_11: string;
  property_pets_image_12: string;
  property_pets_image_13: string;
  property_pets_image_14: string;
  property_pets_image_15: string;
  property_pets_image_16: string;
  property_pets_image_17: string;
  property_pets_image_18: string;
  property_pets_image_19: string;
  property_pets_image_20: string;
  property_pets_image_21: string;
  property_pets_image_22: string;
  property_pets_image_23: string;
  property_pets_image_24: string;
  property_pets_image_25: string;
  property_occupancy_images: any;
  property_occupancy_image_0: string;
  property_occupancy_image_1: string;
  property_occupancy_image_2: string;
  property_occupancy_image_3: string;
  property_occupancy_image_4: string;
  property_occupancy_image_5: string;
  property_occupancy_image_6: string;
  property_occupancy_image_7: string;
  property_occupancy_image_8: string;
  property_occupancy_image_9: string;
  property_occupancy_image_10: string;
  property_occupancy_image_11: string;
  property_occupancy_image_12: string;
  property_occupancy_image_13: string;
  property_occupancy_image_14: string;
  property_occupancy_image_15: string;
  property_occupancy_image_16: string;
  property_occupancy_image_17: string;
  property_occupancy_image_18: string;
  property_occupancy_image_19: string;
  property_occupancy_image_20: string;
  property_occupancy_image_21: string;
  property_occupancy_image_22: string;
  property_occupancy_image_23: string;
  property_occupancy_image_24: string;
  property_occupancy_image_25: string;
  property_condition_images: any;
  property_condition_image_0: string;
  property_condition_image_1: string;
  property_condition_image_2: string;
  property_condition_image_3: string;
  property_condition_image_4: string;
  property_condition_image_5: string;
  property_condition_image_6: string;
  property_condition_image_7: string;
  property_condition_image_8: string;
  property_condition_image_9: string;
  property_condition_image_10: string;
  property_condition_image_11: string;
  property_condition_image_12: string;
  property_condition_image_13: string;
  property_condition_image_14: string;
  property_condition_image_15: string;
  property_condition_image_16: string;
  property_condition_image_17: string;
  property_condition_image_18: string;
  property_condition_image_19: string;
  property_condition_image_20: string;
  property_condition_image_21: string;
  property_condition_image_22: string;
  property_condition_image_23: string;
  property_condition_image_24: string;
  property_condition_image_25: string;
  property_type_images: any;
  property_type_image_0: string;
  property_type_image_1: string;
  property_type_image_2: string;
  property_type_image_3: string;
  property_type_image_4: string;
  property_type_image_5: string;
  property_type_image_6: string;
  property_type_image_7: string;
  property_type_image_8: string;
  property_type_image_9: string;
  property_type_image_10: string;
  property_type_image_11: string;
  property_type_image_12: string;
  property_type_image_13: string;
  property_type_image_14: string;
  property_type_image_15: string;
  property_type_image_16: string;
  property_type_image_17: string;
  property_type_image_18: string;
  property_type_image_19: string;
  property_type_image_20: string;
  property_type_image_21: string;
  property_type_image_22: string;
  property_type_image_23: string;
  property_type_image_24: string;
  property_type_image_25: string;
  service_file_array_images: any;
  service_file_array_image_0: string;
  service_file_array_image_1: string;
  service_file_array_image_2: string;
  service_file_array_image_3: string;
  service_file_array_image_4: string;
  service_file_array_image_5: string;
  service_file_array_image_6: string;
  service_file_array_image_7: string;
  service_file_array_image_8: string;
  service_file_array_image_9: string;
  service_file_array_image_10: string;
  service_file_array_image_11: string;
  service_file_array_image_12: string;
  service_file_array_image_13: string;
  service_file_array_image_14: string;
  service_file_array_image_15: string;
  service_file_array_image_16: string;
  service_file_array_image_17: string;
  service_file_array_image_18: string;
  service_file_array_image_19: string;
  service_file_array_image_20: string;
  service_file_array_image_21: string;
  service_file_array_image_22: string;
  service_file_array_image_23: string;
  service_file_array_image_24: string;
  service_file_array_image_25: string;
  subject_service_agent: any;
  service_paragraphs_model: any;
  subject_service_type: any;
  selected_job_service_rule_description: string;
  subjectServiceOutcome: any;
  subjectLocationStatus: any;
  subjectLocationStatusFound: any;
  subjectExactServiceMethod: any;
  subject_attempt_type: any;
  serviceFellowRelationship: Object;
  subject_service_fellow_relationship: any;
  job_report_client: any;
  user_brand_paragraphs: any;
  serviceMethod: Object;
  subject_service_method: any;
  job_subject_type: Object;
  subject_job_subject_type: any;
  client_contacts: Object;
  job_type_locations_paragraphs: Object;
  job_type_courts_paragraphs: Object;
  subject_contact_numbers_paragraphs: any;
  subject_contact_emails_paragraphs: any;
  job_special_instructions_HTML: any;
  subject_contact_numbers: string;
  subject_contact_emails: string;
  subject_service_list_paragraphs: Object;
  allClientEmailRecipients: any;
  set_last_inserted_note: any;
  myob_checker: Object;
  myob_response: boolean;
  set_max_sync_number: number;
  sessionUserEmailAddress: any;
  sessionUserPasswordHash: any;
  is_tfa_enforced: any;
  is_tfa_setup_passed: any;
  tfa_secret: any;
  tfa_tempSecret: any;
  tfa_dataURL: any;
  tfa_tfaURL: any;
  sessionBrandIsTFAEnforced: string;
  tfa_code_in_use? = 0;
  is_encrypted: number;
  sessionBrandUserUILayoutID: any;
  sessionUserIsStaffAccountingAccess: any;
  sessionBrand_is_client_show_agent_level: string;

  get_system_log_type_id: number;
  // ::

brand_client_code_: any;
brand_client_code_ALL: any;


  constructor(
    private _demoService: DemoService, private http: HttpClient, public router: Router, private _location: Location,
    public _mysqlService: MysqlService ,       private toastr: HotToastService,     public datepipe: DatePipe,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private legalDate: LegalDateTimeService,
    private uploadDiagnostics: UploadDiagnosticsService,
    // new automations service
    // public gfunc_Automation: GlobalAutomationFunctionsService -- circular depandancy issues...!!!!
  ) {
    // auto set login vars
 //   this.setLoginSessionVars();
    this.setBaseRoute();

// ::: Set the base file locations
// this.globalbaseUploadURL = this.gfunc.baseUploadURL_UserAssets + '/' + this.user_id; // no trailing
  this.set_max_sync_number = 25; // Now sets the myob max count as a variable... THIS ALSO NEEDS TO BE UPDATED AT THE HEADEE MAx= in the node app. with the same count....

  }

ngOnInit() {
    // this.getIPAddress(); // CORS ISSUES
    // this.setBaseRoute();
    // this.getBrandById(this.sessionBrandId);
    console.log('On init');

    

}

ngOnChanges(changes) {
  if (changes.item_id) {
  }
  // this.setBaseRoute();
  //   this.getBrandById(this.sessionBrandId);
  console.log('On Changes');
}



  myGlobalAddFunction(a) {
    return a++;
  }

setBaseRoute(){
  this.all_router_details = this.router.url;
  this.current_base_route = this.all_router_details.substr(0, this.all_router_details.lastIndexOf('/'));



}

  // Set Global Login Sessions Variables
  setLoginSessionVars() {
    // login vars
    // Session Storage

if (this.currentUserVAR) {}
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUsername = this.currentUserVAR.username;
    this.sessionUserName = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
    this.sessionUserLevel = this.currentUserVAR.access_level;
    this.sessionUserFullName = this.currentUserVAR.first_name + ' ' + this.currentUserVAR.surname;
    this.sessionUserFirstName = this.currentUserVAR.first_name;

    // tfa variables
    this.sessionUserEmailAddress = this.currentUserVAR.email_address;
    this.sessionUserPasswordHash = this.currentUserVAR.password_hash;
    this.is_tfa_enforced  = this.currentUserVAR.is_tfa_enforced;
    this.is_tfa_setup_passed = this.currentUserVAR.is_tfa_setup_passed;
    this.tfa_secret = this.currentUserVAR.tfa_secret;
    this.tfa_tempSecret = this.currentUserVAR.tfa_tempSecret;
    this.tfa_dataURL = this.currentUserVAR.tfa_dataURL;
    this.tfa_tfaURL = this.currentUserVAR.tfa_tfaURL;

    this.sessionUserIsStaffAccountingAccess = this.currentUserVAR.is_staff_accounting_access // new staff accounting access July 2025


    // gets the base route
    // this.current_base_route = this.router.url.split('/')[1];

    // This is now run on the login page.
    this.getBrandById(this.sessionBrandId);
    


  }

activateTFACodeEntered(){
  this.tfa_code_in_use = 1;
}

  getBrandById(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      data => {
        this.user_brand = data;
        let res = data[0];
         this.sessionBrandName = res.name;
          this.sessionBrandTypeId = res.brand_type_id;
         sessionStorage.setItem('sessionBrandName', res.name);
         this.sessionBrandName = sessionStorage.getItem('sessionBrandName');
         sessionStorage.setItem('sessionBrandTypeId', res.brand_type_id);
         this.sessionBrandTypeId = sessionStorage.getItem('sessionBrandTypeId');
         sessionStorage.setItem('sessionBrandIsTFAEnforced', res.is_tfa_enforced);
         this.sessionBrandIsTFAEnforced = sessionStorage.getItem('sessionBrandIsTFAEnforced');

         sessionStorage.setItem('sessionBrandUserUILayoutID', res.user_ui_layout_id);
         this.sessionBrandUserUILayoutID = sessionStorage.getItem('sessionBrandUserUILayoutID');

            sessionStorage.setItem('is_client_show_agent_level', res.is_client_show_agent_level);
            this.sessionBrand_is_client_show_agent_level =  sessionStorage.getItem('is_client_show_agent_level');
 
          // if(res.is_tfa_enfourced != 1){
          //   this.gfunc.tfa_code_in_use = 1
          // }

 
         // lookup brand type name and set.
         this.getBrandType(res.brand_type_id);
      },
      err => {
        // this.user_password_date_status_expired = 1;
        // this.openModalWithComponent_PasswordExpired();

        console.log(err.error)
      },
      // () => console.log('done loading Trace Types')
    );
  }

     
  





                //  // MODAL view a component
                //  openModalWithComponent_PasswordExpired() {
                //   //   const initialState = {
                //   //     title: 'Your Password Has Expired!',
                //   //     item_id: 1010,
                //   //     user_id: this.user_id,
                //   //     size: 'lg',
                //   //     backdrop: true,
                //   //     IgnoreBackdropClick: true,
                //   //     keyboard: false,
                //   //   };
                    
                //   //   this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, {initialState});
                //   //   // sets the var to in the component model
                //   //   this.bsModalRef.content.user_id = this.user_id;
                //   //  // this.bsModalRef.content.brand_id = this.brand_id;
                //   //   this.bsModalRef.content.item_id = this.user_id;
                //   //   this.bsModalRef.content.closeBtnName = 'Logout';
                //   //   // subscribed to the emitter and get the value.
                //   //   this.bsModalRef.content.action.take(1).subscribe((value) => {
                //   // // console.log(value); // here you will get the value of the file
                //   // // Remove the "uploads/" part from the filename.
                //   //               // this.filenameselected = value;
                //   //               // this.stripped = this.filenameselected.replace('uploads/', '');
                //   //               // // this.model.main_image = this.stripped; // works for simple add not update.
                //   //               // // console.log(this.stripped);
                //   //               // // console.log(this.model);
                //   //               // this.form.photo = this.stripped;
                //   //               // // this.form.reset();
                //   //               // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                //   //               // this.form.controls['photo'].patchValue(this.form.photo);
                //   // });
                
                
                //   const config: ModalOptions = {
                //     backdrop: 'static',
                //     keyboard: false,
                //     animated: true,
                //     ignoreBackdropClick: true,
                //   };
                //   this.bsModalRef = this.modalService.show(UserPasswordExpiredModalComponent, config);
                //     // sets the var to in the component model
                //     this.bsModalRef.content.user_id = null;
                //    // this.bsModalRef.content.brand_id = this.brand_id;
                //     this.bsModalRef.content.item_id = null;
                //     this.bsModalRef.content.closeBtnName = 'Logout';
                //    }
     
  getBrandType(brand_type_id) {
    this._demoService.getBrandBrandType(brand_type_id).subscribe(
      data => { this.brand_type = data;
        let res = data[0];
        
        sessionStorage.setItem('sessionBrandTypeName', res.brand_type_name);
        this.sessionBrandTypeName = sessionStorage.getItem('sessionBrandTypeName');
      },
      err => console.error(err),
    //  () => // console.log('done loading brand_types')
    );
  }




// :: BOF Create a doc by button 2022


createDocumentFileViaAutomation_2(model,invoice_id?: number, work_order_id?: number) {
 
 
 
  // Need to establish A set of file access security permission levels
  // If a file is created (mimic communications model or/ model on the current user at the time of automation??) - Does this need to be a choice for each file... created in the array.
  // As well as a communication model.
  
  
  // this.toastr.info('Createing a file model... made it here')
  
   // generate more data first
   // :: Actual File Model - All Vars Required to Create A file Merge Docx
   const pushed_create_file_model = {
     doc_id: model.doc_id,
     job_id: model.job_id,
     subject_id: model.subject_id,
     subject_number: model.subject_number,
     subject_com_type_id: model.subject_com_type_id,
     job_type_id: model.job_type_id,
     job_type_location_id: model.job_type_location_id,
     job_type_court_id: model.job_type_court_id,
     job_type_document_type_id: model.job_type_document_type_id,
     job_type_affidavit_type_id: model.job_type_affidavit_type_id,
     invoice_id: invoice_id,
     work_order_id: work_order_id,
     assigned_to_agents: model.assigned_to_agents,
     file_brand_id: model.file_brand_id,
 
   }; // multidimentional array push
 // Create the Actual File
 // ORGINAL comms 1
  //  this._mysqlService.createDocument_2021Test(pushed_create_file_model).subscribe(

// 2.0 test -- maybe just have to change this.... and wow that great.
this._mysqlService.createDocument_2023_Paragraphs(model).subscribe(

     (data) => {
       // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
       const res = data;
       console.log(res); // not working as response is showing in body
       // console.log(res._body);
       // console.log(res[0].text()); // Convert response to a string
       // this.created_file_name = res[0].text();
       this.created_file_name = res[0] as string;
       model.attached_file_name = this.created_file_name;
     
     //  this.refreshList(); // loads the file list (diretory)
 
    //   this.displaySubjectDocuments(this.subject_id, this.subject_number);
 
       // push to global array
       // this.allAttachedFiles.push(this.created_file_name);
 
       // Start the new array of file
       // this.allAttachments.push(this.created_file_name);
 
       const pushed_file = {
         file_name: this.created_file_name,
         subject_file: 1,
         job_file: 0,
       }; // multidimentional array push
       // this.allAttachments.push(pushed_file); // old way only works for an array.
 
       // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
       // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
       this.allAttachments.push({
         file_name: this.created_file_name,
         job_file: 0,
         subject_file: 1,
       });
       model.allAttachments = this.allAttachments; // ?? this may be causing errors.
 
       // [{name: currencyName, amount: this.ticker[currencyName].last} ]
 
       // Set the file locations
       //agent
      
       if (model.brand_type_id === '3') {
       this.file_edit_level = '5'; // agent can edit
       }
       //client
       if (model.brand_type_id === '2') {
         this.file_edit_level = '3'; // client cannot edit  (staff member can)
       }
 
 
       if (model.brand_type_id === '1') {
         this.file_edit_level = '3'; // (staff)
       }
 
       const file_server_location = this.fileFolderDocs + model.subject_number;
       const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
       const file_folder = this.fileFolderDocs + model.subject_number;
       const file_name = this.created_file_name.slice(0, -5); // removes the extension
       const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
       // UPGRADE Document Model (Insert the File into the database)
       // File Json
                   const create_file = {
                     file_name: file_name,
                     file_display_name: file_name,
                     file_ext: 'docx',
                     file_server_location: file_server_location,
                     file_url: file_url,
                     file_folder: file_folder,
                     file_make: 'created', // automated / updated / created / uploaded / link_created
                     file_notes: 'File created via button Automat',
                     file_job_id: pushed_create_file_model.job_id,
                     file_subject_id: pushed_create_file_model.subject_id,
                     file_subject_number: pushed_create_file_model.subject_number,
                     created_by: this.sessionUserId,
                     created_date: this.today,
                     created_level: this.sessionUserLevel,
                     file_brand_id: model.file_brand_id, // for general // set above for automatoins
                     // file_brand_id: model.brand_report_id, // for general
                     // file_brand_id: model.who_service, // for attendance/service
                     file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                     is_active: '1',
                     file_password: '',
                     file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                     updated_by: 0,
                     updated_date: '',
                     prev_file_id: '0',    // if updating
                     brand_type_id: model.brand_type_id,  // if an agent or a client file
                     subject_template_doc_id: model.doc_id,
                     // subject_com_type_id: pushed_create_file_model.subject_com_type_id,
                     subject_com_type_id: model.subject_com_type_id, // was empty?
                     random_file_name: random_file_name,
                     full_file_name: this.created_file_name,
                     job_id: pushed_create_file_model.job_id,
                     file_number: model.file_number,
                     file_reference_number: model.file_reference_number,
                     // arrays of sending to - based on subject_template_doc - setup
                     // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                     // report_access_array: JSON.stringify(this.brand_data), // collect client
                     // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                     // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                     agent_id: model.who_service, // attendance var
                     is_theme: model.is_theme,
                     assigned_to_agents: model.assigned_to_agents,
                     is_encrypted: 0,
                     ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?
 
                   };
      // console.log( (JSON.stringify(this.assignedBrandList)) );
  // File Json
       //  const create_file = {
       //   file_name: file_name,
       //   file_display_name: file_name,
       //   file_ext: 'docx',
       //   file_server_location: file_server_location,
       //   file_url: file_url,
       //   file_folder: file_folder,
       //   file_make: 'automation', // automated / updated / created / uploaded / link_created / automation
       //   file_notes: 'File created via system Automation: ' + model.system_automation_name,
       //   file_job_id: pushed_create_file_model.job_id,
       //   file_subject_id: pushed_create_file_model.subject_id,
       //   file_subject_number: pushed_create_file_model.subject_number,
       //   created_by: this.sessionUserId,
       //   created_date: this.today,
       //   created_level: this.sessionUserLevel,
       //   file_brand_id: model.brand_report_id,
       //   file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
       //   is_active: '1',
       //   file_password: '',
       //   // file_password: this.set_document_password,
       //   file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
       //   updated_by: '',
       //   updated_date: '',
       //   prev_file_id: '0',    // if updating
       //   brand_type_id: model.brand_type_id,  // if an agent or a client file
       //   subject_template_doc_id: model.doc_id,
       //   subject_com_type_id: model.subject_com_type_id,
       //   random_file_name: random_file_name,
       //   full_file_name: this.created_file_name,
       //   job_id: pushed_create_file_model.job_id,
       //   file_number: model.file_number,
       //   file_reference_number: model.file_reference_number,
       //   // arrays of sending to - based on subject_template_doc - setup
       //       // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
       //       // report_access_array: JSON.stringify(this.brand_data), // collect client
       //       // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
       //       // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
       //   is_theme: model.is_theme,
       //                       is_encrypted: 0,
       //                     ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?
       // };
 
      
      // :: Now we need to insert the file Data and Create a syste File Data Entry.
       this.createFile(create_file);
       // MAYBE ONLY THIS FOR 2.0 File Creation
      //  this.createFile_2(create_file); ????

  
       // Test this here.
       // THINK BEST TO DO A NEW FUNCTION MAKING SUIRE OF SAME VARAIBALES AS THE CREATE DOCUMENT for CREASTE AND SEND as well as new tabs for a new array in acular UI
       // this.sendCommunicationEmailButton_Original(model); // reverted back to orginal script for buttons.
 
       // const log_content 
       // const log_action
       // Access DOM and get values from HTML template to send to logs
      // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
     // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
     // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
     // get the drop down value of text not id.
 
 
     model.subject_com_type_id = 0; // set to 0 so that the notes query does not try to create its own name based on the template--- only needed for comms. 
     this.insertNote_CreateFileButton(model,create_file.full_file_name); // filemane for note - try to create file model for the ntoe.
     // this.insertNote_CreateFileButton(model,create_file.full_file_name); // filemane for note
     
    // this.onOpenDialog_SuccessCommunication(model, model); -- complete background automation
 
 
     },
     (error) => {
      // this.toastr.error('Error Creating Document');
     //   throwError(() => new Error(error));
       throwError(() => new Error(error));
     }
   );
 }



createDocumentFileViaAutomation(model,invoice_id?: number, work_order_id?: number) {
 
 
 
 // Need to establish A set of file access security permission levels
 // If a file is created (mimic communications model or/ model on the current user at the time of automation??) - Does this need to be a choice for each file... created in the array.
 // As well as a communication model.
 
 this.toastr.info('made it to pushed file model')
 
 
  // generate more data first
  // :: Actual File Model - All Vars Required to Create A file Merge Docx
  const pushed_create_file_model = {
    doc_id: model.doc_id,
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_number: model.subject_number,
    subject_com_type_id: model.subject_com_type_id,
    job_type_id: model.job_type_id,
    job_type_location_id: model.job_type_location_id,
    job_type_court_id: model.job_type_court_id,
    job_type_document_type_id: model.job_type_document_type_id,
    job_type_affidavit_type_id: model.job_type_affidavit_type_id,
    invoice_id: invoice_id,
    work_order_id: work_order_id,
    assigned_to_agents: model.assigned_to_agents,
    file_brand_id: model.file_brand_id,
   

  }; // multidimentional array push
// Create the Actual File
  this._mysqlService.createDocument_2021Test(pushed_create_file_model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
     // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.created_file_name = res[0].text();
      this.created_file_name = res[0] as string;
      model.attached_file_name = this.created_file_name;
    
    //  this.refreshList(); // loads the file list (diretory)

   //   this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      // this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }


      if (model.brand_type_id === '1') {
        this.file_edit_level = '3'; // (staff)
      }

      const file_server_location = this.fileFolderDocs + model.subject_number;
      const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
                  const create_file = {
                    file_name: file_name,
                    file_display_name: file_name,
                    file_ext: 'docx',
                    file_server_location: file_server_location,
                    file_url: file_url,
                    file_folder: file_folder,
                    file_make: 'created', // automated / updated / created / uploaded / link_created
                    file_notes: 'File created via button Automat',
                    file_job_id: pushed_create_file_model.job_id,
                    file_subject_id: pushed_create_file_model.subject_id,
                    file_subject_number: pushed_create_file_model.subject_number,
                    created_by: this.sessionUserId,
                    created_date: this.today,
                    created_level: this.sessionUserLevel,
                    file_brand_id: model.file_brand_id, // for general // set above for automatoins
                    // file_brand_id: model.brand_report_id, // for general
                    // file_brand_id: model.who_service, // for attendance/service
                    file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                    is_active: '1',
                    file_password: '',
                    file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                    updated_by: 0,
                    updated_date: '',
                    prev_file_id: '0',    // if updating
                    brand_type_id: model.brand_type_id,  // if an agent or a client file
                    subject_template_doc_id: model.doc_id,
                    // subject_com_type_id: pushed_create_file_model.subject_com_type_id,
                    subject_com_type_id: model.subject_com_type_id, // was empty?
                    random_file_name: random_file_name,
                    full_file_name: this.created_file_name,
                    job_id: pushed_create_file_model.job_id,
                    file_number: model.file_number,
                    file_reference_number: model.file_reference_number,
                    // arrays of sending to - based on subject_template_doc - setup
                    // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                    // report_access_array: JSON.stringify(this.brand_data), // collect client
                    // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                    // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                    agent_id: model.who_service, // attendance var
                    is_theme: model.is_theme,
                    assigned_to_agents: model.assigned_to_agents,
                    is_encrypted: 0,
                    ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?

                  };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
 // File Json
      //  const create_file = {
      //   file_name: file_name,
      //   file_display_name: file_name,
      //   file_ext: 'docx',
      //   file_server_location: file_server_location,
      //   file_url: file_url,
      //   file_folder: file_folder,
      //   file_make: 'automation', // automated / updated / created / uploaded / link_created / automation
      //   file_notes: 'File created via system Automation: ' + model.system_automation_name,
      //   file_job_id: pushed_create_file_model.job_id,
      //   file_subject_id: pushed_create_file_model.subject_id,
      //   file_subject_number: pushed_create_file_model.subject_number,
      //   created_by: this.sessionUserId,
      //   created_date: this.today,
      //   created_level: this.sessionUserLevel,
      //   file_brand_id: model.brand_report_id,
      //   file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
      //   is_active: '1',
      //   file_password: '',
      //   // file_password: this.set_document_password,
      //   file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
      //   updated_by: '',
      //   updated_date: '',
      //   prev_file_id: '0',    // if updating
      //   brand_type_id: model.brand_type_id,  // if an agent or a client file
      //   subject_template_doc_id: model.doc_id,
      //   subject_com_type_id: model.subject_com_type_id,
      //   random_file_name: random_file_name,
      //   full_file_name: this.created_file_name,
      //   job_id: pushed_create_file_model.job_id,
      //   file_number: model.file_number,
      //   file_reference_number: model.file_reference_number,
      //   // arrays of sending to - based on subject_template_doc - setup
      //       // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
      //       // report_access_array: JSON.stringify(this.brand_data), // collect client
      //       // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
      //       // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
      //   is_theme: model.is_theme,
      //                       is_encrypted: 0,
      //                     ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?
      // };

     
     // :: Now we need to insert the file Data and Create a syste File Data Entry.
      this.createFile(create_file);
 
      // Test this here.
      // THINK BEST TO DO A NEW FUNCTION MAKING SUIRE OF SAME VARAIBALES AS THE CREATE DOCUMENT for CREASTE AND SEND as well as new tabs for a new array in acular UI
      // this.sendCommunicationEmailButton_Original(model); // reverted back to orginal script for buttons.

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.


    model.subject_com_type_id = 0; // set to 0 so that the notes query does not try to create its own name based on the template--- only needed for comms. 
    this.insertNote_CreateFileButton(model,create_file.full_file_name); // filemane for note - try to create file model for the ntoe.
    // this.insertNote_CreateFileButton(model,create_file.full_file_name); // filemane for note
    
   // this.onOpenDialog_SuccessCommunication(model, model); -- complete background automation


    },
    (error) => {
     // this.toastr.error('Error Creating Document');
    //   throwError(() => new Error(error));
      throwError(() => new Error(error));
    }
  );
}
















// for attendance settings
createDocumentButtonTest(model,invoice_id?: number, work_order_id?: number) {
  // generate more data first
  // :: Actual File Model - All Vars Required to Create A file Merge Docx
  const pushed_create_file_model = {
    doc_id: model.doc_id,
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_number: model.subject_number,
    subject_com_type_id: model.subject_com_type_id,
    job_type_id: model.job_type_id,
    job_type_location_id: model.job_type_location_id,
    job_type_court_id: model.job_type_court_id,
    job_type_document_type_id: model.job_type_document_type_id,
    job_type_affidavit_type_id: model.job_type_affidavit_type_id,
    invoice_id: invoice_id,
    work_order_id: work_order_id,
    assigned_to_agents: model.assigned_to_agents,
    file_brand_id: model.file_brand_id,
   

  }; // multidimentional array push
// Create the Actual File
  this._mysqlService.createDocument_2021Test(pushed_create_file_model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
     // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.created_file_name = res[0].text();
      this.created_file_name = res[0] as string;
      model.attached_file_name = this.created_file_name;
    
    //  this.refreshList(); // loads the file list (diretory)
     
   //   this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      // this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }


      if (model.brand_type_id === '1') {
        this.file_edit_level = '1'; // (owner)
      }

      const file_server_location = this.fileFolderDocs + model.subject_number;
      const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'docx',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via button',
        file_job_id: pushed_create_file_model.job_id,
        file_subject_id: pushed_create_file_model.subject_id,
        file_subject_number: pushed_create_file_model.subject_number,
        created_by: this.sessionUserId,
        created_date: this.today,
        created_level: this.sessionUserLevel,
        // file_brand_id: model.brand_report_id, // for general
        file_brand_id: model.who_service, // for attendance/service
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.sessionUserId,
        updated_date: this.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        // subject_com_type_id: pushed_create_file_model.subject_com_type_id,
        subject_com_type_id: model.subject_com_type_id, // was empty?
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: pushed_create_file_model.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        // report_access_array: JSON.stringify(this.brand_data), // collect client
        // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        agent_id: model.who_service, // attendance var
        is_theme: model.is_theme,
        assigned_to_agents: model.assigned_to_agents,
        is_encrypted: 0,
        ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?

      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );


     
     // :: Now we need to insert the file Data and Create a syste File Data Entry.
      this.createFile(create_file);
 
      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.

    this.insertNote_CreateFileButton(model,create_file.full_file_name); // filemane for note
    
    this.onOpenDialog_SuccessCommunication(model, model);


    },
    (error) => {
     // this.toastr.error('Error Creating Document');
    //   throwError(() => new Error(error));
      throwError(() => new Error(error));
    }
  );
}






createDocument_Invoice(model, invoice_id) {
  // generate more data first
  this._mysqlService.createDocument_Invoice(model, invoice_id).subscribe(
    (data) => {
  
      // const res = data;
      const res = data[0] as string;
      // console.log('FileName: ', res); // Convert response to a string
      // console.log(res as string); // Convert response to a string
      this.created_file_name = res
      model.attached_file_name = this.created_file_name;

      console.log('Created Filename: ' + model.attached_file_name);

  // set the invoice from the list of invoices (first record)
  if(invoice_id == null){
    invoice_id = this.current_invoice_id;
  }
      // push to global array
     //  model.allAttachedFiles.push(this.created_file_name);
  
      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);
  
      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.
  
      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      model.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      //model.allAttachments = this.allAttachments; // ?? this may be causing errors.
  
      // [{name: currencyName, amount: this.ticker[currencyName].last} ]
  
      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }
  
      const file_server_location = this.fileFolderDocs + model.subject_number;
      const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'pdf',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via subject communcation Save and Send Invoice Button',
        file_job_id: model.job_id,
        file_subject_id: model.subject_id,
        file_subject_number: model.subject_number,
        created_by: this.sessionUserId,
        created_date: this.today,
        created_level: this.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.sessionUserId,
        updated_date: this.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: model.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        // report_access_array: JSON.stringify(this.brand_data), // collect client
        // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        invoice_id: invoice_id,
        is_theme: model.is_theme,
        is_encrypted: 0
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
      this.createFile(create_file);
  
    // :: @ Update the Invoice Status to Approved+PDF (4)   
    let invoice_model = {
  invoice_id: invoice_id,
  invoice_status_id: 4,
    }; 
  this.updateInvoiceStatus(invoice_model);
  
      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.
  
  
   this.onOpenDialog_SuccessInvoiceCreated(model, model);
  
  
    },
    (error) => {
      this.toastr.error('Error Creating Document');
      //return console.log(error);
      console.log('error: ' , error);
    }
  );
  }
  

  createDocument_InvoiceAndSend(model, invoice_id) {
    // generate more data first
    this._mysqlService.createDocument_Invoice(model, invoice_id).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
      
        // const res = data;
        // console.log(res[0].text()); // Convert response to a string
        // this.created_file_name = res[0].text();
        // model.attached_file_name = this.created_file_name;
  
      // const res = data;
      const res = data[0] as string;
      // console.log('FileName: ', res); // Convert response to a string
      // console.log(res as string); // Convert response to a string
      this.created_file_name = res
      model.attached_file_name = this.created_file_name;


      if(model.encrypt_file == true){
        this.is_encrypted = 1; //  encrypted
      }else{
        this.is_encrypted = 0; // no encrypted
      }

    // set the invoice from the list of invoices (first record)
    if(invoice_id == null){
      invoice_id = this.current_invoice_id;
    }
        // push to global array
       //  model.allAttachedFiles.push(this.created_file_name);
    
        // Start the new array of file
        // this.allAttachments.push(this.created_file_name);
    
        const pushed_file = {
          file_name: this.created_file_name,
          subject_file: 1,
          job_file: 0,
        }; // multidimentional array push
        // this.allAttachments.push(pushed_file); // old way only works for an array.
    
        // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
        // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
        model.allAttachments.push({
          file_name: this.created_file_name,
          job_file: 0,
          subject_file: 1,
        });
        // model.allAttachments = this.allAttachments; // ?? this may be causing errors.
    
        // [{name: currencyName, amount: this.ticker[currencyName].last} ]
    
        // Set the file locations
        //agent
       
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
        //client
        if (model.brand_type_id === '2') {
          this.file_edit_level = '3'; // client cannot edit  (staff member can)
        }
    
        const file_server_location = this.fileFolderDocs + model.subject_number;
        const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
        const file_folder = this.fileFolderDocs + model.subject_number;
        const file_name = this.created_file_name.slice(0, -5); // removes the extension
        const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
        // UPGRADE Document Model (Insert the File into the database)
        // File Json
        const create_file = {
          file_name: file_name,
          file_display_name: file_name,
          file_ext: 'pdf',
          file_server_location: file_server_location,
          file_url: file_url,
          file_folder: file_folder,
          file_make: 'created', // automated / updated / created / uploaded / link_created
          file_notes: 'File created via subject communcation Save and Send Invoice Button',
          file_job_id: model.job_id,
          file_subject_id: model.subject_id,
          file_subject_number: model.subject_number,
          created_by: this.sessionUserId,
          created_date: this.today,
          created_level: this.sessionUserLevel,
          file_brand_id: model.brand_report_id,
          file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
          is_active: '1',
          file_password: '',
          file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
          updated_by: this.sessionUserId,
          updated_date: this.today,
          prev_file_id: '0',    // if updating
          brand_type_id: model.brand_type_id,  // if an agent or a client file
          subject_template_doc_id: model.doc_id,
          subject_com_type_id: model.subject_com_type_id,
          random_file_name: random_file_name,
          full_file_name: this.created_file_name,
          job_id: model.job_id,
          file_number: model.file_number,
          file_reference_number: model.file_reference_number,
          // arrays of sending to - based on subject_template_doc - setup
          // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
          // report_access_array: JSON.stringify(this.brand_data), // collect client
          // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
          // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
          invoice_id: invoice_id,
          is_theme: model.is_theme,
        is_encrypted: this.is_encrypted

        };
       // console.log( (JSON.stringify(this.assignedBrandList)) );
        this.createFile(create_file);


      // :: @ Update the Invoice Status to Approved+PDF (4)   
      let invoice_model = {
    invoice_id: invoice_id,
    invoice_status_id: 4, // draft etc... 4 == Approved PDF
    invoice_communication_status_id: 2, // SENT.

      };       
    this.updateInvoiceStatus(invoice_model);
    this.updateInvoiceCommunicationStatus(invoice_model);
  
    // TODO: agent reporting and
    // this.sendCommunicationEmailButton(model);



   this.sendCommunicationEmailButton_Original(model); // THIS WORKS SENDING OLD ORIGINAL 1.0 COMMS


        // testing below to make see if this goes 2.0
    // this.sendCommunicationEmailButton(model);

// Need to create a new buttton for invoicce 2.0 function.
// To use this function I need all the Communication TempaltesLoaded and set to the model I think....

    // this.sendCommunicationEmailButton_Automation_2(model, create_file); // see if this sends the invoice.


    this.onOpenDialog_SuccessCommunication(model, model);

        // const log_content 
        // const log_action
        // Access DOM and get values from HTML template to send to logs
       // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
      // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
      // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
      // get the drop down value of text not id.
    
    
    
      },
      (error) => {
        // this.toastr.error('Error Creating Document');
        console.log('Error: ', error);
      }
    );
    }




    



  
  updateInvoiceStatus(invoice_model){
    this._demoService.updateInvoiceStatus(invoice_model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the invoice:
  
      },
      error => {
       // console.error('Error saving Event!');
        // this.toastr.error('Error Changing Status of Subject');
        return console.error(error);
      }
     // err => console.error(err),
     //
    )};
  
  
  
    updateInvoiceCommunicationStatus(invoice_model){
     // invoice_model.invoice_id = this.invoice_id;
      this._demoService.updateInvoiceCommunicationStatus(invoice_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:

        },
        error => {
         // console.error('Error saving Event!');

          return console.error(error);
        }
       // err => console.error(err),
       //
      )};
    
    updateInvoicePaymentStatus(invoice_model){
     // invoice_model.invoice_id = this.invoice_id;
      this._demoService.updateInvoicePaymentStatus(invoice_model).subscribe(
        data => { // this.trace_candidate_update = data;
          // refresh the invoice:
        },
        error => {

          return console.error(error);
        }
       // err => console.error(err),
       //
      )};




      sendEmail(model){
        model.doc_id = 0; // set the doc_id as is needed to run the email script.
        // this.gfunc.sendEmailWidgetFunction(model);
        this._mysqlService.sendEmailWidget(model).subscribe(
          data => { this.sent_email_widget_response = data;
         // this.sendCommunicationEmailButton(model. model);


         const subject_communication_history = {
          job_id: model.job_id,
          subject_id: model.subject_id,
          subject_com_type_id: model.subject_com_type_id,
          doc_id: model.doc_id,
          change_dates: model.change_dates,
          additional_message: model.additional_message,
          brand_type_id: model.brand_type_id,
          brand_id: model.brand_id,
          all_attached_file_names: JSON.stringify(model.all_attached_file_names),
          send_to_invoice: model.send_to_invoice,
          send_to_report: model.send_to_report,
          send_to_logins: model.send_to_logins,
          send_to_primary: model.send_to_primary,
          allAttachments: JSON.stringify(model.allAttachments),
          allRecipients: JSON.stringify(model.allRecipients),
          allAttachedFiles: JSON.stringify(model.allAttachedFiles),
          brand_report_id: model.brand_report_id,
          brand_invoice_id: model.brand_invoice_id,
          job_type_name: model.job_type_name,
          job_type_location_name: model.job_type_location_name,
          brand_report_user_id: model.brand_report_user_id,
          email_message_subject: model.email_message_subject,
          email_message_recipeints: JSON.stringify(model.email_message_recipeints),
          message_subject: model.message_subject,
          recipient_name: model.recipient_name,
          recipient_type_name: model.recipient_type_name,
          recipient_email_address: JSON.stringify(model.recipient_email_address),
          email_template_HTML: model.email_template_HTML,
          subject_number: model.subject_number,
          created_by: this.sessionUserId,
          created_date: this.today,
          attached_file_names: JSON.stringify(model.attached_file_names),
          attached_job_file_names: JSON.stringify(model.attached_job_file_names),
          subject_com_type_name: model.subject_com_type_name
        };
        this.createSubjectCommunicationHistory(subject_communication_history);







          },
          err => {
          //  console.log(err);
          //  this.toastr.error('?? Sorry: We could not send the email. Please Try Again Shorty.');
          },
          // () => console.log('done loading Trace Types')
        );
        
        }



 // this function is universal for client or email now.
 sendEmailWidgetFunction(model) {
  // model.attached_file_name = this.created_file_name;
  // model.attached_file_names = this.selectedFeatures;
  // model.attached_job_file_names = this.selectedFeaturesJobFiles;
  // model.all_attached_file_names = this.allAttachedFiles;
  // model.allAttachments = this.allAttachments;
  // console.log(model.attached_file_names);




  // this.model.allAttachments = this.allAttachments;

 // this.createSubjectNote(model); // Insert a Note to the subject

//   const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
//   console.log('Communication Type Task: ' +  subject_com_type_name);
//       //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
//        //  console.log('Communication Type Task: ' +  subject_com_type_name);
//  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);

   // set the invoice from the list of invoices (first record)
// if(model.invoice_id == null){
//   this.getSubjectInvoices(model.subject_id); // lookup the latest invoice to attach
//   model.invoice_id = this.current_invoice_id;
// }

const subject_communication_history = {
  job_id: model.job_id,
  subject_id: model.subject_id,
  subject_com_type_id: model.subject_com_type_id,
  doc_id: model.doc_id,
  change_dates: model.change_dates,
  additional_message: model.additional_message,
  brand_type_id: model.brand_type_id,
  brand_id: model.brand_id,
  all_attached_file_names: JSON.stringify(model.all_attached_file_names),
  send_to_invoice: model.send_to_invoice,
  send_to_report: model.send_to_report,
  send_to_logins: model.send_to_logins,
  send_to_primary: model.send_to_primary,
  allAttachments: JSON.stringify(model.allAttachments),
  allRecipients: JSON.stringify(model.allRecipients),
  allAttachedFiles: JSON.stringify(model.allAttachedFiles),
  brand_report_id: model.brand_report_id,
  brand_invoice_id: model.brand_invoice_id,
  job_type_name: model.job_type_name,
  job_type_location_name: model.job_type_location_name,
  brand_report_user_id: model.brand_report_user_id,
  email_message_subject: model.email_message_subject,
  email_message_recipeints: JSON.stringify(model.email_message_recipeints),
  message_subject: model.message_subject,
  recipient_name: model.recipient_name,
  recipient_type_name: model.recipient_type_name,
  recipient_email_address: JSON.stringify(model.recipient_email_address),
  email_template_HTML: model.email_template_HTML,
  subject_number: model.subject_number,
  created_by: this.sessionUserId,
  created_date: this.today,
  attached_file_names: JSON.stringify(model.attached_file_names),
  attached_job_file_names: JSON.stringify(model.attached_job_file_names),
  subject_com_type_name: model.subject_com_type_name
};
this.createSubjectCommunicationHistory(subject_communication_history);


  const log_action = 'sent';
  // const log_name = 'Subject Document Created Via Button: ' + model.subject_com_type_name  + ' - ' + model.file_display_name + ''; 
  const log_name = 'Custom Email Generated: ' + model.message_subject;
  const create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_subject_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
    created_level: this.sessionUserLevel,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name + ' - ' + this.returned_created_file_id,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
  };
  this.createSystemLog(create_sys_log);

  this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Sent Email.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      this.toastr.error('Error sending Email');
      throwError(() => new Error(error));
    }
  );
}



sendCommunicationEmailButton_Automation_2(model, create_file) {
  // model.attached_file_name = this.created_file_name;
  // model.attached_file_names = this.selectedFeatures;
  // model.attached_job_file_names = this.selectedFeaturesJobFiles;
  // model.all_attached_file_names = this.allAttachedFiles;
  // model.allAttachments = this.allAttachments;
  // console.log(model.attached_file_names);

this.toastr.info('START Comms 2.0 :}')


  // this.model.allAttachments = this.allAttachments;

 // this.createSubjectNote(model); // Insert a Note to the subject

//   const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
//   console.log('Communication Type Task: ' +  subject_com_type_name);
//       //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
//        //  console.log('Communication Type Task: ' +  subject_com_type_name);
//  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);

   // set the invoice from the list of invoices (first record)
if(model.invoice_id == null){
  this.getSubjectInvoices(model.subject_id); // lookup the latest invoice to attach
  model.invoice_id = this.current_invoice_id;
}

  const log_action = 'sent';
  // const log_name = 'Subject Document Created Via Button: ' + model.subject_com_type_name  + ' - ' + model.file_display_name + '';
  const log_name = 'Subject Communicaiton 2.0 Task Automation: ' + model.subject_com_type_name  + ' - ' + this.created_file_name + '';
  const create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_subject_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
    created_level: this.sessionUserLevel,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name + ' - ' + this.returned_created_file_id,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
  };
  this.createSystemLog(create_sys_log);

  // const subject_communication_history = {
  //   job_id: model.job_id,
  //   subject_id: model.subject_id,
  //   subject_com_type_id: model.subject_com_type_id,
  //   doc_id: model.doc_id,
  //   change_dates: model.change_dates,
  //   additional_message: model.additional_message,
  //   brand_type_id: model.brand_type_id,
  //   brand_id: model.brand_id,
  //   all_attached_file_names: JSON.stringify(model.all_attached_file_names),
  //   send_to_invoice: model.send_to_invoice,
  //   send_to_report: model.send_to_report,
  //   send_to_logins: model.send_to_logins,
  //   send_to_primary: model.send_to_primary,
  //   allAttachments: JSON.stringify(model.allAttachments),
  //   allRecipients: JSON.stringify(model.allRecipients),
  //   allAttachedFiles: JSON.stringify(model.allAttachedFiles),
  //   brand_report_id: model.brand_report_id,
  //   brand_invoice_id: model.brand_invoice_id,
  //   job_type_name: model.job_type_name,
  //   job_type_location_name: model.job_type_location_name,
  //   brand_report_user_id: model.brand_report_user_id,
  //   email_message_subject: model.email_message_subject,
  //   email_message_recipeints: JSON.stringify(model.email_message_recipeints),
  //   message_subject: model.message_subject,
  //   recipient_name: model.recipient_name,
  //   recipient_type_name: model.recipient_type_name,
  //   recipient_email_address: JSON.stringify(model.recipient_email_address),
  //   email_template_HTML: model.email_template_HTML,
  //   subject_number: model.subject_number,
  //   created_by: this.sessionUserId,
  //   created_date: this.today,
  //   attached_file_names: JSON.stringify(model.attached_file_names),
  //   attached_job_file_names: JSON.stringify(model.attached_job_file_names),
  //   subject_com_type_name: model.subject_com_type_name
  // };
  // this.createSubjectCommunicationHistory(subject_communication_history);






console.log(model.attached_file_names);

// upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
      // if(model.note_template_HTML_rendered == null){
      // this.createSubjectNote(model); // Insert a Note to the subject
      // }else{
      // this.createSubjectNote_with_vars(model)
      // }




      // Mught have to find another way for this....  stague 11/1/24 -- need to activate.
                  // const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
                  // console.log('Communication Type Task: ' +  subject_com_type_name);
                  //   //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
                  //    //  console.log('Communication Type Task: ' +  subject_com_type_name);
                  // const doc_name = document.getElementById('doc_name').innerText;
                  // console.log('Document Name: ' +  doc_name);

// set the invoice from the list of invoices (first record)
if (model.invoice_id == null) {
model.invoice_id = this.current_invoice_id;
}





// 2.0

 // -- NOT WORKING YET

     // full circle.
    //  this.setAllRecipients_2(model); // same function as on comms page to set to set allRecipients -- sets the paragraph variables here from the model...?



     // Gp Look at the Auotmations model that sets the recipients details on load...- and renderes all the templates in a lopop.
     // Do a test for simply gettin the correct recipients first. -- on load of autiomation.



                          // new 2.0 to load the automations brand report ID
                          this.getBrand_Q_2(model.brand_report_id);

                          // Base veriables and paragraphs - for new email paragraph renders
                          
                          if(model.brand_invoice_id == ""){
                            this.getBrand_invoice_Q(this.job_data_paragraphs.brand_invoice_id) /// ??? load from hob data
                          }else{
                          this.getBrand_invoice_Q(model.brand_invoice_id)  // load from the model defailt
                          }

                          this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
                         
                         

                          // MOVED TO BELOW FUNCTION getJob_and_brands_Q ??? may 24
                          this.getJobReportUserContact_Q(model.brand_report_user_id)


                          this.getCurrentUser_Q(this.sessionUserId); // changed for testing maybe...???
                          // this.getCurrentUser_Q(this.currentUserVAR.user_id); // changed for testing maybe...???
                          
                          // Get Subject Agent - F_agent
                          this.getSubjectAgentBrandsAssigned_Q(model.subject_id) // get the first agent ID.????






  if (model.send_to_report == 1) {
  
    
                        // load subject services (attemps)
                        this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                        this.getSubjectServicesOnly_Q(model.subject_id) // service variables



// FIrst Need to get All the variable Paragraphs
                          // mege variables renders
                          this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                          

                      
                          if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                          this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                          }
                          
                          if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                          this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                          }
                          if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                          this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                          }
                          
                          this.getSubjectContactNumbers_Q(model.subject_id)
                          
                          this.getSubjectContactEmails_Q(model.subject_id)
                     
                          
  
                              // end pre load paragraphs 
  // End load all merge     


    //  this.toastr.success('Gathering sending to report informaton')

    // THIS IS wrong as it sets the replacement varaiables without the all_repciepeints ----- As variables>???
    // NEED TO FIX this




          // :: Impliments automatic recipients based on chosen com template options
          // :: Subract Method / Filter
          // :: DEMOSERVICE look up client brand details.
          this._demoService.getBrandById(model.brand_report_id).subscribe(
            (data) => {


             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];

                // if a company
          let is_privacy_emails = res.is_privacy_emails
          let is_privacy_notes = res.is_privacy_notes
          let is_privacy_no_docs = res.is_privacy_no_docs
          let is_privacy_no_emails = res.is_privacy_no_emails
          let is_privacy_no_notes = res.is_privacy_no_notes
          /*
`is_privacy_emails` varchar(11) DEFAULT NULL,
`is_privacy_notes` varchar(11) DEFAULT NULL,
`is_privacy_no_docs` varchar(11) DEFAULT NULL,
`is_privacy_no_emails` varchar(11) DEFAULT NULL,
`is_privacy_no_notes
          */


          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
          let email_template_primary_HTML = model.email_template_primary_HTML;
          let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML

          let email_template_private_HTML = model.email_template_private_HTML;
          let email_subject_private = model.email_subject_private;
          let note_template_private_HTML = model.note_template_private_HTML
                // set the recipent variables in the model first so I have them
          // model.recipient_name = res.name + ' - Client Report'
          model.recipient_name = res.name
          model.recipient_email_address = res.email
          model.recipient_brand_id = res.brand_id
          model.recipient_brand_type_id = res.brand_type_id
          model.recipient_user_id  = null
          model.recipient_user_level_id = null
          model.recipient_type_name ='Client Report'
        
        
          let rendered_email;
          let rendered_subject;
          let rendered_note;
          let rendered_email_private;
          let rendered_subject_private;
          let rendered_note_private;
 
// Lets see if I can Link Directly to the function on the  SubjectCommunicationWithVarsComponent -- stupid I will get the cyclic loop crapp.. so havt to recreati

          if(is_privacy_emails == 1){
           rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
           rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
         }else{
         rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
         rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
         }

         if(is_privacy_notes == 1){
           rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
         }else{
         rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
         }
     
        
        
          // let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          // let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

          // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
          // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
          // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)
          
              this.allRecipients = []; // to prevent reporting undefined
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Report',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Report',
                 ...model,
                 email_subject_primary_rendered: rendered_subject,
                 email_template_primary_HTML_rendered: rendered_email,
                 note_template_HTML_rendered: rendered_note,

                //  email_subject_private_rendered: rendered_subject_private,
                //  email_template_private_HTML_rendered: rendered_email_private,
                //  note_template_private_HTML_rendered: rendered_note_private,

                 is_privacy_emails: is_privacy_emails,
                 is_privacy_notes: is_privacy_notes,
                 is_privacy_no_docs: is_privacy_no_docs,
                 is_privacy_no_emails: is_privacy_no_emails,
                 is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.
           model.allRecipients = this.allRecipients;

            // model.attached_file_name = this.created_file_name;
            // model.attached_file_names = this.selectedFeatures;
            // model.attached_job_file_names = this.selectedFeaturesJobFiles;
            // model.all_attached_file_names = this.allAttachedFiles;
            // model.allAttachments = this.allAttachments;
            // model.allRecipients = this.allRecipients;

           
            model = model; // see if sets the allReipients into the model

            console.log('WithRecipients Model: ' + JSON.stringify(model))
           
                              // model.message_subject = log_name;
                              model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                            
                              // original
                          // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
                          // comms 2.0
                    
          // upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
          this.createSubjectNote_with_vars(model)   /// NOT WORKING MIGHT HAVE TO HARD CODE THIS ON ELIKE THE EMAIL COMSsss




                          this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


                            (data22) => {
                              // this.trace_candidate_update = data;
                              // this.toastr.success('Sent Email.');
                              const res = data22;
                              // this.onOpenDialog_SuccessCommunication(model, model);
                              // console.log(res); // not working as response is showing in body
                              // console.log(res._body);
                              // console.log(res[0].text()); // Convert response to a string


                              // Now empty the recipients - New 24 in automations loops only when here.-- STOPED EVERYTHING!!!
                              // this.allRecipients = []; // clean array for next loop. -- stop duplicatios!!!!

                              // now close the modal
                              // this.closeParentModel.emit();
                              // this.closeParentModel3.emit();
                              // // refresh the invoice page if
                              // if ( model.invoice_id > 0 ){
                              //   this.refreshSujectInvoicePage.emit(this.subject_id);
                              // }


                    
                            },
                            (error) => {
                              // this.toastr.error('Error sending Email');
                            //  alert('Error sending email');
                              // throwError(() => new Error(error));
                              return;
                            }
                          );

  

            },
            (err) => console.error(err),
            () => console.log('Client Report Recipient Added.')

            );

   




      } // end if send_to_report
      // end client report

            // AGENT
 if ( model.brand_type_id == 3) { 


                          // // had to run al these again??? for some reason.
                          // this.getBrand_Q_2(model.brand_report_id);

                          // // Base veriables and paragraphs - for new email paragraph renders
                          // this.getBrand_invoice_Q(model.brand_invoice_id) 
                          // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
                          // this.getJobReportUserContact_Q(model.brand_report_user_id)
                          // this.getCurrentUser_Q(this.sessionUserId);
                          // // Get Subject Agent - F_agent
                          // this.getSubjectAgentBrandsAssigned_Q(model.subject_id) // get the first agent ID.????

// FIrst Need to get All the variable Paragraphs
                        // load subject services (attemps)
                        this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                        this.getSubjectServicesOnly_Q(model.subject_id) // service variables



// FIrst Need to get All the variable Paragraphs
                          // mege variables renders
                          this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                          

                      
                          if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                          this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                          }
                          
                          if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                          this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                          }
                          if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                          this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                          }
                          
                          this.getSubjectContactNumbers_Q(model.subject_id)
                          
                          this.getSubjectContactEmails_Q(model.subject_id)
  // End load all merge 








              this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
                (data) => {
                  // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
                 let newArr = data;
                 let  count_of_items = Object.keys(newArr).length;
                   // need to do a loop of subject_billing items (.length)
                  //  for(let i=0;i < count_of_items; i++) {} // removed loop
                  //  let res = newArr[i];

                  // only load the first agent aloways - fix 2014 Automations
                   let res = data[0];

      
                   let email_template_primary_HTML = model.email_template_primary_HTML;
                   let email_subject_primary = model.email_subject_primary;
                let note_template_HTML = model.note_template_HTML
      
                
      
                         // set the recipent variables in the model first so I have them
                  //  model.recipient_name = res.name + ' - Agent'
                   model.recipient_name = res.name
                   model.recipient_email_address = res.email
                   model.recipient_brand_id = res.brand_id
                   model.recipient_brand_type_id = res.brand_type_id
                   model.recipient_user_id  = null
                   model.recipient_user_level_id = null
                   model.recipient_type_name = 'Agent'
      
                   let is_privacy_emails = res.is_privacy_emails
                   let is_privacy_notes = res.is_privacy_notes
                   let is_privacy_no_docs = res.is_privacy_no_docs
                   let is_privacy_no_emails = res.is_privacy_no_emails
                   let is_privacy_no_notes = res.is_privacy_no_notes
      
                   let email_template_private_HTML = model.email_template_private_HTML;
                   let email_subject_private = model.email_subject_private;
                   let note_template_private_HTML = model.note_template_private_HTML
      
                   let rendered_email;
                   let rendered_subject;
                   let rendered_note;
                   let rendered_email_private;
                   let rendered_subject_private;
                   let rendered_note_private;
       
                   if(is_privacy_emails == 1){
                    rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
                    rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
                  }else{
                  rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
                  rendered_subject = this.runReplaceAllVariables(email_subject_primary, model) // WHY IS THIS CREATING ERRORS??? -- THERE MUST BE A SUBJECT!!!!
                  }
       
                  if(is_privacy_notes == 1){
                    rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
                  }else{
                  rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
                  }
              
      
      
      
                //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
                //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
                // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
                this.allRecipients = []; // to prevent reporting undefined
      
                   this.allRecipients.push({
                     recipient_name: res.name + ' - Agent',
                     recipient_email_address: res.email,
                     recipient_brand_id: res.brand_id,
                     recipient_brand_type_id: res.brand_type_id,
                     recipient_user_id: null,
                     recipient_user_level_id: null,
                     recipient_type_name: 'Agent',
                     ...model,
                     email_subject_primary_rendered: rendered_subject,
                     email_template_primary_HTML_rendered: rendered_email,
                     note_template_HTML_rendered: rendered_note,
      
                     is_privacy_emails: is_privacy_emails,
                     is_privacy_notes: is_privacy_notes,
                     is_privacy_no_docs: is_privacy_no_docs,
                     is_privacy_no_emails: is_privacy_no_emails,
                     is_privacy_no_notes: is_privacy_no_notes,
      
                   });
                  //  } // end for loop
                 this.allRecipients = this.allRecipients; // ?? this may be causing errors.
                model.allRecipients = this.allRecipients; // MUST SET THIS!@!!!! to send the emails....
                 model = model;


          // upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
          this.createSubjectNote_with_vars(model)   /// NOT WORKING MIGHT HAVE TO HARD CODE THIS ON ELIKE THE EMAIL COMSsss

                   // send the email
                           // model.message_subject = log_name;
                           model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                            
                           // original
                       // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
                       // comms 2.0
                 
                       this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


                         (data22) => {
                           // this.trace_candidate_update = data;
                           // this.toastr.success('Sent Email.');
                           const res = data22;
                           // this.onOpenDialog_SuccessCommunication(model, model);
                           // console.log(res); // not working as response is showing in body
                           // console.log(res._body);
                           // console.log(res[0].text()); // Convert response to a string


                           // Now empty the recipients - New 24 in automations loops only when here.-- STOPED EVERYTHING!!!
                           // this.allRecipients = []; // clean array for next loop. -- stop duplicatios!!!!

                           // now close the modal
                           // this.closeParentModel.emit();
                           // this.closeParentModel3.emit();
                           // // refresh the invoice page if
                           // if ( model.invoice_id > 0 ){
                           //   this.refreshSujectInvoicePage.emit(this.subject_id);
                           // }
                         },
                         (error) => {
                           // this.toastr.error('Error sending Email');
                         //  alert('Error sending email');
                           // throwError(() => new Error(error));
                           return;
                         }
                       );






      
                },
                (err) => console.error(err),
                () => console.log('Agent Recipients Added.')
              );
              // const key = 'Agent';
              // this.allRecipients.forEach((value, index) => {
              //   if (value.recipient_type_name === key) {
              //     this.allRecipients.splice(index, 1);
              //     console.log('Removed Agent Recipients');
              //   }
              // });
            };
//  end agent
if (model.send_to_report_user == 1) {


  // FIrst Need to get All the variable Paragraphs
                        // load subject services (attemps)
                        this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                        this.getSubjectServicesOnly_Q(model.subject_id) // service variables



// FIrst Need to get All the variable Paragraphs
                          // mege variables renders
                          this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                          

                      
                          if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                          this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                          }
                          
                          if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                          this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                          }
                          if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                          this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                          }
                          
                          this.getSubjectContactNumbers_Q(model.subject_id)
                          
                          this.getSubjectContactEmails_Q(model.subject_id)
  // End load all merge 

  this._demoService.getUsersById(model.brand_report_user_id).subscribe(
    (data) => {
      // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
     let newArr = data;
     let  count_of_items = Object.keys(newArr).length;
       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

    //  console.log('Respones: ' + JSON.stringify(res))

    let email_template_primary_HTML = model.email_template_primary_HTML
    let email_subject_primary = model.email_subject_primary;
    let note_template_HTML = model.note_template_HTML


    let email_template_private_HTML = model.email_template_private_HTML;
    let email_subject_private = model.email_subject_private;
    let note_template_private_HTML = model.note_template_private_HTML
    
    // these are different for the user as I have to lookup brand first
    let user_brand_id = res.brand_id;
    //get brand ---
    // this.getUserBrand_Q(user_brand_id); -- Instead Loop these up in the API data and send back with the user details - is_privacy_email (that way its set at a brand level for all users and I have access to these variables without another lookup here.)
              // added to user API not actual user data.
    let is_privacy_emails = res.is_privacy_emails
    let is_privacy_notes = res.is_privacy_notes
    let is_privacy_no_docs = res.is_privacy_no_docs
    let is_privacy_no_emails = res.is_privacy_no_emails
    let is_privacy_no_notes = res.is_privacy_no_notes
    
    // model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client Report User',
    model.recipient_name = res.first_name +  ' ' + res.surname,
    model.recipient_email_address = res.email_address,
    model.recipient_brand_id = null
    model.recipient_brand_type_id = null
    model.recipient_user_id  = res.user_id,
    model.recipient_user_level_id = null
    model.recipient_type_name = 'Client Report User'
  
    let rendered_email;
    let rendered_subject;
    let rendered_note;
    let rendered_email_private;
    let rendered_subject_private;
    let rendered_note_private;

    if(is_privacy_emails == 1){
      rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
      rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
    }else{
    rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
    rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
    }

    if(is_privacy_notes == 1){
      rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
    }else{
    rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
    }

    // rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
    // rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
    // rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


    // TOO MANY CONNECTIONS --- Breaks scripts with many errors so need to limit the replacements.
    // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
    // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
    // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)
    this.allRecipients = []; // to prevent reporting undefined
       this.allRecipients.push({
      recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
      recipient_email_address: res.email_address,
      recipient_brand_id: null,
      recipient_brand_type_id: null,
      recipient_user_id: res.user_id,
      recipient_user_level_id: res.access_level,
      recipient_type_name: 'Client Report User',
      ...model,
      email_subject_primary_rendered: rendered_subject,
      email_template_primary_HTML_rendered: rendered_email,
      note_template_HTML_rendered: rendered_note,

      // email_subject_private_rendered: rendered_subject_private,
      // email_template_private_HTML_rendered: rendered_email_private,
      // note_template_private_HTML_rendered: rendered_note_private,

      is_privacy_emails: is_privacy_emails,
      is_privacy_notes: is_privacy_notes,
      is_privacy_no_docs: is_privacy_no_docs,
      is_privacy_no_emails: is_privacy_no_emails,
      is_privacy_no_notes: is_privacy_no_notes,

       });
       } // end for loop
     this.allRecipients = this.allRecipients; // ?? this may be causing errors.



     model.allRecipients = this.allRecipients; // MUST SET THIS!@!!!! to send the emails....
     model = model;


          // upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
          this.createSubjectNote_with_vars(model)   /// NOT WORKING MIGHT HAVE TO HARD CODE THIS ON ELIKE THE EMAIL COMSsss

       // send the email
               // model.message_subject = log_name;
               model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                
               // original
           // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
           // comms 2.0
     
           this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


             (data22) => {
               // this.trace_candidate_update = data;
               // this.toastr.success('Sent Email.');
               const res = data22;
               // this.onOpenDialog_SuccessCommunication(model, model);
               // console.log(res); // not working as response is showing in body
               // console.log(res._body);
               // console.log(res[0].text()); // Convert response to a string


               // Now empty the recipients - New 24 in automations loops only when here.-- STOPED EVERYTHING!!!
               // this.allRecipients = []; // clean array for next loop. -- stop duplicatios!!!!

               // now close the modal
               // this.closeParentModel.emit();
               // this.closeParentModel3.emit();
               // // refresh the invoice page if
               // if ( model.invoice_id > 0 ){
               //   this.refreshSujectInvoicePage.emit(this.subject_id);
               // }
             },
             (error) => {
               // this.toastr.error('Error sending Email');
             //  alert('Error sending email');
               // throwError(() => new Error(error));
               return;
             }
           );


    },
    (err) => console.error(err),
    () => console.log('Client Report User Recipient Added.')
  );
  // const key = 'Client Report User';
  // this.allRecipients.forEach((value, index) => {
  //   if (value.recipient_type_name === key) {
  //     this.allRecipients.splice(index, 1);
  //     console.log('Removed Report User Recipient');
  //   }
  // });
};

if (model.send_to_invoice == 1) {




  // FIrst Need to get All the variable Paragraphs
                        // load subject services (attemps)
                        this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                        this.getSubjectServicesOnly_Q(model.subject_id) // service variables



// FIrst Need to get All the variable Paragraphs
                          // mege variables renders
                          this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                          

                      
                          if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                          this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                          }
                          
                          if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                          this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                          }
                          if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                          this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                          }
                          
                          this.getSubjectContactNumbers_Q(model.subject_id)
                          
                          this.getSubjectContactEmails_Q(model.subject_id)
  // End load all merge 

  this._demoService.getBrandById(model.brand_invoice_id).subscribe(
    (data) => {
      // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
     let newArr = data;
     let  count_of_items = Object.keys(newArr).length;
       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
       let res = newArr[i];

       let email_template_primary_HTML = model.email_template_primary_HTML;
       let email_subject_primary = model.email_subject_primary;
  let note_template_HTML = model.note_template_HTML


  let email_template_private_HTML = model.email_template_private_HTML;
  let email_subject_private = model.email_subject_private;
  let note_template_private_HTML = model.note_template_private_HTML

  let is_privacy_emails = res.is_privacy_emails
  let is_privacy_notes = res.is_privacy_notes
  let is_privacy_no_docs = res.is_privacy_no_docs
  let is_privacy_no_emails = res.is_privacy_no_emails
  let is_privacy_no_notes = res.is_privacy_no_notes

             // set the recipent variables in the model first so I have them
      //  model.recipient_name = res.name + ' - Client Accounts'
       model.recipient_name = res.name
       model.recipient_email_address = res.accounts_email_address
       model.recipient_brand_id = res.brand_id
       model.recipient_brand_type_id = res.brand_type_id
       model.recipient_user_id  = null
       model.recipient_user_level_id = null
       model.recipient_type_name = 'Client Accounts'


       let rendered_email;
       let rendered_subject;
       let rendered_note;
       let rendered_email_private;
       let rendered_subject_private;
       let rendered_note_private;

       if(is_privacy_emails == 1){
        rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
        rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
      }else{
      rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
      rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
      }

      if(is_privacy_notes == 1){
        rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
      }else{
      rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
      }
  
       
  // let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
  // let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
  // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

  // To many quieries... instead change the above on an if staement and replace the rendered content instead!!!!!!!!!!
  // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
  // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
  // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)

  this.allRecipients = [];
       this.allRecipients.push({
         recipient_name: res.name + ' - Client Accounts',
         recipient_email_address: res.accounts_email_address,
         recipient_brand_id: res.brand_id,
         recipient_brand_type_id: res.brand_type_id,
         recipient_user_id: null,
         recipient_user_level_id: null,
         recipient_type_name: 'Client Accounts',
         ...model,
         email_subject_primary_rendered: rendered_subject,
         email_template_primary_HTML_rendered: rendered_email,
         note_template_HTML_rendered: rendered_note,

        //  email_subject_private_rendered: rendered_subject_private,
        //  email_template_private_HTML_rendered: rendered_email_private,
        //  note_template_private_HTML_rendered: rendered_note_private,
         
         is_privacy_emails: is_privacy_emails,
         is_privacy_notes: is_privacy_notes,
         is_privacy_no_docs: is_privacy_no_docs,
         is_privacy_no_emails: is_privacy_no_emails,
         is_privacy_no_notes: is_privacy_no_notes,

       });
       } // end for loop
     this.allRecipients = this.allRecipients; // ?? this may be causing errors.





     model.allRecipients = this.allRecipients; // MUST SET THIS!@!!!! to send the emails....
     model = model;

          // upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
          this.createSubjectNote_with_vars(model)   /// NOT WORKING MIGHT HAVE TO HARD CODE THIS ON ELIKE THE EMAIL COMSsss


       // send the email
               // model.message_subject = log_name;
               model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                
               // original
           // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
           // comms 2.0
     
           this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


             (data22) => {
               // this.trace_candidate_update = data;
               // this.toastr.success('Sent Email.');
               const res = data22;
               // this.onOpenDialog_SuccessCommunication(model, model);
               // console.log(res); // not working as response is showing in body
               // console.log(res._body);
               // console.log(res[0].text()); // Convert response to a string


               // Now empty the recipients - New 24 in automations loops only when here.-- STOPED EVERYTHING!!!
               // this.allRecipients = []; // clean array for next loop. -- stop duplicatios!!!!

               // now close the modal
               // this.closeParentModel.emit();
               // this.closeParentModel3.emit();
               // // refresh the invoice page if
               // if ( model.invoice_id > 0 ){
               //   this.refreshSujectInvoicePage.emit(this.subject_id);
               // }
             },
             (error) => {
               // this.toastr.error('Error sending Email');
             //  alert('Error sending email');
               // throwError(() => new Error(error));
               return;
             }
           );



    },
    (err) => console.error(err),
    () => console.log('Client Accounts Recipient Added.')
  );
}
 
if (model.send_to_logins == 1) {




  // FIrst Need to get All the variable Paragraphs
                        // load subject services (attemps)
                        this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                        this.getSubjectServicesOnly_Q(model.subject_id) // service variables



// FIrst Need to get All the variable Paragraphs
                          // mege variables renders
                          this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                          

                      
                          if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                          this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                          }
                          
                          if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                          this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                          }
                          if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                          this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                          }
                          
                          this.getSubjectContactNumbers_Q(model.subject_id)
                          
                          this.getSubjectContactEmails_Q(model.subject_id)
  // End load all merge 

  this._demoService.getBrandUsers(model.brand_report_id).subscribe(
    (data) => {
      // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
     let newArr = data;
     let  count_of_items = Object.keys(newArr).length;
       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
       let res = newArr[i];

       let email_template_primary_HTML = model.email_template_primary_HTML;
       let email_subject_primary = model.email_subject_primary;
    let note_template_HTML = model.note_template_HTML

             // set the recipent variables in the model first so I have them
      //  model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client User'
       model.recipient_name = res.first_name +  ' ' + res.surname
       model.recipient_email_address = res.email_address
       model.recipient_brand_id = null
       model.recipient_brand_type_id = null
       model.recipient_user_id  = res.user_id
       model.recipient_user_level_id = res.access_level
       model.recipient_type_name = 'Client User'


       let is_privacy_emails = res.is_privacy_emails
       let is_privacy_notes = res.is_privacy_notes
       let is_privacy_no_docs = res.is_privacy_no_docs
       let is_privacy_no_emails = res.is_privacy_no_emails
       let is_privacy_no_notes = res.is_privacy_no_notes

       let email_template_private_HTML = model.email_template_private_HTML;
       let email_subject_private = model.email_subject_private;
       let note_template_private_HTML = model.note_template_private_HTML

       let rendered_email;
       let rendered_subject;
       let rendered_note;
       let rendered_email_private;
       let rendered_subject_private;
       let rendered_note_private;

       if(is_privacy_emails == 1){
        rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
        rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
      }else{
      rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
      rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
      }

      if(is_privacy_notes == 1){
        rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
      }else{
      rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
      }
  
    //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
    //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
    // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

      this.allRecipients = [];
       this.allRecipients.push({
      recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
      recipient_email_address: res.email_address,
      recipient_brand_id: null,
      recipient_brand_type_id: null,
      recipient_user_id: res.user_id,
      recipient_user_level_id: res.access_level,
      recipient_type_name: 'Client User',
      ...model,
      email_subject_primary_rendered: rendered_subject,
      email_template_primary_HTML_rendered: rendered_email,
      note_template_HTML_rendered: rendered_note,

      is_privacy_emails: is_privacy_emails,
      is_privacy_notes: is_privacy_notes,
      is_privacy_no_docs: is_privacy_no_docs,
      is_privacy_no_emails: is_privacy_no_emails,
      is_privacy_no_notes: is_privacy_no_notes,

       });
       } // end for loop
     this.allRecipients = this.allRecipients; // ?? this may be causing errors.



     model.allRecipients = this.allRecipients; // MUST SET THIS!@!!!! to send the emails....
     model = model;

          // upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
          this.createSubjectNote_with_vars(model)   /// NOT WORKING MIGHT HAVE TO HARD CODE THIS ON ELIKE THE EMAIL COMSsss


       // send the email
               // model.message_subject = log_name;
               model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                
               // original
           // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
           // comms 2.0
     
           this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


             (data22) => {
               // this.trace_candidate_update = data;
               // this.toastr.success('Sent Email.');
               const res = data22;
               // this.onOpenDialog_SuccessCommunication(model, model);
               // console.log(res); // not working as response is showing in body
               // console.log(res._body);
               // console.log(res[0].text()); // Convert response to a string


               // Now empty the recipients - New 24 in automations loops only when here.-- STOPED EVERYTHING!!!
               // this.allRecipients = []; // clean array for next loop. -- stop duplicatios!!!!

               // now close the modal
               // this.closeParentModel.emit();
               // this.closeParentModel3.emit();
               // // refresh the invoice page if
               // if ( model.invoice_id > 0 ){
               //   this.refreshSujectInvoicePage.emit(this.subject_id);
               // }
             },
             (error) => {
               // this.toastr.error('Error sending Email');
             //  alert('Error sending email');
               // throwError(() => new Error(error));
               return;
             }
           );



    },
    (err) => console.error(err),
    () => console.log('Client User Recipient Added.')
  );
  // const key = 'Client User';
  // this.allRecipients.forEach((value, index) => {
  //   if (value.recipient_type_name === key) {
  //     this.allRecipients.splice(index, 1);
  //     console.log('Removed Client User Recipients');
  //   }
  // });
}
 
if (model.send_to_primary == 1) {


    // FIrst Need to get All the variable Paragraphs
                        // load subject services (attemps)
                        this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                        this.getSubjectServicesOnly_Q(model.subject_id) // service variables



// FIrst Need to get All the variable Paragraphs
                          // mege variables renders
                          this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                          

                      
                          if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                          this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                          }
                          
                          if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                          this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                          }
                          if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                          this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                          }
                          
                          this.getSubjectContactNumbers_Q(model.subject_id)
                          
                          this.getSubjectContactEmails_Q(model.subject_id)
  // End load all merge 


  this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
    (data) => {
      // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
     let newArr = data;
     let  count_of_items = Object.keys(newArr).length;
       // need to do a loop of subject_billing items (.length)
       for(let i=0;i < count_of_items; i++) {
       let res = newArr[i];

       let email_template_primary_HTML = model.email_template_primary_HTML;
       let email_subject_primary = model.email_subject_primary;
    let note_template_HTML = model.note_template_HTML

             // set the recipent variables in the model first so I have them
      //  model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client Primary Contact'
       model.recipient_name = res.first_name +  ' ' + res.surname
       model.recipient_email_address = res.email_address
       model.recipient_brand_id = null
       model.recipient_brand_type_id = null
       model.recipient_user_id  = res.user_id
       model.recipient_user_level_id = res.access_level
       model.recipient_type_name = 'Client Primary Contact'

       let is_privacy_emails = res.is_privacy_emails
       let is_privacy_notes = res.is_privacy_notes
       let is_privacy_no_docs = res.is_privacy_no_docs
       let is_privacy_no_emails = res.is_privacy_no_emails
       let is_privacy_no_notes = res.is_privacy_no_notes

       let email_template_private_HTML = model.email_template_private_HTML;
       let email_subject_private = model.email_subject_private;
       let note_template_private_HTML = model.note_template_private_HTML

       let rendered_email;
       let rendered_subject;
       let rendered_note;
       let rendered_email_private;
       let rendered_subject_private;
       let rendered_note_private;

       if(is_privacy_emails == 1){
        rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
        rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
      }else{
      rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
      rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
      }

      if(is_privacy_notes == 1){
        rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
      }else{
      rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
      }
  

    //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
    //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
    // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

    this.allRecipients = [];
       this.allRecipients.push({
      recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
      recipient_email_address: res.email_address,
      recipient_brand_id: null,
      recipient_brand_type_id: null,
      recipient_user_id: res.user_id,
      recipient_user_level_id: res.access_level,
      recipient_type_name: 'Client Primary Contact',
      ...model,
      email_subject_primary_rendered: rendered_subject,
      email_template_primary_HTML_rendered: rendered_email,
      note_template_HTML_rendered: rendered_note,

      is_privacy_emails: is_privacy_emails,
      is_privacy_notes: is_privacy_notes,
      is_privacy_no_docs: is_privacy_no_docs,
      is_privacy_no_emails: is_privacy_no_emails,
      is_privacy_no_notes: is_privacy_no_notes,

       });
       } // end for loop
     this.allRecipients = this.allRecipients; // ?? this may be causing errors.




     model.allRecipients = this.allRecipients; // MUST SET THIS!@!!!! to send the emails....
     model = model;


          // upgrade 2.0 multiple notes and templates. -- note removed for automation at this stague 11/1/24 -- need to activate.
          this.createSubjectNote_with_vars(model)   /// NOT WORKING MIGHT HAVE TO HARD CODE THIS ON ELIKE THE EMAIL COMSsss

       // send the email
               // model.message_subject = log_name;
               model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                
               // original
           // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
           // comms 2.0
     
           this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


             (data22) => {
               // this.trace_candidate_update = data;
               // this.toastr.success('Sent Email.');
               const res = data22;
               // this.onOpenDialog_SuccessCommunication(model, model);
               // console.log(res); // not working as response is showing in body
               // console.log(res._body);
               // console.log(res[0].text()); // Convert response to a string


               // Now empty the recipients - New 24 in automations loops only when here.-- STOPED EVERYTHING!!!
               // this.allRecipients = []; // clean array for next loop. -- stop duplicatios!!!!

               // now close the modal
               // this.closeParentModel.emit();
               // this.closeParentModel3.emit();
               // // refresh the invoice page if
               // if ( model.invoice_id > 0 ){
               //   this.refreshSujectInvoicePage.emit(this.subject_id);
               // }
             },
             (error) => {
               // this.toastr.error('Error sending Email');
             //  alert('Error sending email');
               // throwError(() => new Error(error));
               return;
             }
           );


    },
    (err) => console.error(err),
    () => console.log('Client Primary Contact Added.')
  );
 
 
  // const key = 'Primary Contact';
  // this.allRecipients.forEach((value, index) => {
  //   if (value.recipient_type_name === key) {
  //     this.allRecipients.splice(index, 1);
  //     console.log('Removed Primary Contact Recipient');
  //   }
  // });
}
 
 
 
 
      // ebd 2.0


//  this.allRecipients = this.allClientEmailRecipients;
//  model.allRecipients = this.allClientEmailRecipients;
// merger the two models first
//  this.allRecipients = {
//   ...this.allClientEmailRecipients,
//   ...model
//  }
// model.allRecipeints = this.allRecipients;
//  model.bullshit = 'bullshit!!!';









                                            // Update invoice status
                                        // :: @ Update the Invoice Status to Approved+PDF (4)   
                                        // let invoice_model = {
                                        //   invoice_id: model.invoice_id,
                                        //   invoice_communication_status_id: 2,
                                        //     }; 
                                        //   this.updateInvoiceCommunicationStatus(invoice_model);

                          //     // model.message_subject = log_name;
                          //     model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                            
                          //     // original
                          // // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
                          // // comms 2.0
                    
                          // this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


                          //   (data22) => {
                          //     // this.trace_candidate_update = data;
                          //     // this.toastr.success('Sent Email.');
                          //     const res = data22;
                          //     // this.onOpenDialog_SuccessCommunication(model, model);
                          //     // console.log(res); // not working as response is showing in body
                          //     // console.log(res._body);
                          //     // console.log(res[0].text()); // Convert response to a string


                          //     // now close the modal
                          //     // this.closeParentModel.emit();
                          //     // this.closeParentModel3.emit();
                          //     // // refresh the invoice page if
                          //     // if ( model.invoice_id > 0 ){
                          //     //   this.refreshSujectInvoicePage.emit(this.subject_id);
                          //     // }
                          //   },
                          //   (error) => {
                          //     // this.toastr.error('Error sending Email');
                          //   //  alert('Error sending email');
                          //     // throwError(() => new Error(error));
                          //     return;
                          //   }
                          // );





}







 // this function is universal for client or email now. -- SAME AS OTHER WITH NO NOTIFICATIONS....
 sendCommunicationEmailButton_Automation(model) {
  // model.attached_file_name = this.created_file_name;
  // model.attached_file_names = this.selectedFeatures;
  // model.attached_job_file_names = this.selectedFeaturesJobFiles;
  // model.all_attached_file_names = this.allAttachedFiles;
  // model.allAttachments = this.allAttachments;
  // console.log(model.attached_file_names);




  // this.model.allAttachments = this.allAttachments;

 // this.createSubjectNote(model); // Insert a Note to the subject

//   const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
//   console.log('Communication Type Task: ' +  subject_com_type_name);
//       //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
//        //  console.log('Communication Type Task: ' +  subject_com_type_name);
//  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);

   // set the invoice from the list of invoices (first record)
// if(model.invoice_id == null){
//   this.getSubjectInvoices(model.subject_id); // lookup the latest invoice to attach
//   model.invoice_id = this.current_invoice_id;
// }

  const log_action = 'sent';
  // const log_name = 'Subject Document Created Via Button: ' + model.subject_com_type_name  + ' - ' + model.file_display_name + '';
  const log_name = 'Subject Communicaiton Task Automation: ' + model.subject_com_type_name  + ' - ' + this.created_file_name + '';
  const create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_subject_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
    created_level: this.sessionUserLevel,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name + ' - ' + this.returned_created_file_id,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
  };
  this.createSystemLog(create_sys_log);

  const subject_communication_history = {
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_com_type_id: model.subject_com_type_id,
    doc_id: model.doc_id,
    change_dates: model.change_dates,
    additional_message: model.additional_message,
    brand_type_id: model.brand_type_id,
    brand_id: model.brand_id,
    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
    send_to_invoice: model.send_to_invoice,
    send_to_report: model.send_to_report,
    send_to_logins: model.send_to_logins,
    send_to_primary: model.send_to_primary,
    allAttachments: JSON.stringify(model.allAttachments),
    allRecipients: JSON.stringify(model.allRecipients),
    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
    brand_report_id: model.brand_report_id,
    brand_invoice_id: model.brand_invoice_id,
    job_type_name: model.job_type_name,
    job_type_location_name: model.job_type_location_name,
    brand_report_user_id: model.brand_report_user_id,
    email_message_subject: model.email_message_subject,
    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
    message_subject: model.message_subject,
    recipient_name: model.recipient_name,
    recipient_type_name: model.recipient_type_name,
    recipient_email_address: JSON.stringify(model.recipient_email_address),
    email_template_HTML: model.email_template_HTML,
    subject_number: model.subject_number,
    created_by: this.sessionUserId,
    created_date: this.today,
    attached_file_names: JSON.stringify(model.attached_file_names),
    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
    subject_com_type_name: model.subject_com_type_name
  };
  this.createSubjectCommunicationHistory(subject_communication_history);



          // Update invoice status
      // :: @ Update the Invoice Status to Approved+PDF (4)   
      // let invoice_model = {
      //   invoice_id: model.invoice_id,
      //   invoice_communication_status_id: 2,
      //     }; 
      //   this.updateInvoiceCommunicationStatus(invoice_model);

      // model.message_subject = log_name;
       model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
      
  this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
    (data22) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data22;
      // this.onOpenDialog_SuccessCommunication(model, model);
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string


      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
    //  alert('Error sending email');
      // throwError(() => new Error(error));
      return;
    }
  );
}


 // this function is universal for client or email now.
 sendCommunicationEmailButton(model) {
  // model.attached_file_name = this.created_file_name;
  // model.attached_file_names = this.selectedFeatures;
  // model.attached_job_file_names = this.selectedFeaturesJobFiles;
  // model.all_attached_file_names = this.allAttachedFiles;
  // model.allAttachments = this.allAttachments;
  // console.log(model.attached_file_names);




  // this.model.allAttachments = this.allAttachments;

 // this.createSubjectNote(model); // Insert a Note to the subject

//   const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
//   console.log('Communication Type Task: ' +  subject_com_type_name);
//       //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
//        //  console.log('Communication Type Task: ' +  subject_com_type_name);
//  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);

   // set the invoice from the list of invoices (first record)
// if(model.invoice_id == null){
//   this.getSubjectInvoices(model.subject_id); // lookup the latest invoice to attach
//   model.invoice_id = this.current_invoice_id;
// }

  const log_action = 'sent';
  // const log_name = 'Subject Document Created Via Button: ' + model.subject_com_type_name  + ' - ' + model.file_display_name + '';
  const log_name = 'Subject Communicaiton Task Via button: ' + model.subject_com_type_name  + ' - ' + this.created_file_name + '';
  const create_sys_log = {
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: log_action, // automated / updated / created / uploaded / link_created / sent
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_subject_number,
    reference_number: model.job_reference_number,
    subject_number: model.subject_number,
    log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
    created_level: this.sessionUserLevel,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.doc_id,
    log_name: log_name + ' - ' + this.returned_created_file_id,
    file_id: this.returned_created_file_id,
    invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
  };
  this.createSystemLog(create_sys_log);

  const subject_communication_history = {
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_com_type_id: model.subject_com_type_id,
    doc_id: model.doc_id,
    change_dates: model.change_dates,
    additional_message: model.additional_message,
    brand_type_id: model.brand_type_id,
    brand_id: model.brand_id,
    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
    send_to_invoice: model.send_to_invoice,
    send_to_report: model.send_to_report,
    send_to_logins: model.send_to_logins,
    send_to_primary: model.send_to_primary,
    allAttachments: JSON.stringify(model.allAttachments),
    allRecipients: JSON.stringify(model.allRecipients),
    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
    brand_report_id: model.brand_report_id,
    brand_invoice_id: model.brand_invoice_id,
    job_type_name: model.job_type_name,
    job_type_location_name: model.job_type_location_name,
    brand_report_user_id: model.brand_report_user_id,
    email_message_subject: model.email_message_subject,
    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
    message_subject: model.message_subject,
    recipient_name: model.recipient_name,
    recipient_type_name: model.recipient_type_name,
    recipient_email_address: JSON.stringify(model.recipient_email_address),
    email_template_HTML: model.email_template_HTML,
    subject_number: model.subject_number,
    created_by: this.sessionUserId,
    created_date: this.today,
    attached_file_names: JSON.stringify(model.attached_file_names),
    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
    subject_com_type_name: model.subject_com_type_name
  };
  this.createSubjectCommunicationHistory(subject_communication_history);



          // Update invoice status
      // :: @ Update the Invoice Status to Approved+PDF (4)   
      // let invoice_model = {
      //   invoice_id: model.invoice_id,
      //   invoice_communication_status_id: 2,
      //     }; 
      //   this.updateInvoiceCommunicationStatus(invoice_model);

  this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      this.onOpenDialog_SuccessCommunication(model, model);
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string


      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
      alert('Error sending email');
      throwError(() => new Error(error));
    }
  );
}

  // :: Method to all default recipients -- this has been updated in the automation create file and send function June 2023
  setAllRecipients(model) {
    this.allRecipients = [];

  if (model.send_to_report == 1) {
    // 
          // :: Impliments automatic recipients based on chosen com template options
          // :: Subract Method / Filter
          // :: DEMOSERVICE look up client brand details.
          this._demoService.getBrandById(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Report',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Report',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Report Recipient Added.')
          );

      } // end if send_to_report
        
      // AGENT
      if ( model.brand_type_id == 3) { 
        this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - Agent',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Agent',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Agent Recipients Added.')
        );
        // const key = 'Agent';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Agent Recipients');
        //   }
        // });
      };


      // OWNER
      if ( model.brand_type_id == 1) { 
        this._demoService.getBrandById(94).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
               recipient_name: res.name + ' - TSA Owner',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Owner',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('owner Recipient Added.')
        );

    } // end if send_to_owner


      if (model.send_to_report_user == 1) {

        this._demoService.getUsersById(model.brand_report_user_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Report User',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Report User Recipient Added.')
        );
        // const key = 'Client Report User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Report User Recipient');
        //   }
        // });
      };

      if (model.send_to_invoice == 1) {
          this._demoService.getBrandById(model.brand_invoice_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Accounts',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Accounts',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Accounts Recipient Added.')
          );
      }

      if (model.send_to_logins == 1) {
        this._demoService.getBrandUsers(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client User',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client User Recipient Added.')
        );
        // const key = 'Client User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Client User Recipients');
        //   }
        // });
      }

      if (model.send_to_primary == 1) {
        this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Primary Contact',
             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Primary Contact Added.')
        );
       
       
        // const key = 'Primary Contact';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Primary Contact Recipient');
        //   }
        // });
      }

} // end function

  // :: Method to all default recipients
  setAllRecipients_2(model) {
    this.allRecipients = [];





// new additional rendered comm 2.0 variables for emails 
                            // 2.3.1.1
                            model.attempt_paragraph_template = model.attempt_paragraph_template;

                            model.email_template_primary_HTML = model.email_template_primary_HTML; // load the template
                            // model.email_template_primary_HTML_rendered = '';
                            // model.email_subject_primary_rendered = '';
                            model.email_subject_primary = model.email_subject_primary;
                            model.note_template_HTML = model.note_template_HTML;
                            // model.note_template_HTML_rendered = '';
                                // private templates
                            model.email_template_private_HTML = model.email_template_private_HTML; // load the template
                            // model.email_template_private_HTML_rendered = '';
                            // model.email_subject_private_rendered = '';
                            model.email_subject_private = model.email_subject_private;
                            model.note_template_private_HTML = model.note_template_private_HTML;
                            // model.note_template_private_HTML_rendered = '';
                      
                          // mege variables renders
                      this.getJob_and_brands_Q(model.job_id, model) // was missing 2024!!!
                      
                      if(model.job_service_rule_id  != ''&& model.job_service_rule_id  != undefined ){
                      this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
                      }
                      
                      if(model.job_service_timeframe_id  != '' && model.job_service_timeframe_id != undefined){
                      this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
                      }
                      if(model.subject_service_type_id  != '' && model.subject_service_type_id  != undefined){
                      this.getSubjectServiceType_model_Q(model.subject_service_type_id);
                      }
                      
                      this.getSubjectContactNumbers_Q(model.subject_id)
                      
                      this.getSubjectContactEmails_Q(model.subject_id)
                          // Get Subject Agent - F_agent
                      this.getSubjectAgentBrandsAssigned_Q(model.subject_id) // get the first agent ID.????
                      
                      // load subject services (attemps)
                      this.getSubjectAttemptsAll_Q(model.subject_id) // attmpts and attend
                      this.getSubjectServicesOnly_Q(model.subject_id) // service variables
                          // end pre load paragraphs 
                      
                      






// This works !!!!!!






console.log('Sent AllRerpints Model' + JSON.stringify(model))

        this.toastr.warning('Setting Recipiends ' + model.send_to_report )


  if (model.send_to_report == 1) {

                        




    // 

     this.toastr.success('Gathering sending to report informaton')

    // THIS IS wrong as it sets the replacement varaiables without the all_repciepeints ----- As variables>???
    // NEED TO FIX this




          // :: Impliments automatic recipients based on chosen com template options
          // :: Subract Method / Filter
          // :: DEMOSERVICE look up client brand details.
          this._demoService.getBrandById(model.brand_report_id).subscribe(
            (data) => {


             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];

                // if a company
          let is_privacy_emails = res.is_privacy_emails
          let is_privacy_notes = res.is_privacy_notes
          let is_privacy_no_docs = res.is_privacy_no_docs
          let is_privacy_no_emails = res.is_privacy_no_emails
          let is_privacy_no_notes = res.is_privacy_no_notes
          /*
`is_privacy_emails` varchar(11) DEFAULT NULL,
`is_privacy_notes` varchar(11) DEFAULT NULL,
`is_privacy_no_docs` varchar(11) DEFAULT NULL,
`is_privacy_no_emails` varchar(11) DEFAULT NULL,
`is_privacy_no_notes
          */


          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
          let email_template_primary_HTML = model.email_template_primary_HTML;
          let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML

          let email_template_private_HTML = model.email_template_private_HTML;
          let email_subject_private = model.email_subject_private;
          let note_template_private_HTML = model.note_template_private_HTML
                // set the recipent variables in the model first so I have them
          // model.recipient_name = res.name + ' - Client Report'
          model.recipient_name = res.name
          model.recipient_email_address = res.email
          model.recipient_brand_id = res.brand_id
          model.recipient_brand_type_id = res.brand_type_id
          model.recipient_user_id  = null
          model.recipient_user_level_id = null
          model.recipient_type_name ='Client Report'
        
        
          let rendered_email;
          let rendered_subject;
          let rendered_note;
          let rendered_email_private;
          let rendered_subject_private;
          let rendered_note_private;
 
// Lets see if I can Link Directly to the function on the  SubjectCommunicationWithVarsComponent -- stupid I will get the cyclic loop crapp.. so havt to recreati

          if(is_privacy_emails == 1){
           rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
           rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
         }else{
         rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
         rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
         }

        //  if(is_privacy_notes == 1){
        //    rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
        //  }else{
        //  rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
        //  }
     
        
        
          // let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          // let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

          // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
          // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
          // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)

               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Report',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Report',
                 ...model,
                 email_subject_primary_rendered: rendered_subject,
                 email_template_primary_HTML_rendered: rendered_email,
                 note_template_HTML_rendered: rendered_note,

                //  email_subject_private_rendered: rendered_subject_private,
                //  email_template_private_HTML_rendered: rendered_email_private,
                //  note_template_private_HTML_rendered: rendered_note_private,

                 is_privacy_emails: is_privacy_emails,
                 is_privacy_notes: is_privacy_notes,
                 is_privacy_no_docs: is_privacy_no_docs,
                 is_privacy_no_emails: is_privacy_no_emails,
                 is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.
           model.allRecipients = this.allRecipients;

           

           
                          //     // model.message_subject = log_name;
                          //     model.message_subject = model.email_subject_header + ' Your Reference: ' + model.owner_trace_code + ' Our Reference: ' + model.subject_number ; // sets from the defauilt in the template.
                            
                          //     // original
                          // // this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
                          // // comms 2.0
                    
                          // this._mysqlService.sendAgentCommunicationEmailWithVars(model).subscribe(


                          //   (data22) => {
                          //     // this.trace_candidate_update = data;
                          //     // this.toastr.success('Sent Email.');
                          //     const res = data22;
                          //     // this.onOpenDialog_SuccessCommunication(model, model);
                          //     // console.log(res); // not working as response is showing in body
                          //     // console.log(res._body);
                          //     // console.log(res[0].text()); // Convert response to a string


                          //     // now close the modal
                          //     // this.closeParentModel.emit();
                          //     // this.closeParentModel3.emit();
                          //     // // refresh the invoice page if
                          //     // if ( model.invoice_id > 0 ){
                          //     //   this.refreshSujectInvoicePage.emit(this.subject_id);
                          //     // }
                          //   },
                          //   (error) => {
                          //     // this.toastr.error('Error sending Email');
                          //   //  alert('Error sending email');
                          //     // throwError(() => new Error(error));
                          //     return;
                          //   }
                          // );

  

            },
            (err) => console.error(err),
            () => console.log('Client Report Recipient Added.')
          );

      } // end if send_to_report
        
      // AGENT
      if ( model.brand_type_id == 3) { 
        this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];

             let email_template_primary_HTML = model.email_template_primary_HTML;
             let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML

          

                   // set the recipent variables in the model first so I have them
            //  model.recipient_name = res.name + ' - Agent'
             model.recipient_name = res.name
             model.recipient_email_address = res.email
             model.recipient_brand_id = res.brand_id
             model.recipient_brand_type_id = res.brand_type_id
             model.recipient_user_id  = null
             model.recipient_user_level_id = null
             model.recipient_type_name = 'Agent'

             let is_privacy_emails = res.is_privacy_emails
             let is_privacy_notes = res.is_privacy_notes
             let is_privacy_no_docs = res.is_privacy_no_docs
             let is_privacy_no_emails = res.is_privacy_no_emails
             let is_privacy_no_notes = res.is_privacy_no_notes

             let email_template_private_HTML = model.email_template_private_HTML;
             let email_subject_private = model.email_subject_private;
             let note_template_private_HTML = model.note_template_private_HTML

             let rendered_email;
             let rendered_subject;
             let rendered_note;
             let rendered_email_private;
             let rendered_subject_private;
             let rendered_note_private;
 
             if(is_privacy_emails == 1){
              rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
            }else{
            rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            rendered_subject = this.runReplaceAllVariables(email_subject_primary, model) // WHY IS THIS CREATING ERRORS??? -- THERE MUST BE A SUBJECT!!!!
            }
 
            if(is_privacy_notes == 1){
              rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
            }else{
            rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
            }
        



          //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

             this.allRecipients.push({
               recipient_name: res.name + ' - Agent',
               recipient_email_address: res.email,
               recipient_brand_id: res.brand_id,
               recipient_brand_type_id: res.brand_type_id,
               recipient_user_id: null,
               recipient_user_level_id: null,
               recipient_type_name: 'Agent',
               ...model,
               email_subject_primary_rendered: rendered_subject,
               email_template_primary_HTML_rendered: rendered_email,
               note_template_HTML_rendered: rendered_note,

               is_privacy_emails: is_privacy_emails,
               is_privacy_notes: is_privacy_notes,
               is_privacy_no_docs: is_privacy_no_docs,
               is_privacy_no_emails: is_privacy_no_emails,
               is_privacy_no_notes: is_privacy_no_notes,

             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Agent Recipients Added.')
        );
        // const key = 'Agent';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Agent Recipients');
        //   }
        // });
      };

      if (model.send_to_report_user == 1) {

        this._demoService.getUsersById(model.brand_report_user_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];

          //  console.log('Respones: ' + JSON.stringify(res))

          let email_template_primary_HTML = model.email_template_primary_HTML
          let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML


          let email_template_private_HTML = model.email_template_private_HTML;
          let email_subject_private = model.email_subject_private;
          let note_template_private_HTML = model.note_template_private_HTML
          
          // these are different for the user as I have to lookup brand first
          let user_brand_id = res.brand_id;
          //get brand ---
          // this.getUserBrand_Q(user_brand_id); -- Instead Loop these up in the API data and send back with the user details - is_privacy_email (that way its set at a brand level for all users and I have access to these variables without another lookup here.)
                    // added to user API not actual user data.
          let is_privacy_emails = res.is_privacy_emails
          let is_privacy_notes = res.is_privacy_notes
          let is_privacy_no_docs = res.is_privacy_no_docs
          let is_privacy_no_emails = res.is_privacy_no_emails
          let is_privacy_no_notes = res.is_privacy_no_notes
          
          // model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client Report User',
          model.recipient_name = res.first_name +  ' ' + res.surname,
          model.recipient_email_address = res.email_address,
          model.recipient_brand_id = null
          model.recipient_brand_type_id = null
          model.recipient_user_id  = res.user_id,
          model.recipient_user_level_id = null
          model.recipient_type_name = 'Client Report User'
        
          let rendered_email;
          let rendered_subject;
          let rendered_note;
          let rendered_email_private;
          let rendered_subject_private;
          let rendered_note_private;

          if(is_privacy_emails == 1){
            rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
            rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
          }else{
          rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          }

          if(is_privacy_notes == 1){
            rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
          }else{
          rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
          }

          // rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          // rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


          // TOO MANY CONNECTIONS --- Breaks scripts with many errors so need to limit the replacements.
          // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
          // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
          // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)
          
             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Report User',
            ...model,
            email_subject_primary_rendered: rendered_subject,
            email_template_primary_HTML_rendered: rendered_email,
            note_template_HTML_rendered: rendered_note,

            // email_subject_private_rendered: rendered_subject_private,
            // email_template_private_HTML_rendered: rendered_email_private,
            // note_template_private_HTML_rendered: rendered_note_private,

            is_privacy_emails: is_privacy_emails,
            is_privacy_notes: is_privacy_notes,
            is_privacy_no_docs: is_privacy_no_docs,
            is_privacy_no_emails: is_privacy_no_emails,
            is_privacy_no_notes: is_privacy_no_notes,

             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Report User Recipient Added.')
        );
        // const key = 'Client Report User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Report User Recipient');
        //   }
        // });
      };

      if (model.send_to_invoice == 1) {
          this._demoService.getBrandById(model.brand_invoice_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];

               let email_template_primary_HTML = model.email_template_primary_HTML;
               let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML


          let email_template_private_HTML = model.email_template_private_HTML;
          let email_subject_private = model.email_subject_private;
          let note_template_private_HTML = model.note_template_private_HTML

          let is_privacy_emails = res.is_privacy_emails
          let is_privacy_notes = res.is_privacy_notes
          let is_privacy_no_docs = res.is_privacy_no_docs
          let is_privacy_no_emails = res.is_privacy_no_emails
          let is_privacy_no_notes = res.is_privacy_no_notes

                     // set the recipent variables in the model first so I have them
              //  model.recipient_name = res.name + ' - Client Accounts'
               model.recipient_name = res.name
               model.recipient_email_address = res.email
               model.recipient_brand_id = res.brand_id
               model.recipient_brand_type_id = res.brand_type_id
               model.recipient_user_id  = null
               model.recipient_user_level_id = null
               model.recipient_type_name = 'Client Accounts'


               let rendered_email;
               let rendered_subject;
               let rendered_note;
               let rendered_email_private;
               let rendered_subject_private;
               let rendered_note_private;

               if(is_privacy_emails == 1){
                rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
                rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
              }else{
              rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
              }
  
              if(is_privacy_notes == 1){
                rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
              }else{
              rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
              }
          
               
          // let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          // let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)

          // To many quieries... instead change the above on an if staement and replace the rendered content instead!!!!!!!!!!
          // let rendered_email_private = this.runReplaceAllVariables(email_template_private_HTML, model)
          // let rendered_subject_private = this.runReplaceAllVariables(email_subject_private, model)
          // let rendered_note_private = this.runReplaceAllVariables(note_template_private_HTML, model)

               this.allRecipients.push({
                 recipient_name: res.name + ' - Client Accounts',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Client Accounts',
                 ...model,
                 email_subject_primary_rendered: rendered_subject,
                 email_template_primary_HTML_rendered: rendered_email,
                 note_template_HTML_rendered: rendered_note,

                //  email_subject_private_rendered: rendered_subject_private,
                //  email_template_private_HTML_rendered: rendered_email_private,
                //  note_template_private_HTML_rendered: rendered_note_private,
                 
                 is_privacy_emails: is_privacy_emails,
                 is_privacy_notes: is_privacy_notes,
                 is_privacy_no_docs: is_privacy_no_docs,
                 is_privacy_no_emails: is_privacy_no_emails,
                 is_privacy_no_notes: is_privacy_no_notes,

               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Accounts Recipient Added.')
          );
      }

      if (model.send_to_logins == 1) {
        this._demoService.getBrandUsers(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];

             let email_template_primary_HTML = model.email_template_primary_HTML;
             let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML

                   // set the recipent variables in the model first so I have them
            //  model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client User'
             model.recipient_name = res.first_name +  ' ' + res.surname
             model.recipient_email_address = res.email_address
             model.recipient_brand_id = null
             model.recipient_brand_type_id = null
             model.recipient_user_id  = res.user_id
             model.recipient_user_level_id = res.access_level
             model.recipient_type_name = 'Client User'


             let is_privacy_emails = res.is_privacy_emails
             let is_privacy_notes = res.is_privacy_notes
             let is_privacy_no_docs = res.is_privacy_no_docs
             let is_privacy_no_emails = res.is_privacy_no_emails
             let is_privacy_no_notes = res.is_privacy_no_notes

             let email_template_private_HTML = model.email_template_private_HTML;
             let email_subject_private = model.email_subject_private;
             let note_template_private_HTML = model.note_template_private_HTML

             let rendered_email;
             let rendered_subject;
             let rendered_note;
             let rendered_email_private;
             let rendered_subject_private;
             let rendered_note_private;
 
             if(is_privacy_emails == 1){
              rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
            }else{
            rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            }
 
            if(is_privacy_notes == 1){
              rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
            }else{
            rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
            }
        
          //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client User',
            ...model,
            email_subject_primary_rendered: rendered_subject,
            email_template_primary_HTML_rendered: rendered_email,
            note_template_HTML_rendered: rendered_note,

            is_privacy_emails: is_privacy_emails,
            is_privacy_notes: is_privacy_notes,
            is_privacy_no_docs: is_privacy_no_docs,
            is_privacy_no_emails: is_privacy_no_emails,
            is_privacy_no_notes: is_privacy_no_notes,

             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client User Recipient Added.')
        );
        // const key = 'Client User';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Client User Recipients');
        //   }
        // });
      }

      if (model.send_to_primary == 1) {
        this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];

             let email_template_primary_HTML = model.email_template_primary_HTML;
             let email_subject_primary = model.email_subject_primary;
          let note_template_HTML = model.note_template_HTML

                   // set the recipent variables in the model first so I have them
            //  model.recipient_name = res.first_name +  ' ' + res.surname + ' - Client Primary Contact'
             model.recipient_name = res.first_name +  ' ' + res.surname
             model.recipient_email_address = res.email_address
             model.recipient_brand_id = null
             model.recipient_brand_type_id = null
             model.recipient_user_id  = res.user_id
             model.recipient_user_level_id = res.access_level
             model.recipient_type_name = 'Client Primary Contact'

             let is_privacy_emails = res.is_privacy_emails
             let is_privacy_notes = res.is_privacy_notes
             let is_privacy_no_docs = res.is_privacy_no_docs
             let is_privacy_no_emails = res.is_privacy_no_emails
             let is_privacy_no_notes = res.is_privacy_no_notes

             let email_template_private_HTML = model.email_template_private_HTML;
             let email_subject_private = model.email_subject_private;
             let note_template_private_HTML = model.note_template_private_HTML

             let rendered_email;
             let rendered_subject;
             let rendered_note;
             let rendered_email_private;
             let rendered_subject_private;
             let rendered_note_private;
 
             if(is_privacy_emails == 1){
              rendered_email = this.runReplaceAllVariables(email_template_private_HTML, model)
              rendered_subject = this.runReplaceAllVariables(email_subject_private, model)
            }else{
            rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
            rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
            }
 
            if(is_privacy_notes == 1){
              rendered_note = this.runReplaceAllVariables(note_template_private_HTML, model)
            }else{
            rendered_note = this.runReplaceAllVariables(note_template_HTML, model)
            }
        

          //    let rendered_email = this.runReplaceAllVariables(email_template_primary_HTML, model)
          //    let rendered_subject = this.runReplaceAllVariables(email_subject_primary, model)
          // let rendered_note = this.runReplaceAllVariables(note_template_HTML, model)


             this.allRecipients.push({
            recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
            recipient_email_address: res.email_address,
            recipient_brand_id: null,
            recipient_brand_type_id: null,
            recipient_user_id: res.user_id,
            recipient_user_level_id: res.access_level,
            recipient_type_name: 'Client Primary Contact',
            ...model,
            email_subject_primary_rendered: rendered_subject,
            email_template_primary_HTML_rendered: rendered_email,
            note_template_HTML_rendered: rendered_note,

            is_privacy_emails: is_privacy_emails,
            is_privacy_notes: is_privacy_notes,
            is_privacy_no_docs: is_privacy_no_docs,
            is_privacy_no_emails: is_privacy_no_emails,
            is_privacy_no_notes: is_privacy_no_notes,

             });
             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          },
          (err) => console.error(err),
          () => console.log('Client Primary Contact Added.')
        );
       
       
        // const key = 'Primary Contact';
        // this.allRecipients.forEach((value, index) => {
        //   if (value.recipient_type_name === key) {
        //     this.allRecipients.splice(index, 1);
        //     console.log('Removed Primary Contact Recipient');
        //   }
        // });
      }














} // end function



   // Create New Type of note: -- This function loops the recipients and adds note for each recipent with email content rendered
   createSubjectNote_with_vars(model) {
    
this.toastr.info('starting comms note automation')

    let  count_of_items = this.allRecipients.length;
    for(let i=0; i < count_of_items; i++) {

                     // does not make a note if checked in company profile. - no notes
     if( this.allRecipients[i].is_privacy_no_notes != 1){ 
                  // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
                  model.created_by = this.sessionUserId;
                  // model.note_content =
                  //   'Instruct request emailed to the agent. Manual From Subject Card Screen.';

                  // model.note_content = model.note_template_HTML_rendered;  THIS NEED A FIX AND LOOP!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                  /// this needs to be decoded first. -- Appends Email Conent to the note (notes are differernt to emails and need decodeing to save in database)


                  // Email does filter at PHP level I think.... easier... that way
                  // privacy enfforcement --- NEED TO SUB CHECKS FOR EMAILS (contents)... and notes creations as well
                                  // if(this.allRecipients[i].is_privacy_notes == 1 ){
                                  //   model.note_content =this.transform2(this.allRecipients[i].note_template_private_HTML_rendered);
                                  // }else{
                                  //   model.note_content = this.transform2(this.allRecipients[i].note_template_HTML_rendered + '<p>Email Contents</p>' + this.allRecipients[i].email_template_primary_HTML_rendered ); // decode first.
                                  // }

                let append_email_cc = '';
                let append_email_bcc = '';
                if(this.allRecipients[i].email_cc){
                append_email_cc = '<p>Email Was CC: ' + this.allRecipients[i].email_cc + '</p>'
                }
                if(this.allRecipients[i].email_bcc){
                append_email_bcc = '<p>Email Was BCC: ' + this.allRecipients[i].email_bcc + '</p>'
                }

                
                // append to email checker,
                if(model.append_email_to_note == 1){
                // privacy level replaced at UI....
                model.note_content = this.transform2(this.allRecipients[i].note_template_HTML_rendered + '<p>Email Contents</p>' + this.allRecipients[i].email_template_primary_HTML_rendered ) + append_email_cc + append_email_bcc ; // decode first.

                }else{
                      // privacy level replaced at UI....
                model.note_content = this.transform2(this.allRecipients[i].note_template_HTML_rendered)  + append_email_cc + append_email_bcc ; // decode first.

                }


 
                  model.note_type_id = '1';

                  // this.toastr.info('Creating A Note Tempalate with vars :)')

                  // need to check if this effects the others on insert
                  // this.RemoveElementOthersFromAllRecipients(model.subject_id);
                  // currentlu saves all the recipients into the array and filters out at read

                    // WHEN CREATING A NEW NOTE FROM TEMPLATE!..... Let do a new function.....
                  // NEW 2.0 Version I will need to looop throughthe arrays and add all recipient notes....... to the file.
                  model.assigned_to_agents = JSON.stringify(this.allRecipients);
                  console.log('model.assigned_to_agents: ', model.assigned_to_agents);  // MAY NEED TO CHANGE THIS AND REDUCE THE DATA??????

                  // if (result.job_status === 'OPEN'){
                              this._demoService.createSubjectNoteWithVars(model).subscribe(
                                (data2) => {
                                 let  res2 = data2[0]            
                                 this.set_last_inserted_note = data2;   
                                  this.get_latest_subject_note_id = this.set_last_inserted_note.last_insert_id; // this is the retuned json upon creation.
                                  // console.log('Note Lasdt Insert ID:' + this.get_latest_subject_note_id)
                                  // this.toastr.info('Note Added:  ' +  this.allRecipients[i].recipient_name);
                                  // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                                  // this.search_results[objIndex].note_added = 'yes';


                                  // COMM HISTORY.
                                  // return the last insert ID of Note to insert into communication history every and add to model.

                                  // Ry a neste dLoop Here
                                  let subject_communication_history = {
                                    job_id: model.job_id,
                                    subject_id: model.subject_id,
                                    subject_com_type_id: model.subject_com_type_id,
                                    doc_id: model.doc_id,
                                    change_dates: model.change_dates,
                                    additional_message: model.additional_message,
                                    brand_type_id: model.brand_type_id,
                                    brand_id: model.brand_id,
                                    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
                                    send_to_invoice: model.send_to_invoice,
                                    send_to_report: model.send_to_report,
                                    send_to_logins: model.send_to_logins,
                                    send_to_primary: model.send_to_primary,
                                    allAttachments: JSON.stringify(model.allAttachments),
                                    allRecipients: JSON.stringify(model.allRecipients),
                                    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
                                    brand_report_id: model.brand_report_id,
                                    brand_invoice_id: model.brand_invoice_id,
                                    job_type_name: model.job_type_name,
                                    job_type_location_name: model.job_type_location_name,
                                    brand_report_user_id: model.brand_report_user_id,

                                    //missing
                                       assigned_to_agents: JSON.parse(model.assigned_to_agents), // so array() is not inserted [] must be set as anobject

                                    
                                    email_message_subject: this.allRecipients[i].email_message_subject,
                                    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
                                    message_subject: this.allRecipients[i].message_subject,
                                    // recipient_name: model.recipient_name,
                                    // recipient_type_name: model.recipient_type_name,
                                    // recipient_email_address: JSON.stringify(model.recipient_email_address),
                                    recipient_name: this.allRecipients[i].recipient_name,
                                    recipient_type_name: this.allRecipients[i].recipient_type_name,
                                    recipient_email_address: this.allRecipients[i].recipient_email_address,
                              
                                    email_template_HTML: this.allRecipients[i].email_template_HTML,
                                    subject_number: this.allRecipients[i].subject_number,
                                    created_by: this.sessionUserId,
                                    created_date: this.today,
                                    attached_file_names: JSON.stringify(model.attached_file_names),
                                    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
                                    subject_com_type_name: model.subject_com_type_name,
                                    // New Nov 2023 Fields. Captured
                                    email_template_primary_HTML_rendered: this.allRecipients[i].email_template_primary_HTML_rendered,
                                    email_subject_primary_rendered: this.allRecipients[i].email_subject_primary_rendered,
                                    note_template_HTML_rendered: this.allRecipients[i].note_template_HTML_rendered,
                                    email_template_private_HTML_rendered: this.allRecipients[i].email_template_private_HTML_rendered,
                                    email_subject_private_rendered: this.allRecipients[i].email_subject_private_rendered,
                                    note_template_private_HTML_rendered: this.allRecipients[i].note_template_private_HTML_rendered,
                                    is_privacy_emails: this.allRecipients[i].is_privacy_emails,
                                    is_privacy_notes: this.allRecipients[i].is_privacy_notes,
                                    is_privacy_no_docs: this.allRecipients[i].is_privacy_no_docs,
                                    is_privacy_no_emails: this.allRecipients[i].is_privacy_no_emails,
                                    is_privacy_no_notes: this.allRecipients[i].is_privacy_no_notes,
                                    created_note_id: this.get_latest_subject_note_id, // from above loop
                                    created_file_id: this.returned_created_file_id,
                                    email_bcc: this.allRecipients[i].email_bcc,
                                    email_cc: this.allRecipients[i].email_cc,
                              

                                    job_type_id: model.job_type_id,
                                    job_type_location_id: model.job_type_location_id,
                                   job_type_court_id: model.job_type_court_id,
                                   job_type_document_type_id: model.job_type_document_type_id,
                                   job_type_affidavit_type_id: model.job_type_affidavit_type_id,
                                   log_content: JSON.stringify(model)
                                    // 
                                    // email_cc
                                    
                                /*
                                 */
                                
                                  };
                              
                              
                                    this._demoService.createSubjectCommunicationHistory(subject_communication_history).subscribe(
                                      data => { 
                                        this.subject_communication_history_created_response = data;
                                      // this.toastr.success('Communication History Created with vars' + this.allRecipients[i].recipient_name)
                                      // console.log('Comms History Model: ' + JSON.stringify(model))


                                                  // const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
                                                   
                                                  let doc_name;
                                                  // doc_name = document.getElementById('doc_name').innerText; // removed may 24

                                                      // thrid nest create log
                                                      const log_action = 'sent';
                                                      const log_name = 'Subject Communicaiton 2.0 Task: ' + model.subject_com_type_name  + ' - ' + model.doc_name + ' - ' + this.allRecipients[i].recipient_name;
                                                      const create_sys_log = {
                                                        log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                                                        log_action: log_action, // automated / updated / created / uploaded / link_created / sent
                                                        created_by: this.sessionUserId,
                                                        created_date: this.todayDate,
                                                        subject_id: model.subject_id,
                                                        job_id: model.job_id,
                                                        job_reference_number: model.job_reference_number,
                                                        file_number: model.file_subject_number,
                                                        reference_number: model.job_reference_number,
                                                        subject_number: model.subject_number,
                                                        log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
                                                        created_level: this.sessionUserLevel,
                                                        brand_type_id: model.brand_type_id,
                                                        subject_com_type_id: model.subject_com_type_id,
                                                        subject_template_doc_id: model.doc_id,
                                                        log_name: log_name,
                                                        file_id: this.returned_created_file_id,
                                                        invoice_id: model.invoice_id,
                                                        brand_id: model.brand_id,
                                                        note_id: this.get_latest_subject_note_id, // from above loop
                                                                            //missing
                                                      assigned_to_agents: JSON.parse(model.assigned_to_agents), // so array() is not inserted [] must be set as anobject

                                                      };
                                                      this.createSystemLog(create_sys_log);


                                      },
                                      err => console.error(err),
                                      // () => console.log('done loading Trace Types')
                                    );
                              
                                // end nested loop.


                                },
                                (error) => {
                                  // console.log(error(error));
                                  //return console.log(error);
                                  // this.toastr.error('Note NOT Added  ' +  this.allRecipients[i].recipient_name);

                                }
                              );
                  // } // end if  open


          }else{ // if NO NOTES on
          // we still need to insert the comms log with no note ID
           // TODO
                // //  this.createSubjectCommunicationHistory_with_vars(model);
                //             const subject_communication_history = {
                //               job_id: model.job_id,
                //               subject_id: model.subject_id,
                //               subject_com_type_id: model.subject_com_type_id,
                //               doc_id: model.doc_id,
                //               change_dates: model.change_dates,
                //               additional_message: model.additional_message,
                //               brand_type_id: model.brand_type_id,
                //               brand_id: model.brand_id,
                //               all_attached_file_names: JSON.stringify(model.all_attached_file_names),
                //               send_to_invoice: model.send_to_invoice,
                //               send_to_report: model.send_to_report,
                //               send_to_logins: model.send_to_logins,
                //               send_to_primary: model.send_to_primary,
                //               allAttachments: JSON.stringify(model.allAttachments),
                //               allRecipients: JSON.stringify(model.allRecipients),
                //               allAttachedFiles: JSON.stringify(model.allAttachedFiles),
                //               brand_report_id: model.brand_report_id,
                //               brand_invoice_id: model.brand_invoice_id,
                //               job_type_name: model.job_type_name,
                //               job_type_location_name: model.job_type_location_name,
                //               brand_report_user_id: model.brand_report_user_id,
                              
                //               email_message_subject: this.allRecipients[i].email_message_subject,
                //               email_message_recipeints: JSON.stringify(model.email_message_recipeints),
                //               message_subject: this.allRecipients[i].message_subject,
                //               // recipient_name: model.recipient_name,
                //               // recipient_type_name: model.recipient_type_name,
                //               // recipient_email_address: JSON.stringify(model.recipient_email_address),
                //               recipient_name: this.allRecipients[i].recipient_name,
                //               recipient_type_name: this.allRecipients[i].recipient_type_name,
                //               recipient_email_address: this.allRecipients[i].recipient_email_address,
                        
                //               email_template_HTML: this.allRecipients[i].email_template_HTML,
                //               subject_number: this.allRecipients[i].subject_number,
                //               created_by: this.sessionUserId,
                //               created_date: this.today,
                //               attached_file_names: JSON.stringify(model.attached_file_names),
                //               attached_job_file_names: JSON.stringify(model.attached_job_file_names),
                //               subject_com_type_name: model.subject_com_type_name,
                //               // New Nov 2023 Fields. Captured
                //               email_template_primary_HTML_rendered: this.allRecipients[i].email_template_primary_HTML_rendered,
                //               email_subject_primary_rendered: this.allRecipients[i].email_subject_primary_rendered,
                //               note_template_HTML_rendered: this.allRecipients[i].note_template_HTML_rendered,
                //               email_template_private_HTML_rendered: this.allRecipients[i].email_template_private_HTML_rendered,
                //               email_subject_private_rendered: this.allRecipients[i].email_subject_private_rendered,
                //               note_template_private_HTML_rendered: this.allRecipients[i].note_template_private_HTML_rendered,
                //               is_privacy_emails: this.allRecipients[i].is_privacy_emails,
                //               is_privacy_notes: this.allRecipients[i].is_privacy_notes,
                //               is_privacy_no_docs: this.allRecipients[i].is_privacy_no_docs,
                //               is_privacy_no_emails: this.allRecipients[i].is_privacy_no_emails,
                //               is_privacy_no_notes: this.allRecipients[i].is_privacy_no_notes,
                //               created_note_id: this.get_latest_subject_note_id, // from above loop
                //               created_file_id: this.returned_created_file_id,
                //               email_bcc: this.allRecipients[i].email_bcc,
                //               email_cc: this.allRecipients[i].email_cc,

                //               job_type_id: model.job_type_id,
                //               job_type_location_id: model.job_type_location_id,
                //              job_type_court_id: model.job_type_court_id,
                //              job_type_document_type_id: model.job_type_document_type_id,
                //              job_type_affidavit_type_id: model.job_type_affidavit_type_id,
                //              log_content: JSON.stringify(model)
                        
                //               // 
                //               // email_cc
                              
                //           /*
                //            */
                          
                //             };
                //              this.gfunc.createSubjectCommunicationHistory(subject_communication_history); // run the original Function Here if NO NOTES ON. (single NOt looped as contained in loop.)
          } // en dif no notes on
            // end if send note privacy checker

    } // end loop

    
   

  }




  // Job and Subject Focus
  runReplaceAllVariables(str, model){
  
         // New load the attending agent
         // Load this if the attempts_paragraph model exists.
         if(this.attempts_paragraphs_model){
this.getBrand_Q(this.attempts_paragraphs_model.who_service_id) // ???
         }


    if(model.job_type_location_id != '' || model.job_type_location_id != '' ){ 
      this.getJobTypeLocation_Q(model.job_type_location_id);
    }
        
    if(model.job_type_location_id != '' || model.job_type_location_id != '' ){ 
    this.getJobTypeLocation_Q(model.job_type_location_id); // 
    }
    if(model.job_type_court_id != '' || model.job_type_court_id != '' ){ 
        this.getJobTypeCourt_Q(model.job_type_court_id);       // 
    }
    if(model.job_type_document_type_id != '' || model.job_type_document_type_id != '' ){ 
        this.getJobTypeDocumentType_Q(model.job_type_document_type_id)
    }
    if(model.job_type_affidavit_type_id != '' || model.job_type_affidavit_type_id != '' ){ 
        this.getJobTypeAffidavitType_Q(model.job_type_affidavit_type_id);
    }
        // console.log('Brand invoice ID: ' + this.brand_invoice_id);
    
        // Moved to getJob() -- this worked
              // this.getBrand_invoice_Q(model.brand_invoice_id) 
              // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
              // this.getJobReportUserContact_Q(model.brand_report_user_id)
              //  this.getCurrentUser_Q(this.gfunc.sessionUserId);
        
      
    
    
          // moved to get()Subject --
              // Get Subject Agent - F_agent
              // this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????
          // this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
          // this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
          // this.getSubjectServiceType_model_Q(model.subject_service_type_id);
    
          // this.getSubjectContactNumbers_Q(model.subject_id)
          // this.getSubjectContactEmails_Q(model.subject_id)
    
        // console.log('this.job_data_paragraphs: ' + JSON.stringify(this.job_data_paragraphs))
    
    
          if(model.job_id != ''){ 
    
            // Uppercese
            if ( this.job_data_paragraphs  && this.job_data_paragraphs != ''  ){
              this.registry_name = this.job_data_paragraphs[0].registry_name;
            let var_job_registry_name = this.job_data_paragraphs[0].registry_name;
            if(var_job_registry_name != null){
            this.job_registry_name_Upper = var_job_registry_name.toUpperCase();
            }
           }
            // Uppercese
            if ( this.job_type_paragraphs && this.job_type_paragraphs != '' ){
              this.job_type_name = this.job_type_paragraphs[0].job_type_name;
            let var_job_type_name = this.job_type_paragraphs[0].job_type_name;
            if(var_job_type_name != null){
            this.job_type_name_Upper = var_job_type_name.toUpperCase();
            }
             }
            // Uppercese
            // console.log('job_type_location_paragraphs: ' + this.job_type_location_paragraphs);
            if ( this.job_type_location_paragraphs && this.job_type_location_paragraphs != '' ){
              this.job_type_location_name = this.job_type_location_paragraphs[0].job_type_location_name;
            let var_job_type_location_name = this.job_type_location_paragraphs[0].job_type_location_name;
            if(var_job_type_location_name != null){
            this.job_type_location_name_Upper = var_job_type_location_name.toUpperCase();
            }
          }
            // Uppercese
            if ( this.job_type_court_paragraphs && this.job_type_court_paragraphs != '' ){
              this.job_type_court_name = this.job_type_court_paragraphs[0].job_type_court_name;
            let var_job_type_court_name = this.job_type_court_paragraphs[0].job_type_court_name;
            if(var_job_type_court_name != null){
            this.job_type_court_name_Upper = var_job_type_court_name.toUpperCase();
            }
          }
            // Uppercese
            if ( this.job_type_document_type_paragraphs && this.job_type_document_type_paragraphs != '' ){
              this.job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name
              // console.log(this.job_type_document_type_paragraphs)
            let var_job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name;
            if(var_job_type_document_type_name != null){
            this.job_type_document_type_name_Upper = var_job_type_document_type_name.toUpperCase();
            }
            }
    
            //model.job_subject_type_name.toUpperCase() 
                           
       }     
           
    
    
        
       // just if emtpies.
       if ( this.job_service_rule_paragraphs && this.job_service_rule_paragraphs != '' ){
       this.job_service_rule_name = this.job_service_rule_paragraphs[0].job_service_rule_name 
       this.job_service_rule_description = this.job_service_rule_paragraphs[0].job_service_rule_description 
       }
    
       if ( this.job_service_timeframe_paragraphs && this.job_service_timeframe_paragraphs != '' ){
       this.job_service_timeframe_name = this.job_service_timeframe_paragraphs[0].job_service_timeframe_name
       this.job_service_timeframe_text = this.job_service_timeframe_paragraphs[0].job_service_timeframe_text
       }
    
       if ( this.subject_service_type_model_paragraphs && this.subject_service_type_model_paragraphs != '' ){
       this.subject_service_type_name = this.subject_service_type_model_paragraphs[0].subject_service_type_name 
       this.subject_service_type_description =  this.subject_service_type_model_paragraphs[0].subject_service_type_description
       this.subject_service_type_staff_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_staff_instructions
       this.subject_service_type_agent_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_agent_instructions
       this.subject_service_type_instructions = this.subject_service_type_model_paragraphs[0].subject_service_type_instructions 
       }
    
      // Must check for nulls first and set as a variable.
      if(model.job_type_affidavit_type_paragraphs && model.job_type_affidavit_type_paragraphs != '' ){
        this.job_type_affidavit_type_name = this.job_type_affidavit_type_paragraphs[0].job_type_affidavit_type_name
        this.job_type_affidavit_type_name_Upper = this.job_type_affidavit_type_name.toUpperCase();
      }
      if(model.job_subject_type_name && model.job_subject_type_name  != '' ){
        this.job_subject_type_name = model.job_subject_type_name;
        this.job_subject_type_name_Upper = this.job_subject_type_name.toUpperCase();
      }
      
      
      if(model.job_subject_type_id && model.job_subject_type_id != '' ){
        this.getJobSubjectType_Q(model.job_subject_type_id) ;
         }
      
      
      
      // Subject Conversions from model
            // // Uppercese
            if(this.job_type_document_type_paragraphs && this.job_type_document_type_paragraphs != '' ){
            let var_job_type_document_type_name = this.job_type_document_type_paragraphs[0].job_type_document_type_name;
            if(var_job_type_document_type_name != null){
            this.job_type_document_type_name_Upper = var_job_type_document_type_name.toUpperCase();
            }
          }
      
      
      
      
           // Attempt Agent Details
            // if(model.who_service != ''){
            //   this.getBrand_Q(model.who_service);
            //  }
         
             // Job report client
            if(model.brand_report_id != ''){
              this.getBrand_report_Q(model.brand_report_id);
             }
      
      
      
      
      // Set some variables
        // Do checks for subject name / Businesss Name of FUll SUbject Name fields
        let var_subject_name =  model.first_name + ' ' +  model.middlename + ' '+  model.surname;
        let var_subject_name_4_doc = model.first_name +'-'+  model.surname;
        let var_subject_business_name =  model.business_name;
        
        // Subject Name of Business
            if(var_subject_business_name != null){
                let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
                // $subject_name = $trim_subject_business_name;
                 var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
                  var_subject_name_4_doc= var_trim_subject_business_name;
                
            }
        
      // Subject Genders -- based on passed model.
      if (model.sex == 'femail' || model.sex  == 'female'){
      this.subject_gender_descriptor = "Female";
      }
      if (model.sex == 'mail'){
      this.subject_gender_descriptor = "Male";
      }
      if (model.sex == '' || model.sex == null){
        this.subject_gender_descriptor = "The Person";
        }
      
    
        
    // this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
    this.message_subject_var = 'Subject: ' +  model.email_subject + ' Our Reference: '  + this.subject_number;
    
    if(model.subject_com_type_id == 3){
      // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
      this.message_subject_var = 'Reference: ' + this.client_reference + ', ' +  model.email_subject + ' Our Reference: '  + this.subject_number;
    }
      
    // Subject Com Document - Template Variables - if {model.doc_id}
    // commented out for automatins as was throwing erros... -- is this cruning twice???
          // if(model.doc_id != null){
          //   // need to set the communication template vars.
          //   // console.log(JSON.stringify(this.doc_check))
          
          //   this.doc_name_var = this.doc_check[0].doc_name 
          // }
      
      /*   
      // :: Gender Descriptor
      PHP code below.  
      if ($sbj->sex == 'femail' || $sbj->sex  == 'female'){
            $templateProcessor->setValue("subject_" .$sbjx. "_gender_descriptor", "She");
            $templateProcessor->setValue($f_starter. "_gender_descriptor", "She"); // focus
        }
        if ($sbj->sex  == 'male'){
            $templateProcessor->setValue("subject_" .$sbjx. "_gender_descriptor", "He");
            $templateProcessor->setValue($f_starter. "_gender_descriptor", "He"); // focus
        }
      */
      
      
      // Convert HTML
          if(model.special_instructions_HTML == null){
            this.job_special_instructions_HTML = model.special_instructions_HTML;
            }else{
             this.job_special_instructions_HTML = unescape(this.transform2(this.job_data_paragraphs[0].special_instructions_HTML))
            }
    
    
    
    // Where are all my time Conversions??????

    //LIKE SIBJECT NASME OR BSUINESS NAME???????? -
    
    
    
      const rendered_result = str
      .replaceAll('${f_subject_name}', model.subject_name)
      .replaceAll('${f_subject_number}', model.subject_number)
      .replaceAll('${subject_number}', model.subject_number)
    
          // Job Merge Variables.
          .replaceAll('${job_id}', model.job_id)
          .replaceAll('${job_number}', model.job_id)
          .replaceAll('${job_status_code}', this.job_data_paragraphs[0].job_status_code)
          .replaceAll('${owner_trace_code}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${client_ref}', this.client_reference)
          // .replaceAll('${client_ref}', this.job_data_paragraphs[0].owner_trace_code + '_ TEST APPEND')
          
          .replaceAll('${client_reference}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${your_reference}', this.job_data_paragraphs[0].owner_trace_code)
          .replaceAll('${job_document_number}', this.job_data_paragraphs[0].document_number)
          // .replaceAll('${job_registry_name}', this.job_data_paragraphs[0].registry_name)
          .replaceAll('${job_registry_name}', this.registry_name)
          .replaceAll('${job_registry_name_upper}', this.job_registry_name_Upper) // capitalise
          .replaceAll('${job_special_instrucitons}', this.job_special_instructions_HTML)
    
    
          // .replaceAll('${job_type_name}', this.job_type_paragraphs[0].job_type_name)
          .replaceAll('${job_type_name}', this.job_type_name)
          .replaceAll('${job_type_name_upper}', this.job_type_name_Upper)
    
          // .replaceAll('${job_type_location_name}', this.job_type_location_paragraphs[0].job_type_location_name)
          .replaceAll('${job_type_location_name}', this.job_type_location_name)
          .replaceAll('${job_type_location_name_upper}', this.job_type_location_name_Upper)
          // .replaceAll('${job_type_court_name}', this.job_type_court_paragraphs[0].job_type_court_name)
          .replaceAll('${job_type_court_name}', this.job_type_court_name)
          .replaceAll('${job_type_court_name_upper}', this.job_type_court_name_Upper)
    
          // .replaceAll('${job_type_document_type_name}', this.job_type_document_type_paragraphs[0].job_type_document_type_name)
          .replaceAll('${job_type_document_type_name}', this.job_type_document_type_name)
    
          .replaceAll('${job_type_document_type_name_upper}', this.job_type_document_type_name_Upper)
          .replaceAll('${job_type_affidavit_type_name}', this.job_type_affidavit_type_name )
          .replaceAll('${job_type_affidavit_type_name_upper}', this.job_type_affidavit_type_name_Upper )
    
    
          // .replaceAll('${job_type_location_name}', this.job_type_location_paragraphs[0].job_type_location_name)
          .replaceAll('${job_type_location_name}', this.job_type_location_name)
          .replaceAll('${job_type_location_name_upper}', this.job_type_location_name_Upper)
    
          .replaceAll('${job_type_court_name}', this.job_type_court_name)
          .replaceAll('${job_type_court_name_upper}', this.job_type_court_name_Upper)
          .replaceAll('${job_type_document_type_name}', this.job_type_document_type_name)
          .replaceAll('${job_type_document_type_name_upper}', this.job_type_document_type_name_Upper)
          .replaceAll('${job_type_affidavit_type_name}', this.job_type_affidavit_type_name )
          .replaceAll('${job_type_affidavit_type_name_upper}', this.job_type_affidavit_type_name_Upper )
    
          // JoB Dates - Need to Lookup Job. and use the details.
    
    
          .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'D/M/YYYY'))
          .replaceAll('${job_hearing_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'h:mma dddd MMMM Do, YYYY') ) // equivilent to in PHP :: date("g:ia l jS F Y", strtotime($job_hearing_date))
          .replaceAll('${job_hearing_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'dddd MMMM Do, YYYY h:mma') )
          .replaceAll('${job_hearing_date}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'D/M/YYYY'))
          .replaceAll('${job_hearing_day}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'dddd'))
          .replaceAll('${job_hearing_day_number}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'Do'))
          .replaceAll('${job_hearing_month}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'MMMM'))
          .replaceAll('${job_hearing_month_number}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'Mo'))
          .replaceAll('${job_hearing_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'M'))
          .replaceAll('${job_hearing_year}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'YYYY'))
          .replaceAll('${job_hearing_time}', this.legalDate.format(this.job_data_paragraphs[0].hearing_date, 'h:mma'))
    
          .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'D/M/YYYY'))
          .replaceAll('${job_judgement_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_judgement_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'dddd MMMM Do, YYYY h:mma') ) 
          .replaceAll('${job_judgement_date}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'D/M/YYYY'))
          .replaceAll('${job_judgement_day}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'dddd'))
          .replaceAll('${job_judgement_day_number}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'Do'))
          .replaceAll('${job_judgement_month}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'MMMM'))
          .replaceAll('${job_judgement_month_number}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'Mo'))
          .replaceAll('${job_judgement_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'M'))
          .replaceAll('${job_judgement_year}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'YYYY'))
          .replaceAll('${job_judgement_time}', this.legalDate.format(this.job_data_paragraphs[0].judgement_date, 'h:mma'))
    
          .replaceAll('${job_filing_date}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'D/M/YYYY'))
          .replaceAll('${job_filing_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_filing_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'dddd MMMM Do, YYYY h:mma') ) 
          .replaceAll('${job_filing_date}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'D/M/YYYY'))
          .replaceAll('${job_filing_day}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'dddd'))
          .replaceAll('${job_filing_day_number}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'Do'))
          .replaceAll('${job_filing_month}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'MMMM'))
          .replaceAll('${job_filing_month_number}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'Mo'))
          .replaceAll('${job_filing_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'M'))
          .replaceAll('${job_filing_year}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'YYYY'))
          .replaceAll('${job_filing_time}', this.legalDate.format(this.job_data_paragraphs[0].filing_date, 'h:mma'))
    
    
          .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'D/M/YYYY'))
          .replaceAll('${job_instructions_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_instructions_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'dddd MMMM Do, YYYY h:mma') ) 
          .replaceAll('${job_instructions_date}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'D/M/YYYY'))
          .replaceAll('${job_instructions_day}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'dddd'))
          .replaceAll('${job_instructions_day_number}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'Do'))
          .replaceAll('${job_instructions_month}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'MMMM'))
          .replaceAll('${job_instructions_month_number}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'Mo'))
          .replaceAll('${job_instructions_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'M'))
          .replaceAll('${job_instructions_year}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'YYYY'))
          .replaceAll('${job_instructions_time}', this.legalDate.format(this.job_data_paragraphs[0].instructions_date, 'h:mma'))
    
          .replaceAll('${job_aos_date}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'D/M/YYYY'))
          .replaceAll('${job_aos_date_and_time_full_words_time_first}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma dddd MMMM Do, YYYY') ) 
          .replaceAll('${job_aos_date_and_time_full_words}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'dddd MMMM Do, YYYY h:mma') ) 
          .replaceAll('${job_aos_date}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'D/M/YYYY'))
          .replaceAll('${job_aos_day}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'dddd'))
          .replaceAll('${job_aos_day_number}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'Do'))
          .replaceAll('${job_aos_month}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'MMMM'))
          .replaceAll('${job_aos_month_number}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'Mo'))
          .replaceAll('${job_aos_month_number_simple}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'M'))
          .replaceAll('${job_aos_year}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'YYYY'))
          .replaceAll('${job_aos_time}', this.legalDate.format(this.job_data_paragraphs[0].aos_date, 'h:mma'))
    
          // Missing Report Client Name - And Report Client Details for the paragraph
     .replaceAll('${job_report_client_name}', this.brand_data[0].name)
     .replaceAll('${job_client_report_name}', this.brand_data[0].name)
     .replaceAll('${job_client_report_name_upper}', this.brand_data[0].name)

     .replaceAll('${job_client_report_phone}', this.brand_data[0].phone)
     .replaceAll('${job_client_report_address_1}', this.brand_data[0].address_1)
     .replaceAll('${job_client_report_address_2}', this.brand_data[0].address_2)
     .replaceAll('${job_client_report_suburb}', this.brand_data[0].suburb)
     .replaceAll('${job_client_report_state}', this.brand_data[0].state)
     .replaceAll('${job_client_report_postcode}', this.brand_data[0].postcode)
     .replaceAll('${job_client_report_country}', this.brand_data[0].country)
     .replaceAll('${job_client_report_brand_type_id}', this.brand_data[0].brand_type_id)
     .replaceAll('${job_client_report_notes}', this.brand_data[0].brand_notes)
     .replaceAll('${job_client_report_fax}', this.brand_data[0].fax)
     .replaceAll('${job_client_report_email}', this.brand_data[0].email)
     .replaceAll('${job_client_report_website}', this.brand_data[0].website)
     .replaceAll('${job_client_report_postal_address_1}', this.brand_data[0].postal_address_1)
     .replaceAll('${job_client_report_postal_address_2}', this.brand_data[0].postal_address_2)
     .replaceAll('${job_client_report_postal_suburb}', this.brand_data[0].postal_suburb)
     .replaceAll('${job_client_report_postal_state}', this.brand_data[0].postal_state)
     .replaceAll('${job_client_report_postal_postcode}', this.brand_data[0].postal_postcode)
     .replaceAll('${job_client_report_postal_country}', this.brand_data[0].postal_country)
     .replaceAll('${job_client_report_myob_id}', this.brand_data[0].myob_id)
     .replaceAll('${job_client_report_accounts_email_address}', this.brand_data[0].accounts_email_address)
     .replaceAll('${job_client_report_brand_type}', this.brand_data[0].brand_type_id)
    

 
               .replaceAll('${job_invoice_client_name}', this.job_invoice_client_paragraphs[0].name)
               .replaceAll('${job_client_invoice_name}', this.job_invoice_client_paragraphs[0].name)
               .replaceAll('${job_client_invoice_name_upper}', this.job_invoice_client_paragraphs[0].name)
    
               .replaceAll('${job_client_invoice_phone}', this.job_invoice_client_paragraphs[0].phone)
               .replaceAll('${job_client_invoice_address_1}', this.job_invoice_client_paragraphs[0].address_1)
               .replaceAll('${job_client_invoice_address_2}', this.job_invoice_client_paragraphs[0].address_2)
               .replaceAll('${job_client_invoice_suburb}', this.job_invoice_client_paragraphs[0].suburb)
               .replaceAll('${job_client_invoice_state}', this.job_invoice_client_paragraphs[0].state)
               .replaceAll('${job_client_invoice_postcode}', this.job_invoice_client_paragraphs[0].postcode)
               .replaceAll('${job_client_invoice_country}', this.job_invoice_client_paragraphs[0].country)
               .replaceAll('${job_client_invoice_brand_type_id}', this.job_invoice_client_paragraphs[0].brand_type_id)
               .replaceAll('${job_client_invoice_notes}', this.job_invoice_client_paragraphs[0].brand_notes)
               .replaceAll('${job_client_invoice_fax}', this.job_invoice_client_paragraphs[0].fax)
               .replaceAll('${job_client_invoice_email}', this.job_invoice_client_paragraphs[0].email)
               .replaceAll('${job_client_invoice_website}', this.job_invoice_client_paragraphs[0].website)
               .replaceAll('${job_client_invoice_postal_address_1}', this.job_invoice_client_paragraphs[0].postal_address_1)
               .replaceAll('${job_client_invoice_postal_address_2}', this.job_invoice_client_paragraphs[0].postal_address_2)
               .replaceAll('${job_client_invoice_postal_suburb}', this.job_invoice_client_paragraphs[0].postal_suburb)
               .replaceAll('${job_client_invoice_postal_state}', this.job_invoice_client_paragraphs[0].postal_state)
               .replaceAll('${job_client_invoice_postal_postcode}', this.job_invoice_client_paragraphs[0].postal_postcode)
               .replaceAll('${job_client_invoice_postal_country}', this.job_invoice_client_paragraphs[0].postal_country)
               .replaceAll('${job_client_invoice_myob_id}', this.job_invoice_client_paragraphs[0].myob_id)
               .replaceAll('${job_client_invoice_accounts_email_address}', this.job_invoice_client_paragraphs[0].accounts_email_address)
               .replaceAll('${job_client_invoice_brand_type}', this.job_invoice_client_paragraphs[0].brand_type_id)
    
    
               .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
               .replaceAll('${job_owner_name}', this.job_owner_client_paragraphs[0].name)
               .replaceAll('${job_owner_name_upper}', this.job_owner_client_paragraphs[0].name)
    
               .replaceAll('${job_owner_phone}', this.job_owner_client_paragraphs[0].phone)
               .replaceAll('${job_owner_address_1}', this.job_owner_client_paragraphs[0].address_1)
               .replaceAll('${job_owner_address_2}', this.job_owner_client_paragraphs[0].address_2)
               .replaceAll('${job_owner_suburb}', this.job_owner_client_paragraphs[0].suburb)
               .replaceAll('${job_owner_state}', this.job_owner_client_paragraphs[0].state)
               .replaceAll('${job_owner_postcode}', this.job_owner_client_paragraphs[0].postcode)
               .replaceAll('${job_owner_country}', this.job_owner_client_paragraphs[0].country)
               .replaceAll('${job_owner_brand_type_id}', this.job_owner_client_paragraphs[0].brand_type_id)
               .replaceAll('${job_owner_notes}', this.job_owner_client_paragraphs[0].brand_notes)
               .replaceAll('${job_owner_fax}', this.job_owner_client_paragraphs[0].fax)
               .replaceAll('${job_owner_email}', this.job_owner_client_paragraphs[0].email)
               .replaceAll('${job_owner_website}', this.job_owner_client_paragraphs[0].website)
               .replaceAll('${job_owner_postal_address_1}', this.job_owner_client_paragraphs[0].postal_address_1)
               .replaceAll('${job_owner_postal_address_2}', this.job_owner_client_paragraphs[0].postal_address_2)
               .replaceAll('${job_owner_postal_suburb}', this.job_owner_client_paragraphs[0].postal_suburb)
               .replaceAll('${job_owner_postal_state}', this.job_owner_client_paragraphs[0].postal_state)
               .replaceAll('${job_owner_postal_postcode}', this.job_owner_client_paragraphs[0].postal_postcode)
               .replaceAll('${job_owner_postal_country}', this.job_owner_client_paragraphs[0].postal_country)
               .replaceAll('${job_owner_myob_id}', this.job_owner_client_paragraphs[0].myob_id)
               .replaceAll('${job_owner_accounts_email_address}', this.job_owner_client_paragraphs[0].accounts_email_address)
               .replaceAll('${job_owner_brand_type}', this.job_owner_client_paragraphs[0].brand_type_id)
   
              
    
    
               .replaceAll('${job_client_report_user_first_name}',  this.job_report_client_user_paragraphs[0].first_name)
               .replaceAll('${job_client_report_user_name_surname}', this.job_report_client_user_paragraphs[0].surname)
               .replaceAll('${job_client_report_user_surname}', this.job_report_client_user_paragraphs[0].surname)
    
               .replaceAll('${job_client_report_user_name}', this.job_report_client_user_paragraphs[0].username)
               .replaceAll('${job_client_report_user_name_upper}', this.job_report_client_user_paragraphs[0].username)
               .replaceAll('${job_client_report_user_phone}', this.job_report_client_user_paragraphs[0].phone)
               .replaceAll('${job_client_report_user_address_1}', this.job_report_client_user_paragraphs[0].address_1)
               .replaceAll('${job_client_report_user_address_2}', this.job_report_client_user_paragraphs[0].address_2)
               .replaceAll('${job_client_report_user_suburb}', this.job_report_client_user_paragraphs[0].suburb)
               .replaceAll('${job_client_report_user_state}', this.job_report_client_user_paragraphs[0].state)
               .replaceAll('${job_client_report_user_postcode}', this.job_report_client_user_paragraphs[0].postcode)
               .replaceAll('${job_client_report_user_country}', this.job_report_client_user_paragraphs[0].country)
               .replaceAll('${job_client_report_user_brand_type_id}', this.job_report_client_user_paragraphs[0].brand_type_id)
               .replaceAll('${job_client_report_user_notes}', this.job_report_client_user_paragraphs[0].brand_notes)
               .replaceAll('${job_client_report_user_fax}', this.job_report_client_user_paragraphs[0].fax)
               .replaceAll('${job_client_report_user_email}', this.job_report_client_user_paragraphs[0].email_address)
               .replaceAll('${job_client_report_user_website}', this.job_report_client_user_paragraphs[0].website)
               .replaceAll('${job_client_report_user_postal_address_1}', this.job_report_client_user_paragraphs[0].postal_address_1)
               .replaceAll('${job_client_report_user_postal_address_2}', this.job_report_client_user_paragraphs[0].postal_address_2)
               .replaceAll('${job_client_report_user_postal_suburb}', this.job_report_client_user_paragraphs[0].postal_suburb)
               .replaceAll('${job_client_report_user_postal_state}', this.job_report_client_user_paragraphs[0].postal_state)
               .replaceAll('${job_client_report_user_postal_postcode}', this.job_report_client_user_paragraphs[0].postal_postcode)
               .replaceAll('${job_client_report_user_postal_country}', this.job_report_client_user_paragraphs[0].postal_country)
    
    
               .replaceAll('${f_user_first_name}',  this.current_user_paragraphs[0].first_name)
               .replaceAll('${f_user_name_surname}', this.current_user_paragraphs[0].surname)
               .replaceAll('${f_user_surname}', this.current_user_paragraphs[0].surname)
    
               .replaceAll('${f_user_name}', this.current_user_paragraphs[0].username)
               .replaceAll('${f_user_name_upper}', this.current_user_paragraphs[0].username)
               .replaceAll('${f_user_phone}', this.current_user_paragraphs[0].phone)
               .replaceAll('${f_user_address_1}', this.current_user_paragraphs[0].address_1)
               .replaceAll('${f_user_address_2}', this.current_user_paragraphs[0].address_2)
               .replaceAll('${f_user_suburb}', this.current_user_paragraphs[0].suburb)
               .replaceAll('${f_user_state}', this.current_user_paragraphs[0].state)
               .replaceAll('${f_user_postcode}', this.current_user_paragraphs[0].postcode)
               .replaceAll('${f_user_country}', this.current_user_paragraphs[0].country)
               .replaceAll('${f_user_brand_type_id}', this.current_user_paragraphs[0].brand_type_id)
               .replaceAll('${f_user_notes}', this.current_user_paragraphs[0].brand_notes)
               .replaceAll('${f_user_fax}', this.current_user_paragraphs[0].fax)
               .replaceAll('${f_user_email}', this.current_user_paragraphs[0].email_address)
               .replaceAll('${f_user_website}', this.current_user_paragraphs[0].website)
               .replaceAll('${f_user_postal_address_1}', this.current_user_paragraphs[0].postal_address_1)
               .replaceAll('${f_user_postal_address_2}', this.current_user_paragraphs[0].postal_address_2)
               .replaceAll('${f_user_postal_suburb}', this.current_user_paragraphs[0].postal_suburb)
               .replaceAll('${f_user_postal_state}', this.current_user_paragraphs[0].postal_state)
               .replaceAll('${f_user_postal_postcode}', this.current_user_paragraphs[0].postal_postcode)
               .replaceAll('${f_user_postal_country}', this.current_user_paragraphs[0].postal_country)
    
               .replaceAll('${f_user_email_signature}', this.current_user_paragraphs[0].email_signature_HTML_rendered) // plain and not encoded.
    
    
    // Current Subjcet as a passed commnunication model.
    .replaceAll('${f_subject_subject_id}', model.subject_id )
    .replaceAll('${f_subject_job_id}', model.job_id )
    .replaceAll('${f_subject_first_name}', model.first_name )
    .replaceAll('${f_subject_surname}', model.surname )
    .replaceAll('${f_subject_title}', model.title )
    .replaceAll('${f_subject_is_active}', model.is_active )
    
    .replaceAll('${f_subject_next_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
    // .replaceAll('${f_subject_next_date}', model.next_date )
    
    .replaceAll('${f_subject_next_date_and_time_full_words_time_first}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_next_date_and_time_full_words}', this.legalDate.format(model.next_date, 'dddd MMMM Do, YYYY h:mma') ) 
    .replaceAll('${f_subject_next_date_full_words_time_first}', this.legalDate.format(model.next_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_next_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_next_day}', this.legalDate.format(model.next_date, 'dddd'))
    .replaceAll('${f_subject_next_day_number}', this.legalDate.format(model.next_date, 'Do'))
    .replaceAll('${f_subject_next_month}', this.legalDate.format(model.next_date, 'MMMM'))
    .replaceAll('${f_subject_next_month_number}', this.legalDate.format(model.next_date, 'Mo'))
    .replaceAll('${f_subject_next_month_number_simple}', this.legalDate.format(model.next_date, 'M'))
    .replaceAll('${f_subject_next_year}', this.legalDate.format(model.next_date, 'YYYY'))
    .replaceAll('${f_subject_next_time}', this.legalDate.format(model.next_date, 'h:mma'))
    
    .replaceAll('${f_subject_final_date}', this.legalDate.format(model.final_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_final_date_and_time_full_words_time_first}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_final_date_and_time_full_words}', this.legalDate.format(model.final_date, 'dddd MMMM Do, YYYY h:mma') ) 
    .replaceAll('${f_subject_final_date_full_words_time_first}', this.legalDate.format(model.final_date, 'h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_final_date}', this.legalDate.format(model.final_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_final_day}', this.legalDate.format(model.final_date, 'dddd'))
    .replaceAll('${f_subject_final_day_number}', this.legalDate.format(model.final_date, 'Do'))
    .replaceAll('${f_subject_final_month}', this.legalDate.format(model.final_date, 'MMMM'))
    .replaceAll('${f_subject_final_month_number}', this.legalDate.format(model.final_date, 'Mo'))
    .replaceAll('${f_subject_final_month_number_simple}', this.legalDate.format(model.final_date, 'M'))
    .replaceAll('${f_subject_final_year}', this.legalDate.format(model.final_date, 'YYYY'))
    .replaceAll('${f_subject_final_time}', this.legalDate.format(model.final_date, 'h:mma'))
    
    .replaceAll('${f_subject_job_status_id}', model.job_status_id )
    .replaceAll('${f_subject_street_address}', model.street_address )
    .replaceAll('${f_subject_suburb}', model.suburb )
    .replaceAll('${f_subject_state}', model.state )
    .replaceAll('${f_subject_postcode}', model.postcode )
    .replaceAll('${f_subjectphone_h}', model.f_subjectphone_h )
    .replaceAll('${f_subject_email}', model.email )
    
    .replaceAll('${f_subject_dob}', moment(model.dob).format('D/M/YYYY'))
    .replaceAll('${f_subject_dob_and_time_full_words_time_first}', moment(model.dob).format('h:mma dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_dob_and_time_full_words}', moment(model.dob).format('dddd MMMM Do, YYYY h:mma') ) 
    .replaceAll('${f_subject_dob_full_words}', moment(model.dob).format('dddd MMMM Do, YYYY') ) 
    .replaceAll('${f_subject_dob_full_words_time_first}', moment(model.dob).format('dddd MMMM Do, YYYY h:mma') ) 
    .replaceAll('${f_subject_dob}', moment(model.dob).format('D/M/YYYY'))
    .replaceAll('${f_subject_dob_day}', moment(model.dob).format('dddd'))
    .replaceAll('${f_subject_dob_day_number}', moment(model.dob).format('Do'))
    .replaceAll('${f_subject_dob_month}', moment(model.dob).format('MMMM'))
    .replaceAll('${f_subject_dob_month_number}', moment(model.dob).format('Mo'))
    .replaceAll('${f_subject_dob_month_number_simple}', moment(model.dob).format('M'))
    .replaceAll('${f_subject_dob_year}', moment(model.dob).format('YYYY'))
    .replaceAll('${f_subject_dob_time}', moment(model.dob).format('h:mma'))
    
    .replaceAll('${f_subject_phone_m}', model.phone_m )
    .replaceAll('${f_subject_subject_type_id}', model.subject_type_id )
    
    // .replaceAll('${f_subject_file_number}', model.file_number )
    .replaceAll('${f_subject_file_number}', this.ordinalInWord(model.file_number) ) // Ordinal eg First... need to capitasie.
    
    .replaceAll('${f_subject_special_instructions}', model.special_instructions )
    .replaceAll('${f_subject_job_status}', model.job_status )
    .replaceAll('${f_subject_reference_number}', model.reference_number )
    .replaceAll('${f_subject_job_reference_number}', model.job_reference_number )
    .replaceAll('${f_subject_subject_number}', model.subject_number )
    .replaceAll('${f_subject_created_by}', model.created_by )
    .replaceAll('${f_subject_created_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_updated_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_updated_by}', model.updated_by )
    .replaceAll('${f_subject_completed_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_completed_by}', model.completed_by )
    .replaceAll('${f_subject_start_date}', this.legalDate.format(model.next_date, 'D/M/YYYY'))
    .replaceAll('${f_subject_started_by}', model.started_by )
    .replaceAll('${f_subject_time_taken}', model.time_taken )
    .replaceAll('${f_subject_sex}', model.sex )
    
    // .replaceAll('${f_subject_gender_descriptor}', model.sex )
    .replaceAll('${f_subject_gender_descriptor}', this.subject_gender_descriptor )
    
    
    .replaceAll('${f_subject_finalised}', model.finalised )
    .replaceAll('${f_subject_subject_reference_created}', model.subject_reference_created )
    .replaceAll('${f_subject_brand_report_user_id}', model.brand_report_user_id )
    .replaceAll('${f_subject_job_type_id}', model.job_type_id )
    .replaceAll('${f_subject_job_type_location_id}', model.job_type_location_id )
    .replaceAll('${f_subject_job_type_court_id}', model.job_type_court_id )
    .replaceAll('${f_subject_job_type_document_type_id}', model.job_type_document_type_id )
    .replaceAll('${f_subject_job_type_affidavit_type_id}', model.job_type_affidavit_type_id )
    .replaceAll('${f_subject_business_name}', model.business_name )
    .replaceAll('${f_subject_prev_subject_id}', model.prev_subject_id )
    .replaceAll('${f_subject_next_subject_id}', model.next_subject_id )
    .replaceAll('${f_subject_job_subject_type_id}', model.job_subject_type_id )
    .replaceAll('${f_subject_subject_report_order_number}', model.subject_report_order_number )
    .replaceAll('${f_subject_job_service_rule_id}', model.job_service_rule_id )
    
          .replaceAll('${f_subject_job_service_rule_name}', this.job_service_rule_name )
          .replaceAll('${f_subject_job_service_rule_description}', this.job_service_rule_description )
    
    
          .replaceAll('${f_subject_job_service_timeframe_id}', model.job_service_timeframe_id )
          .replaceAll('${f_subject_job_service_timeframe_name}', this.job_service_timeframe_name )
          .replaceAll('${f_subject_job_service_timeframe_text}', this.job_service_timeframe_text )
    
          .replaceAll('${f_subject_subject_service_type_id}', model.subject_service_type_id )
          .replaceAll('${f_subject_subject_service_type_name}', this.subject_service_type_name )
          .replaceAll('${f_subject_subject_service_type_description}', this.subject_service_type_description )
          .replaceAll('${f_subject_subject_service_type_staff_instructions}', this.subject_service_type_staff_instructions )
          .replaceAll('${f_subject_subject_service_type_agent_instructions}', this.subject_service_type_agent_instructions )
          .replaceAll('${f_subject_subject_service_type_instructions}', this.subject_service_type_instructions )
    
    
    .replaceAll('${f_subject_service_company_name}', model.service_company_name )
    .replaceAll('${f_subject_service_directors_name}', model.service_directors_name )
    .replaceAll('${f_subject_service_prison_name}', model.service_prison_name )
    .replaceAll('${f_subject_service_law_firm_name}', model.service_law_firm_name )
    .replaceAll('${f_subject_service_solicitor_name}', model.service_solicitor_name )
    .replaceAll('${f_subject_middle_name}', model.middle_name )
    .replaceAll('${f_subject_special_instructions_HTML}', model.special_instructions_HTML )
    
    // .replaceAll('${f_subject_job_subject_type_name}', model.job_subject_type_name )
    .replaceAll('${f_subject_subject_type_name}', this.job_subject_type_name )
    .replaceAll('${f_subject_subject_type_name_upper}', this.job_subject_type_name_Upper)
    
    // .replaceAll('${f_subject_job__type}', model.job_type )
    .replaceAll('${f_subject_subject_type}', model.job_type )
    
    .replaceAll('${f_subject_brand_invoice_id}', model.brand_invoice_id )
    .replaceAll('${f_subject_brand_report_id}', model.brand_report_id )
    .replaceAll('${f_subject_instructions_date}', model.instructions_date )
    .replaceAll('${f_subject_hearing_date}', model.hearing_date )
    .replaceAll('${f_subject_judgement_date}', model.judgement_date )
    .replaceAll('${f_subject_filing_date}', model.filing_date )
    .replaceAll('${f_subject_client_reference}', model.client_reference )
    .replaceAll('${f_subject_brand_report_name}', model.brand_report_name )
    .replaceAll('${f_subject_brand_invoice_name}', model.brand_invoice_name )
    
    .replaceAll('${f_subject_subject_name}', model.subject_name )
    // NEED IF STATEMENTS
    // .replaceAll('${f_subject_name_upper}', model.subject_name.toUpperCase() )
    .replaceAll('${subject_name}', model.subject_name )
    // .replaceAll('${subject_name_upper}', model.subject_name.toUpperCase() )
    
    .replaceAll('${f_subject_contact_numbers}', this.subject_contact_numbers)
    .replaceAll('${f_subject_contact_emails}', this.subject_contact_emails)
    
    
    
    
    
    // // Subject Focus Agent
                .replaceAll('${f_subject_agent_name}', this.assignedBrandList_paragraphs[0].first_name + ' ' + this.assignedBrandList_paragraphs[0].middle_name + ' ' + this.assignedBrandList_paragraphs[0].surname )
                .replaceAll('${f_subject_agent_name_upper}', this.assignedBrandList_paragraphs[0].name  )
                .replaceAll('${f_subject_agent_first_name}', this.assignedBrandList_paragraphs[0].first_name)
                .replaceAll('${f_subject_agent_middle_name}', this.assignedBrandList_paragraphs[0].middle_name)
                .replaceAll('${f_subject_agent_surname}', this.assignedBrandList_paragraphs[0].surname)
    
                .replaceAll('${f_subject_agent_address_1}', this.assignedBrandList_paragraphs[0].address_1)
                .replaceAll('${f_subject_agent_address_2}', this.assignedBrandList_paragraphs[0].address_2)
                .replaceAll('${f_subject_agent_suburb}', this.assignedBrandList_paragraphs[0].suburb)
                .replaceAll('${f_subject_agent_state}', this.assignedBrandList_paragraphs[0].state)
                .replaceAll('${f_subject_agent_postcode}', this.assignedBrandList_paragraphs[0].postcode)
                .replaceAll('${f_subject_agent_country}', this.assignedBrandList_paragraphs[0].country)
    
    
                .replaceAll('${f_subject_agent_postal_address_1}', this.assignedBrandList_paragraphs[0].address_1)
                .replaceAll('${f_subject_agent_postal_address_2}', this.assignedBrandList_paragraphs[0].address_2)
                .replaceAll('${f_subject_agent_postal_suburb}', this.assignedBrandList_paragraphs[0].suburb)
                .replaceAll('${f_subject_agent_postal_state}', this.assignedBrandList_paragraphs[0].state)
                .replaceAll('${f_subject_agent_postal_postcode}', this.assignedBrandList_paragraphs[0].postcode)
                .replaceAll('${f_subject_agent_postal_country}', this.assignedBrandList_paragraphs[0].country)
    
                .replaceAll('${f_subject_agent_adddress_full}', this.assignedBrandList_paragraphs[0].address_1 + ' ' + this.assignedBrandList_paragraphs[0].address_2 + ' ' + this.assignedBrandList_paragraphs[0].suburb + ' ' + this.assignedBrandList_paragraphs[0].state + ', ' + this.assignedBrandList_paragraphs[0].postcode )
                .replaceAll('${f_subject_agent_qualification}', this.assignedBrandList_paragraphs[0].qualification)
                .replaceAll('${f_subject_agent_qualification_number}', this.assignedBrandList_paragraphs[0].qualification_number)
    
                .replaceAll('${f_subject_agent_myob_id}', this.assignedBrandList_paragraphs[0].myob_id)
                .replaceAll('${f_subject_agent_brand_type}', this.assignedBrandList_paragraphs[0].brand_type_id)
    
                .replaceAll('${f_subject_agent_phone}', this.assignedBrandList_paragraphs[0].phone)
                .replaceAll('${f_subject_agent_fax}', this.assignedBrandList_paragraphs[0].fax)
                .replaceAll('${f_subject_agent_website}', this.assignedBrandList_paragraphs[0].website)
                .replaceAll('${f_subject_agent_accounts_email_address}', this.assignedBrandList_paragraphs[0].accounts_email_address)
    
                .replaceAll('${f_subject_agent_qualification_renewal_date}', moment(this.assignedBrandList_paragraphs[0].qualification_renewal_date).format('D/M/YYYY') )
                .replaceAll('${f_subject_agent_qualification_renewal_date_full_words}', moment(this.assignedBrandList_paragraphs[0].qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )
    
    
    // Sent from the allRecipeints Atray Function when adding recipeints
            .replaceAll('${recipient_name}', model.recipient_name )
            .replaceAll('${recipient_email_address}', model.recipient_email_address )
            .replaceAll('${recipient_brand_id}', model.recipient_brand_id )
            .replaceAll('${recipient_brand_type_id}', model.recipient_brand_type_id )
            .replaceAll('${recipient_user_id}', model.recipient_user_id )
            .replaceAll('${recipient_user_level_id}', model.recipient_user_level_id )
            .replaceAll('${recipient_type_name}', model.recipient_type_name )
           
            // .replaceAll('${message_subject}', this.message_subject_var )
            .replaceAll('${message_subject}', 'NOT WORKING YET ...' ) // set from the old system
            // .replaceAll('${message_subject}', this.message_subject + 'NO WORKING YET ...' ) // set from the old system
            .replaceAll('${doc_name}', this.doc_name_var  ) // set from the old system
         
    
    
    
    // hide anything null or undefined.
    .replaceAll('${undefined}', '')
    .replaceAll('${null}', '')
    .replaceAll('undefined', '') // makes all undefined print empty
    .replaceAll('null', '') // makes all undefined print empty
    .replaceAll('Invalid date', '') // makes all undefined print empty
    
    
    // model.email_template_primary_HTML_rendered
    // email_subject_primary_rendered
    
    // Convert the results to a form field value.
    // model.email_template_primary_HTML_rendered = rendered_result;
    
    
    
    // must put back below condition
    // return rendered_result;
            if(this.attempts_paragraphs_model != undefined){
              

            return this.runReplaceAllVariables_AttemptsOnly(rendered_result, model) // returns after running all the attempts.
            
            }else{
              return rendered_result; // just return without rendering the attempts
            }
    
    return rendered_result; // just return without rendering the attempts
    


    }

    

// Attempt f_attempt focus variables for all templates -- Only run if a service acualty exisits to save time and pervent errors.
// THIS TRIGGERS ALL OTHER ATTEMPT VARIABELS AT THE END.
runReplaceAllVariables_AttemptsOnly(str, model){


  // Already loaded in the job/subject lookup
  // if(this.attempts_paragraphs_model.job_subject_type_id){
  //   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
  // }
  // let var_subject_type_name;
  // if(this.subject_job_subject_type != null){
  // var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
  // } else{
  // var_subject_type_name = '';
  // }

  if(this.attempts_paragraphs_model){ 
          // // set here like this as it was not laoding correctly -- quick hack fix...
          //             this._demoService.getBrandById(this.attempts_paragraphs_model.who_service_id).subscribe(
          //               (data222) => {
          //                 // this.brand_data = data;

          //                 let res = data222[0];
          //                 // this.subject_service_agent = DataUtil.parse.parseJson(res);
          //                 this.subject_service_agent = res;
          //                 // this.allClientEmailRecipients = data;

          //           this.toastr.success('Subject Service Agent Details Q -- if attemptes model.')

          //                 // let newArr = data
          //                 // let  count_of_items = Object.keys(newArr).length;
          //                 //   // need to do a loop of subject_billing items (.length)
          //                 //   for (let i = 0; i < count_of_items; i++) {
          //                 //   let res = newArr[i];
          //                 //   this.allRecipients.push({
          //                 //     recipient_name: res.name + ' - Client Report',
          //                 //     recipient_email_address: res.email,
          //                 //     recipient_brand_id: res.brand_id,
          //                 //     recipient_brand_type_id: res.brand_type_id,
          //                 //     recipient_user_id: null,
          //                 //     recipient_user_level_id: null,
          //                 //     recipient_type_name: 'Client Report',
          //                 //   });
          //                 //   } // end for loop
          //                 // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

          //               },
          //               (err) => { this.toastr.error('Subject Service Agent Details Q'),console.error(err)},
          //               () => console.log('Brand Loaded.')
          //             );
     }


// ATTEMPS
  // Current Attempt Variables Setups
  // Uppercase.
  if(this.attempts_paragraphs_model){

    let var_subject_attempt_type_name = this.attempts_paragraphs_model.subject_attempt_type_name
    if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
     this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
    }
  
  } // end if attemps paragraphs model.

if(this.attempts_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.attempts_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.attempts_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.attempts_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.attempts_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.attempts_paragraphs_model.vehicles_notes_HTML);}
if(this.attempts_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.attempts_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.attempts_paragraphs_model.neighbours_notes_HTML);}
if(this.attempts_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.attempts_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.attempts_paragraphs_model.calling_card_notes_HTML);}
if(this.attempts_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.attempts_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.attempts_paragraphs_model.postal_mail_notes_HTML);}
if(this.attempts_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.attempts_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.attempts_paragraphs_model.phone_call_notes_HTML);}
if(this.attempts_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.attempts_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.attempts_paragraphs_model.attempts_notes_HTML);}
if(this.attempts_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.attempts_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.attempts_paragraphs_model.email_contents_HTML);}
if(this.attempts_paragraphs_model.general_notes_HTML == null){
  this.set_general_notes = this.attempts_paragraphs_model.general_notes;
  }else{
   this.set_general_notes = this.transform2(this.attempts_paragraphs_model.general_notes_HTML)
  }
  if(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.attempts_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
  if(this.attempts_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.attempts_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.attempts_paragraphs_model.property_mail_details_HTML);}
  if(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.attempts_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML);}  
  if(this.attempts_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.attempts_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.attempts_paragraphs_model.property_pets_details_HTML);}

  if(this.attempts_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.attempts_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupancy_details_HTML);}
  
  if(this.attempts_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.attempts_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.attempts_paragraphs_model.property_condition_HTML);}
if(this.attempts_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.attempts_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupied_details_HTML);}
if(this.attempts_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.attempts_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.attempts_paragraphs_model.property_type_details_HTML);}

if(this.attempts_paragraphs_model.service_under_order_HTML == null){this.service_under_order_HTML = this.attempts_paragraphs_model.service_under_order; }else{this.service_under_order_HTML = this.transform2(this.attempts_paragraphs_model.service_under_order_HTML);}


 // Do checks for subject name / Businesss Name of FUll SUbject Name fields
 let var_subject_name =  this.attempts_paragraphs_model.first_name + ' ' +  this.attempts_paragraphs_model.middlename + ' '+  this.attempts_paragraphs_model.surname;
 let var_subject_name_4_doc = this.attempts_paragraphs_model.first_name +'-'+  this.attempts_paragraphs_model.surname;
 let var_subject_business_name =  this.attempts_paragraphs_model.business_name;
 
 // Subject Name of Business
     if(var_subject_business_name != null){
         let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
         // $subject_name = $trim_subject_business_name;
          var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
           var_subject_name_4_doc= var_trim_subject_business_name;
         
     }



if(this.attempts_paragraphs_model.service_paragraph_rendered == null){
  this.set_service_paragraph_rendered = '';
 }else{
  this.set_service_paragraph_rendered = this.attempts_paragraphs_model.service_paragraph_rendered; // does not require encodeing
}

// Property Images
if(this.attempts_paragraphs_model.property_images != '[]' || this.attempts_paragraphs_model.property_images != null){
  this.property_images = JSON.parse(this.attempts_paragraphs_model.property_images)



  let newArr = this.property_images;
  let  count_of_items = Object.keys(newArr).length;

  // let  count_of_items = 25;
  //   let  count_of_items = Object.keys(newArr).length;
  // //     for(let i=0;i < count_of_items; i++) { 
  // //     let res = newArr[i];
  // // }
 
  if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
  if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
  if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
  if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
  if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
  if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
  if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
  if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
  if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
  if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
  if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
  if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
  if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
  if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
  if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
  if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
  if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
  if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
  if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
  if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
  if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
  if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
  if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
  if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
  if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
  if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}
   


  

  // Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
  // loop 0 - 25 and only set if exisis or '' if not.


}

if(this.attempts_paragraphs_model.property_sign_images != '[]' && this.attempts_paragraphs_model.property_sign_images != null){
  this.property_sign_images = JSON.parse(this.attempts_paragraphs_model.property_sign_images)
  let newArr = this.property_sign_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
  if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
  if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
  if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
  if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
  if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
  if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
  if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
  if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
  if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
  if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
  if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
  if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
  if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
  if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
  if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
  if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
  if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
  if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
  if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
  if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
  if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
  if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
  if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
  if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
  if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_mail_images != '[]' && this.attempts_paragraphs_model.property_mail_images != null ){
  this.property_mail_images = JSON.parse(this.attempts_paragraphs_model.property_mail_images)
  let newArr = this.property_mail_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
  if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
  if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
  if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
  if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
  if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
  if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
  if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
  if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
  if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
  if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
  if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
  if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
  if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
  if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
  if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
  if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
  if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
  if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
  if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
  if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
  if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
  if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
  if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
  if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
  if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_vehicles_images != '[]' && this.attempts_paragraphs_model.property_vehicles_images != null){
  this.property_vehicles_images = JSON.parse(this.attempts_paragraphs_model.property_vehicles_images)
  let newArr = this.property_vehicles_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
  if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
  if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
  if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
  if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
  if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
  if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
  if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
  if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
  if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
  if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
  if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
  if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
  if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
  if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
  if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
  if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
  if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
  if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
  if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
  if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
  if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
  if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
  if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
  if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
  if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.attempts_paragraphs_model.property_pets_images != '[]' && this.attempts_paragraphs_model.property_pets_images != null){
  this.property_pets_images = JSON.parse(this.attempts_paragraphs_model.property_pets_images)
  let newArr = this.property_pets_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
  if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
  if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
  if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
  if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
  if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
  if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
  if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
  if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
  if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
  if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
  if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
  if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
  if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
  if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
  if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
  if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
  if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
  if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
  if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
  if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
  if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
  if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
  if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
  if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
  if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.attempts_paragraphs_model.property_occupancy_images != '[]' && this.attempts_paragraphs_model.property_occupancy_images != null){
  this.property_occupancy_images = JSON.parse(this.attempts_paragraphs_model.property_occupancy_images)
  let newArr = this.property_occupancy_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
  if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
  if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
  if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
  if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
  if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
  if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
  if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
  if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
  if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
  if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
  if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
  if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
  if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
  if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
  if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
  if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
  if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
  if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
  if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
  if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
  if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
  if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
  if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
  if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
  if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.attempts_paragraphs_model.property_condition_images != '[]' && this.attempts_paragraphs_model.property_condition_images != null ){
  this.property_condition_images = JSON.parse(this.attempts_paragraphs_model.property_condition_images)
  let newArr = this.property_condition_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
  if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
  if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
  if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
  if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
  if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
  if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
  if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
  if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
  if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
  if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
  if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
  if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
  if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
  if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
  if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
  if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
  if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
  if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
  if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
  if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
  if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
  if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
  if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
  if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
  if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.attempts_paragraphs_model.property_type_images != '[]' && this.attempts_paragraphs_model.property_type_images != null){
  this.property_type_images = JSON.parse(this.attempts_paragraphs_model.property_type_images)
  let newArr = this.property_type_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
  if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
  if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
  if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
  if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
  if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
  if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
  if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
  if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
  if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
  if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
  if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
  if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
  if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
  if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
  if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
  if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
  if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
  if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
  if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
  if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
  if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
  if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
  if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
  if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
  if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.attempts_paragraphs_model.service_file_array != '[]' && this.attempts_paragraphs_model.service_file_array != null){
  this.service_file_array_images = JSON.parse(this.attempts_paragraphs_model.service_file_array)
  let newArr = this.service_file_array_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
  if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
  if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
  if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
  if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
  if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
  if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
  if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
  if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
  if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
  if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
  if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
  if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
  if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
  if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
  if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
  if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
  if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
  if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
  if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
  if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
  if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
  if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
  if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
  if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
  if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

  let rendered_result = str



      .replaceAll('${f_attempt_type_id}', this.attempts_paragraphs_model.subject_attempt_type_id)
      .replaceAll('${f_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll('${f_attempt_subject_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll('${f_attempt_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

      .replaceAll('${f_attempt_subject_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id)
      .replaceAll('${f_attempt_subject_service_method_name}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll('${f_attempt_service_method}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll('${f_attempt_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id) // tested above.


      .replaceAll('${f_attempt_date_service}', moment(this.attempts_paragraphs_model.date_service).format('D/M/YYYY'))
      .replaceAll('${f_attempt_date_service_full_words_time_first}', this.attempts_paragraphs_model.time_service_text + ' ' + moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
      .replaceAll('${f_attempt_date_service_and_time_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.attempts_paragraphs_model.time_service_text ) 
      .replaceAll('${f_attempt_date_service_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

      .replaceAll('${f_attempt_day}', moment(this.attempts_paragraphs_model.date_service).format('dddd'))
      .replaceAll('${f_attempt_day_number}', moment(this.attempts_paragraphs_model.date_service).format('Do'))
      .replaceAll('${f_attempt_day_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('D'))
      .replaceAll('${f_attempt_month}', moment(this.attempts_paragraphs_model.date_service).format('MMMM'))
      .replaceAll('${f_attempt_month_number}', moment(this.attempts_paragraphs_model.date_service).format('Mo'))
      .replaceAll('${f_attempt_month_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('M'))
      .replaceAll('${f_attempt_year}', moment(this.attempts_paragraphs_model.date_service).format('YYYY'))

      .replaceAll('${f_attempt_service_local}', this.attempts_paragraphs_model.service_local) // region Australia/Perth of service undertaken
      .replaceAll('${f_attempt_time}', this.attempts_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll('${f_attempt_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll('${f_attempt_subject_name}', var_subject_name)
      .replaceAll('${f_attempt_subject_number}', this.attempts_paragraphs_model.subject_number)
      .replaceAll('${f_attempt_subject_name_4_doc}', var_subject_name_4_doc)
      .replaceAll('${f_attempt_subject_business_name}', var_subject_business_name)
      .replaceAll('${f_attempt_business_name}', var_subject_business_name)

  // Subject Attempt Address
  .replaceAll('${f_attempt_address_1}', this.attempts_paragraphs_model.address_1)
  .replaceAll('${f_attempt_address_2}', this.attempts_paragraphs_model.address_2)
  .replaceAll('${f_attempt_suburb}', this.attempts_paragraphs_model.suburb)
  .replaceAll('${f_attempt_state}', this.attempts_paragraphs_model.state)
  .replaceAll('${f_attempt_postcode}', this.attempts_paragraphs_model.postcode)
  .replaceAll('${f_attempt_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // Sav
  .replaceAll('${f_attempt_sav_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // New address
  .replaceAll('${f_attempt_new_business_name}', this.attempts_paragraphs_model.new_business_name)
  .replaceAll('${f_attempt_new_address_1}', this.attempts_paragraphs_model.new_address_1)
  .replaceAll('${f_attempt_new_address_2}', this.attempts_paragraphs_model.new_address_2)
  .replaceAll('${f_attempt_new_suburb}', this.attempts_paragraphs_model.new_suburb)
  .replaceAll('${f_attempt_new_state}', this.attempts_paragraphs_model.new_state)
  .replaceAll('${f_attempt_new_postcode}', this.attempts_paragraphs_model.new_postcode)
  .replaceAll('${f_attempt_new_address_full}', this.attempts_paragraphs_model.new_address_1 +  ' ' + this.attempts_paragraphs_model.new_address_2 +  ' ' + this.attempts_paragraphs_model.new_suburb +  ' ' + this.attempts_paragraphs_model.new_state +  ',  ' + this.attempts_paragraphs_model.new_postcode )
  
  .replaceAll('${f_attempt_service_number}', this.attempts_paragraphs_model.service_number)

  .replaceAll('${f_attempt_service_outcome_name}', this.attempts_paragraphs_model.subject_service_outcome_name)
  .replaceAll('${f_attempt_exact_service_method_name}', this.attempts_paragraphs_model.exact_service_method_name) //
  .replaceAll('${f_attempt_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
  .replaceAll('${f_attempt_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
  .replaceAll('${f_attempt_location_status_name}', this.attempts_paragraphs_model.subject_location_status_name)
  .replaceAll('${f_attempt_location_status_found_name}', this.attempts_paragraphs_model.subject_location_status_found_name)

  .replaceAll('${f_attempt_fellow_occupants_name}', this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll('${f_attempt_fellow_occupants_sex}', this.attempts_paragraphs_model.fellow_occupants_sex)
  .replaceAll('${f_attempt_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll('${f_attempt_subject_relationship_name}', this.attempts_paragraphs_model.subject_service_fellow_relationship)

  .replaceAll('${f_attempt_person_spoken_with}', this.attempts_paragraphs_model.person_spoken_with)
  .replaceAll('${f_attempt_person_type}', this.attempts_paragraphs_model.person_type)
  .replaceAll('${f_attempt_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

  .replaceAll('${f_attempt_vehicles}', this.attempts_paragraphs_model.vehicles)
.replaceAll('${f_attempt_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_neighbours}', this.attempts_paragraphs_model.neighbours)
.replaceAll('${f_attempt_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_calling_card}', this.attempts_paragraphs_model.calling_card)
.replaceAll('${f_attempt_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_postal_mail}', this.attempts_paragraphs_model.postal_mail)
.replaceAll('${f_attempt_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_phone_call}', this.attempts_paragraphs_model.phone_call)
.replaceAll('${f_attempt_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_attempts}', this.attempts_paragraphs_model.attempts)
.replaceAll('${f_attempt_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_authorised_employee_name}', this.attempts_paragraphs_model.authorised_employee_name)
.replaceAll('${f_attempt_authorised_employee_job_title}', this.attempts_paragraphs_model.authorised_employee_job_title)
.replaceAll('${f_attempt_authorised_employee_sex}', this.attempts_paragraphs_model.authorised_employee_sex)
.replaceAll('${f_attempt_office_business_name}', this.attempts_paragraphs_model.office_business_name)

.replaceAll('${f_attempt_witness_name}', this.attempts_paragraphs_model.witness_name)
.replaceAll('${f_attempt_witness_business_name}', this.attempts_paragraphs_model.witness_business_name)
.replaceAll('${f_attempt_witness_address}', this.attempts_paragraphs_model.witness_address_1 + ' ' + this.attempts_paragraphs_model.witness_address_2 + ' ' +  this.attempts_paragraphs_model.witness_suburb + ' ' + this.attempts_paragraphs_model.witness_state + ', ' + this.attempts_paragraphs_model.witness_postcode  ) // 
.replaceAll('${f_attempt_witness_address_1}', this.attempts_paragraphs_model.witness_address_1)
.replaceAll('${f_attempt_witness_address_2}', this.attempts_paragraphs_model.witness_address_2)
.replaceAll('${f_attempt_witness_state}', this.attempts_paragraphs_model.witness_state)
.replaceAll('${f_attempt_witness_suburb}', this.attempts_paragraphs_model.witness_suburb)
.replaceAll('${f_attempt_witness_country}', this.attempts_paragraphs_model.witness_country)
.replaceAll('${f_attempt_witness_postcode}', this.attempts_paragraphs_model.witness_postcode)

.replaceAll('${f_attempt_person_in_charge_of_prison_name}', this.attempts_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll('${f_attempt_person_in_charge_of_prison_occupation}', this.attempts_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll('${f_attempt_ubject_contact_email_id}', this.attempts_paragraphs_model.subject_contact_email_id)
.replaceAll('${f_attempt_email_address_served}', this.attempts_paragraphs_model.email_address_served)
.replaceAll('${f_attempt_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_director_name}', this.attempts_paragraphs_model.director_name)
// .replaceAll('${f_attempt_service_under_order}', this.attempts_paragraphs_model.service_under_order)
.replaceAll('${f_attempt_service_under_order}', this.service_under_order_HTML)

.replaceAll('${f_attempt_phone_number}', this.attempts_paragraphs_model.phone_number)


// NOT WORKING need to fix?
  // Agent Details
  .replaceAll('${f_attempt_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
  .replaceAll('${f_attempt_agent_first_name}', this.subject_service_agent.first_name)
  .replaceAll('${f_attempt_agent_middle_name}', this.subject_service_agent.middle_name)
  .replaceAll('${f_attempt_agent_surname}', this.subject_service_agent.surname)
  
  .replaceAll('${f_attempt_agent_address_1}', this.subject_service_agent.address_1)
  .replaceAll('${f_attempt_agent_address_2}', this.subject_service_agent.address_2)
  .replaceAll('${f_attempt_agent_suburb}', this.subject_service_agent.suburb)
  .replaceAll('${f_attempt_agent_state}', this.subject_service_agent.state)
  .replaceAll('${f_attempt_agent_postcode}', this.subject_service_agent.postcode)
  .replaceAll('${f_attempt_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
  .replaceAll('${f_attempt_agent_qualification}', this.subject_service_agent.qualification)
  .replaceAll('${f_attempt_agent_qualification_number}', this.subject_service_agent.qualification_number)
  
  .replaceAll('${f_attempt_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('D/M/YYYY') )
  .replaceAll('${f_attempt_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

  .replaceAll('${f_attempt_general_notes}',  this.set_general_notes ) // replace original only use this for create.

  .replaceAll('${f_attempt_is_count}', this.attempts_paragraphs_model.is_count)
  .replaceAll('${f_attempt_property_images}', this.attempts_paragraphs_model.property_images)
  .replaceAll('${f_attempt_attach_file_array_name}', this.attempts_paragraphs_model.attach_file_array_name)
  .replaceAll('${f_attempt_property_occupied}', this.attempts_paragraphs_model.property_occupied)

  .replaceAll('${f_attempt_property_forsale_or_lease_sign}', this.attempts_paragraphs_model.property_forsale_or_lease_sign)
  .replaceAll('${f_attempt_property_sign_images}', this.attempts_paragraphs_model.property_sign_images)
.replaceAll('${f_attempt_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll('${f_attempt_property_agent_name}', this.attempts_paragraphs_model.property_agent_name)
.replaceAll('${f_attempt_property_agency_name}', this.attempts_paragraphs_model.property_agency_name)
.replaceAll('${f_attempt_property_agency_contact_numbers}', this.attempts_paragraphs_model.property_agency_contact_numbers)


.replaceAll('${f_attempt_property_mail}', this.attempts_paragraphs_model.property_mail)
.replaceAll('${f_attempt_property_mail_images}', this.attempts_paragraphs_model.property_mail_images)
.replaceAll('${f_attempt_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll('${f_attempt_property_vehicles_sighted}', this.attempts_paragraphs_model.property_vehicles_sighted)
.replaceAll('${f_attempt_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
  .replaceAll('${f_attempt_property_vehicles_images}', this.attempts_paragraphs_model.property_vehicles_images)
  .replaceAll('${f_attempt_property_v_make}', this.attempts_paragraphs_model.property_v_make)
  .replaceAll('${f_attempt_property_v_model}', this.attempts_paragraphs_model.property_v_model)
  .replaceAll('${f_attempt_property_v_plate}', this.attempts_paragraphs_model.property_v_plate)
  .replaceAll('${f_attempt_property_v_rego_state}', this.attempts_paragraphs_model.property_v_rego_state)

  .replaceAll('${f_attempt_property_pets}', this.attempts_paragraphs_model.property_pets)
.replaceAll('${f_attempt_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
  .replaceAll('${f_attempt_property_pets_images}', this.attempts_paragraphs_model.property_pets_images)

.replaceAll('${f_attempt_property_occupancy}', this.attempts_paragraphs_model.property_occupancy)
.replaceAll('${f_attempt_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll('${f_attempt_property_occupancy_images}', this.attempts_paragraphs_model.property_occupancy_images)
.replaceAll('${f_attempt_property_o_name}', this.attempts_paragraphs_model.property_o_name)
.replaceAll('${f_attempt_property_o_contact_numbers}', this.attempts_paragraphs_model.property_o_contact_numbers)
.replaceAll('${f_attempt_property_o_lease_details}', this.attempts_paragraphs_model.property_o_lease_details)
.replaceAll('${f_attempt_property_o_lease_date}', this.attempts_paragraphs_model.property_o_lease_date)
.replaceAll('${f_attempt_property_o_landlord_contacts}', this.attempts_paragraphs_model.property_o_landlord_contacts)

.replaceAll('${f_attempt_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
  .replaceAll('${f_attempt_property_condition_images}', this.attempts_paragraphs_model.property_condition_images)

.replaceAll('${f_attempt_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll('${f_attempt_property_type_id}', this.attempts_paragraphs_model.property_type_id)
.replaceAll('${f_attempt_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll('${f_attempt_property_type_images}', this.attempts_paragraphs_model.property_type_images)

.replaceAll('${f_attempt_property_type_name}', this.attempts_paragraphs_model.property_type_name)

.replaceAll('${f_attempt_service_file_array}', this.attempts_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.attempts_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll('${f_attempt_property_image_0}',  this.propery_image_0 )
.replaceAll('${f_attempt_property_image_1}',  this.propery_image_1 )
.replaceAll('${f_attempt_property_image_2}',  this.propery_image_2 )
.replaceAll('${f_attempt_property_image_3}',  this.propery_image_3 )
.replaceAll('${f_attempt_property_image_4}',  this.propery_image_4 )
.replaceAll('${f_attempt_property_image_5}',  this.propery_image_5 )
.replaceAll('${f_attempt_property_image_6}',  this.propery_image_6 )
.replaceAll('${f_attempt_property_image_7}',  this.propery_image_7 )
.replaceAll('${f_attempt_property_image_8}',  this.propery_image_8 )
.replaceAll('${f_attempt_property_image_9}',  this.propery_image_9 )
.replaceAll('${f_attempt_property_image_10}',  this.propery_image_10 )
.replaceAll('${f_attempt_property_image_11}',  this.propery_image_11 )
.replaceAll('${f_attempt_property_image_12}',  this.propery_image_12 )
.replaceAll('${f_attempt_property_image_13}',  this.propery_image_13 )
.replaceAll('${f_attempt_property_image_14}',  this.propery_image_14 )
.replaceAll('${f_attempt_property_image_15}',  this.propery_image_15 )
.replaceAll('${f_attempt_property_image_16}',  this.propery_image_16 )
.replaceAll('${f_attempt_property_image_17}',  this.propery_image_17 )
.replaceAll('${f_attempt_property_image_18}',  this.propery_image_18 )
.replaceAll('${f_attempt_property_image_19}',  this.propery_image_19 )
.replaceAll('${f_attempt_property_image_20}',  this.propery_image_20 )
.replaceAll('${f_attempt_property_image_21}',  this.propery_image_21 )
.replaceAll('${f_attempt_property_image_22}',  this.propery_image_22 )
.replaceAll('${f_attempt_property_image_23}',  this.propery_image_23 )
.replaceAll('${f_attempt_property_image_24}',  this.propery_image_24 )
.replaceAll('${f_attempt_property_image_25}',  this.propery_image_25 )


.replaceAll('${f_attempt_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll('${f_attempt_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll('${f_attempt_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll('${f_attempt_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll('${f_attempt_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll('${f_attempt_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll('${f_attempt_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll('${f_attempt_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll('${f_attempt_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll('${f_attempt_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll('${f_attempt_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll('${f_attempt_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll('${f_attempt_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll('${f_attempt_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll('${f_attempt_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll('${f_attempt_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll('${f_attempt_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll('${f_attempt_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll('${f_attempt_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll('${f_attempt_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll('${f_attempt_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll('${f_attempt_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll('${f_attempt_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll('${f_attempt_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll('${f_attempt_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll('${f_attempt_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll('${f_attempt_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll('${f_attempt_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll('${f_attempt_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll('${f_attempt_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll('${f_attempt_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll('${f_attempt_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll('${f_attempt_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll('${f_attempt_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll('${f_attempt_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll('${f_attempt_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll('${f_attempt_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll('${f_attempt_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll('${f_attempt_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll('${f_attempt_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll('${f_attempt_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll('${f_attempt_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll('${f_attempt_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll('${f_attempt_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll('${f_attempt_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll('${f_attempt_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll('${f_attempt_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll('${f_attempt_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll('${f_attempt_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll('${f_attempt_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll('${f_attempt_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll('${f_attempt_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll('${f_attempt_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll('${f_attempt_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll('${f_attempt_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll('${f_attempt_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll('${f_attempt_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll('${f_attempt_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll('${f_attempt_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll('${f_attempt_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll('${f_attempt_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll('${f_attempt_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll('${f_attempt_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll('${f_attempt_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll('${f_attempt_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll('${f_attempt_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll('${f_attempt_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll('${f_attempt_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll('${f_attempt_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll('${f_attempt_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll('${f_attempt_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll('${f_attempt_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll('${f_attempt_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll('${f_attempt_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll('${f_attempt_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll('${f_attempt_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll('${f_attempt_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll('${f_attempt_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll('${f_attempt_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll('${f_attempt_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll('${f_attempt_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll('${f_attempt_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll('${f_attempt_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll('${f_attempt_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll('${f_attempt_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll('${f_attempt_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll('${f_attempt_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll('${f_attempt_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll('${f_attempt_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll('${f_attempt_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll('${f_attempt_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll('${f_attempt_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll('${f_attempt_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll('${f_attempt_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll('${f_attempt_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll('${f_attempt_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll('${f_attempt_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll('${f_attempt_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll('${f_attempt_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll('${f_attempt_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll('${f_attempt_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll('${f_attempt_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll('${f_attempt_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll('${f_attempt_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll('${f_attempt_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll('${f_attempt_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll('${f_attempt_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll('${f_attempt_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll('${f_attempt_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll('${f_attempt_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll('${f_attempt_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll('${f_attempt_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll('${f_attempt_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll('${f_attempt_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll('${f_attempt_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll('${f_attempt_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll('${f_attempt_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll('${f_attempt_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll('${f_attempt_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll('${f_attempt_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll('${f_attempt_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll('${f_attempt_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll('${f_attempt_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll('${f_attempt_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll('${f_attempt_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll('${f_attempt_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll('${f_attempt_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll('${f_attempt_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll('${f_attempt_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll('${f_attempt_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll('${f_attempt_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll('${f_attempt_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll('${f_attempt_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll('${f_attempt_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll('${f_attempt_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll('${f_attempt_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll('${f_attempt_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll('${f_attempt_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll('${f_attempt_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll('${f_attempt_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll('${f_attempt_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll('${f_attempt_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll('${f_attempt_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll('${f_attempt_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll('${f_attempt_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll('${f_attempt_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll('${f_attempt_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll('${f_attempt_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll('${f_attempt_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll('${f_attempt_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll('${f_attempt_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll('${f_attempt_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll('${f_attempt_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll('${f_attempt_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll('${f_attempt_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll('${f_attempt_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll('${f_attempt_property_type_image_0}',  this.property_type_image_0 )
.replaceAll('${f_attempt_property_type_image_1}',  this.property_type_image_1 )
.replaceAll('${f_attempt_property_type_image_2}',  this.property_type_image_2 )
.replaceAll('${f_attempt_property_type_image_3}',  this.property_type_image_3 )
.replaceAll('${f_attempt_property_type_image_4}',  this.property_type_image_4 )
.replaceAll('${f_attempt_property_type_image_5}',  this.property_type_image_5 )
.replaceAll('${f_attempt_property_type_image_6}',  this.property_type_image_6 )
.replaceAll('${f_attempt_property_type_image_7}',  this.property_type_image_7 )
.replaceAll('${f_attempt_property_type_image_8}',  this.property_type_image_8 )
.replaceAll('${f_attempt_property_type_image_9}',  this.property_type_image_9 )
.replaceAll('${f_attempt_property_type_image_10}',  this.property_type_image_10 )
.replaceAll('${f_attempt_property_type_image_11}',  this.property_type_image_11 )
.replaceAll('${f_attempt_property_type_image_12}',  this.property_type_image_12 )
.replaceAll('${f_attempt_property_type_image_13}',  this.property_type_image_13 )
.replaceAll('${f_attempt_property_type_image_14}',  this.property_type_image_14 )
.replaceAll('${f_attempt_property_type_image_15}',  this.property_type_image_15 )
.replaceAll('${f_attempt_property_type_image_16}',  this.property_type_image_16 )
.replaceAll('${f_attempt_property_type_image_17}',  this.property_type_image_17 )
.replaceAll('${f_attempt_property_type_image_18}',  this.property_type_image_18 )
.replaceAll('${f_attempt_property_type_image_19}',  this.property_type_image_19 )
.replaceAll('${f_attempt_property_type_image_20}',  this.property_type_image_20 )
.replaceAll('${f_attempt_property_type_image_21}',  this.property_type_image_21 )
.replaceAll('${f_attempt_property_type_image_22}',  this.property_type_image_22 )
.replaceAll('${f_attempt_property_type_image_23}',  this.property_type_image_23 )
.replaceAll('${f_attempt_property_type_image_24}',  this.property_type_image_24 )
.replaceAll('${f_attempt_property_type_image_25}',  this.property_type_image_25 )

.replaceAll('${f_attempt_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll('${f_attempt_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll('${f_attempt_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll('${f_attempt_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll('${f_attempt_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll('${f_attempt_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll('${f_attempt_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll('${f_attempt_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll('${f_attempt_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll('${f_attempt_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll('${f_attempt_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll('${f_attempt_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll('${f_attempt_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll('${f_attempt_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll('${f_attempt_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll('${f_attempt_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll('${f_attempt_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll('${f_attempt_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll('${f_attempt_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll('${f_attempt_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll('${f_attempt_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll('${f_attempt_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll('${f_attempt_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll('${f_attempt_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll('${f_attempt_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll('${f_attempt_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered
// return rendered_result f_service;
rendered_result = this.runReplaceAllVariables_AttemptsOnly_keystarter(rendered_result, model, 'f_attend', 2) // returns after running all the attempts.
rendered_result = this.runReplaceAllVariables_ServicesOnly_keystarter(rendered_result, model, 'f_service', 1)  // returns after running all the attempts.


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}




runReplaceAllVariables_AttemptsOnly_keystarter(str, model, keystarter, subject_attempt_type_id){


      // // Filters objects for nul and undefined values.
      // const obj = this.attempts_paragraphs_model;
      // const filteredObject = _.pickBy(obj, v =>  v.subject_attempt_type_id === subject_attempt_type_id);
      // // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
      // console.log('FilteredObject', JSON.stringify(filteredObject));



// Filter the array for attempt_type_id = 1 or 2 service or attemdamce -- Do a filter on the final RESULTS IF F SERVICE!!!!! 
// Do a simple loadash filter on attempts_paragraphs model.'

// change the data for a service
if (subject_attempt_type_id = 1)
{


}



 // set here like this as it was not laoding correctly -- quick hack fix...
 this._demoService.getBrandById(this.attempts_paragraphs_model.who_service_id).subscribe(
  (data) => {
    // this.brand_data = data;

    let res = data[0];
    // this.subject_service_agent = DataUtil.parse.parseJson(res);
    this.subject_service_agent = res;
    // this.allClientEmailRecipients = data;

this.toastr.success('Subject Service Agent Details Q')

    // let newArr = data
    // let  count_of_items = Object.keys(newArr).length;
    //   // need to do a loop of subject_billing items (.length)
    //   for (let i = 0; i < count_of_items; i++) {
    //   let res = newArr[i];
    //   this.allRecipients.push({
    //     recipient_name: res.name + ' - Client Report',
    //     recipient_email_address: res.email,
    //     recipient_brand_id: res.brand_id,
    //     recipient_brand_type_id: res.brand_type_id,
    //     recipient_user_id: null,
    //     recipient_user_level_id: null,
    //     recipient_type_name: 'Client Report',
    //   });
    //   } // end for loop
    // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

  },
  (err) => console.error(err),
  () => console.log('Brand Loaded.')
);



// New load the attending agent
// this.getBrand_Q(this.attempts_paragraphs_model.who_service_id)


  // Already loaded in the job/subject lookup
  // if(this.attempts_paragraphs_model.job_subject_type_id){
  //   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
  // }
  // let var_subject_type_name;
  // if(this.subject_job_subject_type != null){
  // var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
  // } else{
  // var_subject_type_name = '';
  // }


// NEED TO DETERMINE THE attempt_type === data

    // FIX THIS AND WE CAN USE FOR ALL. -- By getting   if(this.attempts_paragraphs_model){ to refresh or reset the data lookip as it needs to ne differemt for a service or attedance

// ATTEMPS
  // Current Attempt Variables Setups
  // Uppercase.
  if(this.attempts_paragraphs_model){

    let var_subject_attempt_type_name = this.attempts_paragraphs_model.subject_attempt_type_name
    if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
     this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
    }
  
  } // end if attemps paragraphs model.

if(this.attempts_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.attempts_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.attempts_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.attempts_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.attempts_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.attempts_paragraphs_model.vehicles_notes_HTML);}
if(this.attempts_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.attempts_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.attempts_paragraphs_model.neighbours_notes_HTML);}
if(this.attempts_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.attempts_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.attempts_paragraphs_model.calling_card_notes_HTML);}
if(this.attempts_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.attempts_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.attempts_paragraphs_model.postal_mail_notes_HTML);}
if(this.attempts_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.attempts_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.attempts_paragraphs_model.phone_call_notes_HTML);}
if(this.attempts_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.attempts_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.attempts_paragraphs_model.attempts_notes_HTML);}
if(this.attempts_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.attempts_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.attempts_paragraphs_model.email_contents_HTML);}
if(this.attempts_paragraphs_model.general_notes_HTML == null){
  this.set_general_notes = this.attempts_paragraphs_model.general_notes;
  }else{
   this.set_general_notes = this.transform2(this.attempts_paragraphs_model.general_notes_HTML)
  }
  if(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.attempts_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.attempts_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
  if(this.attempts_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.attempts_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.attempts_paragraphs_model.property_mail_details_HTML);}
  if(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.attempts_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.attempts_paragraphs_model.property_vehicles_sighted_details_HTML);}  
  if(this.attempts_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.attempts_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.attempts_paragraphs_model.property_pets_details_HTML);}

  if(this.attempts_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.attempts_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupancy_details_HTML);}
  
  if(this.attempts_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.attempts_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.attempts_paragraphs_model.property_condition_HTML);}
if(this.attempts_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.attempts_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.attempts_paragraphs_model.property_occupied_details_HTML);}
if(this.attempts_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.attempts_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.attempts_paragraphs_model.property_type_details_HTML);}
if(this.attempts_paragraphs_model.service_under_order_HTML == null){this.service_under_order_HTML = this.attempts_paragraphs_model.service_under_order; }else{this.service_under_order_HTML = this.transform2(this.attempts_paragraphs_model.service_under_order_HTML);}



 // Do checks for subject name / Businesss Name of FUll SUbject Name fields
 let var_subject_name =  this.attempts_paragraphs_model.first_name + ' ' +  this.attempts_paragraphs_model.middlename + ' '+  this.attempts_paragraphs_model.surname;
 let var_subject_name_4_doc = this.attempts_paragraphs_model.first_name +'-'+  this.attempts_paragraphs_model.surname;
 let var_subject_business_name =  this.attempts_paragraphs_model.business_name;
 
 // Subject Name of Business
     if(var_subject_business_name != null){
         let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
         // $subject_name = $trim_subject_business_name;
          var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
           var_subject_name_4_doc= var_trim_subject_business_name;
         
     }



if(this.attempts_paragraphs_model.service_paragraph_rendered == null){
  this.set_service_paragraph_rendered = '';
 }else{
  this.set_service_paragraph_rendered = this.attempts_paragraphs_model.service_paragraph_rendered; // does not require encodeing
}

// Property Images
if(this.attempts_paragraphs_model.property_images != '[]' || this.attempts_paragraphs_model.property_images != null){
  this.property_images = JSON.parse(this.attempts_paragraphs_model.property_images)



  let newArr = this.property_images;
  let  count_of_items = Object.keys(newArr).length;

  // let  count_of_items = 25;
  //   let  count_of_items = Object.keys(newArr).length;
  // //     for(let i=0;i < count_of_items; i++) { 
  // //     let res = newArr[i];
  // // }
 
  if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
  if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
  if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
  if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
  if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
  if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
  if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
  if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
  if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
  if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
  if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
  if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
  if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
  if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
  if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
  if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
  if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
  if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
  if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
  if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
  if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
  if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
  if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
  if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
  if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
  if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}
   


  

  // Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
  // loop 0 - 25 and only set if exisis or '' if not.


}

if(this.attempts_paragraphs_model.property_sign_images != '[]' && this.attempts_paragraphs_model.property_sign_images != null){
  this.property_sign_images = JSON.parse(this.attempts_paragraphs_model.property_sign_images)
  let newArr = this.property_sign_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
  if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
  if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
  if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
  if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
  if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
  if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
  if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
  if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
  if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
  if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
  if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
  if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
  if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
  if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
  if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
  if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
  if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
  if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
  if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
  if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
  if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
  if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
  if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
  if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
  if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_mail_images != '[]' && this.attempts_paragraphs_model.property_mail_images != null ){
  this.property_mail_images = JSON.parse(this.attempts_paragraphs_model.property_mail_images)
  let newArr = this.property_mail_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
  if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
  if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
  if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
  if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
  if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
  if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
  if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
  if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
  if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
  if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
  if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
  if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
  if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
  if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
  if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
  if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
  if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
  if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
  if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
  if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
  if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
  if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
  if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
  if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
  if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}
  
if(this.attempts_paragraphs_model.property_vehicles_images != '[]' && this.attempts_paragraphs_model.property_vehicles_images != null){
  this.property_vehicles_images = JSON.parse(this.attempts_paragraphs_model.property_vehicles_images)
  let newArr = this.property_vehicles_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.gfunc.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
  if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
  if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
  if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
  if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
  if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
  if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
  if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
  if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
  if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
  if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
  if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
  if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
  if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
  if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
  if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
  if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
  if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
  if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
  if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
  if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
  if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
  if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
  if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
  if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
  if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.attempts_paragraphs_model.property_pets_images != '[]' && this.attempts_paragraphs_model.property_pets_images != null){
  this.property_pets_images = JSON.parse(this.attempts_paragraphs_model.property_pets_images)
  let newArr = this.property_pets_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
  if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
  if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
  if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
  if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
  if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
  if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
  if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
  if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
  if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
  if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
  if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
  if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
  if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
  if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
  if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
  if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
  if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
  if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
  if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
  if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
  if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
  if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
  if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
  if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
  if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.attempts_paragraphs_model.property_occupancy_images != '[]' && this.attempts_paragraphs_model.property_occupancy_images != null){
  this.property_occupancy_images = JSON.parse(this.attempts_paragraphs_model.property_occupancy_images)
  let newArr = this.property_occupancy_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
  if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
  if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
  if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
  if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
  if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
  if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
  if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
  if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
  if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
  if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
  if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
  if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
  if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
  if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
  if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
  if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
  if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
  if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
  if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
  if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
  if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
  if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
  if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
  if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
  if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.attempts_paragraphs_model.property_condition_images != '[]' && this.attempts_paragraphs_model.property_condition_images != null ){
  this.property_condition_images = JSON.parse(this.attempts_paragraphs_model.property_condition_images)
  let newArr = this.property_condition_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
  if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
  if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
  if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
  if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
  if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
  if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
  if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
  if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
  if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
  if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
  if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
  if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
  if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
  if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
  if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
  if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
  if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
  if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
  if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
  if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
  if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
  if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
  if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
  if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
  if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.attempts_paragraphs_model.property_type_images != '[]' && this.attempts_paragraphs_model.property_type_images != null){
  this.property_type_images = JSON.parse(this.attempts_paragraphs_model.property_type_images)
  let newArr = this.property_type_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
  if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
  if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
  if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
  if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
  if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
  if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
  if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
  if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
  if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
  if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
  if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
  if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
  if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
  if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
  if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
  if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
  if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
  if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
  if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
  if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
  if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
  if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
  if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
  if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
  if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.attempts_paragraphs_model.service_file_array != '[]' && this.attempts_paragraphs_model.service_file_array != null){
  this.service_file_array_images = JSON.parse(this.attempts_paragraphs_model.service_file_array)
  let newArr = this.service_file_array_images;
  let  count_of_items = Object.keys(newArr).length;

  if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
  if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
  if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
  if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
  if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
  if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
  if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
  if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
  if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
  if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
  if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
  if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
  if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
  if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
  if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
  if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
  if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
  if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
  if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
  if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
  if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
  if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
  if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
  if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
  if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
  if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.gfunc.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

  const rendered_result = str



      .replaceAll( '${' + keystarter + '_type_id}', this.attempts_paragraphs_model.subject_attempt_type_id)
      .replaceAll( '${' + keystarter + '_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll( '${' + keystarter + '_subject_attempt_type_name}', this.attempts_paragraphs_model.subject_attempt_type_name ) // run a function with return;
      .replaceAll( '${' + keystarter + '_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

      .replaceAll( '${' + keystarter + '_subject_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id)
      .replaceAll( '${' + keystarter + '_subject_service_method_name}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll( '${' + keystarter + '_service_method}', this.attempts_paragraphs_model.subject_service_method_name ) // tested above.
      .replaceAll( '${' + keystarter + '_service_method_id}', this.attempts_paragraphs_model.subject_service_method_id) // tested above.


      .replaceAll( '${' + keystarter + '_date_service}', moment(this.attempts_paragraphs_model.date_service).format('D/M/YYYY'))
      .replaceAll( '${' + keystarter + '_date_service_full_words_time_first}', this.attempts_paragraphs_model.time_service_text + ' ' + moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
      .replaceAll( '${' + keystarter + '_date_service_and_time_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.attempts_paragraphs_model.time_service_text ) 
      .replaceAll( '${' + keystarter + '_date_service_full_words}', moment(this.attempts_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

      .replaceAll( '${' + keystarter + '_day}', moment(this.attempts_paragraphs_model.date_service).format('dddd'))
      .replaceAll( '${' + keystarter + '_day_number}', moment(this.attempts_paragraphs_model.date_service).format('Do'))
      .replaceAll( '${' + keystarter + '_day_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('D'))
      .replaceAll( '${' + keystarter + '_month}', moment(this.attempts_paragraphs_model.date_service).format('MMMM'))
      .replaceAll( '${' + keystarter + '_month_number}', moment(this.attempts_paragraphs_model.date_service).format('Mo'))
      .replaceAll( '${' + keystarter + '_month_number_simple}', moment(this.attempts_paragraphs_model.date_service).format('M'))
      .replaceAll( '${' + keystarter + '_year}', moment(this.attempts_paragraphs_model.date_service).format('YYYY'))

      .replaceAll( '${' + keystarter + '_service_local}', this.attempts_paragraphs_model.service_local) // region Australia/Perth of service undertaken
      .replaceAll( '${' + keystarter + '_time}', this.attempts_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll( '${' + keystarter + '_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

      .replaceAll( '${' + keystarter + '_subject_name}', var_subject_name)
      .replaceAll( '${' + keystarter + '_subject_number}', this.attempts_paragraphs_model.subject_number)
      .replaceAll( '${' + keystarter + '_subject_name_4_doc}', var_subject_name_4_doc)
      .replaceAll( '${' + keystarter + '_subject_business_name}', var_subject_business_name)
      .replaceAll( '${' + keystarter + '_business_name}', var_subject_business_name)

  // Subject Attempt Address
  .replaceAll( '${' + keystarter + '_address_1}', this.attempts_paragraphs_model.address_1)
  .replaceAll( '${' + keystarter + '_address_2}', this.attempts_paragraphs_model.address_2)
  .replaceAll( '${' + keystarter + '_suburb}', this.attempts_paragraphs_model.suburb)
  .replaceAll( '${' + keystarter + '_state}', this.attempts_paragraphs_model.state)
  .replaceAll( '${' + keystarter + '_postcode}', this.attempts_paragraphs_model.postcode)
  .replaceAll( '${' + keystarter + '_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // Sav
  .replaceAll( '${' + keystarter + '_sav_address_full}', this.attempts_paragraphs_model.address_1 +  ' ' + this.attempts_paragraphs_model.address_2 +  ' ' + this.attempts_paragraphs_model.suburb +  ' ' + this.attempts_paragraphs_model.state +  ',  ' + this.attempts_paragraphs_model.postcode )
  // New address
  .replaceAll( '${' + keystarter + '_new_business_name}', this.attempts_paragraphs_model.new_business_name)
  .replaceAll( '${' + keystarter + '_new_address_1}', this.attempts_paragraphs_model.new_address_1)
  .replaceAll( '${' + keystarter + '_new_address_2}', this.attempts_paragraphs_model.new_address_2)
  .replaceAll( '${' + keystarter + '_new_suburb}', this.attempts_paragraphs_model.new_suburb)
  .replaceAll( '${' + keystarter + '_new_state}', this.attempts_paragraphs_model.new_state)
  .replaceAll( '${' + keystarter + '_new_postcode}', this.attempts_paragraphs_model.new_postcode)
  .replaceAll( '${' + keystarter + '_new_address_full}', this.attempts_paragraphs_model.new_address_1 +  ' ' + this.attempts_paragraphs_model.new_address_2 +  ' ' + this.attempts_paragraphs_model.new_suburb +  ' ' + this.attempts_paragraphs_model.new_state +  ',  ' + this.attempts_paragraphs_model.new_postcode )
  
  .replaceAll( '${' + keystarter + '_service_number}', this.attempts_paragraphs_model.service_number)

  .replaceAll( '${' + keystarter + '_service_outcome_name}', this.attempts_paragraphs_model.subject_service_outcome_name)
  .replaceAll( '${' + keystarter + '_exact_service_method_name}', this.attempts_paragraphs_model.exact_service_method_name) //
  .replaceAll( '${' + keystarter + '_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
  .replaceAll( '${' + keystarter + '_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
  .replaceAll( '${' + keystarter + '_location_status_name}', this.attempts_paragraphs_model.subject_location_status_name)
  .replaceAll( '${' + keystarter + '_location_status_found_name}', this.attempts_paragraphs_model.subject_location_status_found_name)

  .replaceAll( '${' + keystarter + '_fellow_occupants_name}', this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll( '${' + keystarter + '_fellow_occupants_sex}', this.attempts_paragraphs_model.fellow_occupants_sex)
  .replaceAll( '${' + keystarter + '_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.attempts_paragraphs_model.fellow_occupants_name)
  .replaceAll( '${' + keystarter + '_subject_relationship_name}', this.attempts_paragraphs_model.subject_service_fellow_relationship)

  .replaceAll( '${' + keystarter + '_person_spoken_with}', this.attempts_paragraphs_model.person_spoken_with)
  .replaceAll( '${' + keystarter + '_person_type}', this.attempts_paragraphs_model.person_type)
  .replaceAll( '${' + keystarter + '_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

  .replaceAll( '${' + keystarter + '_vehicles}', this.attempts_paragraphs_model.vehicles)
.replaceAll( '${' + keystarter + '_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_neighbours}', this.attempts_paragraphs_model.neighbours)
.replaceAll( '${' + keystarter + '_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_calling_card}', this.attempts_paragraphs_model.calling_card)
.replaceAll( '${' + keystarter + '_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_postal_mail}', this.attempts_paragraphs_model.postal_mail)
.replaceAll( '${' + keystarter + '_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_phone_call}', this.attempts_paragraphs_model.phone_call)
.replaceAll( '${' + keystarter + '_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_attempts}', this.attempts_paragraphs_model.attempts)
.replaceAll( '${' + keystarter + '_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_authorised_employee_name}', this.attempts_paragraphs_model.authorised_employee_name)
.replaceAll( '${' + keystarter + '_authorised_employee_job_title}', this.attempts_paragraphs_model.authorised_employee_job_title)
.replaceAll( '${' + keystarter + '_authorised_employee_sex}', this.attempts_paragraphs_model.authorised_employee_sex)
.replaceAll( '${' + keystarter + '_office_business_name}', this.attempts_paragraphs_model.office_business_name)

.replaceAll( '${' + keystarter + '_witness_name}', this.attempts_paragraphs_model.witness_name)
.replaceAll( '${' + keystarter + '_witness_business_name}', this.attempts_paragraphs_model.witness_business_name)
.replaceAll( '${' + keystarter + '_witness_address}', this.attempts_paragraphs_model.witness_address_1 + ' ' + this.attempts_paragraphs_model.witness_address_2 + ' ' +  this.attempts_paragraphs_model.witness_suburb + ' ' + this.attempts_paragraphs_model.witness_state + ', ' + this.attempts_paragraphs_model.witness_postcode  ) // 
.replaceAll( '${' + keystarter + '_witness_address_1}', this.attempts_paragraphs_model.witness_address_1)
.replaceAll( '${' + keystarter + '_witness_address_2}', this.attempts_paragraphs_model.witness_address_2)
.replaceAll( '${' + keystarter + '_witness_state}', this.attempts_paragraphs_model.witness_state)
.replaceAll( '${' + keystarter + '_witness_suburb}', this.attempts_paragraphs_model.witness_suburb)
.replaceAll( '${' + keystarter + '_witness_country}', this.attempts_paragraphs_model.witness_country)
.replaceAll( '${' + keystarter + '_witness_postcode}', this.attempts_paragraphs_model.witness_postcode)

.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_name}', this.attempts_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_occupation}', this.attempts_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll( '${' + keystarter + '_ubject_contact_email_id}', this.attempts_paragraphs_model.subject_contact_email_id)
.replaceAll( '${' + keystarter + '_email_address_served}', this.attempts_paragraphs_model.email_address_served)
.replaceAll( '${' + keystarter + '_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_director_name}', this.attempts_paragraphs_model.director_name)
// .replaceAll( '${' + keystarter + '_service_under_order}', this.attempts_paragraphs_model.service_under_order)
.replaceAll( '${' + keystarter + '_service_under_order}', this.service_under_order_HTML)

.replaceAll( '${' + keystarter + '_phone_number}', this.attempts_paragraphs_model.phone_number)


// need to fix this below - not working 24
  // Agent Details
  .replaceAll( '${' + keystarter + '_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
  .replaceAll( '${' + keystarter + '_agent_first_name}', this.subject_service_agent.first_name)
  .replaceAll( '${' + keystarter + '_agent_middle_name}', this.subject_service_agent.middle_name)
  .replaceAll( '${' + keystarter + '_agent_surname}', this.subject_service_agent.surname)
  
  .replaceAll( '${' + keystarter + '_agent_address_1}', this.subject_service_agent.address_1)
  .replaceAll( '${' + keystarter + '_agent_address_2}', this.subject_service_agent.address_2)
  .replaceAll( '${' + keystarter + '_agent_suburb}', this.subject_service_agent.suburb)
  .replaceAll( '${' + keystarter + '_agent_state}', this.subject_service_agent.state)
  .replaceAll( '${' + keystarter + '_agent_postcode}', this.subject_service_agent.postcode)
  .replaceAll( '${' + keystarter + '_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
  .replaceAll( '${' + keystarter + '_agent_qualification}', this.subject_service_agent.qualification)
  .replaceAll( '${' + keystarter + '_agent_qualification_number}', this.subject_service_agent.qualification_number)
  
  .replaceAll( '${' + keystarter + '_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('D/M/YYYY') )
  .replaceAll( '${' + keystarter + '_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

  .replaceAll( '${' + keystarter + '_general_notes}',  this.set_general_notes ) // replace original only use this for create.

  .replaceAll( '${' + keystarter + '_is_count}', this.attempts_paragraphs_model.is_count)
  .replaceAll( '${' + keystarter + '_property_images}', this.attempts_paragraphs_model.property_images)
  .replaceAll( '${' + keystarter + '_attach_file_array_name}', this.attempts_paragraphs_model.attach_file_array_name)
  .replaceAll( '${' + keystarter + '_property_occupied}', this.attempts_paragraphs_model.property_occupied)

  .replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign}', this.attempts_paragraphs_model.property_forsale_or_lease_sign)
  .replaceAll( '${' + keystarter + '_property_sign_images}', this.attempts_paragraphs_model.property_sign_images)
.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_agent_name}', this.attempts_paragraphs_model.property_agent_name)
.replaceAll( '${' + keystarter + '_property_agency_name}', this.attempts_paragraphs_model.property_agency_name)
.replaceAll( '${' + keystarter + '_property_agency_contact_numbers}', this.attempts_paragraphs_model.property_agency_contact_numbers)


.replaceAll( '${' + keystarter + '_property_mail}', this.attempts_paragraphs_model.property_mail)
.replaceAll( '${' + keystarter + '_property_mail_images}', this.attempts_paragraphs_model.property_mail_images)
.replaceAll( '${' + keystarter + '_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_vehicles_sighted}', this.attempts_paragraphs_model.property_vehicles_sighted)
.replaceAll( '${' + keystarter + '_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_vehicles_images}', this.attempts_paragraphs_model.property_vehicles_images)
  .replaceAll( '${' + keystarter + '_property_v_make}', this.attempts_paragraphs_model.property_v_make)
  .replaceAll( '${' + keystarter + '_property_v_model}', this.attempts_paragraphs_model.property_v_model)
  .replaceAll( '${' + keystarter + '_property_v_plate}', this.attempts_paragraphs_model.property_v_plate)
  .replaceAll( '${' + keystarter + '_property_v_rego_state}', this.attempts_paragraphs_model.property_v_rego_state)

  .replaceAll( '${' + keystarter + '_property_pets}', this.attempts_paragraphs_model.property_pets)
.replaceAll( '${' + keystarter + '_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_pets_images}', this.attempts_paragraphs_model.property_pets_images)

.replaceAll( '${' + keystarter + '_property_occupancy}', this.attempts_paragraphs_model.property_occupancy)
.replaceAll( '${' + keystarter + '_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_occupancy_images}', this.attempts_paragraphs_model.property_occupancy_images)
.replaceAll( '${' + keystarter + '_property_o_name}', this.attempts_paragraphs_model.property_o_name)
.replaceAll( '${' + keystarter + '_property_o_contact_numbers}', this.attempts_paragraphs_model.property_o_contact_numbers)
.replaceAll( '${' + keystarter + '_property_o_lease_details}', this.attempts_paragraphs_model.property_o_lease_details)
.replaceAll( '${' + keystarter + '_property_o_lease_date}', this.attempts_paragraphs_model.property_o_lease_date)
.replaceAll( '${' + keystarter + '_property_o_landlord_contacts}', this.attempts_paragraphs_model.property_o_landlord_contacts)

.replaceAll( '${' + keystarter + '_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
  .replaceAll( '${' + keystarter + '_property_condition_images}', this.attempts_paragraphs_model.property_condition_images)

.replaceAll( '${' + keystarter + '_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_type_id}', this.attempts_paragraphs_model.property_type_id)
.replaceAll( '${' + keystarter + '_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_type_images}', this.attempts_paragraphs_model.property_type_images)

.replaceAll( '${' + keystarter + '_property_type_name}', this.attempts_paragraphs_model.property_type_name)

.replaceAll( '${' + keystarter + '_service_file_array}', this.attempts_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.attempts_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll( '${' + keystarter + '_property_image_0}',  this.propery_image_0 )
.replaceAll( '${' + keystarter + '_property_image_1}',  this.propery_image_1 )
.replaceAll( '${' + keystarter + '_property_image_2}',  this.propery_image_2 )
.replaceAll( '${' + keystarter + '_property_image_3}',  this.propery_image_3 )
.replaceAll( '${' + keystarter + '_property_image_4}',  this.propery_image_4 )
.replaceAll( '${' + keystarter + '_property_image_5}',  this.propery_image_5 )
.replaceAll( '${' + keystarter + '_property_image_6}',  this.propery_image_6 )
.replaceAll( '${' + keystarter + '_property_image_7}',  this.propery_image_7 )
.replaceAll( '${' + keystarter + '_property_image_8}',  this.propery_image_8 )
.replaceAll( '${' + keystarter + '_property_image_9}',  this.propery_image_9 )
.replaceAll( '${' + keystarter + '_property_image_10}',  this.propery_image_10 )
.replaceAll( '${' + keystarter + '_property_image_11}',  this.propery_image_11 )
.replaceAll( '${' + keystarter + '_property_image_12}',  this.propery_image_12 )
.replaceAll( '${' + keystarter + '_property_image_13}',  this.propery_image_13 )
.replaceAll( '${' + keystarter + '_property_image_14}',  this.propery_image_14 )
.replaceAll( '${' + keystarter + '_property_image_15}',  this.propery_image_15 )
.replaceAll( '${' + keystarter + '_property_image_16}',  this.propery_image_16 )
.replaceAll( '${' + keystarter + '_property_image_17}',  this.propery_image_17 )
.replaceAll( '${' + keystarter + '_property_image_18}',  this.propery_image_18 )
.replaceAll( '${' + keystarter + '_property_image_19}',  this.propery_image_19 )
.replaceAll( '${' + keystarter + '_property_image_20}',  this.propery_image_20 )
.replaceAll( '${' + keystarter + '_property_image_21}',  this.propery_image_21 )
.replaceAll( '${' + keystarter + '_property_image_22}',  this.propery_image_22 )
.replaceAll( '${' + keystarter + '_property_image_23}',  this.propery_image_23 )
.replaceAll( '${' + keystarter + '_property_image_24}',  this.propery_image_24 )
.replaceAll( '${' + keystarter + '_property_image_25}',  this.propery_image_25 )


.replaceAll( '${' + keystarter + '_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll( '${' + keystarter + '_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll( '${' + keystarter + '_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll( '${' + keystarter + '_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll( '${' + keystarter + '_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll( '${' + keystarter + '_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll( '${' + keystarter + '_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll( '${' + keystarter + '_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll( '${' + keystarter + '_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll( '${' + keystarter + '_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll( '${' + keystarter + '_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll( '${' + keystarter + '_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll( '${' + keystarter + '_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll( '${' + keystarter + '_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll( '${' + keystarter + '_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll( '${' + keystarter + '_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll( '${' + keystarter + '_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll( '${' + keystarter + '_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll( '${' + keystarter + '_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll( '${' + keystarter + '_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll( '${' + keystarter + '_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll( '${' + keystarter + '_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll( '${' + keystarter + '_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll( '${' + keystarter + '_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll( '${' + keystarter + '_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll( '${' + keystarter + '_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll( '${' + keystarter + '_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll( '${' + keystarter + '_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll( '${' + keystarter + '_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll( '${' + keystarter + '_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll( '${' + keystarter + '_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll( '${' + keystarter + '_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll( '${' + keystarter + '_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll( '${' + keystarter + '_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll( '${' + keystarter + '_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll( '${' + keystarter + '_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll( '${' + keystarter + '_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll( '${' + keystarter + '_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll( '${' + keystarter + '_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll( '${' + keystarter + '_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll( '${' + keystarter + '_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll( '${' + keystarter + '_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll( '${' + keystarter + '_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll( '${' + keystarter + '_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll( '${' + keystarter + '_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll( '${' + keystarter + '_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll( '${' + keystarter + '_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll( '${' + keystarter + '_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll( '${' + keystarter + '_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll( '${' + keystarter + '_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll( '${' + keystarter + '_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll( '${' + keystarter + '_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll( '${' + keystarter + '_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll( '${' + keystarter + '_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll( '${' + keystarter + '_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll( '${' + keystarter + '_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll( '${' + keystarter + '_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll( '${' + keystarter + '_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll( '${' + keystarter + '_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll( '${' + keystarter + '_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll( '${' + keystarter + '_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll( '${' + keystarter + '_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll( '${' + keystarter + '_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll( '${' + keystarter + '_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll( '${' + keystarter + '_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll( '${' + keystarter + '_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll( '${' + keystarter + '_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll( '${' + keystarter + '_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll( '${' + keystarter + '_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll( '${' + keystarter + '_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll( '${' + keystarter + '_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll( '${' + keystarter + '_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll( '${' + keystarter + '_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll( '${' + keystarter + '_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll( '${' + keystarter + '_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll( '${' + keystarter + '_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll( '${' + keystarter + '_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll( '${' + keystarter + '_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll( '${' + keystarter + '_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll( '${' + keystarter + '_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll( '${' + keystarter + '_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll( '${' + keystarter + '_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll( '${' + keystarter + '_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll( '${' + keystarter + '_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll( '${' + keystarter + '_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll( '${' + keystarter + '_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll( '${' + keystarter + '_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll( '${' + keystarter + '_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll( '${' + keystarter + '_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll( '${' + keystarter + '_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll( '${' + keystarter + '_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll( '${' + keystarter + '_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll( '${' + keystarter + '_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll( '${' + keystarter + '_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll( '${' + keystarter + '_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll( '${' + keystarter + '_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll( '${' + keystarter + '_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll( '${' + keystarter + '_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll( '${' + keystarter + '_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll( '${' + keystarter + '_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll( '${' + keystarter + '_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll( '${' + keystarter + '_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll( '${' + keystarter + '_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll( '${' + keystarter + '_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll( '${' + keystarter + '_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll( '${' + keystarter + '_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll( '${' + keystarter + '_property_type_image_0}',  this.property_type_image_0 )
.replaceAll( '${' + keystarter + '_property_type_image_1}',  this.property_type_image_1 )
.replaceAll( '${' + keystarter + '_property_type_image_2}',  this.property_type_image_2 )
.replaceAll( '${' + keystarter + '_property_type_image_3}',  this.property_type_image_3 )
.replaceAll( '${' + keystarter + '_property_type_image_4}',  this.property_type_image_4 )
.replaceAll( '${' + keystarter + '_property_type_image_5}',  this.property_type_image_5 )
.replaceAll( '${' + keystarter + '_property_type_image_6}',  this.property_type_image_6 )
.replaceAll( '${' + keystarter + '_property_type_image_7}',  this.property_type_image_7 )
.replaceAll( '${' + keystarter + '_property_type_image_8}',  this.property_type_image_8 )
.replaceAll( '${' + keystarter + '_property_type_image_9}',  this.property_type_image_9 )
.replaceAll( '${' + keystarter + '_property_type_image_10}',  this.property_type_image_10 )
.replaceAll( '${' + keystarter + '_property_type_image_11}',  this.property_type_image_11 )
.replaceAll( '${' + keystarter + '_property_type_image_12}',  this.property_type_image_12 )
.replaceAll( '${' + keystarter + '_property_type_image_13}',  this.property_type_image_13 )
.replaceAll( '${' + keystarter + '_property_type_image_14}',  this.property_type_image_14 )
.replaceAll( '${' + keystarter + '_property_type_image_15}',  this.property_type_image_15 )
.replaceAll( '${' + keystarter + '_property_type_image_16}',  this.property_type_image_16 )
.replaceAll( '${' + keystarter + '_property_type_image_17}',  this.property_type_image_17 )
.replaceAll( '${' + keystarter + '_property_type_image_18}',  this.property_type_image_18 )
.replaceAll( '${' + keystarter + '_property_type_image_19}',  this.property_type_image_19 )
.replaceAll( '${' + keystarter + '_property_type_image_20}',  this.property_type_image_20 )
.replaceAll( '${' + keystarter + '_property_type_image_21}',  this.property_type_image_21 )
.replaceAll( '${' + keystarter + '_property_type_image_22}',  this.property_type_image_22 )
.replaceAll( '${' + keystarter + '_property_type_image_23}',  this.property_type_image_23 )
.replaceAll( '${' + keystarter + '_property_type_image_24}',  this.property_type_image_24 )
.replaceAll( '${' + keystarter + '_property_type_image_25}',  this.property_type_image_25 )

.replaceAll( '${' + keystarter + '_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll( '${' + keystarter + '_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll( '${' + keystarter + '_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll( '${' + keystarter + '_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll( '${' + keystarter + '_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll( '${' + keystarter + '_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll( '${' + keystarter + '_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll( '${' + keystarter + '_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll( '${' + keystarter + '_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll( '${' + keystarter + '_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll( '${' + keystarter + '_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll( '${' + keystarter + '_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll( '${' + keystarter + '_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll( '${' + keystarter + '_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll( '${' + keystarter + '_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll( '${' + keystarter + '_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll( '${' + keystarter + '_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll( '${' + keystarter + '_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll( '${' + keystarter + '_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll( '${' + keystarter + '_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll( '${' + keystarter + '_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll( '${' + keystarter + '_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll( '${' + keystarter + '_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll( '${' + keystarter + '_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll( '${' + keystarter + '_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll( '${' + keystarter + '_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}

// different data model.
runReplaceAllVariables_ServicesOnly_keystarter(str, model, keystarter, subject_attempt_type_id){


  // // Filters objects for nul and undefined values.
  // const obj = this.attempts_paragraphs_model;
  // const filteredObject = _.pickBy(obj, v =>  v.subject_attempt_type_id === subject_attempt_type_id);
  // // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
  // console.log('FilteredObject', JSON.stringify(filteredObject));



// Filter the array for attempt_type_id = 1 or 2 service or attemdamce -- Do a filter on the final RESULTS IF F SERVICE!!!!! 
// Do a simple loadash filter on attempts_paragraphs model.'

// change the data for a service
if (subject_attempt_type_id = 1)
{


}


if(this.service_paragraphs_model){
 // set here like this as it was not laoding correctly -- quick hack fix...
 this._demoService.getBrandById(this.service_paragraphs_model.who_service_id).subscribe(
  (data) => {
    // this.brand_data = data;

    let res = data[0];
    // this.subject_service_agent = DataUtil.parse.parseJson(res);
    this.subject_service_agent = res;
    // this.allClientEmailRecipients = data;

this.toastr.success('Subject Service Agent Details Q')

    // let newArr = data
    // let  count_of_items = Object.keys(newArr).length;
    //   // need to do a loop of subject_billing items (.length)
    //   for (let i = 0; i < count_of_items; i++) {
    //   let res = newArr[i];
    //   this.allRecipients.push({
    //     recipient_name: res.name + ' - Client Report',
    //     recipient_email_address: res.email,
    //     recipient_brand_id: res.brand_id,
    //     recipient_brand_type_id: res.brand_type_id,
    //     recipient_user_id: null,
    //     recipient_user_level_id: null,
    //     recipient_type_name: 'Client Report',
    //   });
    //   } // end for loop
    // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

  },
  (err) => console.error(err),
  () => console.log('Brand Loaded.')
);

}

// Already loaded in the job/subject lookup
// if(this.attempts_paragraphs_model.job_subject_type_id){
//   this.getJobSubjectType_Q(this.attempts_paragraphs_model.job_subject_type_id) ;
// }
// let var_subject_type_name;
// if(this.subject_job_subject_type != null){
// var_subject_type_name = this.subject_job_subject_type.job_subject_type_name
// } else{
// var_subject_type_name = '';
// }


// New load the attending agent
// this.getBrand_Q(this.service_paragraphs_model.who_service_id)



// NEED TO DETERMINE THE attempt_type === data

// FIX THIS AND WE CAN USE FOR ALL. -- By getting   if(this.attempts_paragraphs_model){ to refresh or reset the data lookip as it needs to ne differemt for a service or attedance

// ATTEMPS
// Current Attempt Variables Setups
// Uppercase.
if(this.service_paragraphs_model){

let var_subject_attempt_type_name = this.service_paragraphs_model.subject_attempt_type_name
if(var_subject_attempt_type_name != null){ // uppercase must be validated if not null
 this.var_subject_attempt_type_name_Upper = var_subject_attempt_type_name.toUpperCase();
}

} // end if attemps paragraphs model.

if(this.service_paragraphs_model.person_spoken_with_advised_HTML == null){this.person_spoken_with_advised_HTML = this.service_paragraphs_model.person_spoken_with_advised; }else{this.person_spoken_with_advised_HTML = this.transform2(this.service_paragraphs_model.person_spoken_with_advised_HTML);}
if(this.service_paragraphs_model.vehicles_notes_HTML == null){this.vehicles_notes_HTML = this.service_paragraphs_model.vehicles_notes; }else{this.vehicles_notes_HTML = this.transform2(this.service_paragraphs_model.vehicles_notes_HTML);}
if(this.service_paragraphs_model.neighbours_notes_HTML == null){this.neighbours_notes_HTML = this.service_paragraphs_model.neighbours_notes; }else{this.neighbours_notes_HTML = this.transform2(this.service_paragraphs_model.neighbours_notes_HTML);}
if(this.service_paragraphs_model.calling_card_notes_HTML == null){this.calling_card_notes_HTML = this.service_paragraphs_model.calling_card_notes; }else{this.calling_card_notes_HTML = this.transform2(this.service_paragraphs_model.calling_card_notes_HTML);}
if(this.service_paragraphs_model.postal_mail_notes_HTML == null){this.postal_mail_notes_HTML = this.service_paragraphs_model.postal_mail_notes; }else{this.postal_mail_notes_HTML = this.transform2(this.service_paragraphs_model.postal_mail_notes_HTML);}
if(this.service_paragraphs_model.phone_call_notes_HTML == null){this.phone_call_notes_HTML = this.service_paragraphs_model.phone_call_notes; }else{this.phone_call_notes_HTML = this.transform2(this.service_paragraphs_model.phone_call_notes_HTML);}
if(this.service_paragraphs_model.attempts_notes_HTML == null){this.attempts_notes_HTML = this.service_paragraphs_model.attempts_notes; }else{this.attempts_notes_HTML = this.transform2(this.service_paragraphs_model.attempts_notes_HTML);}
if(this.service_paragraphs_model.email_contents_HTML == null){this.email_contents_HTML = this.service_paragraphs_model.email_contents; }else{this.email_contents_HTML = this.transform2(this.service_paragraphs_model.email_contents_HTML);}
if(this.service_paragraphs_model.general_notes_HTML == null){
this.set_general_notes = this.service_paragraphs_model.general_notes;
}else{
this.set_general_notes = this.transform2(this.service_paragraphs_model.general_notes_HTML)
}
if(this.service_paragraphs_model.property_forsale_or_lease_sign_details_HTML == null){this.property_forsale_or_lease_sign_details_HTML = this.service_paragraphs_model.property_forsale_or_lease_sign_details; }else{this.property_forsale_or_lease_sign_details_HTML = this.transform2(this.service_paragraphs_model.property_forsale_or_lease_sign_details_HTML);}  
if(this.service_paragraphs_model.property_mail_details_HTML == null){this.property_mail_details_HTML = this.service_paragraphs_model.property_mail_details; }else{this.property_mail_details_HTML = this.transform2(this.service_paragraphs_model.property_mail_details_HTML);}
if(this.service_paragraphs_model.property_vehicles_sighted_details_HTML == null){this.property_vehicles_sighted_details_HTML = this.service_paragraphs_model.property_vehicles_sighted_details; }else{this.property_vehicles_sighted_details_HTML = this.transform2(this.service_paragraphs_model.property_vehicles_sighted_details_HTML);}  
if(this.service_paragraphs_model.property_pets_details_HTML == null){this.property_pets_details_HTML = this.service_paragraphs_model.property_pets_details; }else{this.property_pets_details_HTML = this.transform2(this.service_paragraphs_model.property_pets_details_HTML);}

if(this.service_paragraphs_model.property_occupancy_details_HTML == null){this.property_occupancy_details_HTML = this.service_paragraphs_model.property_occupancy_details; }else{this.property_occupancy_details_HTML = this.transform2(this.service_paragraphs_model.property_occupancy_details_HTML);}

if(this.service_paragraphs_model.property_condition_HTML == null){this.property_condition_HTML = this.service_paragraphs_model.property_condition; }else{this.property_condition_HTML = this.transform2(this.service_paragraphs_model.property_condition_HTML);}
if(this.service_paragraphs_model.property_occupied_details_HTML == null){this.property_occupied_details_HTML = this.service_paragraphs_model.property_occupied_details; }else{this.property_occupied_details_HTML = this.transform2(this.service_paragraphs_model.property_occupied_details_HTML);}
if(this.service_paragraphs_model.property_type_details_HTML == null){this.set_property_type_details_HTML = this.service_paragraphs_model.property_type_details; }else{this.set_property_type_details_HTML = this.transform2(this.service_paragraphs_model.property_type_details_HTML);}
if(this.attempts_paragraphs_model.service_under_order_HTML == null){this.service_under_order_HTML = this.attempts_paragraphs_model.service_under_order; }else{this.service_under_order_HTML = this.transform2(this.attempts_paragraphs_model.service_under_order_HTML);}



// Do checks for subject name / Businesss Name of FUll SUbject Name fields
let var_subject_name =  this.service_paragraphs_model.first_name + ' ' +  this.service_paragraphs_model.middlename + ' '+  this.service_paragraphs_model.surname;
let var_subject_name_4_doc = this.service_paragraphs_model.first_name +'-'+  this.service_paragraphs_model.surname;
let var_subject_business_name =  this.service_paragraphs_model.business_name;

// Subject Name of Business
 if(var_subject_business_name != null){
     let var_trim_subject_business_name = var_subject_business_name.replaceAll(' ', ''); // need javscipt version of trim (all spaces removed)
     // $subject_name = $trim_subject_business_name;
      var_subject_name = var_subject_business_name; // changed here feb 2023 as subject busines name was printing stripped as variable in affidavid // Not trimmed
       var_subject_name_4_doc= var_trim_subject_business_name;
     
 }



if(this.service_paragraphs_model.service_paragraph_rendered == null){
this.set_service_paragraph_rendered = '';
}else{
this.set_service_paragraph_rendered = this.service_paragraphs_model.service_paragraph_rendered; // does not require encodeing
}

// Property Images
if(this.service_paragraphs_model.property_images != '[]' || this.service_paragraphs_model.property_images != null){
this.property_images = JSON.parse(this.service_paragraphs_model.property_images)



let newArr = this.property_images;
let  count_of_items = Object.keys(newArr).length;

// let  count_of_items = 25;
//   let  count_of_items = Object.keys(newArr).length;
// //     for(let i=0;i < count_of_items; i++) { 
// //     let res = newArr[i];
// // }

if(count_of_items >= 1){this.propery_image_0  = '<img src="' + this.fileURL + '/'+ this.property_images[0].file_server_location +  '/' + this.property_images[0].file_name + '"></img>'}else{this.propery_image_0=''}
if(count_of_items >= 2){this.propery_image_1   = '<img src="' + this.fileURL + '/'+ this.property_images[1].file_server_location +  '/' + this.property_images[1].file_name + '"></img>'}else{this.propery_image_1=''}
if(count_of_items >= 3){this.propery_image_2   = '<img src="' + this.fileURL + '/'+ this.property_images[2].file_server_location +  '/' + this.property_images[2].file_name + '"></img>'}else{this.propery_image_2=''}
if(count_of_items >= 4){this.propery_image_3   = '<img src="' + this.fileURL + '/'+ this.property_images[3].file_server_location +  '/' + this.property_images[3].file_name + '"></img>'}else{this.propery_image_3=''}
if(count_of_items >= 5){this.propery_image_4   = '<img src="' + this.fileURL + '/'+ this.property_images[4].file_server_location +  '/' + this.property_images[4].file_name + '"></img>'}else{this.propery_image_4=''}
if(count_of_items >= 6){this.propery_image_5   = '<img src="' + this.fileURL + '/'+ this.property_images[5].file_server_location +  '/' + this.property_images[5].file_name + '"></img>'}else{this.propery_image_5=''}
if(count_of_items >= 7){this.propery_image_6   = '<img src="' + this.fileURL + '/'+ this.property_images[6].file_server_location +  '/' + this.property_images[6].file_name + '"></img>'}else{this.propery_image_6=''}
if(count_of_items >= 8){this.propery_image_7   = '<img src="' + this.fileURL + '/'+ this.property_images[7].file_server_location +  '/' + this.property_images[7].file_name + '"></img>'}else{this.propery_image_7=''}
if(count_of_items >= 9){this.propery_image_8   = '<img src="' + this.fileURL + '/'+ this.property_images[8].file_server_location +  '/' + this.property_images[8].file_name + '"></img>'}else{this.propery_image_8=''}
if(count_of_items >= 10){this.propery_image_9   = '<img src="' + this.fileURL + '/'+ this.property_images[9].file_server_location +  '/' + this.property_images[9].file_name + '"></img>'}else{this.propery_image_9=''}
if(count_of_items >= 11){this.propery_image_10   = '<img src="' + this.fileURL + '/'+ this.property_images[10].file_server_location +  '/' + this.property_images[10].file_name + '"></img>'}else{this.propery_image_10=''}
if(count_of_items >= 11){this.propery_image_11   = '<img src="' + this.fileURL + '/'+ this.property_images[11].file_server_location +  '/' + this.property_images[11].file_name + '"></img>'}else{this.propery_image_11=''}
if(count_of_items >= 11){this.propery_image_12   = '<img src="' + this.fileURL + '/'+ this.property_images[12].file_server_location +  '/' + this.property_images[12].file_name + '"></img>'}else{this.propery_image_12=''}
if(count_of_items >= 11){this.propery_image_13   = '<img src="' + this.fileURL + '/'+ this.property_images[13].file_server_location +  '/' + this.property_images[13].file_name + '"></img>'}else{this.propery_image_13=''}
if(count_of_items >= 11){this.propery_image_14   = '<img src="' + this.fileURL + '/'+ this.property_images[14].file_server_location +  '/' + this.property_images[14].file_name + '"></img>'}else{this.propery_image_14=''}
if(count_of_items >= 11){this.propery_image_15   = '<img src="' + this.fileURL + '/'+ this.property_images[15].file_server_location +  '/' + this.property_images[15].file_name + '"></img>'}else{this.propery_image_15=''}
if(count_of_items >= 11){this.propery_image_16   = '<img src="' + this.fileURL + '/'+ this.property_images[16].file_server_location +  '/' + this.property_images[16].file_name + '"></img>'}else{this.propery_image_16=''}
if(count_of_items >= 11){this.propery_image_17   = '<img src="' + this.fileURL + '/'+ this.property_images[17].file_server_location +  '/' + this.property_images[17].file_name + '"></img>'}else{this.propery_image_17=''}
if(count_of_items >= 11){this.propery_image_18   = '<img src="' + this.fileURL + '/'+ this.property_images[18].file_server_location +  '/' + this.property_images[18].file_name + '"></img>'}else{this.propery_image_18=''}
if(count_of_items >= 11){this.propery_image_19   = '<img src="' + this.fileURL + '/'+ this.property_images[19].file_server_location +  '/' + this.property_images[19].file_name + '"></img>'}else{this.propery_image_19=''}
if(count_of_items >= 11){this.propery_image_20   = '<img src="' + this.fileURL + '/'+ this.property_images[20].file_server_location +  '/' + this.property_images[20].file_name + '"></img>'}else{this.propery_image_20=''}
if(count_of_items >= 11){this.propery_image_21   = '<img src="' + this.fileURL + '/'+ this.property_images[21].file_server_location +  '/' + this.property_images[21].file_name + '"></img>'}else{this.propery_image_21=''}
if(count_of_items >= 11){this.propery_image_22   = '<img src="' + this.fileURL + '/'+ this.property_images[22].file_server_location +  '/' + this.property_images[22].file_name + '"></img>'}else{this.propery_image_22=''}
if(count_of_items >= 11){this.propery_image_23   = '<img src="' + this.fileURL + '/'+ this.property_images[23].file_server_location +  '/' + this.property_images[23].file_name + '"></img>'}else{this.propery_image_23=''}
if(count_of_items >= 11){this.propery_image_24   = '<img src="' + this.fileURL + '/'+ this.property_images[24].file_server_location +  '/' + this.property_images[24].file_name + '"></img>'}else{this.propery_image_24=''}
if(count_of_items >= 11){this.propery_image_25   = '<img src="' + this.fileURL + '/'+ this.property_images[25].file_server_location +  '/' + this.property_images[25].file_name + '"></img>'}else{this.propery_image_25=''}





// Loop function to set the images set the ones that exist and then set nulls to the ones that dont. -- similar to the php function in the doucment imaee replacement function 
// loop 0 - 25 and only set if exisis or '' if not.


}

if(this.service_paragraphs_model.property_sign_images != '[]' && this.service_paragraphs_model.property_sign_images != null){
this.property_sign_images = JSON.parse(this.service_paragraphs_model.property_sign_images)
let newArr = this.property_sign_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_sign_image_0  = '<img src="' + this.fileURL + '/'+ this.property_sign_images[0].file_server_location +  '/' + this.property_sign_images[0].file_name + '"></img>'}else{this.property_sign_image_0=''}
if(count_of_items >= 2){this.property_sign_image_1   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[1].file_server_location +  '/' + this.property_sign_images[1].file_name + '"></img>'}else{this.property_sign_image_1=''}
if(count_of_items >= 3){this.property_sign_image_2   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[2].file_server_location +  '/' + this.property_sign_images[2].file_name + '"></img>'}else{this.property_sign_image_2=''}
if(count_of_items >= 4){this.property_sign_image_3   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[3].file_server_location +  '/' + this.property_sign_images[3].file_name + '"></img>'}else{this.property_sign_image_3=''}
if(count_of_items >= 5){this.property_sign_image_4   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[4].file_server_location +  '/' + this.property_sign_images[4].file_name + '"></img>'}else{this.property_sign_image_4=''}
if(count_of_items >= 6){this.property_sign_image_5   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[5].file_server_location +  '/' + this.property_sign_images[5].file_name + '"></img>'}else{this.property_sign_image_5=''}
if(count_of_items >= 7){this.property_sign_image_6   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[6].file_server_location +  '/' + this.property_sign_images[6].file_name + '"></img>'}else{this.property_sign_image_6=''}
if(count_of_items >= 8){this.property_sign_image_7   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[7].file_server_location +  '/' + this.property_sign_images[7].file_name + '"></img>'}else{this.property_sign_image_7=''}
if(count_of_items >= 9){this.property_sign_image_8   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[8].file_server_location +  '/' + this.property_sign_images[8].file_name + '"></img>'}else{this.property_sign_image_8=''}
if(count_of_items >= 10){this.property_sign_image_9   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[9].file_server_location +  '/' + this.property_sign_images[9].file_name + '"></img>'}else{this.property_sign_image_9=''}
if(count_of_items >= 11){this.property_sign_image_10   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[10].file_server_location +  '/' + this.property_sign_images[10].file_name + '"></img>'}else{this.property_sign_image_10=''}
if(count_of_items >= 11){this.property_sign_image_11   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[11].file_server_location +  '/' + this.property_sign_images[11].file_name + '"></img>'}else{this.property_sign_image_11=''}
if(count_of_items >= 11){this.property_sign_image_12   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[12].file_server_location +  '/' + this.property_sign_images[12].file_name + '"></img>'}else{this.property_sign_image_12=''}
if(count_of_items >= 11){this.property_sign_image_13   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[13].file_server_location +  '/' + this.property_sign_images[13].file_name + '"></img>'}else{this.property_sign_image_13=''}
if(count_of_items >= 11){this.property_sign_image_14   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[14].file_server_location +  '/' + this.property_sign_images[14].file_name + '"></img>'}else{this.property_sign_image_14=''}
if(count_of_items >= 11){this.property_sign_image_15   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[15].file_server_location +  '/' + this.property_sign_images[15].file_name + '"></img>'}else{this.property_sign_image_15=''}
if(count_of_items >= 11){this.property_sign_image_16   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[16].file_server_location +  '/' + this.property_sign_images[16].file_name + '"></img>'}else{this.property_sign_image_16=''}
if(count_of_items >= 11){this.property_sign_image_17   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[17].file_server_location +  '/' + this.property_sign_images[17].file_name + '"></img>'}else{this.property_sign_image_17=''}
if(count_of_items >= 11){this.property_sign_image_18   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[18].file_server_location +  '/' + this.property_sign_images[18].file_name + '"></img>'}else{this.property_sign_image_18=''}
if(count_of_items >= 11){this.property_sign_image_19   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[19].file_server_location +  '/' + this.property_sign_images[19].file_name + '"></img>'}else{this.property_sign_image_19=''}
if(count_of_items >= 11){this.property_sign_image_20   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[20].file_server_location +  '/' + this.property_sign_images[20].file_name + '"></img>'}else{this.property_sign_image_20=''}
if(count_of_items >= 11){this.property_sign_image_21   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[21].file_server_location +  '/' + this.property_sign_images[21].file_name + '"></img>'}else{this.property_sign_image_21=''}
if(count_of_items >= 11){this.property_sign_image_22   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[22].file_server_location +  '/' + this.property_sign_images[22].file_name + '"></img>'}else{this.property_sign_image_22=''}
if(count_of_items >= 11){this.property_sign_image_23   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[23].file_server_location +  '/' + this.property_sign_images[23].file_name + '"></img>'}else{this.property_sign_image_23=''}
if(count_of_items >= 11){this.property_sign_image_24   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[24].file_server_location +  '/' + this.property_sign_images[24].file_name + '"></img>'}else{this.property_sign_image_24=''}
if(count_of_items >= 11){this.property_sign_image_25   = '<img src="' + this.fileURL + '/'+ this.property_sign_images[25].file_server_location +  '/' + this.property_sign_images[25].file_name + '"></img>'}else{this.property_sign_image_25=''}
}

if(this.service_paragraphs_model.property_mail_images != '[]' && this.service_paragraphs_model.property_mail_images != null ){
this.property_mail_images = JSON.parse(this.service_paragraphs_model.property_mail_images)
let newArr = this.property_mail_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_mail_image_0  = '<img src="' + this.fileURL + '/'+ this.property_mail_images[0].file_server_location +  '/' + this.property_mail_images[0].file_name + '"></img>'}else{this.property_mail_image_0=''}
if(count_of_items >= 2){this.property_mail_image_1   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[1].file_server_location +  '/' + this.property_mail_images[1].file_name + '"></img>'}else{this.property_mail_image_1=''}
if(count_of_items >= 3){this.property_mail_image_2   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[2].file_server_location +  '/' + this.property_mail_images[2].file_name + '"></img>'}else{this.property_mail_image_2=''}
if(count_of_items >= 4){this.property_mail_image_3   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[3].file_server_location +  '/' + this.property_mail_images[3].file_name + '"></img>'}else{this.property_mail_image_3=''}
if(count_of_items >= 5){this.property_mail_image_4   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[4].file_server_location +  '/' + this.property_mail_images[4].file_name + '"></img>'}else{this.property_mail_image_4=''}
if(count_of_items >= 6){this.property_mail_image_5   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[5].file_server_location +  '/' + this.property_mail_images[5].file_name + '"></img>'}else{this.property_mail_image_5=''}
if(count_of_items >= 7){this.property_mail_image_6   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[6].file_server_location +  '/' + this.property_mail_images[6].file_name + '"></img>'}else{this.property_mail_image_6=''}
if(count_of_items >= 8){this.property_mail_image_7   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[7].file_server_location +  '/' + this.property_mail_images[7].file_name + '"></img>'}else{this.property_mail_image_7=''}
if(count_of_items >= 9){this.property_mail_image_8   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[8].file_server_location +  '/' + this.property_mail_images[8].file_name + '"></img>'}else{this.property_mail_image_8=''}
if(count_of_items >= 10){this.property_mail_image_9   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[9].file_server_location +  '/' + this.property_mail_images[9].file_name + '"></img>'}else{this.property_mail_image_9=''}
if(count_of_items >= 11){this.property_mail_image_10   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[10].file_server_location +  '/' + this.property_mail_images[10].file_name + '"></img>'}else{this.property_mail_image_10=''}
if(count_of_items >= 11){this.property_mail_image_11   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[11].file_server_location +  '/' + this.property_mail_images[11].file_name + '"></img>'}else{this.property_mail_image_11=''}
if(count_of_items >= 11){this.property_mail_image_12   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[12].file_server_location +  '/' + this.property_mail_images[12].file_name + '"></img>'}else{this.property_mail_image_12=''}
if(count_of_items >= 11){this.property_mail_image_13   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[13].file_server_location +  '/' + this.property_mail_images[13].file_name + '"></img>'}else{this.property_mail_image_13=''}
if(count_of_items >= 11){this.property_mail_image_14   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[14].file_server_location +  '/' + this.property_mail_images[14].file_name + '"></img>'}else{this.property_mail_image_14=''}
if(count_of_items >= 11){this.property_mail_image_15   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[15].file_server_location +  '/' + this.property_mail_images[15].file_name + '"></img>'}else{this.property_mail_image_15=''}
if(count_of_items >= 11){this.property_mail_image_16   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[16].file_server_location +  '/' + this.property_mail_images[16].file_name + '"></img>'}else{this.property_mail_image_16=''}
if(count_of_items >= 11){this.property_mail_image_17   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[17].file_server_location +  '/' + this.property_mail_images[17].file_name + '"></img>'}else{this.property_mail_image_17=''}
if(count_of_items >= 11){this.property_mail_image_18   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[18].file_server_location +  '/' + this.property_mail_images[18].file_name + '"></img>'}else{this.property_mail_image_18=''}
if(count_of_items >= 11){this.property_mail_image_19   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[19].file_server_location +  '/' + this.property_mail_images[19].file_name + '"></img>'}else{this.property_mail_image_19=''}
if(count_of_items >= 11){this.property_mail_image_20   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[20].file_server_location +  '/' + this.property_mail_images[20].file_name + '"></img>'}else{this.property_mail_image_20=''}
if(count_of_items >= 11){this.property_mail_image_21   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[21].file_server_location +  '/' + this.property_mail_images[21].file_name + '"></img>'}else{this.property_mail_image_21=''}
if(count_of_items >= 11){this.property_mail_image_22   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[22].file_server_location +  '/' + this.property_mail_images[22].file_name + '"></img>'}else{this.property_mail_image_22=''}
if(count_of_items >= 11){this.property_mail_image_23   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[23].file_server_location +  '/' + this.property_mail_images[23].file_name + '"></img>'}else{this.property_mail_image_23=''}
if(count_of_items >= 11){this.property_mail_image_24   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[24].file_server_location +  '/' + this.property_mail_images[24].file_name + '"></img>'}else{this.property_mail_image_24=''}
if(count_of_items >= 11){this.property_mail_image_25   = '<img src="' + this.fileURL + '/'+ this.property_mail_images[25].file_server_location +  '/' + this.property_mail_images[25].file_name + '"></img>'}else{this.property_mail_image_25=''}
}

if(this.service_paragraphs_model.property_vehicles_images != '[]' && this.service_paragraphs_model.property_vehicles_images != null){
this.property_vehicles_images = JSON.parse(this.service_paragraphs_model.property_vehicles_images)
let newArr = this.property_vehicles_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_vehicles_image_0  = '<img src="' + this.fileURL + '/' + this.property_vehicles_images[0].file_server_location +  '/' + this.property_vehicles_images[0].file_name + '"></img>'}else{this.property_vehicles_image_0=''}
if(count_of_items >= 2){this.property_vehicles_image_1   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[1].file_server_location +  '/' + this.property_vehicles_images[1].file_name + '"></img>'}else{this.property_vehicles_image_1=''}
if(count_of_items >= 3){this.property_vehicles_image_2   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[2].file_server_location +  '/' + this.property_vehicles_images[2].file_name + '"></img>'}else{this.property_vehicles_image_2=''}
if(count_of_items >= 4){this.property_vehicles_image_3   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[3].file_server_location +  '/' + this.property_vehicles_images[3].file_name + '"></img>'}else{this.property_vehicles_image_3=''}
if(count_of_items >= 5){this.property_vehicles_image_4   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[4].file_server_location +  '/' + this.property_vehicles_images[4].file_name + '"></img>'}else{this.property_vehicles_image_4=''}
if(count_of_items >= 6){this.property_vehicles_image_5   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[5].file_server_location +  '/' + this.property_vehicles_images[5].file_name + '"></img>'}else{this.property_vehicles_image_5=''}
if(count_of_items >= 7){this.property_vehicles_image_6   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[6].file_server_location +  '/' + this.property_vehicles_images[6].file_name + '"></img>'}else{this.property_vehicles_image_6=''}
if(count_of_items >= 8){this.property_vehicles_image_7   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[7].file_server_location +  '/' + this.property_vehicles_images[7].file_name + '"></img>'}else{this.property_vehicles_image_7=''}
if(count_of_items >= 9){this.property_vehicles_image_8   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[8].file_server_location +  '/' + this.property_vehicles_images[8].file_name + '"></img>'}else{this.property_vehicles_image_8=''}
if(count_of_items >= 10){this.property_vehicles_image_9   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[9].file_server_location +  '/' + this.property_vehicles_images[9].file_name + '"></img>'}else{this.property_vehicles_image_9=''}
if(count_of_items >= 11){this.property_vehicles_image_10   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[10].file_server_location +  '/' + this.property_vehicles_images[10].file_name + '"></img>'}else{this.property_vehicles_image_10=''}
if(count_of_items >= 11){this.property_vehicles_image_11   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[11].file_server_location +  '/' + this.property_vehicles_images[11].file_name + '"></img>'}else{this.property_vehicles_image_11=''}
if(count_of_items >= 11){this.property_vehicles_image_12   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[12].file_server_location +  '/' + this.property_vehicles_images[12].file_name + '"></img>'}else{this.property_vehicles_image_12=''}
if(count_of_items >= 11){this.property_vehicles_image_13   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[13].file_server_location +  '/' + this.property_vehicles_images[13].file_name + '"></img>'}else{this.property_vehicles_image_13=''}
if(count_of_items >= 11){this.property_vehicles_image_14   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[14].file_server_location +  '/' + this.property_vehicles_images[14].file_name + '"></img>'}else{this.property_vehicles_image_14=''}
if(count_of_items >= 11){this.property_vehicles_image_15   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[15].file_server_location +  '/' + this.property_vehicles_images[15].file_name + '"></img>'}else{this.property_vehicles_image_15=''}
if(count_of_items >= 11){this.property_vehicles_image_16   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[16].file_server_location +  '/' + this.property_vehicles_images[16].file_name + '"></img>'}else{this.property_vehicles_image_16=''}
if(count_of_items >= 11){this.property_vehicles_image_17   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[17].file_server_location +  '/' + this.property_vehicles_images[17].file_name + '"></img>'}else{this.property_vehicles_image_17=''}
if(count_of_items >= 11){this.property_vehicles_image_18   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[18].file_server_location +  '/' + this.property_vehicles_images[18].file_name + '"></img>'}else{this.property_vehicles_image_18=''}
if(count_of_items >= 11){this.property_vehicles_image_19   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[19].file_server_location +  '/' + this.property_vehicles_images[19].file_name + '"></img>'}else{this.property_vehicles_image_19=''}
if(count_of_items >= 11){this.property_vehicles_image_20   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[20].file_server_location +  '/' + this.property_vehicles_images[20].file_name + '"></img>'}else{this.property_vehicles_image_20=''}
if(count_of_items >= 11){this.property_vehicles_image_21   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[21].file_server_location +  '/' + this.property_vehicles_images[21].file_name + '"></img>'}else{this.property_vehicles_image_21=''}
if(count_of_items >= 11){this.property_vehicles_image_22   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[22].file_server_location +  '/' + this.property_vehicles_images[22].file_name + '"></img>'}else{this.property_vehicles_image_22=''}
if(count_of_items >= 11){this.property_vehicles_image_23   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[23].file_server_location +  '/' + this.property_vehicles_images[23].file_name + '"></img>'}else{this.property_vehicles_image_23=''}
if(count_of_items >= 11){this.property_vehicles_image_24   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[24].file_server_location +  '/' + this.property_vehicles_images[24].file_name + '"></img>'}else{this.property_vehicles_image_24=''}
if(count_of_items >= 11){this.property_vehicles_image_25   = '<img src="' + this.fileURL + '/'+ this.property_vehicles_images[25].file_server_location +  '/' + this.property_vehicles_images[25].file_name + '"></img>'}else{this.property_vehicles_image_25=''}
}


if(this.service_paragraphs_model.property_pets_images != '[]' && this.service_paragraphs_model.property_pets_images != null){
this.property_pets_images = JSON.parse(this.service_paragraphs_model.property_pets_images)
let newArr = this.property_pets_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_pets_image_0  = '<img src="' + this.fileURL + '/'+ this.property_pets_images[0].file_server_location +  '/' + this.property_pets_images[0].file_name + '"></img>'}else{this.property_pets_image_0=''}
if(count_of_items >= 2){this.property_pets_image_1   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[1].file_server_location +  '/' + this.property_pets_images[1].file_name + '"></img>'}else{this.property_pets_image_1=''}
if(count_of_items >= 3){this.property_pets_image_2   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[2].file_server_location +  '/' + this.property_pets_images[2].file_name + '"></img>'}else{this.property_pets_image_2=''}
if(count_of_items >= 4){this.property_pets_image_3   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[3].file_server_location +  '/' + this.property_pets_images[3].file_name + '"></img>'}else{this.property_pets_image_3=''}
if(count_of_items >= 5){this.property_pets_image_4   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[4].file_server_location +  '/' + this.property_pets_images[4].file_name + '"></img>'}else{this.property_pets_image_4=''}
if(count_of_items >= 6){this.property_pets_image_5   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[5].file_server_location +  '/' + this.property_pets_images[5].file_name + '"></img>'}else{this.property_pets_image_5=''}
if(count_of_items >= 7){this.property_pets_image_6   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[6].file_server_location +  '/' + this.property_pets_images[6].file_name + '"></img>'}else{this.property_pets_image_6=''}
if(count_of_items >= 8){this.property_pets_image_7   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[7].file_server_location +  '/' + this.property_pets_images[7].file_name + '"></img>'}else{this.property_pets_image_7=''}
if(count_of_items >= 9){this.property_pets_image_8   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[8].file_server_location +  '/' + this.property_pets_images[8].file_name + '"></img>'}else{this.property_pets_image_8=''}
if(count_of_items >= 10){this.property_pets_image_9   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[9].file_server_location +  '/' + this.property_pets_images[9].file_name + '"></img>'}else{this.property_pets_image_9=''}
if(count_of_items >= 11){this.property_pets_image_10   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[10].file_server_location +  '/' + this.property_pets_images[10].file_name + '"></img>'}else{this.property_pets_image_10=''}
if(count_of_items >= 11){this.property_pets_image_11   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[11].file_server_location +  '/' + this.property_pets_images[11].file_name + '"></img>'}else{this.property_pets_image_11=''}
if(count_of_items >= 11){this.property_pets_image_12   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[12].file_server_location +  '/' + this.property_pets_images[12].file_name + '"></img>'}else{this.property_pets_image_12=''}
if(count_of_items >= 11){this.property_pets_image_13   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[13].file_server_location +  '/' + this.property_pets_images[13].file_name + '"></img>'}else{this.property_pets_image_13=''}
if(count_of_items >= 11){this.property_pets_image_14   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[14].file_server_location +  '/' + this.property_pets_images[14].file_name + '"></img>'}else{this.property_pets_image_14=''}
if(count_of_items >= 11){this.property_pets_image_15   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[15].file_server_location +  '/' + this.property_pets_images[15].file_name + '"></img>'}else{this.property_pets_image_15=''}
if(count_of_items >= 11){this.property_pets_image_16   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[16].file_server_location +  '/' + this.property_pets_images[16].file_name + '"></img>'}else{this.property_pets_image_16=''}
if(count_of_items >= 11){this.property_pets_image_17   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[17].file_server_location +  '/' + this.property_pets_images[17].file_name + '"></img>'}else{this.property_pets_image_17=''}
if(count_of_items >= 11){this.property_pets_image_18   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[18].file_server_location +  '/' + this.property_pets_images[18].file_name + '"></img>'}else{this.property_pets_image_18=''}
if(count_of_items >= 11){this.property_pets_image_19   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[19].file_server_location +  '/' + this.property_pets_images[19].file_name + '"></img>'}else{this.property_pets_image_19=''}
if(count_of_items >= 11){this.property_pets_image_20   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[20].file_server_location +  '/' + this.property_pets_images[20].file_name + '"></img>'}else{this.property_pets_image_20=''}
if(count_of_items >= 11){this.property_pets_image_21   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[21].file_server_location +  '/' + this.property_pets_images[21].file_name + '"></img>'}else{this.property_pets_image_21=''}
if(count_of_items >= 11){this.property_pets_image_22   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[22].file_server_location +  '/' + this.property_pets_images[22].file_name + '"></img>'}else{this.property_pets_image_22=''}
if(count_of_items >= 11){this.property_pets_image_23   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[23].file_server_location +  '/' + this.property_pets_images[23].file_name + '"></img>'}else{this.property_pets_image_23=''}
if(count_of_items >= 11){this.property_pets_image_24   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[24].file_server_location +  '/' + this.property_pets_images[24].file_name + '"></img>'}else{this.property_pets_image_24=''}
if(count_of_items >= 11){this.property_pets_image_25   = '<img src="' + this.fileURL + '/'+ this.property_pets_images[25].file_server_location +  '/' + this.property_pets_images[25].file_name + '"></img>'}else{this.property_pets_image_25=''}
}


if(this.service_paragraphs_model.property_occupancy_images != '[]' && this.service_paragraphs_model.property_occupancy_images != null){
this.property_occupancy_images = JSON.parse(this.service_paragraphs_model.property_occupancy_images)
let newArr = this.property_occupancy_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_occupancy_image_0  = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[0].file_server_location +  '/' + this.property_occupancy_images[0].file_name + '"></img>'}else{this.property_occupancy_image_0=''}
if(count_of_items >= 2){this.property_occupancy_image_1   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[1].file_server_location +  '/' + this.property_occupancy_images[1].file_name + '"></img>'}else{this.property_occupancy_image_1=''}
if(count_of_items >= 3){this.property_occupancy_image_2   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[2].file_server_location +  '/' + this.property_occupancy_images[2].file_name + '"></img>'}else{this.property_occupancy_image_2=''}
if(count_of_items >= 4){this.property_occupancy_image_3   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[3].file_server_location +  '/' + this.property_occupancy_images[3].file_name + '"></img>'}else{this.property_occupancy_image_3=''}
if(count_of_items >= 5){this.property_occupancy_image_4   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[4].file_server_location +  '/' + this.property_occupancy_images[4].file_name + '"></img>'}else{this.property_occupancy_image_4=''}
if(count_of_items >= 6){this.property_occupancy_image_5   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[5].file_server_location +  '/' + this.property_occupancy_images[5].file_name + '"></img>'}else{this.property_occupancy_image_5=''}
if(count_of_items >= 7){this.property_occupancy_image_6   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[6].file_server_location +  '/' + this.property_occupancy_images[6].file_name + '"></img>'}else{this.property_occupancy_image_6=''}
if(count_of_items >= 8){this.property_occupancy_image_7   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[7].file_server_location +  '/' + this.property_occupancy_images[7].file_name + '"></img>'}else{this.property_occupancy_image_7=''}
if(count_of_items >= 9){this.property_occupancy_image_8   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[8].file_server_location +  '/' + this.property_occupancy_images[8].file_name + '"></img>'}else{this.property_occupancy_image_8=''}
if(count_of_items >= 10){this.property_occupancy_image_9   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[9].file_server_location +  '/' + this.property_occupancy_images[9].file_name + '"></img>'}else{this.property_occupancy_image_9=''}
if(count_of_items >= 11){this.property_occupancy_image_10   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[10].file_server_location +  '/' + this.property_occupancy_images[10].file_name + '"></img>'}else{this.property_occupancy_image_10=''}
if(count_of_items >= 11){this.property_occupancy_image_11   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[11].file_server_location +  '/' + this.property_occupancy_images[11].file_name + '"></img>'}else{this.property_occupancy_image_11=''}
if(count_of_items >= 11){this.property_occupancy_image_12   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[12].file_server_location +  '/' + this.property_occupancy_images[12].file_name + '"></img>'}else{this.property_occupancy_image_12=''}
if(count_of_items >= 11){this.property_occupancy_image_13   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[13].file_server_location +  '/' + this.property_occupancy_images[13].file_name + '"></img>'}else{this.property_occupancy_image_13=''}
if(count_of_items >= 11){this.property_occupancy_image_14   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[14].file_server_location +  '/' + this.property_occupancy_images[14].file_name + '"></img>'}else{this.property_occupancy_image_14=''}
if(count_of_items >= 11){this.property_occupancy_image_15   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[15].file_server_location +  '/' + this.property_occupancy_images[15].file_name + '"></img>'}else{this.property_occupancy_image_15=''}
if(count_of_items >= 11){this.property_occupancy_image_16   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[16].file_server_location +  '/' + this.property_occupancy_images[16].file_name + '"></img>'}else{this.property_occupancy_image_16=''}
if(count_of_items >= 11){this.property_occupancy_image_17   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[17].file_server_location +  '/' + this.property_occupancy_images[17].file_name + '"></img>'}else{this.property_occupancy_image_17=''}
if(count_of_items >= 11){this.property_occupancy_image_18   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[18].file_server_location +  '/' + this.property_occupancy_images[18].file_name + '"></img>'}else{this.property_occupancy_image_18=''}
if(count_of_items >= 11){this.property_occupancy_image_19   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[19].file_server_location +  '/' + this.property_occupancy_images[19].file_name + '"></img>'}else{this.property_occupancy_image_19=''}
if(count_of_items >= 11){this.property_occupancy_image_20   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[20].file_server_location +  '/' + this.property_occupancy_images[20].file_name + '"></img>'}else{this.property_occupancy_image_20=''}
if(count_of_items >= 11){this.property_occupancy_image_21   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[21].file_server_location +  '/' + this.property_occupancy_images[21].file_name + '"></img>'}else{this.property_occupancy_image_21=''}
if(count_of_items >= 11){this.property_occupancy_image_22   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[22].file_server_location +  '/' + this.property_occupancy_images[22].file_name + '"></img>'}else{this.property_occupancy_image_22=''}
if(count_of_items >= 11){this.property_occupancy_image_23   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[23].file_server_location +  '/' + this.property_occupancy_images[23].file_name + '"></img>'}else{this.property_occupancy_image_23=''}
if(count_of_items >= 11){this.property_occupancy_image_24   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[24].file_server_location +  '/' + this.property_occupancy_images[24].file_name + '"></img>'}else{this.property_occupancy_image_24=''}
if(count_of_items >= 11){this.property_occupancy_image_25   = '<img src="' + this.fileURL + '/'+ this.property_occupancy_images[25].file_server_location +  '/' + this.property_occupancy_images[25].file_name + '"></img>'}else{this.property_occupancy_image_25=''}
}

if(this.service_paragraphs_model.property_condition_images != '[]' && this.service_paragraphs_model.property_condition_images != null ){
this.property_condition_images = JSON.parse(this.service_paragraphs_model.property_condition_images)
let newArr = this.property_condition_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_condition_image_0  = '<img src="' + this.fileURL + '/'+ this.property_condition_images[0].file_server_location +  '/' + this.property_condition_images[0].file_name + '"></img>'}else{this.property_condition_image_0=''}
if(count_of_items >= 2){this.property_condition_image_1   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[1].file_server_location +  '/' + this.property_condition_images[1].file_name + '"></img>'}else{this.property_condition_image_1=''}
if(count_of_items >= 3){this.property_condition_image_2   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[2].file_server_location +  '/' + this.property_condition_images[2].file_name + '"></img>'}else{this.property_condition_image_2=''}
if(count_of_items >= 4){this.property_condition_image_3   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[3].file_server_location +  '/' + this.property_condition_images[3].file_name + '"></img>'}else{this.property_condition_image_3=''}
if(count_of_items >= 5){this.property_condition_image_4   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[4].file_server_location +  '/' + this.property_condition_images[4].file_name + '"></img>'}else{this.property_condition_image_4=''}
if(count_of_items >= 6){this.property_condition_image_5   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[5].file_server_location +  '/' + this.property_condition_images[5].file_name + '"></img>'}else{this.property_condition_image_5=''}
if(count_of_items >= 7){this.property_condition_image_6   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[6].file_server_location +  '/' + this.property_condition_images[6].file_name + '"></img>'}else{this.property_condition_image_6=''}
if(count_of_items >= 8){this.property_condition_image_7   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[7].file_server_location +  '/' + this.property_condition_images[7].file_name + '"></img>'}else{this.property_condition_image_7=''}
if(count_of_items >= 9){this.property_condition_image_8   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[8].file_server_location +  '/' + this.property_condition_images[8].file_name + '"></img>'}else{this.property_condition_image_8=''}
if(count_of_items >= 10){this.property_condition_image_9   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[9].file_server_location +  '/' + this.property_condition_images[9].file_name + '"></img>'}else{this.property_condition_image_9=''}
if(count_of_items >= 11){this.property_condition_image_10   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[10].file_server_location +  '/' + this.property_condition_images[10].file_name + '"></img>'}else{this.property_condition_image_10=''}
if(count_of_items >= 11){this.property_condition_image_11   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[11].file_server_location +  '/' + this.property_condition_images[11].file_name + '"></img>'}else{this.property_condition_image_11=''}
if(count_of_items >= 11){this.property_condition_image_12   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[12].file_server_location +  '/' + this.property_condition_images[12].file_name + '"></img>'}else{this.property_condition_image_12=''}
if(count_of_items >= 11){this.property_condition_image_13   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[13].file_server_location +  '/' + this.property_condition_images[13].file_name + '"></img>'}else{this.property_condition_image_13=''}
if(count_of_items >= 11){this.property_condition_image_14   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[14].file_server_location +  '/' + this.property_condition_images[14].file_name + '"></img>'}else{this.property_condition_image_14=''}
if(count_of_items >= 11){this.property_condition_image_15   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[15].file_server_location +  '/' + this.property_condition_images[15].file_name + '"></img>'}else{this.property_condition_image_15=''}
if(count_of_items >= 11){this.property_condition_image_16   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[16].file_server_location +  '/' + this.property_condition_images[16].file_name + '"></img>'}else{this.property_condition_image_16=''}
if(count_of_items >= 11){this.property_condition_image_17   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[17].file_server_location +  '/' + this.property_condition_images[17].file_name + '"></img>'}else{this.property_condition_image_17=''}
if(count_of_items >= 11){this.property_condition_image_18   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[18].file_server_location +  '/' + this.property_condition_images[18].file_name + '"></img>'}else{this.property_condition_image_18=''}
if(count_of_items >= 11){this.property_condition_image_19   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[19].file_server_location +  '/' + this.property_condition_images[19].file_name + '"></img>'}else{this.property_condition_image_19=''}
if(count_of_items >= 11){this.property_condition_image_20   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[20].file_server_location +  '/' + this.property_condition_images[20].file_name + '"></img>'}else{this.property_condition_image_20=''}
if(count_of_items >= 11){this.property_condition_image_21   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[21].file_server_location +  '/' + this.property_condition_images[21].file_name + '"></img>'}else{this.property_condition_image_21=''}
if(count_of_items >= 11){this.property_condition_image_22   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[22].file_server_location +  '/' + this.property_condition_images[22].file_name + '"></img>'}else{this.property_condition_image_22=''}
if(count_of_items >= 11){this.property_condition_image_23   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[23].file_server_location +  '/' + this.property_condition_images[23].file_name + '"></img>'}else{this.property_condition_image_23=''}
if(count_of_items >= 11){this.property_condition_image_24   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[24].file_server_location +  '/' + this.property_condition_images[24].file_name + '"></img>'}else{this.property_condition_image_24=''}
if(count_of_items >= 11){this.property_condition_image_25   = '<img src="' + this.fileURL + '/'+ this.property_condition_images[25].file_server_location +  '/' + this.property_condition_images[25].file_name + '"></img>'}else{this.property_condition_image_25=''}
}


if(this.service_paragraphs_model.property_type_images != '[]' && this.service_paragraphs_model.property_type_images != null){
this.property_type_images = JSON.parse(this.service_paragraphs_model.property_type_images)
let newArr = this.property_type_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.property_type_image_0  = '<img src="' + this.fileURL + '/'+ this.property_type_images[0].file_server_location +  '/' + this.property_type_images[0].file_name + '"></img>'}else{this.property_type_image_0=''}
if(count_of_items >= 2){this.property_type_image_1   = '<img src="' + this.fileURL + '/'+ this.property_type_images[1].file_server_location +  '/' + this.property_type_images[1].file_name + '"></img>'}else{this.property_type_image_1=''}
if(count_of_items >= 3){this.property_type_image_2   = '<img src="' + this.fileURL + '/'+ this.property_type_images[2].file_server_location +  '/' + this.property_type_images[2].file_name + '"></img>'}else{this.property_type_image_2=''}
if(count_of_items >= 4){this.property_type_image_3   = '<img src="' + this.fileURL + '/'+ this.property_type_images[3].file_server_location +  '/' + this.property_type_images[3].file_name + '"></img>'}else{this.property_type_image_3=''}
if(count_of_items >= 5){this.property_type_image_4   = '<img src="' + this.fileURL + '/'+ this.property_type_images[4].file_server_location +  '/' + this.property_type_images[4].file_name + '"></img>'}else{this.property_type_image_4=''}
if(count_of_items >= 6){this.property_type_image_5   = '<img src="' + this.fileURL + '/'+ this.property_type_images[5].file_server_location +  '/' + this.property_type_images[5].file_name + '"></img>'}else{this.property_type_image_5=''}
if(count_of_items >= 7){this.property_type_image_6   = '<img src="' + this.fileURL + '/'+ this.property_type_images[6].file_server_location +  '/' + this.property_type_images[6].file_name + '"></img>'}else{this.property_type_image_6=''}
if(count_of_items >= 8){this.property_type_image_7   = '<img src="' + this.fileURL + '/'+ this.property_type_images[7].file_server_location +  '/' + this.property_type_images[7].file_name + '"></img>'}else{this.property_type_image_7=''}
if(count_of_items >= 9){this.property_type_image_8   = '<img src="' + this.fileURL + '/'+ this.property_type_images[8].file_server_location +  '/' + this.property_type_images[8].file_name + '"></img>'}else{this.property_type_image_8=''}
if(count_of_items >= 10){this.property_type_image_9   = '<img src="' + this.fileURL + '/'+ this.property_type_images[9].file_server_location +  '/' + this.property_type_images[9].file_name + '"></img>'}else{this.property_type_image_9=''}
if(count_of_items >= 11){this.property_type_image_10   = '<img src="' + this.fileURL + '/'+ this.property_type_images[10].file_server_location +  '/' + this.property_type_images[10].file_name + '"></img>'}else{this.property_type_image_10=''}
if(count_of_items >= 11){this.property_type_image_11   = '<img src="' + this.fileURL + '/'+ this.property_type_images[11].file_server_location +  '/' + this.property_type_images[11].file_name + '"></img>'}else{this.property_type_image_11=''}
if(count_of_items >= 11){this.property_type_image_12   = '<img src="' + this.fileURL + '/'+ this.property_type_images[12].file_server_location +  '/' + this.property_type_images[12].file_name + '"></img>'}else{this.property_type_image_12=''}
if(count_of_items >= 11){this.property_type_image_13   = '<img src="' + this.fileURL + '/'+ this.property_type_images[13].file_server_location +  '/' + this.property_type_images[13].file_name + '"></img>'}else{this.property_type_image_13=''}
if(count_of_items >= 11){this.property_type_image_14   = '<img src="' + this.fileURL + '/'+ this.property_type_images[14].file_server_location +  '/' + this.property_type_images[14].file_name + '"></img>'}else{this.property_type_image_14=''}
if(count_of_items >= 11){this.property_type_image_15   = '<img src="' + this.fileURL + '/'+ this.property_type_images[15].file_server_location +  '/' + this.property_type_images[15].file_name + '"></img>'}else{this.property_type_image_15=''}
if(count_of_items >= 11){this.property_type_image_16   = '<img src="' + this.fileURL + '/'+ this.property_type_images[16].file_server_location +  '/' + this.property_type_images[16].file_name + '"></img>'}else{this.property_type_image_16=''}
if(count_of_items >= 11){this.property_type_image_17   = '<img src="' + this.fileURL + '/'+ this.property_type_images[17].file_server_location +  '/' + this.property_type_images[17].file_name + '"></img>'}else{this.property_type_image_17=''}
if(count_of_items >= 11){this.property_type_image_18   = '<img src="' + this.fileURL + '/'+ this.property_type_images[18].file_server_location +  '/' + this.property_type_images[18].file_name + '"></img>'}else{this.property_type_image_18=''}
if(count_of_items >= 11){this.property_type_image_19   = '<img src="' + this.fileURL + '/'+ this.property_type_images[19].file_server_location +  '/' + this.property_type_images[19].file_name + '"></img>'}else{this.property_type_image_19=''}
if(count_of_items >= 11){this.property_type_image_20   = '<img src="' + this.fileURL + '/'+ this.property_type_images[20].file_server_location +  '/' + this.property_type_images[20].file_name + '"></img>'}else{this.property_type_image_20=''}
if(count_of_items >= 11){this.property_type_image_21   = '<img src="' + this.fileURL + '/'+ this.property_type_images[21].file_server_location +  '/' + this.property_type_images[21].file_name + '"></img>'}else{this.property_type_image_21=''}
if(count_of_items >= 11){this.property_type_image_22   = '<img src="' + this.fileURL + '/'+ this.property_type_images[22].file_server_location +  '/' + this.property_type_images[22].file_name + '"></img>'}else{this.property_type_image_22=''}
if(count_of_items >= 11){this.property_type_image_23   = '<img src="' + this.fileURL + '/'+ this.property_type_images[23].file_server_location +  '/' + this.property_type_images[23].file_name + '"></img>'}else{this.property_type_image_23=''}
if(count_of_items >= 11){this.property_type_image_24   = '<img src="' + this.fileURL + '/'+ this.property_type_images[24].file_server_location +  '/' + this.property_type_images[24].file_name + '"></img>'}else{this.property_type_image_24=''}
if(count_of_items >= 11){this.property_type_image_25   = '<img src="' + this.fileURL + '/'+ this.property_type_images[25].file_server_location +  '/' + this.property_type_images[25].file_name + '"></img>'}else{this.property_type_image_25=''}
}




if(this.service_paragraphs_model.service_file_array != '[]' && this.service_paragraphs_model.service_file_array != null){
this.service_file_array_images = JSON.parse(this.service_paragraphs_model.service_file_array)
let newArr = this.service_file_array_images;
let  count_of_items = Object.keys(newArr).length;

if(count_of_items >= 1){this.service_file_array_image_0  = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[0].file_server_location +  '/' + this.service_file_array_images[0].file_name + '"></img>'}else{this.service_file_array_image_0=''}
if(count_of_items >= 2){this.service_file_array_image_1   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[1].file_server_location +  '/' + this.service_file_array_images[1].file_name + '"></img>'}else{this.service_file_array_image_1=''}
if(count_of_items >= 3){this.service_file_array_image_2   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[2].file_server_location +  '/' + this.service_file_array_images[2].file_name + '"></img>'}else{this.service_file_array_image_2=''}
if(count_of_items >= 4){this.service_file_array_image_3   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[3].file_server_location +  '/' + this.service_file_array_images[3].file_name + '"></img>'}else{this.service_file_array_image_3=''}
if(count_of_items >= 5){this.service_file_array_image_4   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[4].file_server_location +  '/' + this.service_file_array_images[4].file_name + '"></img>'}else{this.service_file_array_image_4=''}
if(count_of_items >= 6){this.service_file_array_image_5   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[5].file_server_location +  '/' + this.service_file_array_images[5].file_name + '"></img>'}else{this.service_file_array_image_5=''}
if(count_of_items >= 7){this.service_file_array_image_6   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[6].file_server_location +  '/' + this.service_file_array_images[6].file_name + '"></img>'}else{this.service_file_array_image_6=''}
if(count_of_items >= 8){this.service_file_array_image_7   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[7].file_server_location +  '/' + this.service_file_array_images[7].file_name + '"></img>'}else{this.service_file_array_image_7=''}
if(count_of_items >= 9){this.service_file_array_image_8   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[8].file_server_location +  '/' + this.service_file_array_images[8].file_name + '"></img>'}else{this.service_file_array_image_8=''}
if(count_of_items >= 10){this.service_file_array_image_9   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[9].file_server_location +  '/' + this.service_file_array_images[9].file_name + '"></img>'}else{this.service_file_array_image_9=''}
if(count_of_items >= 11){this.service_file_array_image_10   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[10].file_server_location +  '/' + this.service_file_array_images[10].file_name + '"></img>'}else{this.service_file_array_image_10=''}
if(count_of_items >= 11){this.service_file_array_image_11   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[11].file_server_location +  '/' + this.service_file_array_images[11].file_name + '"></img>'}else{this.service_file_array_image_11=''}
if(count_of_items >= 11){this.service_file_array_image_12   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[12].file_server_location +  '/' + this.service_file_array_images[12].file_name + '"></img>'}else{this.service_file_array_image_12=''}
if(count_of_items >= 11){this.service_file_array_image_13   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[13].file_server_location +  '/' + this.service_file_array_images[13].file_name + '"></img>'}else{this.service_file_array_image_13=''}
if(count_of_items >= 11){this.service_file_array_image_14   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[14].file_server_location +  '/' + this.service_file_array_images[14].file_name + '"></img>'}else{this.service_file_array_image_14=''}
if(count_of_items >= 11){this.service_file_array_image_15   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[15].file_server_location +  '/' + this.service_file_array_images[15].file_name + '"></img>'}else{this.service_file_array_image_15=''}
if(count_of_items >= 11){this.service_file_array_image_16   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[16].file_server_location +  '/' + this.service_file_array_images[16].file_name + '"></img>'}else{this.service_file_array_image_16=''}
if(count_of_items >= 11){this.service_file_array_image_17   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[17].file_server_location +  '/' + this.service_file_array_images[17].file_name + '"></img>'}else{this.service_file_array_image_17=''}
if(count_of_items >= 11){this.service_file_array_image_18   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[18].file_server_location +  '/' + this.service_file_array_images[18].file_name + '"></img>'}else{this.service_file_array_image_18=''}
if(count_of_items >= 11){this.service_file_array_image_19   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[19].file_server_location +  '/' + this.service_file_array_images[19].file_name + '"></img>'}else{this.service_file_array_image_19=''}
if(count_of_items >= 11){this.service_file_array_image_20   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[20].file_server_location +  '/' + this.service_file_array_images[20].file_name + '"></img>'}else{this.service_file_array_image_20=''}
if(count_of_items >= 11){this.service_file_array_image_21   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[21].file_server_location +  '/' + this.service_file_array_images[21].file_name + '"></img>'}else{this.service_file_array_image_21=''}
if(count_of_items >= 11){this.service_file_array_image_22   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[22].file_server_location +  '/' + this.service_file_array_images[22].file_name + '"></img>'}else{this.service_file_array_image_22=''}
if(count_of_items >= 11){this.service_file_array_image_23   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[23].file_server_location +  '/' + this.service_file_array_images[23].file_name + '"></img>'}else{this.service_file_array_image_23=''}
if(count_of_items >= 11){this.service_file_array_image_24   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[24].file_server_location +  '/' + this.service_file_array_images[24].file_name + '"></img>'}else{this.service_file_array_image_24=''}
if(count_of_items >= 11){this.service_file_array_image_25   = '<img src="' + this.fileURL + '/'+ this.service_file_array_images[25].file_server_location +  '/' + this.service_file_array_images[25].file_name + '"></img>'}else{this.service_file_array_image_25=''}
}

const rendered_result = str



  .replaceAll( '${' + keystarter + '_type_id}', this.service_paragraphs_model.subject_attempt_type_id)
  .replaceAll( '${' + keystarter + '_type_name}', this.service_paragraphs_model.subject_attempt_type_name ) // run a function with return;
  .replaceAll( '${' + keystarter + '_subject_attempt_type_name}', this.service_paragraphs_model.subject_attempt_type_name ) // run a function with return;
  .replaceAll( '${' + keystarter + '_type_name_upper}', this.var_subject_attempt_type_name_Upper) // all if statments set a this/g/ varaibales

  .replaceAll( '${' + keystarter + '_subject_service_method_id}', this.service_paragraphs_model.subject_service_method_id)
  .replaceAll( '${' + keystarter + '_subject_service_method_name}', this.service_paragraphs_model.subject_service_method_name ) // tested above.
  .replaceAll( '${' + keystarter + '_service_method}', this.service_paragraphs_model.subject_service_method_name ) // tested above.
  .replaceAll( '${' + keystarter + '_service_method_id}', this.service_paragraphs_model.subject_service_method_id) // tested above.


  .replaceAll( '${' + keystarter + '_date_service}', moment(this.service_paragraphs_model.date_service).format('D/M/YYYY'))
  .replaceAll( '${' + keystarter + '_date_service_full_words_time_first}', this.service_paragraphs_model.time_service_text + ' ' + moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') ) 
  .replaceAll( '${' + keystarter + '_date_service_and_time_full_words}', moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + this.service_paragraphs_model.time_service_text ) 
  .replaceAll( '${' + keystarter + '_date_service_full_words}', moment(this.service_paragraphs_model.date_service).format('dddd MMMM Do, YYYY') + ' ' + model.time_service_text ) 

  .replaceAll( '${' + keystarter + '_day}', moment(this.service_paragraphs_model.date_service).format('dddd'))
  .replaceAll( '${' + keystarter + '_day_number}', moment(this.service_paragraphs_model.date_service).format('Do'))
  .replaceAll( '${' + keystarter + '_day_number_simple}', moment(this.service_paragraphs_model.date_service).format('D'))
  .replaceAll( '${' + keystarter + '_month}', moment(this.service_paragraphs_model.date_service).format('MMMM'))
  .replaceAll( '${' + keystarter + '_month_number}', moment(this.service_paragraphs_model.date_service).format('Mo'))
  .replaceAll( '${' + keystarter + '_month_number_simple}', moment(this.service_paragraphs_model.date_service).format('M'))
  .replaceAll( '${' + keystarter + '_year}', moment(this.service_paragraphs_model.date_service).format('YYYY'))

  .replaceAll( '${' + keystarter + '_service_local}', this.service_paragraphs_model.service_local) // region Australia/Perth of service undertaken
  .replaceAll( '${' + keystarter + '_time}', this.service_paragraphs_model.time_service_text) //$_set_service_time - Fixed and set time of attempt and service

  .replaceAll( '${' + keystarter + '_paragraph_rendered}',  this.set_service_paragraph_rendered) //$_set_service_time - Fixed and set time of attempt and service

  .replaceAll( '${' + keystarter + '_subject_name}', var_subject_name)
  .replaceAll( '${' + keystarter + '_subject_number}', this.service_paragraphs_model.subject_number)
  .replaceAll( '${' + keystarter + '_subject_name_4_doc}', var_subject_name_4_doc)
  .replaceAll( '${' + keystarter + '_subject_business_name}', var_subject_business_name)
  .replaceAll( '${' + keystarter + '_business_name}', var_subject_business_name)

// Subject Attempt Address
.replaceAll( '${' + keystarter + '_address_1}', this.service_paragraphs_model.address_1)
.replaceAll( '${' + keystarter + '_address_2}', this.service_paragraphs_model.address_2)
.replaceAll( '${' + keystarter + '_suburb}', this.service_paragraphs_model.suburb)
.replaceAll( '${' + keystarter + '_state}', this.service_paragraphs_model.state)
.replaceAll( '${' + keystarter + '_postcode}', this.service_paragraphs_model.postcode)
.replaceAll( '${' + keystarter + '_address_full}', this.service_paragraphs_model.address_1 +  ' ' + this.service_paragraphs_model.address_2 +  ' ' + this.service_paragraphs_model.suburb +  ' ' + this.service_paragraphs_model.state +  ',  ' + this.service_paragraphs_model.postcode )
// Sav
.replaceAll( '${' + keystarter + '_sav_address_full}', this.service_paragraphs_model.address_1 +  ' ' + this.service_paragraphs_model.address_2 +  ' ' + this.service_paragraphs_model.suburb +  ' ' + this.service_paragraphs_model.state +  ',  ' + this.service_paragraphs_model.postcode )
// New address
.replaceAll( '${' + keystarter + '_new_business_name}', this.service_paragraphs_model.new_business_name)
.replaceAll( '${' + keystarter + '_new_address_1}', this.service_paragraphs_model.new_address_1)
.replaceAll( '${' + keystarter + '_new_address_2}', this.service_paragraphs_model.new_address_2)
.replaceAll( '${' + keystarter + '_new_suburb}', this.service_paragraphs_model.new_suburb)
.replaceAll( '${' + keystarter + '_new_state}', this.service_paragraphs_model.new_state)
.replaceAll( '${' + keystarter + '_new_postcode}', this.service_paragraphs_model.new_postcode)
.replaceAll( '${' + keystarter + '_new_address_full}', this.service_paragraphs_model.new_address_1 +  ' ' + this.service_paragraphs_model.new_address_2 +  ' ' + this.service_paragraphs_model.new_suburb +  ' ' + this.service_paragraphs_model.new_state +  ',  ' + this.service_paragraphs_model.new_postcode )

.replaceAll( '${' + keystarter + '_service_number}', this.service_paragraphs_model.service_number)

.replaceAll( '${' + keystarter + '_service_outcome_name}', this.service_paragraphs_model.subject_service_outcome_name)
.replaceAll( '${' + keystarter + '_exact_service_method_name}', this.service_paragraphs_model.exact_service_method_name) //
.replaceAll( '${' + keystarter + '_subject_type_name}', this.job_subject_type_name) // set in the job lookup.
.replaceAll( '${' + keystarter + '_subject_type_name_upper}', this.job_subject_type_name_Upper) // set in the job lookup.
.replaceAll( '${' + keystarter + '_location_status_name}', this.service_paragraphs_model.subject_location_status_name)
.replaceAll( '${' + keystarter + '_location_status_found_name}', this.service_paragraphs_model.subject_location_status_found_name)

.replaceAll( '${' + keystarter + '_fellow_occupants_name}', this.service_paragraphs_model.fellow_occupants_name)
.replaceAll( '${' + keystarter + '_fellow_occupants_sex}', this.service_paragraphs_model.fellow_occupants_sex)
.replaceAll( '${' + keystarter + '_fellow_occupants_name_label}', 'Fellow Occupants Name: ' +  this.service_paragraphs_model.fellow_occupants_name)
.replaceAll( '${' + keystarter + '_subject_relationship_name}', this.service_paragraphs_model.subject_service_fellow_relationship)

.replaceAll( '${' + keystarter + '_person_spoken_with}', this.service_paragraphs_model.person_spoken_with)
.replaceAll( '${' + keystarter + '_person_type}', this.service_paragraphs_model.person_type)
.replaceAll( '${' + keystarter + '_person_spoken_with_advised}',   this.person_spoken_with_advised_HTML ) 

.replaceAll( '${' + keystarter + '_vehicles}', this.service_paragraphs_model.vehicles)
.replaceAll( '${' + keystarter + '_vehicles_notes}',   this.vehicles_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_neighbours}', this.service_paragraphs_model.neighbours)
.replaceAll( '${' + keystarter + '_neighbours_notes}',   this.neighbours_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_calling_card}', this.service_paragraphs_model.calling_card)
.replaceAll( '${' + keystarter + '_calling_card_notes}',   this.calling_card_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_postal_mail}', this.service_paragraphs_model.postal_mail)
.replaceAll( '${' + keystarter + '_postal_mail_notes}',   this.postal_mail_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_phone_call}', this.service_paragraphs_model.phone_call)
.replaceAll( '${' + keystarter + '_phone_call_notes}',   this.phone_call_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_attempts}', this.service_paragraphs_model.attempts)
.replaceAll( '${' + keystarter + '_attempts_notes}',   this.attempts_notes_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_authorised_employee_name}', this.service_paragraphs_model.authorised_employee_name)
.replaceAll( '${' + keystarter + '_authorised_employee_job_title}', this.service_paragraphs_model.authorised_employee_job_title)
.replaceAll( '${' + keystarter + '_authorised_employee_sex}', this.service_paragraphs_model.authorised_employee_sex)
.replaceAll( '${' + keystarter + '_office_business_name}', this.service_paragraphs_model.office_business_name)

.replaceAll( '${' + keystarter + '_witness_name}', this.service_paragraphs_model.witness_name)
.replaceAll( '${' + keystarter + '_witness_business_name}', this.service_paragraphs_model.witness_business_name)
.replaceAll( '${' + keystarter + '_witness_address}', this.service_paragraphs_model.witness_address_1 + ' ' + this.service_paragraphs_model.witness_address_2 + ' ' +  this.service_paragraphs_model.witness_suburb + ' ' + this.service_paragraphs_model.witness_state + ', ' + this.service_paragraphs_model.witness_postcode  ) // 
.replaceAll( '${' + keystarter + '_witness_address_1}', this.service_paragraphs_model.witness_address_1)
.replaceAll( '${' + keystarter + '_witness_address_2}', this.service_paragraphs_model.witness_address_2)
.replaceAll( '${' + keystarter + '_witness_state}', this.service_paragraphs_model.witness_state)
.replaceAll( '${' + keystarter + '_witness_suburb}', this.service_paragraphs_model.witness_suburb)
.replaceAll( '${' + keystarter + '_witness_country}', this.service_paragraphs_model.witness_country)
.replaceAll( '${' + keystarter + '_witness_postcode}', this.service_paragraphs_model.witness_postcode)

.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_name}', this.service_paragraphs_model.person_in_charge_of_prison_name)
.replaceAll( '${' + keystarter + '_person_in_charge_of_prison_occupation}', this.service_paragraphs_model.person_in_charge_of_prison_occupation)

.replaceAll( '${' + keystarter + '_ubject_contact_email_id}', this.service_paragraphs_model.subject_contact_email_id)
.replaceAll( '${' + keystarter + '_email_address_served}', this.service_paragraphs_model.email_address_served)
.replaceAll( '${' + keystarter + '_email_contents}', this.email_contents_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_director_name}', this.service_paragraphs_model.director_name)
// .replaceAll( '${' + keystarter + '_service_under_order}', this.service_paragraphs_model.service_under_order)
.replaceAll( '${' + keystarter + '_service_under_order}', this.service_under_order_HTML)


.replaceAll( '${' + keystarter + '_phone_number}', this.service_paragraphs_model.phone_number)


// Meed it fix 24 -- must activate
// Agent Details
.replaceAll( '${' + keystarter + '_agent_name}', this.subject_service_agent.first_name + ' ' + this.subject_service_agent.middle_name + ' ' + this.subject_service_agent.surname )
.replaceAll( '${' + keystarter + '_agent_first_name}', this.subject_service_agent.first_name)
.replaceAll( '${' + keystarter + '_agent_middle_name}', this.subject_service_agent.middle_name)
.replaceAll( '${' + keystarter + '_agent_surname}', this.subject_service_agent.surname)

.replaceAll( '${' + keystarter + '_agent_address_1}', this.subject_service_agent.address_1)
.replaceAll( '${' + keystarter + '_agent_address_2}', this.subject_service_agent.address_2)
.replaceAll( '${' + keystarter + '_agent_suburb}', this.subject_service_agent.suburb)
.replaceAll( '${' + keystarter + '_agent_state}', this.subject_service_agent.state)
.replaceAll( '${' + keystarter + '_agent_postcode}', this.subject_service_agent.postcode)
.replaceAll( '${' + keystarter + '_agent_address_full}', this.subject_service_agent.address_1 + ' ' + this.subject_service_agent.address_2 + ' ' + this.subject_service_agent.suburb + ' ' + this.subject_service_agent.state + ', ' + this.subject_service_agent.postcode )
.replaceAll( '${' + keystarter + '_agent_qualification}', this.subject_service_agent.qualification)
.replaceAll( '${' + keystarter + '_agent_qualification_number}', this.subject_service_agent.qualification_number)

.replaceAll( '${' + keystarter + '_agent_qualification_renewal_date}', moment(this.subject_service_agent.qualification_renewal_date).format('D/M/YYYY') )
.replaceAll( '${' + keystarter + '_agent_qualification_renewal_date_full_words}', moment(this.subject_service_agent.qualification_renewal_date).format('dddd MMMM Do, YYYY h:mma') )

.replaceAll( '${' + keystarter + '_general_notes}',  this.set_general_notes ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_is_count}', this.service_paragraphs_model.is_count)
.replaceAll( '${' + keystarter + '_property_images}', this.service_paragraphs_model.property_images)
.replaceAll( '${' + keystarter + '_attach_file_array_name}', this.service_paragraphs_model.attach_file_array_name)
.replaceAll( '${' + keystarter + '_property_occupied}', this.service_paragraphs_model.property_occupied)

.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign}', this.service_paragraphs_model.property_forsale_or_lease_sign)
.replaceAll( '${' + keystarter + '_property_sign_images}', this.service_paragraphs_model.property_sign_images)
.replaceAll( '${' + keystarter + '_property_forsale_or_lease_sign_details}',   this.property_forsale_or_lease_sign_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_agent_name}', this.service_paragraphs_model.property_agent_name)
.replaceAll( '${' + keystarter + '_property_agency_name}', this.service_paragraphs_model.property_agency_name)
.replaceAll( '${' + keystarter + '_property_agency_contact_numbers}', this.service_paragraphs_model.property_agency_contact_numbers)


.replaceAll( '${' + keystarter + '_property_mail}', this.service_paragraphs_model.property_mail)
.replaceAll( '${' + keystarter + '_property_mail_images}', this.service_paragraphs_model.property_mail_images)
.replaceAll( '${' + keystarter + '_property_mail_details}', this.property_mail_details_HTML ) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_vehicles_sighted}', this.service_paragraphs_model.property_vehicles_sighted)
.replaceAll( '${' + keystarter + '_property_vehicles_sighted_details}', this.property_vehicles_sighted_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_vehicles_images}', this.service_paragraphs_model.property_vehicles_images)
.replaceAll( '${' + keystarter + '_property_v_make}', this.service_paragraphs_model.property_v_make)
.replaceAll( '${' + keystarter + '_property_v_model}', this.service_paragraphs_model.property_v_model)
.replaceAll( '${' + keystarter + '_property_v_plate}', this.service_paragraphs_model.property_v_plate)
.replaceAll( '${' + keystarter + '_property_v_rego_state}', this.service_paragraphs_model.property_v_rego_state)

.replaceAll( '${' + keystarter + '_property_pets}', this.service_paragraphs_model.property_pets)
.replaceAll( '${' + keystarter + '_property_pets_details}', this.property_pets_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_pets_images}', this.service_paragraphs_model.property_pets_images)

.replaceAll( '${' + keystarter + '_property_occupancy}', this.service_paragraphs_model.property_occupancy)
.replaceAll( '${' + keystarter + '_property_occupancy_details}', this.property_occupancy_details_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_occupancy_images}', this.service_paragraphs_model.property_occupancy_images)
.replaceAll( '${' + keystarter + '_property_o_name}', this.service_paragraphs_model.property_o_name)
.replaceAll( '${' + keystarter + '_property_o_contact_numbers}', this.service_paragraphs_model.property_o_contact_numbers)
.replaceAll( '${' + keystarter + '_property_o_lease_details}', this.service_paragraphs_model.property_o_lease_details)
.replaceAll( '${' + keystarter + '_property_o_lease_date}', this.service_paragraphs_model.property_o_lease_date)
.replaceAll( '${' + keystarter + '_property_o_landlord_contacts}', this.service_paragraphs_model.property_o_landlord_contacts)

.replaceAll( '${' + keystarter + '_property_condition}', this.property_condition_HTML ) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_condition_images}', this.service_paragraphs_model.property_condition_images)

.replaceAll( '${' + keystarter + '_property_occupied_details}', this.property_occupied_details_HTML) // replace original only use this for create.

.replaceAll( '${' + keystarter + '_property_type_id}', this.service_paragraphs_model.property_type_id)
.replaceAll( '${' + keystarter + '_property_type_details}', this.set_property_type_details_HTML) // replace original only use this for create.
.replaceAll( '${' + keystarter + '_property_type_images}', this.service_paragraphs_model.property_type_images)

.replaceAll( '${' + keystarter + '_property_type_name}', this.service_paragraphs_model.property_type_name)

.replaceAll( '${' + keystarter + '_service_file_array}', this.service_paragraphs_model.service_file_array)


// Images // <img src="pic_trulli.jpg" alt="Italian Trulli">
// this.service_paragraphs_model.property_images - runs a loop functino above to set image variables
.replaceAll( '${' + keystarter + '_property_image_0}',  this.propery_image_0 )
.replaceAll( '${' + keystarter + '_property_image_1}',  this.propery_image_1 )
.replaceAll( '${' + keystarter + '_property_image_2}',  this.propery_image_2 )
.replaceAll( '${' + keystarter + '_property_image_3}',  this.propery_image_3 )
.replaceAll( '${' + keystarter + '_property_image_4}',  this.propery_image_4 )
.replaceAll( '${' + keystarter + '_property_image_5}',  this.propery_image_5 )
.replaceAll( '${' + keystarter + '_property_image_6}',  this.propery_image_6 )
.replaceAll( '${' + keystarter + '_property_image_7}',  this.propery_image_7 )
.replaceAll( '${' + keystarter + '_property_image_8}',  this.propery_image_8 )
.replaceAll( '${' + keystarter + '_property_image_9}',  this.propery_image_9 )
.replaceAll( '${' + keystarter + '_property_image_10}',  this.propery_image_10 )
.replaceAll( '${' + keystarter + '_property_image_11}',  this.propery_image_11 )
.replaceAll( '${' + keystarter + '_property_image_12}',  this.propery_image_12 )
.replaceAll( '${' + keystarter + '_property_image_13}',  this.propery_image_13 )
.replaceAll( '${' + keystarter + '_property_image_14}',  this.propery_image_14 )
.replaceAll( '${' + keystarter + '_property_image_15}',  this.propery_image_15 )
.replaceAll( '${' + keystarter + '_property_image_16}',  this.propery_image_16 )
.replaceAll( '${' + keystarter + '_property_image_17}',  this.propery_image_17 )
.replaceAll( '${' + keystarter + '_property_image_18}',  this.propery_image_18 )
.replaceAll( '${' + keystarter + '_property_image_19}',  this.propery_image_19 )
.replaceAll( '${' + keystarter + '_property_image_20}',  this.propery_image_20 )
.replaceAll( '${' + keystarter + '_property_image_21}',  this.propery_image_21 )
.replaceAll( '${' + keystarter + '_property_image_22}',  this.propery_image_22 )
.replaceAll( '${' + keystarter + '_property_image_23}',  this.propery_image_23 )
.replaceAll( '${' + keystarter + '_property_image_24}',  this.propery_image_24 )
.replaceAll( '${' + keystarter + '_property_image_25}',  this.propery_image_25 )


.replaceAll( '${' + keystarter + '_property_sign_image_0}',  this.property_sign_image_0 )
.replaceAll( '${' + keystarter + '_property_sign_image_1}',  this.property_sign_image_1 )
.replaceAll( '${' + keystarter + '_property_sign_image_2}',  this.property_sign_image_2 )
.replaceAll( '${' + keystarter + '_property_sign_image_3}',  this.property_sign_image_3 )
.replaceAll( '${' + keystarter + '_property_sign_image_4}',  this.property_sign_image_4 )
.replaceAll( '${' + keystarter + '_property_sign_image_5}',  this.property_sign_image_5 )
.replaceAll( '${' + keystarter + '_property_sign_image_6}',  this.property_sign_image_6 )
.replaceAll( '${' + keystarter + '_property_sign_image_7}',  this.property_sign_image_7 )
.replaceAll( '${' + keystarter + '_property_sign_image_8}',  this.property_sign_image_8 )
.replaceAll( '${' + keystarter + '_property_sign_image_9}',  this.property_sign_image_9 )
.replaceAll( '${' + keystarter + '_property_sign_image_10}',  this.property_sign_image_10 )
.replaceAll( '${' + keystarter + '_property_sign_image_11}',  this.property_sign_image_11 )
.replaceAll( '${' + keystarter + '_property_sign_image_12}',  this.property_sign_image_12 )
.replaceAll( '${' + keystarter + '_property_sign_image_13}',  this.property_sign_image_13 )
.replaceAll( '${' + keystarter + '_property_sign_image_14}',  this.property_sign_image_14 )
.replaceAll( '${' + keystarter + '_property_sign_image_15}',  this.property_sign_image_15 )
.replaceAll( '${' + keystarter + '_property_sign_image_16}',  this.property_sign_image_16 )
.replaceAll( '${' + keystarter + '_property_sign_image_17}',  this.property_sign_image_17 )
.replaceAll( '${' + keystarter + '_property_sign_image_18}',  this.property_sign_image_18 )
.replaceAll( '${' + keystarter + '_property_sign_image_19}',  this.property_sign_image_19 )
.replaceAll( '${' + keystarter + '_property_sign_image_20}',  this.property_sign_image_20 )
.replaceAll( '${' + keystarter + '_property_sign_image_21}',  this.property_sign_image_21 )
.replaceAll( '${' + keystarter + '_property_sign_image_22}',  this.property_sign_image_22 )
.replaceAll( '${' + keystarter + '_property_sign_image_23}',  this.property_sign_image_23 )
.replaceAll( '${' + keystarter + '_property_sign_image_24}',  this.property_sign_image_24 )
.replaceAll( '${' + keystarter + '_property_sign_image_25}',  this.property_sign_image_25 )


.replaceAll( '${' + keystarter + '_property_mail_image_0}',  this.property_mail_image_0 )
.replaceAll( '${' + keystarter + '_property_mail_image_1}',  this.property_mail_image_1 )
.replaceAll( '${' + keystarter + '_property_mail_image_2}',  this.property_mail_image_2 )
.replaceAll( '${' + keystarter + '_property_mail_image_3}',  this.property_mail_image_3 )
.replaceAll( '${' + keystarter + '_property_mail_image_4}',  this.property_mail_image_4 )
.replaceAll( '${' + keystarter + '_property_mail_image_5}',  this.property_mail_image_5 )
.replaceAll( '${' + keystarter + '_property_mail_image_6}',  this.property_mail_image_6 )
.replaceAll( '${' + keystarter + '_property_mail_image_7}',  this.property_mail_image_7 )
.replaceAll( '${' + keystarter + '_property_mail_image_8}',  this.property_mail_image_8 )
.replaceAll( '${' + keystarter + '_property_mail_image_9}',  this.property_mail_image_9 )
.replaceAll( '${' + keystarter + '_property_mail_image_10}',  this.property_mail_image_10 )
.replaceAll( '${' + keystarter + '_property_mail_image_11}',  this.property_mail_image_11 )
.replaceAll( '${' + keystarter + '_property_mail_image_12}',  this.property_mail_image_12 )
.replaceAll( '${' + keystarter + '_property_mail_image_13}',  this.property_mail_image_13 )
.replaceAll( '${' + keystarter + '_property_mail_image_14}',  this.property_mail_image_14 )
.replaceAll( '${' + keystarter + '_property_mail_image_15}',  this.property_mail_image_15 )
.replaceAll( '${' + keystarter + '_property_mail_image_16}',  this.property_mail_image_16 )
.replaceAll( '${' + keystarter + '_property_mail_image_17}',  this.property_mail_image_17 )
.replaceAll( '${' + keystarter + '_property_mail_image_18}',  this.property_mail_image_18 )
.replaceAll( '${' + keystarter + '_property_mail_image_19}',  this.property_mail_image_19 )
.replaceAll( '${' + keystarter + '_property_mail_image_20}',  this.property_mail_image_20 )
.replaceAll( '${' + keystarter + '_property_mail_image_21}',  this.property_mail_image_21 )
.replaceAll( '${' + keystarter + '_property_mail_image_22}',  this.property_mail_image_22 )
.replaceAll( '${' + keystarter + '_property_mail_image_23}',  this.property_mail_image_23 )
.replaceAll( '${' + keystarter + '_property_mail_image_24}',  this.property_mail_image_24 )
.replaceAll( '${' + keystarter + '_property_mail_image_25}',  this.property_mail_image_25 )


.replaceAll( '${' + keystarter + '_property_vehicles_image_0}',  this.property_vehicles_image_0 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_1}',  this.property_vehicles_image_1 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_2}',  this.property_vehicles_image_2 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_3}',  this.property_vehicles_image_3 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_4}',  this.property_vehicles_image_4 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_5}',  this.property_vehicles_image_5 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_6}',  this.property_vehicles_image_6 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_7}',  this.property_vehicles_image_7 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_8}',  this.property_vehicles_image_8 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_9}',  this.property_vehicles_image_9 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_10}',  this.property_vehicles_image_10 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_11}',  this.property_vehicles_image_11 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_12}',  this.property_vehicles_image_12 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_13}',  this.property_vehicles_image_13 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_14}',  this.property_vehicles_image_14 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_15}',  this.property_vehicles_image_15 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_16}',  this.property_vehicles_image_16 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_17}',  this.property_vehicles_image_17 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_18}',  this.property_vehicles_image_18 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_19}',  this.property_vehicles_image_19 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_20}',  this.property_vehicles_image_20 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_21}',  this.property_vehicles_image_21 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_22}',  this.property_vehicles_image_22 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_23}',  this.property_vehicles_image_23 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_24}',  this.property_vehicles_image_24 )
.replaceAll( '${' + keystarter + '_property_vehicles_image_25}',  this.property_vehicles_image_25 )


.replaceAll( '${' + keystarter + '_property_pets_image_0}',  this.property_pets_image_0 )
.replaceAll( '${' + keystarter + '_property_pets_image_1}',  this.property_pets_image_1 )
.replaceAll( '${' + keystarter + '_property_pets_image_2}',  this.property_pets_image_2 )
.replaceAll( '${' + keystarter + '_property_pets_image_3}',  this.property_pets_image_3 )
.replaceAll( '${' + keystarter + '_property_pets_image_4}',  this.property_pets_image_4 )
.replaceAll( '${' + keystarter + '_property_pets_image_5}',  this.property_pets_image_5 )
.replaceAll( '${' + keystarter + '_property_pets_image_6}',  this.property_pets_image_6 )
.replaceAll( '${' + keystarter + '_property_pets_image_7}',  this.property_pets_image_7 )
.replaceAll( '${' + keystarter + '_property_pets_image_8}',  this.property_pets_image_8 )
.replaceAll( '${' + keystarter + '_property_pets_image_9}',  this.property_pets_image_9 )
.replaceAll( '${' + keystarter + '_property_pets_image_10}',  this.property_pets_image_10 )
.replaceAll( '${' + keystarter + '_property_pets_image_11}',  this.property_pets_image_11 )
.replaceAll( '${' + keystarter + '_property_pets_image_12}',  this.property_pets_image_12 )
.replaceAll( '${' + keystarter + '_property_pets_image_13}',  this.property_pets_image_13 )
.replaceAll( '${' + keystarter + '_property_pets_image_14}',  this.property_pets_image_14 )
.replaceAll( '${' + keystarter + '_property_pets_image_15}',  this.property_pets_image_15 )
.replaceAll( '${' + keystarter + '_property_pets_image_16}',  this.property_pets_image_16 )
.replaceAll( '${' + keystarter + '_property_pets_image_17}',  this.property_pets_image_17 )
.replaceAll( '${' + keystarter + '_property_pets_image_18}',  this.property_pets_image_18 )
.replaceAll( '${' + keystarter + '_property_pets_image_19}',  this.property_pets_image_19 )
.replaceAll( '${' + keystarter + '_property_pets_image_20}',  this.property_pets_image_20 )
.replaceAll( '${' + keystarter + '_property_pets_image_21}',  this.property_pets_image_21 )
.replaceAll( '${' + keystarter + '_property_pets_image_22}',  this.property_pets_image_22 )
.replaceAll( '${' + keystarter + '_property_pets_image_23}',  this.property_pets_image_23 )
.replaceAll( '${' + keystarter + '_property_pets_image_24}',  this.property_pets_image_24 )
.replaceAll( '${' + keystarter + '_property_pets_image_25}',  this.property_pets_image_25 )

.replaceAll( '${' + keystarter + '_property_occupancy_image_0}',  this.property_occupancy_image_0 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_1}',  this.property_occupancy_image_1 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_2}',  this.property_occupancy_image_2 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_3}',  this.property_occupancy_image_3 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_4}',  this.property_occupancy_image_4 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_5}',  this.property_occupancy_image_5 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_6}',  this.property_occupancy_image_6 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_7}',  this.property_occupancy_image_7 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_8}',  this.property_occupancy_image_8 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_9}',  this.property_occupancy_image_9 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_10}',  this.property_occupancy_image_10 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_11}',  this.property_occupancy_image_11 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_12}',  this.property_occupancy_image_12 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_13}',  this.property_occupancy_image_13 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_14}',  this.property_occupancy_image_14 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_15}',  this.property_occupancy_image_15 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_16}',  this.property_occupancy_image_16 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_17}',  this.property_occupancy_image_17 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_18}',  this.property_occupancy_image_18 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_19}',  this.property_occupancy_image_19 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_20}',  this.property_occupancy_image_20 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_21}',  this.property_occupancy_image_21 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_22}',  this.property_occupancy_image_22 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_23}',  this.property_occupancy_image_23 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_24}',  this.property_occupancy_image_24 )
.replaceAll( '${' + keystarter + '_property_occupancy_image_25}',  this.property_occupancy_image_25 )

.replaceAll( '${' + keystarter + '_property_condition_image_0}',  this.property_condition_image_0 )
.replaceAll( '${' + keystarter + '_property_condition_image_1}',  this.property_condition_image_1 )
.replaceAll( '${' + keystarter + '_property_condition_image_2}',  this.property_condition_image_2 )
.replaceAll( '${' + keystarter + '_property_condition_image_3}',  this.property_condition_image_3 )
.replaceAll( '${' + keystarter + '_property_condition_image_4}',  this.property_condition_image_4 )
.replaceAll( '${' + keystarter + '_property_condition_image_5}',  this.property_condition_image_5 )
.replaceAll( '${' + keystarter + '_property_condition_image_6}',  this.property_condition_image_6 )
.replaceAll( '${' + keystarter + '_property_condition_image_7}',  this.property_condition_image_7 )
.replaceAll( '${' + keystarter + '_property_condition_image_8}',  this.property_condition_image_8 )
.replaceAll( '${' + keystarter + '_property_condition_image_9}',  this.property_condition_image_9 )
.replaceAll( '${' + keystarter + '_property_condition_image_10}',  this.property_condition_image_10 )
.replaceAll( '${' + keystarter + '_property_condition_image_11}',  this.property_condition_image_11 )
.replaceAll( '${' + keystarter + '_property_condition_image_12}',  this.property_condition_image_12 )
.replaceAll( '${' + keystarter + '_property_condition_image_13}',  this.property_condition_image_13 )
.replaceAll( '${' + keystarter + '_property_condition_image_14}',  this.property_condition_image_14 )
.replaceAll( '${' + keystarter + '_property_condition_image_15}',  this.property_condition_image_15 )
.replaceAll( '${' + keystarter + '_property_condition_image_16}',  this.property_condition_image_16 )
.replaceAll( '${' + keystarter + '_property_condition_image_17}',  this.property_condition_image_17 )
.replaceAll( '${' + keystarter + '_property_condition_image_18}',  this.property_condition_image_18 )
.replaceAll( '${' + keystarter + '_property_condition_image_19}',  this.property_condition_image_19 )
.replaceAll( '${' + keystarter + '_property_condition_image_20}',  this.property_condition_image_20 )
.replaceAll( '${' + keystarter + '_property_condition_image_21}',  this.property_condition_image_21 )
.replaceAll( '${' + keystarter + '_property_condition_image_22}',  this.property_condition_image_22 )
.replaceAll( '${' + keystarter + '_property_condition_image_23}',  this.property_condition_image_23 )
.replaceAll( '${' + keystarter + '_property_condition_image_24}',  this.property_condition_image_24 )
.replaceAll( '${' + keystarter + '_property_condition_image_25}',  this.property_condition_image_25 )

.replaceAll( '${' + keystarter + '_property_type_image_0}',  this.property_type_image_0 )
.replaceAll( '${' + keystarter + '_property_type_image_1}',  this.property_type_image_1 )
.replaceAll( '${' + keystarter + '_property_type_image_2}',  this.property_type_image_2 )
.replaceAll( '${' + keystarter + '_property_type_image_3}',  this.property_type_image_3 )
.replaceAll( '${' + keystarter + '_property_type_image_4}',  this.property_type_image_4 )
.replaceAll( '${' + keystarter + '_property_type_image_5}',  this.property_type_image_5 )
.replaceAll( '${' + keystarter + '_property_type_image_6}',  this.property_type_image_6 )
.replaceAll( '${' + keystarter + '_property_type_image_7}',  this.property_type_image_7 )
.replaceAll( '${' + keystarter + '_property_type_image_8}',  this.property_type_image_8 )
.replaceAll( '${' + keystarter + '_property_type_image_9}',  this.property_type_image_9 )
.replaceAll( '${' + keystarter + '_property_type_image_10}',  this.property_type_image_10 )
.replaceAll( '${' + keystarter + '_property_type_image_11}',  this.property_type_image_11 )
.replaceAll( '${' + keystarter + '_property_type_image_12}',  this.property_type_image_12 )
.replaceAll( '${' + keystarter + '_property_type_image_13}',  this.property_type_image_13 )
.replaceAll( '${' + keystarter + '_property_type_image_14}',  this.property_type_image_14 )
.replaceAll( '${' + keystarter + '_property_type_image_15}',  this.property_type_image_15 )
.replaceAll( '${' + keystarter + '_property_type_image_16}',  this.property_type_image_16 )
.replaceAll( '${' + keystarter + '_property_type_image_17}',  this.property_type_image_17 )
.replaceAll( '${' + keystarter + '_property_type_image_18}',  this.property_type_image_18 )
.replaceAll( '${' + keystarter + '_property_type_image_19}',  this.property_type_image_19 )
.replaceAll( '${' + keystarter + '_property_type_image_20}',  this.property_type_image_20 )
.replaceAll( '${' + keystarter + '_property_type_image_21}',  this.property_type_image_21 )
.replaceAll( '${' + keystarter + '_property_type_image_22}',  this.property_type_image_22 )
.replaceAll( '${' + keystarter + '_property_type_image_23}',  this.property_type_image_23 )
.replaceAll( '${' + keystarter + '_property_type_image_24}',  this.property_type_image_24 )
.replaceAll( '${' + keystarter + '_property_type_image_25}',  this.property_type_image_25 )

.replaceAll( '${' + keystarter + '_service_file_array_image_0}',  this.service_file_array_image_0 )
.replaceAll( '${' + keystarter + '_service_file_array_image_1}',  this.service_file_array_image_1 )
.replaceAll( '${' + keystarter + '_service_file_array_image_2}',  this.service_file_array_image_2 )
.replaceAll( '${' + keystarter + '_service_file_array_image_3}',  this.service_file_array_image_3 )
.replaceAll( '${' + keystarter + '_service_file_array_image_4}',  this.service_file_array_image_4 )
.replaceAll( '${' + keystarter + '_service_file_array_image_5}',  this.service_file_array_image_5 )
.replaceAll( '${' + keystarter + '_service_file_array_image_6}',  this.service_file_array_image_6 )
.replaceAll( '${' + keystarter + '_service_file_array_image_7}',  this.service_file_array_image_7 )
.replaceAll( '${' + keystarter + '_service_file_array_image_8}',  this.service_file_array_image_8 )
.replaceAll( '${' + keystarter + '_service_file_array_image_9}',  this.service_file_array_image_9 )
.replaceAll( '${' + keystarter + '_service_file_array_image_10}',  this.service_file_array_image_10 )
.replaceAll( '${' + keystarter + '_service_file_array_image_11}',  this.service_file_array_image_11 )
.replaceAll( '${' + keystarter + '_service_file_array_image_12}',  this.service_file_array_image_12 )
.replaceAll( '${' + keystarter + '_service_file_array_image_13}',  this.service_file_array_image_13 )
.replaceAll( '${' + keystarter + '_service_file_array_image_14}',  this.service_file_array_image_14 )
.replaceAll( '${' + keystarter + '_service_file_array_image_15}',  this.service_file_array_image_15 )
.replaceAll( '${' + keystarter + '_service_file_array_image_16}',  this.service_file_array_image_16 )
.replaceAll( '${' + keystarter + '_service_file_array_image_17}',  this.service_file_array_image_17 )
.replaceAll( '${' + keystarter + '_service_file_array_image_18}',  this.service_file_array_image_18 )
.replaceAll( '${' + keystarter + '_service_file_array_image_19}',  this.service_file_array_image_19 )
.replaceAll( '${' + keystarter + '_service_file_array_image_20}',  this.service_file_array_image_20 )
.replaceAll( '${' + keystarter + '_service_file_array_image_21}',  this.service_file_array_image_21 )
.replaceAll( '${' + keystarter + '_service_file_array_image_22}',  this.service_file_array_image_22 )
.replaceAll( '${' + keystarter + '_service_file_array_image_23}',  this.service_file_array_image_23 )
.replaceAll( '${' + keystarter + '_service_file_array_image_24}',  this.service_file_array_image_24 )
.replaceAll( '${' + keystarter + '_service_file_array_image_25}',  this.service_file_array_image_25 )



// hide anything null or undefined.
.replaceAll('${undefined}', '')
.replaceAll('${null}', '')
.replaceAll('undefined', '') // makes all undefined print empty
.replaceAll('null', '') // makes all undefined print empty
.replaceAll('Invalid date', '') // makes all undefined print empty


// model.email_template_primary_HTML_rendered
// email_subject_primary_rendered


// Convert the results to a form field value.
// model.email_template_primary_HTML_rendered = rendered_result;
return rendered_result;

}




 // this function is universal for client or email now.
 sendCommunicationEmailButton_Original(model) {
  // model.attached_file_name = this.created_file_name;
  // model.attached_file_names = this.selectedFeatures;
  // model.attached_job_file_names = this.selectedFeaturesJobFiles;
  // model.all_attached_file_names = this.allAttachedFiles;
  // model.allAttachments = this.allAttachments;
  // console.log(model.attached_file_names);


// moved loggint to after send to stop delays... August 2022

  // this.model.allAttachments = this.allAttachments;

 // this.createSubjectNote(model); // Insert a Note to the subject

//   const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
//   console.log('Communication Type Task: ' +  subject_com_type_name);
//       //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
//        //  console.log('Communication Type Task: ' +  subject_com_type_name);
//  const doc_name = document.getElementById('doc_name').innerText;
//  console.log('Document Name: ' +  doc_name);

   // set the invoice from the list of invoices (first record)
// if(model.invoice_id == null){
//   this.getSubjectInvoices(model.subject_id); // lookup the latest invoice to attach
//   model.invoice_id = this.current_invoice_id;
// }





          // Update invoice status
      // :: @ Update the Invoice Status to Approved+PDF (4)   
      // let invoice_model = {
      //   invoice_id: model.invoice_id,
      //   invoice_communication_status_id: 2,
      //     }; 
      //   this.updateInvoiceCommunicationStatus(invoice_model);

  this._mysqlService.sendAgentCommunicationEmail_Original(model).subscribe(
    // this._mysqlService.sendAgentCommunicationEmail_Original(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;


      const log_action = 'sent';
      // const log_name = 'Subject Document Created Via Button: ' + model.subject_com_type_name  + ' - ' + model.file_display_name + '';
      const log_name = 'Subject Communicaiton Task Via button: ' + model.subject_com_type_name  + ' - ' + this.created_file_name + '';
      const create_sys_log = {
        log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
        log_action: log_action, // automated / updated / created / uploaded / link_created / sent
        created_by: this.sessionUserId,
        created_date: this.today,
        subject_id: model.subject_id,
        job_id: model.job_id,
        job_reference_number: model.job_reference_number,
        file_number: model.file_subject_number,
        reference_number: model.job_reference_number,
        subject_number: model.subject_number,
        log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
        created_level: this.sessionUserLevel,
         brand_type_id: this.sessionBrandTypeId,
        subject_com_type_id: model.subject_com_type_id,
        subject_template_doc_id: model.doc_id,
        log_name: log_name + ' - ' + this.returned_created_file_id,
        file_id: this.returned_created_file_id,
        invoice_id: model.invoice_id,
        work_order_id: model.work_order_id,
      };
      this.createSystemLog(create_sys_log);
    
      // const subject_communication_history = {
      //   job_id: model.job_id,
      //   subject_id: model.subject_id,
      //   subject_com_type_id: model.subject_com_type_id,
      //   doc_id: model.doc_id,
      //   change_dates: model.change_dates,
      //   additional_message: model.additional_message,
      //   brand_type_id: model.brand_type_id,
      //   brand_id: model.brand_id,
      //   all_attached_file_names: JSON.stringify(model.all_attached_file_names),
      //   send_to_invoice: model.send_to_invoice,
      //   send_to_report: model.send_to_report,
      //   send_to_logins: model.send_to_logins,
      //   send_to_primary: model.send_to_primary,
      //   allAttachments: JSON.stringify(model.allAttachments),
      //   allRecipients: JSON.stringify(model.allRecipients),
      //   allAttachedFiles: JSON.stringify(model.allAttachedFiles),
      //   brand_report_id: model.brand_report_id,
      //   brand_invoice_id: model.brand_invoice_id,
      //   job_type_name: model.job_type_name,
      //   job_type_location_name: model.job_type_location_name,
      //   brand_report_user_id: model.brand_report_user_id,
      //   email_message_subject: model.email_message_subject,
      //   email_message_recipeints: JSON.stringify(model.email_message_recipeints),
      //   message_subject: model.message_subject,
      //   recipient_name: model.recipient_name,
      //   recipient_type_name: model.recipient_type_name,
      //   recipient_email_address: JSON.stringify(model.recipient_email_address),
      //   email_template_HTML: model.email_template_HTML,
      //   subject_number: model.subject_number,
      //   created_by: this.sessionUserId,
      //   created_date: this.today,
      //   attached_file_names: JSON.stringify(model.attached_file_names),
      //   attached_job_file_names: JSON.stringify(model.attached_job_file_names),
      //   subject_com_type_name: model.subject_com_type_name
      // };
      // this.createSubjectCommunicationHistory(subject_communication_history);








              // this.onOpenDialog_SuccessCommunication(model, model);
              // // console.log(res); // not working as response is showing in body
              // // console.log(res._body);
              // // console.log(res[0].text()); // Convert response to a string
              // this.toastr.success('Package send via Email :: Success');

      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
    //  alert('Error sending email');
    //  throwError(() => new Error(error));
    },
    () => {


      this.onOpenDialog_SuccessCommunication(model, model);
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      this.toastr.success('Package send via Email :: Success');

      
    }
  );
}



getSubjectInvoices(subject_id){
  this._demoService.getSubjectInvoices(subject_id).subscribe(
    data => {
    //  this.subject_invoices = data;
  let res = data[0];
  if(res){
  this.current_invoice_id = res.invoice_id;
  }
  },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


createDocumentButtonAndSend(model, invoice_id?: number, work_order_id?: number) {
  // generate more data first
  // make sure not nulls printed to database
if (model.brand_type_id !== 3) {
  model.assigned_to_agents = [];
}

  // :: Actual File Model - All Vars Required to Create A file Merge Docx
  const pushed_create_file_model = {
    doc_id: model.doc_id,
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_number: model.subject_number,
    subject_com_type_id: model.subject_com_type_id,
    job_type_id: model.job_type_id,
    job_type_location_id: model.job_type_location_id,
    job_type_court_id: model.job_type_court_id,
    job_type_document_type_id: model.job_type_document_type_id,
    job_type_affidavit_type_id: model.job_type_affidavit_type_id,
    invoice_id: invoice_id,
    work_order_id: work_order_id,
    assinged_to_agents: model.assinged_to_agents // test and upgrade to see if fixex Array issue in files database August 20022.

  }; // multidimentional array push
// Create the Actual File
  this._mysqlService.createDocument_2021Test(pushed_create_file_model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
     // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
    
    //  this.refreshList(); // loads the file list (diretory)
     
   //   this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      // this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      model.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      // model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      const file_server_location = this.fileFolderDocs + model.subject_number;
      const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'docx',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via button',
        file_job_id: pushed_create_file_model.job_id,
        file_subject_id: pushed_create_file_model.subject_id,
        file_subject_number: pushed_create_file_model.subject_number,
        created_by: this.sessionUserId,
        created_date: this.today,
        created_level: this.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.sessionUserId,
        updated_date: this.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: pushed_create_file_model.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        // report_access_array: JSON.stringify(this.brand_data), // collect client
        // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.

        agent_access_array: [], // collect current agent ids
        report_access_array: [], // collect client
        invoice_access_array: [], // collect client
        user_access_array: [], // of selected associated users.
        is_theme: model.is_theme,
        assigned_to_agents: JSON.stringify(model.assigned_to_agents),  /// fix Array insert into dab
        is_encrypted: 0

      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );

     // :: Now we need to insert the file Data and Create a syste File Data Entry.
      this.createFile(create_file);
      
      // Send the email ( The only addition/difference to the function without send communication)
      // this.sendCommunicationEmailButton(model);

      this.sendCommunicationEmailButton_Original(model); // reverted back to orginal script for buttons.

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.

    /// this.onOpenDialog_SuccessCommunication(model, model);

    },
    (error) => {
     // this.toastr.error('Error Creating Document');
      throwError(() => new Error(error));
    }
  );
}


createDocumentButtonAndSend_Automation_2(model, invoice_id?: number, work_order_id?: number) {
  // generate more data first
  // make sure not nulls printed to database
if (model.brand_type_id !== 3) {
  model.assigned_to_agents = [];
}



// Load all the functions for paragraph replacements



// end merge calls
// 2.0
// this.setAllRecipients_2(model); // same function as on comms page to set to set allRecipients -- sets the paragraph variables here from the model...?




 
      




// test
          // :: Impliments automatic recipients based on chosen com template options
          // :: Subract Method / Filter
          // :: DEMOSERVICE look up client brand details.


// end test




// removed original set recipients code from coms 2.0 -- see of sets om tje fuctopm above.





        // // See if this stops doubles test??? now
        //     let uniqueRecipeints = this.allRecipients.filter((value, index, self) =>
        //     index === self.findIndex((t) => (
        //       t.recipeint_name === value.recipeint_name &&
        //       t.recipeint_email_address === value.recipeint_email_address &&
        //       t.recipient_brand_type_id === value.recipient_brand_type_id    
        //     ))
        //   )
        //   this.allRecipients = uniqueRecipeints; // remove duplicates
        //   model.allRecipients = this.allRecipients;


  // :: Actual File Model - All Vars Required to Create A file Merge Docx
  const pushed_create_file_model = {
    doc_id: model.doc_id,
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_number: model.subject_number,
    subject_com_type_id: model.subject_com_type_id,
    job_type_id: model.job_type_id,
    job_type_location_id: model.job_type_location_id,
    job_type_court_id: model.job_type_court_id,
    job_type_document_type_id: model.job_type_document_type_id,
    job_type_affidavit_type_id: model.job_type_affidavit_type_id,
    invoice_id: invoice_id,
    work_order_id: work_order_id,
    assinged_to_agents: model.assinged_to_agents // test and upgrade to see if fixex Array issue in files database August 20022.

  }; // multidimentional array push
// Create the Actual File
// Orginal Version.
  // this._mysqlService.createDocument_2021Test(pushed_create_file_model).subscribe(

// 2.0 need to impliment it here.... -- file creation.....
this._mysqlService.createDocument_2023_Paragraphs(model).subscribe(


    (data) => {
      // this.trace_candidate_update = data;
     // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
    
    //  this.refreshList(); // loads the file list (diretory)
     
   //   this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      // this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);


      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      model.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      // model.allAttachments = this.allAttachments; // ?? this may be causing errors.



      
      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      if (model.brand_type_id === '1') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }


      // corrected for automations June 2025
      if(!model.is_theme){
        model.is_theme = 0;
      }

      const file_server_location = this.fileFolderDocs + model.subject_number;
      const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'docx',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'automated', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via automation',
        file_job_id: pushed_create_file_model.job_id,
        file_subject_id: pushed_create_file_model.subject_id,
        file_subject_number: pushed_create_file_model.subject_number,
        created_by: this.sessionUserId,
        created_date: this.today,
        created_level: this.sessionUserLevel,
        // file_brand_id: model.brand_report_id,
        file_brand_id: model.file_brand_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.sessionUserId,
        updated_date: this.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: pushed_create_file_model.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        // report_access_array: JSON.stringify(this.brand_data), // collect client
        // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.

        agent_access_array: [], // collect current agent ids
        report_access_array: [], // collect client
        invoice_access_array: [], // collect client
        user_access_array: [], // of selected associated users.
        is_theme: model.is_theme, // need to be a number to fix file creation issues.
        assigned_to_agents: JSON.stringify(model.assigned_to_agents),  /// fix Array insert into dab
        is_encrypted: 0,
        ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?
        allRecipients: this.allRecipients, // created by funning the above function.
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );

     // :: Now we need to insert the file Data and Create a syste File Data Entry.
      this.createFile(create_file);
      // this.createFile(create_file);
    
      // Send the email ( The only addition/difference to the function without send communication)
      // this.sendCommunicationEmailButton(model);

      // this.sendCommunicationEmailButton_Original(model); // reverted back to orginal script for buttons.
      // this.sendCommunicationEmailButton(model); // reverted back to orginal script for buttons. --- ORIGINAL FOR ALL


                                      
                        

      model.message_subject = model.message_subject_header;
      this.sendCommunicationEmailButton_Automation_2(model, create_file); // reverted back to orginal script for buttons. --- ORIGINAL with no notifications. --- SEND



      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.

    /// this.onOpenDialog_SuccessCommunication(model, model);

    },
    (error) => {
     // this.toastr.error('Error Creating Document');
      throwError(() => new Error(error));
    }
  );
}


createDocumentButtonAndSend_Automation(model, invoice_id?: number, work_order_id?: number) {
  // generate more data first
  // make sure not nulls printed to database
if (model.brand_type_id !== 3) {
  model.assigned_to_agents = [];
}

// this.setAllRecipients(model); // same function as on comms page to set to set allRecipients

this.allRecipients = [];
model.allRecipients = this.allRecipients; // reset the model as we.. so dont get duplicates....

if (model.send_to_report == 1) {
  
  console.log('BRand REport Id:', model.brand_report_id);
  // 
        // :: Impliments automatic recipients based on chosen com template options
        // :: Subract Method / Filter
        // :: DEMOSERVICE look up client brand details.
        this._demoService.getBrandById(model.brand_report_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
            //  this.allRecipients.push({
            //    recipient_name: res.name + ' - Client Report',
            //    recipient_email_address: res.email,
            //    recipient_brand_id: res.brand_id,
            //    recipient_brand_type_id: res.brand_type_id,
            //    recipient_user_id: null,
            //    recipient_user_level_id: null,
            //    recipient_type_name: 'Client Report',
            //  });
                  // Just set instead of push to see if this prevents duplicates.
                  this.allRecipients = [{
                    recipient_name: res.name + ' - Client Report',
                    recipient_email_address: res.email,
                    recipient_brand_id: res.brand_id,
                    recipient_brand_type_id: res.brand_type_id,
                    recipient_user_id: null,
                    recipient_user_level_id: null,
                    recipient_type_name: 'Client Report',
                  }]


             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.
           model.allRecipients = this.allRecipients;

          },
          (err) => console.error(err),
          () => console.log('Client Report Recipient Added.')
        );

    } // end if send_to_report
      
    // AGENT --- only sends to the firts agent of the subject (1)
    if ( model.brand_type_id == 3) { 
      this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
              //  this.allRecipients.push({
              //    recipient_name: res.name + ' - Agent',
              //    recipient_email_address: res.email,
              //    recipient_brand_id: res.brand_id,
              //    recipient_brand_type_id: res.brand_type_id,
              //    recipient_user_id: null,
              //    recipient_user_level_id: null,
              //    recipient_type_name: 'Agent',
              //  });
              
         
                  // Just set instead of push to see if this prevents duplicates.
                  this.allRecipients = [{
                    recipient_name: res.name + ' - Agent',
                    recipient_email_address: res.email,
                    recipient_brand_id: res.brand_id,
                    recipient_brand_type_id: res.brand_type_id,
                    recipient_user_id: null,
                    recipient_user_level_id: null,
                    recipient_type_name: 'Agent',
                  }]
           } // end for loop



         
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.
         model.allRecipients = this.allRecipients;

        },
        (err) => console.error(err),
        () => console.log('Agent Recipients Added.')
      );
      // const key = 'Agent';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Agent Recipients');
      //   }
      // });
    };


    // OWNER
    if ( model.brand_type_id == 1) { 
      this._demoService.getBrandById(94).subscribe(
        (data66) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data66;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
          //  this.allRecipients.push({
          //    recipient_name: res.name + ' - TSA Owner',
          //    recipient_email_address: res.email,
          //    recipient_brand_id: res.brand_id,
          //    recipient_brand_type_id: res.brand_type_id,
          //    recipient_user_id: null,
          //    recipient_user_level_id: null,
          //    recipient_type_name: 'Owner',
          //  });

          // Just set instead of push to see if this prevents duplicates.
          this.allRecipients = [{
             recipient_name: res.name + ' - TSA Owner',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Owner',
            }]

           } // end for loop

           // Running function to remove the duplicates if two files added the same brand type wit the create doc and send function (doubnle ups)
           let uniqueRecipeints = this.allRecipients.filter((value, index, self) =>
           index === self.findIndex((t) => (
             t.recipeint_name === value.recipeint_name &&
             t.recipeint_email_address === value.recipeint_email_address &&
             t.recipient_brand_type_id === value.recipient_brand_type_id    
           ))
         )
    
    
          //  this.allRecipients = this.allRecipients; // ?? this may be causing errors.
           this.allRecipients = uniqueRecipeints; // remove duplicates
         model.allRecipients = this.allRecipients;

        },
        (err) => console.error(err),
        () => console.log('owner Recipient Added.')
      );

  } // end if send_to_owner

  // console.log('Brand Report User: ', model.brand_report_user_id);
    if (model.send_to_report_user == 1) {

      this._demoService.getUsersById(model.brand_report_user_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
          //  this.allRecipients.push({
          // recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
          // recipient_email_address: res.email_address,
          // recipient_brand_id: null,
          // recipient_brand_type_id: null,
          // recipient_user_id: res.user_id,
          // recipient_user_level_id: res.access_level,
          // recipient_type_name: 'Client Report User',
          //  });
                  // Just set instead of push to see if this prevents duplicates.
                  this.allRecipients = [{
                    recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
                    recipient_email_address: res.email_address,
                    recipient_brand_id: null,
                    recipient_brand_type_id: null,
                    recipient_user_id: res.user_id,
                    recipient_user_level_id: res.access_level,
                    recipient_type_name: 'Client Report User',
                  }]

           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.
         console.log('All REport user Recipients:', JSON.stringify(this.allRecipients));
         model.allRecipients = this.allRecipients;

        },
        (err) => console.error(err),
        () => console.log('Client Report User Recipient Added.')
      );
      // const key = 'Client Report User';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Report User Recipient');
      //   }
      // });
    };

    if (model.send_to_invoice == 1) {
        this._demoService.getBrandById(model.brand_invoice_id).subscribe(
          (data) => {
            // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
           let newArr = data;
           let  count_of_items = Object.keys(newArr).length;
             // need to do a loop of subject_billing items (.length)
             for(let i=0;i < count_of_items; i++) {
             let res = newArr[i];
            //  this.allRecipients.push({
            //    recipient_name: res.name + ' - Client Accounts',
            //    recipient_email_address: res.email,
            //    recipient_brand_id: res.brand_id,
            //    recipient_brand_type_id: res.brand_type_id,
            //    recipient_user_id: null,
            //    recipient_user_level_id: null,
            //    recipient_type_name: 'Client Accounts',
            //  });

                  // Just set instead of push to see if this prevents duplicates.
                  this.allRecipients = [{
                    recipient_name: res.name + ' - Client Accounts',
                    recipient_email_address: res.email,
                    recipient_brand_id: res.brand_id,
                    recipient_brand_type_id: res.brand_type_id,
                    recipient_user_id: null,
                    recipient_user_level_id: null,
                    recipient_type_name: 'Client Accounts',
                  }]


             } // end for loop
           this.allRecipients = this.allRecipients; // ?? this may be causing errors.
           model.allRecipients = this.allRecipients;

          },
          (err) => console.error(err),
          () => console.log('Client Accounts Recipient Added.')
        );
    }

    if (model.send_to_logins == 1) {
      this._demoService.getBrandUsers(model.brand_report_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
          //  this.allRecipients.push({
          // recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
          // recipient_email_address: res.email_address,
          // recipient_brand_id: null,
          // recipient_brand_type_id: null,
          // recipient_user_id: res.user_id,
          // recipient_user_level_id: res.access_level,
          // recipient_type_name: 'Client User',
          //  });

                  // Just set instead of push to see if this prevents duplicates.
                  this.allRecipients = [{
                    recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
                    recipient_email_address: res.email_address,
                    recipient_brand_id: null,
                    recipient_brand_type_id: null,
                    recipient_user_id: res.user_id,
                    recipient_user_level_id: res.access_level,
                    recipient_type_name: 'Client User',
                  }]

           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.
         model.allRecipients = this.allRecipients;

        },
        (err) => console.error(err),
        () => console.log('Client User Recipient Added.')
      );
      // const key = 'Client User';
      // this.allRecipients.forEach((value, index) => {
      //   if (value.recipient_type_name === key) {
      //     this.allRecipients.splice(index, 1);
      //     console.log('Removed Client User Recipients');
      //   }
      // });
    }

    if (model.send_to_primary == 1) {
      this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
        (data) => {
          // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
          //  this.allRecipients.push({
          // recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
          // recipient_email_address: res.email_address,
          // recipient_brand_id: null,
          // recipient_brand_type_id: null,
          // recipient_user_id: res.user_id,
          // recipient_user_level_id: res.access_level,
          // recipient_type_name: 'Client Primary Contact',
          //  });

                  // Just set instead of push to see if this prevents duplicates.
                  this.allRecipients = [{
                    recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
                    recipient_email_address: res.email_address,
                    recipient_brand_id: null,
                    recipient_brand_type_id: null,
                    recipient_user_id: res.user_id,
                    recipient_user_level_id: res.access_level,
                    recipient_type_name: 'Client Primary Contact',
                  }]


           } // end for loop
         this.allRecipients = this.allRecipients; // ?? this may be causing errors.
         model.allRecipients = this.allRecipients;

        },
        (err) => console.error(err),
        () => console.log('Client Primary Contact Added.')
      );

    }

        // // See if this stops doubles test??? now
        //     let uniqueRecipeints = this.allRecipients.filter((value, index, self) =>
        //     index === self.findIndex((t) => (
        //       t.recipeint_name === value.recipeint_name &&
        //       t.recipeint_email_address === value.recipeint_email_address &&
        //       t.recipient_brand_type_id === value.recipient_brand_type_id    
        //     ))
        //   )
        //   this.allRecipients = uniqueRecipeints; // remove duplicates
        //   model.allRecipients = this.allRecipients;


  // :: Actual File Model - All Vars Required to Create A file Merge Docx
  const pushed_create_file_model = {
    doc_id: model.doc_id,
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_number: model.subject_number,
    subject_com_type_id: model.subject_com_type_id,
    job_type_id: model.job_type_id,
    job_type_location_id: model.job_type_location_id,
    job_type_court_id: model.job_type_court_id,
    job_type_document_type_id: model.job_type_document_type_id,
    job_type_affidavit_type_id: model.job_type_affidavit_type_id,
    invoice_id: invoice_id,
    work_order_id: work_order_id,
    assinged_to_agents: model.assinged_to_agents // test and upgrade to see if fixex Array issue in files database August 20022.

  }; // multidimentional array push
// Create the Actual File
  this._mysqlService.createDocument_2021Test(pushed_create_file_model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
     // this.toastr.success('Creating Document for you now.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;
    
    //  this.refreshList(); // loads the file list (diretory)
     
   //   this.displaySubjectDocuments(this.subject_id, this.subject_number);

      // push to global array
      // this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);


      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      model.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      // model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      if (model.brand_type_id === '1') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      if(!model.is_theme){
        model.is_theme = 0;
      }

      const file_server_location = this.fileFolderDocs + model.subject_number;
      const file_url = this.fileURL + '/' + this.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'docx',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'automated', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via automation',
        file_job_id: pushed_create_file_model.job_id,
        file_subject_id: pushed_create_file_model.subject_id,
        file_subject_number: pushed_create_file_model.subject_number,
        created_by: this.sessionUserId,
        created_date: this.today,
        created_level: this.sessionUserLevel,
        // file_brand_id: model.brand_report_id,
        file_brand_id: model.file_brand_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: '',
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.sessionUserId,
        updated_date: this.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: pushed_create_file_model.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        // agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        // report_access_array: JSON.stringify(this.brand_data), // collect client
        // invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        // user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.

        agent_access_array: [], // collect current agent ids
        report_access_array: [], // collect client
        invoice_access_array: [], // collect client
        user_access_array: [], // of selected associated users.
        is_theme: model.is_theme,
        assigned_to_agents: JSON.stringify(model.assigned_to_agents),  /// fix Array insert into dab
        is_encrypted: 0,
        ...pushed_create_file_model, // added for automations as was missing sibject details in the log_model?
        allRecipients: this.allRecipients, // created by funning the above function.
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );

     // :: Now we need to insert the file Data and Create a syste File Data Entry.
      this.createFile(create_file);
    
      // Send the email ( The only addition/difference to the function without send communication)
      // this.sendCommunicationEmailButton(model);

      // this.sendCommunicationEmailButton_Original(model); // reverted back to orginal script for buttons.
      // this.sendCommunicationEmailButton(model); // reverted back to orginal script for buttons. --- ORIGINAL FOR ALL
      model.message_subject = model.message_subject_header;
      this.sendCommunicationEmailButton_Automation(model); // reverted back to orginal script for buttons. --- ORIGINAL with no notifications.

      model.subject_template_doc_id = model.doc_id // needts to be set make the correct note in the system.
      this.insertNote_CreateFileButton(model,create_file.full_file_name); // filemane for note - try to create file model for the ntoe. // insert the note.

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.

    /// this.onOpenDialog_SuccessCommunication(model, model);

    },
    (error) => {
     // this.toastr.error('Error Creating Document');
      throwError(() => new Error(error));
    }
  );
}




createFile(model){
  this._demoService.createFile(model).subscribe(
    data => { this.file_created_response = data;
    // need to get the returned ID to send to log create action
  
    this.returned_created_file_id = this.file_created_response.last_insert_id;
    console.log(this.returned_created_file_id);


  //   const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
  //   console.log('Communication Type Task: ' +  subject_com_type_name);
  //       //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
  //        //  console.log('Communication Type Task: ' +  subject_com_type_name);
  //  const doc_name = document.getElementById('doc_name').innerText;
  //  console.log('Document Name: ' +  doc_name);
   
   const log_action = 'created';
   const log_name = 'Subject Document Created Via Button: ' + model.subject_com_type_id  + ' - ' + model.file_display_name + ''; 
   
           const create_sys_log = {
             log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
             log_action: log_action, // automated / updated / created / uploaded / link_created / sent
             created_by: this.sessionUserId,
             created_date: this.today,
             subject_id: model.subject_id,
             job_id: model.job_id,
             job_reference_number: model.job_reference_number,
             file_number: model.file_number,
             reference_number: model.job_reference_number,
             subject_number: model.subject_number,
             log_type_id: '1', // see datatable system_log_types
             created_level: this.sessionUserLevel,
              brand_type_id: this.sessionBrandTypeId,
             subject_com_type_id: model.subject_com_type_id,
             subject_template_doc_id: model.doc_id,
             log_name: log_name + ' - ' + this.returned_created_file_id,
             file_id: this.returned_created_file_id,
             invoice_id: model.invoice_id,
             work_order_id: model.work_order_id,
             agent_id: model.agent_id,
           };
           //switche off as it sets off automation checker...
          //  this.createSystemLog(create_sys_log);


           this.toastr.info('Documents Created & Tasks Achieved');

    },
    err => console.log(err),
    // () => console.log('done loading Trace Types')
  );
}




// syncfusion dialog simple sample
public onOpenDialog_SuccessInvoiceCreated = function(event: any, model): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Invoice PDF Created',
    content: 'You can access in the subject files, and communications as well as on the subject building page.',
    okButton: {  text: 'Ok', click: this.okClick_SuccessInvoiceCreated.bind(this, model) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '', click: this.okClick_SuccessInvoiceCreated.bind(this, model) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick_SuccessInvoiceCreated(this, model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
 this.globalJobSubjectBillingViewSkipRoute(model.subject_id);

}; // end functiiom

private cancelClick2_SuccessInvoiceCreated(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}



// syncfusion dialog simple sample
public onOpenDialog_SuccessCommunication = function(event: any, model): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Communication Processed',
    content: 'Successfully created the document requested.',
    okButton: {  text: 'Ok', click: this.okClick2.bind(this, model) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '.', click: this.okClick2.bind(this, model) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick2(this, model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
 this.globalJobSubjectViewSkipRoute(model.subject_id);

}; // end functiiom

private cancelClick2(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}

// :: EOF Create a doc by button



// syncfusion dialog simple sample
public onOpenDialog_SuccessSendEmail = function(event: any, model): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Succesfully Sent Email.',
    content: 'You may close this window to cotinue.',
    okButton: {  text: 'Ok', click: this.okClick_SuccessSendEmail.bind(this, model) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '', click: this.okClick_SuccessSendEmail.bind(this, model) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick_SuccessSendEmail(this, model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
 this.globalJobSubjectView(model.subject_id);

}; // end functiiom

private cancelClick2_SuccessSendEmaild(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}






// sumple send email function based on log data and buitt models.
sendSimpleEmail(log_data, model){
  model.message_body = log_data.log_body;
  model.message_subject = log_data.log_name;

// model = [{
//   ...log_data,
//   ...model
// }];

// console.log('Comb Email Model: ' + JSON.stringify(model));

  this._mysqlService.sendSimpleEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
      throwError(() => new Error(error));
    }
  );



  }


// sumple send email function based on log data and buitt models.
sendSimpleClientEmail(log_data, model){
  model.message_body = log_data.log_body;
  model.message_subject = log_data.log_name;
  model.email_body = log_data.email_body;
  model.email_subject = log_data.email_subject;

// model = [{
//   ...log_data,
//   ...model
// }];

// console.log('Comb Email Model: ' + JSON.stringify(model));

  this._mysqlService.sendSimpleClientEmail(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Sent Email.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // now close the modal
      // this.closeParentModel.emit();
      // this.closeParentModel3.emit();
      // // refresh the invoice page if
      // if ( model.invoice_id > 0 ){
      //   this.refreshSujectInvoicePage.emit(this.subject_id);
      // }
    },
    (error) => {
      // this.toastr.error('Error sending Email');
      throwError(() => new Error(error));
    }
  );



  }





  insertLog_CreateJob_Client_Started(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: null, // inserts the entire JSON action into mysql cell
      log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: model.created_by,
      created_date: model.created_date,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: null,
      file_number: null,
      reference_number: null,
      subject_number: null,
      log_type_id: 59, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'New Job Created for Submission (Pending): ' + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: New Job Started :' + model.job_id  + ' Created By' + ' Company: ' + this.sessionBrandName + ' - ' + this.sessionUserName + ' (Step 1: not complete): ' + ' - ' + this.sessionUserFullName + '',
      // tslint:disable-next-line:max-line-length
      log_body: 'NOTICE New Job Created: On:' + this.today_date_time_words + ' a New Job ' +  + model.job_id + ' was Created By ' + this.sessionBrandName + ' - ' + this.sessionUserName + ' : ' + this.sessionUserFullName + ' From: (Step 1: not yet complete, or submitted for Sharmans review - draft) ',
      file_id: null,
    };
    this.createSystemLog(log_data);

    model = {
      ...model,
      ...log_data
    }
    // only send if agent or client.
    if(this.sessionBrandTypeId != 1){
    // this.sendSimpleEmail(log_data, model); // notify sharmans
    }
  
  }





  insertLog_CreateJob(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: null, // inserts the entire JSON action into mysql cell
      log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: model.created_by,
      created_date: model.created_date,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: null,
      file_number: null,
      reference_number: null,
      subject_number: null,
      log_type_id: 6, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'New Job Created for Submission (Pending): ' + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: New Job :' + model.job_id  + ' Created By' + ' Company: ' + this.sessionBrandName + ' - ' + this.sessionUserName + ' (Step 1: not complete): ' + ' - ' + this.sessionUserFullName + '',
      // tslint:disable-next-line:max-line-length
      log_body: 'NOTICE New Job Created: On:' + this.today_date_time_words + ' a New Job ' +  + model.job_id + ' was Created By ' + this.sessionBrandName + ' - ' + this.sessionUserName + ' : ' + this.sessionUserFullName + ' From: (Step 1: not yet complete, or submitted for Sharmans review - draft) ',
      file_id: null,
    };
    this.createSystemLog(log_data);

    model = {
      ...model,
      ...log_data
    }
    // only send if agent or client.
    if(this.sessionBrandTypeId != 1){
    // this.sendSimpleEmail(log_data, model); // notify sharmans
    }
  
  }

  insertLog_UpdateJob(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: null,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: null,
      log_type_id: 13, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Job Details Updated :' + model.job_id  + ' By' + this.sessionBrandName +  ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Job: ' +  model.job_id +  ' was updated By' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Job Edit Widget) Step 3 - > Saved as Draft/Pending. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }

        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }


  insertLog_OpenJobReadyForAction(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: null,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: null,
      log_type_id: 37, // see datatable system_log_types
      // log_type_id: 33, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Job Open Ready for Action :' + model.job_id  + ' By' + this.sessionBrandName +  ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Job: ' +  model.job_id +  ' was Made Ready For Action, By' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Job Edit Widget) Step 3 - > Saved as Draft/Pending. ',

    };

    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }

        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }



  insertLog_UpdateJobSubmission(model) {

    // Log type swticher by brand_type_id of the user action
    // There was a bug runnign the wrong log code as same page same action.
    if(this.sessionBrandTypeId == '1') {
      var log_type_id = 6;
      // var log_type_id = 37;
    }
    if(this.sessionBrandTypeId == '2') {
      var log_type_id = 6;
    }
    if(this.sessionBrandTypeId == '3') {
      var log_type_id = 6;
    }


    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: null,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: null,
      log_type_id: log_type_id,
      // log_type_id: 37, // new now 37 -- is the saff member.
      // log_type_id: 6, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Job Details SUBMITTED FOR ACTION :' + model.job_number  + ' - ' + model.job_status_code  + ' By' + this.sessionBrandName +  ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
      log_body: 'NOTICE:  On: ' + this.todayDate + ' Job: ' +  model.job_number + ' - ' + model.job_status_code  + ' was updated and SUBMITTED FOR ACTION' + ' by: ' + this.sessionBrandName + ' - ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Job Edit Widget) Step 3 - > Ready for Staff Review, Please Action this Job. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // Converted to System Auotmation ID: 5
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }

  insertLog_CreateJobNote(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 25, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Job Note Added :'  + model.job_id   + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Job: '  + model.job_id  +  ' a note was created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
        // Now hard coded. Auotmation ID 6
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }


  insertLog_CreateSubjectNote(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 32, // see datatable system_log_types // Now has specific Log Type.... Category...
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Subject Note Added :'  + model.subject_number  + ' - ' + model.subject_name   + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Subject: ' + model.subject_number  + ' - ' + model.subject_name   + ' a Subject note was added By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ')  From: ' + ' (Subject Note Widget). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){

          // Setting up this automation now automation id 7
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }


// new function so that status does not change in adding a note daft mode.
  insertLog_CreateSubjectNoteMYDRAFT(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 86, // see datatable system_log_types // Now has specific Log Type.... Category...
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Subject MYDRAFT Note Added :'  + model.subject_number  + ' - ' + model.subject_name   + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Subject: ' + model.subject_number  + ' - ' + model.subject_name   + ' a Subject note was added before submission By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ')  From: ' + ' (Subject Note Widget). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){

          // Setting up this automation now automation id 7
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }


  
  insertLog_UploadSubjectFile(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'uploaded', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 34, // see datatable system_log_types -- fixed was wrong at 8 - new log type created.
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: model.subject_com_type_id,
      subject_template_doc_id: model.subject_template_doc_id,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Subject File Uploaded :'  + model.subject_number  + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Subject: ' + model.subject_number  + ' a file was uploaded By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') File: ' + model.file_name +  '  - From: ' + ' (Subject File Widget). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }  
    // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // converted over automation id 11
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }



  insertLog_UploadJobFile(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'uploaded', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 26, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: model.subject_com_type_id,
      subject_template_doc_id: model.subject_template_doc_id,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Job File Uploaded :'  + model.job_id  + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Job: ' + model.job_id  + ' a file was uploaded By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') File: ' + model.file_name +  '  - From: ' + ' (Subject File Widget). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // Now coverted to system automation ID 10
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }



  insertLog_EncryptPDFFile(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'encrypt-pdf', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 62, // success
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: model.subject_com_type_id,
      subject_template_doc_id: model.subject_template_doc_id,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'PDF Encyption:'  + model.file_name +  ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'On: ' + this.today_date_time_words + ' a file was encrypted: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') File: ' + model.file_name +  '  - From: ' + ' (PDF Encrypt Button). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // Now coverted to system automation ID 10
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }



  insertLog_EncryptPDFFileERROR(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'encrypt-pdf-ERROR', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 63, // start Encryption
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: model.subject_com_type_id,
      subject_template_doc_id: model.subject_template_doc_id,
      // log_name: 'Job Details Updated: ' + model.job_id + ' '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'PDF Encyption ERROR: ' + model.file_name + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'On: ' + this.today_date_time_words  + ' a file FAILED encrypted: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') File: ' + model.file_name +  '  - From: ' + ' (PDF Encrypt Button). Login to view and action. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // Now coverted to system automation ID 10
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
  }





  insertLog_UpdateSubjectGeneral(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 14, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      // log_name: 'Subject Details Updated: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Subject Details Updated: :' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' was updated by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Update Wizard). ',
    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
    // only send if agent or client.
    if(this.sessionBrandTypeId != 1){
     // this.sendSimpleEmail(log_data, model); // notify sharmans
      }
  }

  insertLog_UpdateSubjectNewStage(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 15, // see datatable system_log_types -- I will be splutting this up for if from closed to a new log id...
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'New Subject Stage Created from: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
    };
    this.createSystemLog(log_data);
  }



  insertLog_DeleteSubject(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'deleted', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 80, // see datatable system_log_types -- I will be splutting this up for if from closed to a new log id...
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'Subject Deleted : ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
    };
    this.createSystemLog(log_data);
  }


  insertLog_UpdateSubjectNewStageFromClosed(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 79, // see datatable system_log_types -- I will be splutting this up for if from closed to a new log id...
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'New Subject Stage Created from Closed: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
    };
    this.createSystemLog(log_data);
  }


  insertLog_UpdateSubjectClose(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 78, // see datatable system_log_types // was 14 now sepeated
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'Subject Closed: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
    };
    this.createSystemLog(log_data);
  }


  insertLog_UpdateSubjectNewStageJobType(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 66, // see datatable system_log_types -- specic new log type created for this
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'New Job Type & Subject Stage Created from: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
    };
    this.createSystemLog(log_data);
  }

  insertLog_UpdateSubjectStatus(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 77, // see datatable system_log_types -- NEED TO SEPERSTE THIS INTO A SEPERSTE LOG TYPE AND TRIGGER>... was 14
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'Subject Status Updated: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
    };
    this.createSystemLog(log_data);
  }


  insertLog_UpdateSubjectAgentAdded(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 16, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
    
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'Agent' + model.brand_id[0]  + ' Addd to Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      agent_id: model.brand_id[0]
    };
    this.createSystemLog(log_data);
  }


  insertLog_UpdateSubjectAgentRemoved(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 16, // see datatable system_log_types
      created_level: this.sessionUserLevel, // staff manager
      brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'Agent' + model.user_id  + ' Removed From Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      agent_id: model.user_id,
    };
    this.createSystemLog(log_data);
  }


  insertLog_UpdateSubjectUrgentAgentCommunication(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'sent', // automated / updated / created / uploaded / link_created / sent / accessed
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id,
      job_id: model.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_number,
      reference_number: model.reference_number,
      subject_number: model.subject_number,
      log_type_id: 38, // see datatable system_log_types -- THIS WILL HAVE TO BE A NEW LOG TYPE -- NEW data entry subject_urgent_communications
      created_level: this.sessionUserLevel, // staff manager
       brand_type_id: this.sessionBrandTypeId,
    
      subject_com_type_id: null,
      subject_template_doc_id: null,
      log_name: 'Agent Comms: ' + model.allocated_to_array[0].name  + ' ' + this.transform2(model.email_subject_primary_rendered) + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
        + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
      file_id: null,
      agent_id: model.assigned_to_agents[0].recipient_brand_id
    };
    this.createSystemLog(log_data);
  }


// Custom Build Drop Down Automations 2.0 - Client Services.
// Quick Links :: Client Update Request


// quick link update request - subject
insertLog_QuickLink_UNIVERSAL_Subject(model, automation_model, log_type_id) {
  if (confirm('Are you sure you wish to '+ automation_model.system_automation_name +  ' upon the SUBJECT ' + model.subject_name + '?' )) {
  // insert log
let combo_model = {
  ...automation_model,
  ...model,
  log_type_id: log_type_id
}

  const log_data = {
    log_id: null,
    log_content: JSON.stringify(combo_model), // inserts the entire JSON action into mysql cell
    log_action:  automation_model.system_automation_name, // automated / updated / created / uploaded / link_created / sent / accessed
    // log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
   
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // log_type_id: 39, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    log_type_id: log_type_id, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: automation_model.system_automation_name + ' ' + ' '  + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.success(automation_model.system_automation_name + ' : Action Requested')
  this.closeParentModel.emit()
 this.createSystemLog(log_data);
}
}



insertLog_QuickLink_UNIVERSAL_Job(model, automation_model, log_type_id) {
  if (confirm('Are you sure you wish to '+ automation_model.system_automation_name +  ' upon the JOB ' + model.owner_trace_code + '?' )) {
    // insert log
  let combo_model = {
    ...automation_model,
    ...model,
    log_type_id: log_type_id
  }
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(combo_model), // inserts the entire JSON action into mysql cell
    log_action: automation_model.system_automation_name, // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: log_type_id, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: automation_model.system_automation_name + ' '  + ' Job: ' + model.job_id + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.success(automation_model.system_automation_name + ' : Action Requested')
  this.closeParentModel.emit()
 this.createSystemLog(log_data);
}
}


// quick link update request - subject
insertLog_QuickLink_UpdateRequest(model) {
  if (confirm('Are you sure you wish to reqest an update? ')) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 39, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Update Request: ' + ' '  + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}

// quick link update request - subject
insertLog_QuickLink_JobUpdateRequest(model) {
  if (confirm('Are you sure you wish to reqest an update? ')) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 45, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Job Update Request: ' + ' '  + ' Job: ' + model.job_id + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}


// HOLD FILE
insertLog_QuickLink_HoldFile(model) {
  if (confirm('Are you sure you wish to reqest Hold File? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 40, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Hold File: ' + ' '  + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}


insertLog_QuickLink_JobHoldFile(model) {
  if (confirm('Are you sure you wish to reqest Hold File? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 46, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Job Hold File: ' + ' '  + ' Job: ' + model.job_id + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}

// Remove Hold and Continue 
insertLog_QuickLink_RemoveHoldContinue(model) {
  if (confirm('Are you sure you wish to remove the Hold and Continue? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 41, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Remove Hold and Continue: ' + ' '  + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}


insertLog_QuickLink_JobRemoveHoldContinue(model) {
  if (confirm('Are you sure you wish to remove the Hold and Continue? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 47, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Job Remove Hold and Continue: ' + ' '  + ' Job: ' + model.job_id + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}


// Remove Hold and Continue 
insertLog_QuickLink_InstructSkipTrace(model) {
  if (confirm('Are you sure you wish to Instruct a Skip Trace? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 42, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Instruct Skip Trace: ' + ' '  + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}

insertLog_QuickLink_JobInstructSkipTrace(model) {
  if (confirm('Are you sure you wish to Instruct a Skip Trace? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 48, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Job Instruct Skip Trace: ' + ' '  + ' Job: ' + model.job_id + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}

// Remove Hold and Continue 
insertLog_QuickLink_ReOpenSubject(model) {
  if (confirm('Are you sure you wish to Re-Open the Subject? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 43, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Re-Open Subject: ' + ' '  + ' Subject: ' + model.subject_number + ' ' + model.subject_name + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}




// Remove Hold and Continue 
insertLog_QuickLink_ReOpenJob(model) {
  if (confirm('Are you sure you wish to Re-Open the Job? ')) {

  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'quick_link', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 44, // NEED TO CREATE NEW QUICK LINK AUTOMATION --- Log Type.... -- First Quick Link Log Type Trigger... In System
    created_level: this.sessionUserLevel, // staff manager
     brand_type_id: this.sessionBrandTypeId,
  
    subject_com_type_id: null,
    subject_template_doc_id: null,
    log_name: 'Quick Link - Re-Open Job: ' + ' '  + ' Job: ' + model.job_id + ' ' + model.owner_trace_code + ' by: '
      + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    agent_id: null
  };
  this.toastr.info('Quick Link Requeted')
 this.createSystemLog(log_data);
}
}







insertLog_TFA_remove(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'user_tfa_removed', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 53, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'TFA removed  : By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' USERID: '  + this.sessionUserId  +  ' created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
      // Now hard coded. Auotmation ID 6
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}



insertLog_TFA_setup_attempt(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'user_tfa_setup_attempt', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 54, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'TFA setup Attempt : By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' USERID: '  + this.sessionUserId  +  ' created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
      // Now hard coded. Auotmation ID 6
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}
insertLog_TFA_setup_complete(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'user_tfa_setup_complete', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 55, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'TFA setup Complete : By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' USERID: '  + this.sessionUserId  +  ' created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
      // Now hard coded. Auotmation ID 6
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}



insertLog_TFA_login_passed(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'user_tfa_login_pass', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 56, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'TFA user success : By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' USERID: '  + this.sessionUserId  +  ' created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
      // Now hard coded. Auotmation ID 6
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}






insertLog_TFA_login_skipped(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'user_tfa_login_skipped', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 57, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'TFA user SKIPPED : By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' USERID: '  + this.sessionUserId  +  ' created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
      // Now hard coded. Auotmation ID 6
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}



insertLog_TFA_login_failed(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'user_tfa_login_failed', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 58, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'TFA user FAILED : By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' USERID: '  + this.sessionUserId  +  ' created By ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') From: ' + ' (Job Note Widget). Login to view and action. ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
      // Now hard coded. Auotmation ID 6
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}




insertLog_CreateSubject(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 64, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    brand_id: model.report_brand_id, // who for
    user_id: model.report_brand_user_id, // who for

    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'subject_created :' + model.job_id  + ' By' + this.sessionBrandName +  ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' a Subject: for job: ' +  model.job_id +  ' was created By' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' ',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }

      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}


insertLog_CreateSubject_FAIL(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'fail', // automated / updated / created / uploaded / link_created / sent / accessed
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    log_type_id: 65, // see datatable system_log_types
    created_level: this.sessionUserLevel, // staff manager
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    brand_id: model.report_brand_id, // who for
    user_id: model.report_brand_user_id, // who for

    // log_name: 'Job Details Updated: ' + model.job_id + ' '
    //   + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
    file_id: null,
    // tslint:disable-next-line:max-line-length
    log_name: 'subject_created_FAIL :' + model.job_id  + ' By' + this.sessionBrandName +  ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }

      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}

  // SYSTEM LOGGING
  // runSystemAutomation(log_model, model) {
  //   this._demoService.createSystemLog(log_model, model).subscribe(
  //     data => { this.system_log_created_response = data; },
  //     err => console.log(err),
  //     // () => console.log('done loading Trace Types')
  //   );
  // }

  
  getSystemLogType(log_type_id) {
    this._demoService.getSystemLogType(log_type_id).subscribe(
       data => { this.system_log_type = data;
      
      },
       err => console.error(err),
       () => console.log('System Log Type')
     );
   }
  



  runSystemAutomation(log_model, model, system_automation_id) {
    // generate more data first
    // :: merged Both Models For convenince and consistancy


// this.systemAutomationConditionChecker(model); /// Need to incorporate this some how.....


// Lookup the log_model type
const log_type_id = model.log_type_id
this.system_log_type = '[]';
console.log("Log Type ID: " + log_type_id);

              this._demoService.getSystemLogType(log_type_id).subscribe(
                data => { 
                  this.system_log_type = data;
                  const system_log_type_data = data;
                       
console.log('this.system_log_type[0].create_document_file: ', this.system_log_type[0].create_document_file);

                    // create the file function -- first make sure that system automation array exists.// only run if required.
                    if(this.system_log_type[0].system_automation_array != '[]' ){


                  // CHANGE STATUS AND DATES ????
                  // Dates and Status Changes  
                   this.runSystemAuomationDatesAndStatus_No_Loop(this.system_log_type,model, system_automation_id); 

                      //  this.runSystemAuomationFileCreation(this.system_log_type,model);  // stop duplicates when it runs all the time... etc...
                       this.runSystemAuomationFileCreation_No_Loop(this.system_log_type,model, system_automation_id);  // October 2023 :: added system_automation_id to stop loop and new function

                       // october 2024 - added system_automation_id to stop loop
                      //  this.runSystemAuomationCommunicationsCreation(this.system_log_type,model);  // stop duplicates when it runs all the time... etc...
                   
              // Commeented out for testing coms 2
               this.runSystemAuomationCommunicationsCreation_No_Loop(this.system_log_type,model, system_automation_id); // :: October 2023 New function to prevent loop and creating document doubles (Orking Correctly)


              // 2.0 Run Suystem File Creation No Loop - Start to setup and mimic the function
              this.runSystemAuomationFileCreation_No_Loop_2(this.system_log_type,model, system_automation_id);  // October 2023 :: added system_automation_id to stop loop and new function


                      // 2.0 Full Comms creation
                      this.runSystemAuomationCommunicationsCreation_No_Loop_2(this.system_log_type,model, system_automation_id); // :: October 2023 New function to prevent loop and creating document doubles (Orking Correctly)


                     // this.insertLog_TriggerSystemAutomation(this.system_log_type, model); // WORKING MODELS DO NOT DELETE -- work her as well but
                     //:: BUG TESTING --- THIS worked below function now sends when communications only (if not here notes and emails double when checked and files are not.)
                      if ((this.system_log_type[0].send_email != 0 || this.system_log_type[0].send_email != null) && (this.system_log_type[0].send_note != 0 || this.system_log_type[0].send_note != null) ) {// this prevents from running twice when emails and comms are checked in automation
                        // this.insertLog_TriggerSystemAutomation(this.system_log_type, model); // See if this only runs once? Needed here as it was not running when creating Comminucations alone??????
                      
                        // this.insertLog_TriggerSystemAutomation_No_Loop(this.system_log_type, model, system_automation_id); // Octoner 2023 :: No Loop Function to replace current DO WE NEED THIS HERE>?>>>

                      } 
                        return; // this is needed
    

                     }  
              },
                err => console.error(err),
                () => {
                
                  // this.insertLog_TriggerSystemAutomation(this.system_log_type, model); // WORKING MODELS DO NOT DELETE USE AS BASE>
                  console.log('System Log Type Trigger Event')
                }
              );
 // This function now runs automatically when a log is created... so will need to filter out
                  //  setTimeout(() => {  
                  //   console.log("A Simple Pause!"); 
                  // }, 4000);


    const pushed_automation_model = {
      ...log_model,
      ...model,
      // ...this.system_log_type[0]
    }; // multidimentional array push
    // const pushed_automation_model = {
    //   ...model,
    // }; // multidimentional array push

    // only run the php of required.
    // if(this.system_log_type[0].system_automation_array != '[]'){
    if(this.system_log_type[0].system_automation_array != '[]'){
     




      // Send the Email(s)
              this._mysqlService.runSystemAutomation(log_model, pushed_automation_model, system_automation_id).subscribe(
                (data) => {
                  // this.trace_candidate_update = data;
                // this.toastr.success('Creating Document for you now.');
                  const res = data;
                  console.log(res); // not working as response is showing in body
  
                },
                (error) => {
                // this.toastr.error('Error Creating Document');
                //   throwError(() => new Error(error));
                  throwError(() => new Error(error));
                }
               );
          } //..end null


          // Imseting an Automation Log: Full Details:
        // Need to do a quick lookup for the automation Name or names... if array... etc... PAUSE IMPORTANT! so it can run everything
        setTimeout(() => {  
        //  this.insertLog_TriggerSystemAutomation(this.system_log_type, model); // WORKING MODELS DO NOT DELETE USE AS BASE>
         this.insertLog_TriggerSystemAutomation_No_Loop(this.system_log_type, model, system_automation_id); // WORKING MODELS DO NOT DELETE USE AS BASE>
          console.log("A Simple Pause: Insert Trigger Log!"); 
        }, 0);
                        // Soly for the Automation Log Event Only
                        // Function to run the automation logs with correct data. !must check and rember its running on ever command!!!!!!
                              // if(this.system_log_type[0].system_automation_array != '[]'){
                                  
                              //       const system_automation_array = this.system_log_type[0].system_automation_array
                              //       console.log('Log Model FINAL System Automation.: system_automation_array: ' + JSON.stringify(this.system_log_type[0].system_automation_array))
                              //       console.log('PASSED: system_automation_array - AUTOMATION LOGGING : ' + system_automation_array);
                                  
                                  
                              //     // Commented out below for testing

                              //                   const count_system_automation_array = system_automation_array.length;
                              //                   // const count_system_automation_array = Object.keys(system_automation_array).length; // try the objec with keys method...?

                              //                   console.log('system Automation Array:', system_automation_array )

                              //                   // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
                              //           for(let i=0;i < count_system_automation_array; i++) {


                              //                   this.false_count = 0;
                              //                   this.true_count = 0;

                              //                   this._demoService.getSystemAutomation(system_automation_array[i])
                              //                   .subscribe(
                              //                   res24 => {
                              //                   this.system_automation = res24;
                              //                   let data_s = res24[0]
                              //                   let current_automation =  JSON.stringify(data_s) // result from quiery above
                              //                   //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                              //                   // OK we have the automatino details as well as the / model - current log_model
                              //                   // We can now get an array of files to loop.

                              //                   console.log('insertLog_TriggerSystemAutomation: ' +  res24[0].run_data_sector_conditions);

                                                
                              //                               const new_model = {
                              //                                 ...model
                              //                                 // ...this.system_log_type[0]
                              //                               }; // multidimentional array push

                              //                               // Now insert the new log trigger Automation Run./Triggered.

                              //                               this.insertLog_TriggerSystemAutomation(this.system_log_type[0],model); // FInished Maybe?    
                                          

                              //                         },
                              //                         err => console.error(err),
                              //                         () => console.log('')
                              //                       );
                              //                     // end second looup template doc.

                              //         } // end conditions loop

                              //       } // end if automations array




  }



// new condition for automations -- same as jobs urgent...BUT DIFFERENT>..
  updateSubjectStatusBulkAutomationBasic(subject_id, job_status, result, next_date, final_date){
    let new_status = job_status;
    // result.job_status = job_status;
    result.new_status = job_status;
    result.update_job_status = job_status;
    result.update_next_date = next_date;
    result.update_final_date = final_date;

    this._demoService.updateSubjectStatusBulkBasic(result, new_status)
    // .pipe(
    //   this.toastr.observe({
    //     loading: 'Subject Updates...',
    //     success: 'ðŸš€.. ',
    //     error: '...ðŸ˜¡ Error updating ...' + subject_id
    //  })
    //  )
    .subscribe(
      data => { // this.trace_candidate_update = data;
      this.toastr.success('Subject Status Updated');
      // const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      // this.search_results[objIndex].updated_status = 'yes';
      },
      error => {
        this.toastr.error('Error Changing Status of Subject');
      //  return console.log(error);
      }
  );
  }


  updateSubjectStatusONLYAutomationBasic(subject_id, job_status, result, next_date, final_date){
    let new_status = job_status;
    // result.job_status = job_status;
    result.new_status = job_status;
    result.update_job_status = job_status;
    result.update_next_date = next_date;
    result.update_final_date = final_date;

    this._demoService.updateSubjectStatusOnlyBasic(result, new_status)
    // .pipe(
    //   this.toastr.observe({
    //     loading: 'Subject Updates...',
    //     success: 'ðŸš€.. ',
    //     error: '...ðŸ˜¡ Error updating ...' + subject_id
    //  })
    //  )
    .subscribe(
      data => { // this.trace_candidate_update = data;
      // this.toastr.success('Subject Status Updated');
      // const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      // this.search_results[objIndex].updated_status = 'yes';
      },
      error => {
        this.toastr.error('Error Changing Status of Subject');
      //  return console.log(error);
      }
  );
  }


  updateJobAndSubjectStatusAutomation(automation_model, job_status, result, next_date, final_date){
    let new_status = job_status;
    // result.job_status = job_status;
    result.new_status = job_status;
    result.update_job_status = job_status;
    result.update_next_date = next_date;
    result.update_final_date = final_date;

    // checks done at API
    result.change_job_status = automation_model.change_job_status;
    result.change_subject_status = automation_model.change_subject_status;
    result.job_status = automation_model.job_status;
    result.subject_status = automation_model.subject_status;


    this._demoService.updateJobAndSubjectStatus(result, new_status)
    // .pipe(
    //   this.toastr.observe({
    //     loading: 'Subject Updates...',
    //     success: 'ðŸš€.. ',
    //     error: '...ðŸ˜¡ Error updating ...' + subject_id
    //  })
    //  )
    .subscribe(
      data => { // this.trace_candidate_update = data;
      // this.toastr.success('Subject & Job Status Updated');
      // const objIndex = this.search_results.findIndex((obj => obj.subject_id === subject_id));
      // this.search_results[objIndex].updated_status = 'yes';
      },
      error => {
        this.toastr.error('Error Changing Status of Job and Subject');
      //  return console.log(error);
      }
  );
  }


// Insert Log on create company
insertLog_TriggerSystemAutomation(log_model, model) {
// console.log('insertLog_TriggerSystemAutomation log_model: ', log_model)
// console.log('insertLog_TriggerSystemAutomation model: ', model)


let current_automation_array = JSON.parse(log_model[0].system_automation_array)


// set above.
// let current_automation_array = JSON.parse(this.system_log_type[0].system_automation_array)
// const current_automation_array = log_model.system_automation_array;
let count_current_automation_array = current_automation_array.length;
// console.log('insertLog_TriggerSystemAutomation current_automation_array: ', current_automation_array)
console.log('insertLog_TriggerSystemAutomation count_current_automation_array: ', count_current_automation_array)
  



// look up each and push the log -- automation.
for(let iiii=0;iiii < count_current_automation_array; iiii++) {

          
                       console.log('current_automation_array[i]: ', current_automation_array[iiii])
                           this._demoService.getSystemAutomation(current_automation_array[iiii])
                                                .subscribe(
                                                res245 => {
                                                this.system_automation2 = res245;
                                                
                                             let  data_ss = res245[0] // changed to
                                                let current_automation =  JSON.stringify(data_ss) // result from quiery above
                                                //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                                                // OK we have the automatino details as well as the / model - current log_model
                                                // We can now get an array of files to loop.
                                                  // let current_atomation_details = data_ss.system_automation_name + ' active: ' + data_ss.is_active;
                                                  let current_atomation_details = data_ss.system_automation_name;
                                                  // 

                                                  let is_active = data_ss.is_active;

                                                    let full_capture = [{
                                                      ...data_ss, // the system automation data FOOTPRINT
                                                      ...model // the log_capture FOOTPRINT that actually triggered the event
                                                    }]

                                                  // insert log
                                                  let log_data = {
                                                    log_id: null,
                                                    // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                                                    // log_content: JSON.stringify(data_ss), // inserts the entire JSON action into mysql cell -- changed to insert the System Automation Model Instead of the The actual Event 
                                                    log_content: JSON.stringify(full_capture[0]), // cobined model of both
                                                    log_action: 'triggered', // automated / updated / created / uploaded / link_created / sent / accessed
                                                    log_name: 'Automation Triggered: ' + ' - ' + current_atomation_details + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
                                                    log_type_id: 36, // see datatable system_log_types (7 = company created)
                                                    created_level: this.sessionUserLevel, // staff manager
                                                    created_by: this.sessionUserId,
                                                    created_date: this.today,
                                                    subject_id: null,
                                                    job_id: null,
                                                    job_reference_number: null,
                                                    file_number: null,
                                                    reference_number: null,
                                                    subject_number: null,
                                                    brand_type_id: this.sessionBrandTypeId,
                                                    subject_com_type_id: null,
                                                    subject_template_doc_id: null,
                                                    file_id: null,
                                                    brand_id: model.brand_id,
                                                    // ...model // Octoner Did Nothing
                                                    // system_automation_content: JSON.stringify(model),
                                                    // system_automation_content2: JSON.parse(model),
                                                    
                                                  };
                                                  if(is_active == 1 ){
                                                   this.createSystemLogNoSystemAutomations(log_data);
                                                  }
                                                  data_ss = '';

                                              },
                            err => console.error(err),
                            () => console.log('')
                          );
                        // end second looup template doc.

} // end currene collection of automations

 
}

insertLog_TriggerSystemAutomation_No_Loop(log_model, model, system_automation_id) {
  // console.log('insertLog_TriggerSystemAutomation log_model: ', log_model)
  // console.log('insertLog_TriggerSystemAutomation model: ', model)
  
  
  // let current_automation_array = JSON.parse(log_model[0].system_automation_array)
  // let current_automation_array = JSON.parse(log_model[0].system_automation_array)
  
  
      // set above.
      // let current_automation_array = JSON.parse(this.system_log_type[0].system_automation_array)
      // const current_automation_array = log_model.system_automation_array;



  // let count_current_automation_array = current_automation_array.length;
      // console.log('insertLog_TriggerSystemAutomation current_automation_array: ', current_automation_array)
  // console.log('insertLog_TriggerSystemAutomation count_current_automation_array: ', count_current_automation_array)
    
  
  
  
  // look up each and push the log -- automation.
  // for(let iiii=0;iiii < count_current_automation_array; iiii++) {
  
            
                        //  console.log('current_automation_array[i]: ', current_automation_array[iiii])
                         
                             this._demoService.getSystemAutomation(system_automation_id)
                                                  .subscribe(
                                                  res245 => {
                                                  this.system_automation2 = res245;
                                                  
                                               let  data_ss = res245[0] // changed to
                                                  let current_automation =  JSON.stringify(data_ss) // result from quiery above
                                                  //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                                                  // OK we have the automatino details as well as the / model - current log_model
                                                  // We can now get an array of files to loop.
                                                    // let current_atomation_details = data_ss.system_automation_name + ' active: ' + data_ss.is_active;
                                                    let current_atomation_details = data_ss.system_automation_name;
                                                    // 
  
                                                    let is_active = data_ss.is_active;
  
                                                      let full_capture = [{
                                                        ...data_ss, // the system automation data FOOTPRINT
                                                        ...model // the log_capture FOOTPRINT that actually triggered the event
                                                      }]
  
                                                    // insert log
                                                    let log_data = {
                                                      log_id: null,
                                                      // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                                                      // log_content: JSON.stringify(data_ss), // inserts the entire JSON action into mysql cell -- changed to insert the System Automation Model Instead of the The actual Event 
                                                      log_content: JSON.stringify(full_capture[0]), // cobined model of both
                                                      log_action: 'triggered', // automated / updated / created / uploaded / link_created / sent / accessed
                                                      log_name: 'Automation Triggered: ' + ' - ' + current_atomation_details + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
                                                      log_type_id: 36, // see datatable system_log_types (7 = company created)
                                                      created_level: this.sessionUserLevel, // staff manager
                                                      created_by: this.sessionUserId,
                                                      created_date: this.today,
                                                      subject_id: null,
                                                      job_id: null,
                                                      job_reference_number: null,
                                                      file_number: null,
                                                      reference_number: null,
                                                      subject_number: null,
                                                      brand_type_id: this.sessionBrandTypeId,
                                                      subject_com_type_id: null,
                                                      subject_template_doc_id: null,
                                                      file_id: null,
                                                      brand_id: model.brand_id,
                                                      // ...model // Octoner Did Nothing
                                                      // system_automation_content: JSON.stringify(model),
                                                      // system_automation_content2: JSON.parse(model),
                                                      
                                                    };
                                                    if(is_active == 1 ){
                                                     this.createSystemLogNoSystemAutomations(log_data);
                                                    }
                                                    data_ss = '';
  
                                                },
                              err => console.error(err),
                              () => console.log('')
                            );
                          // end second looup template doc.
  
  // } // end currene collection of automations
  
   
  }
  



systemAutomationConditionChecker(model){
  // console.log('Data Sector Condition Check', JSON.stringify(model))

  // october 2023
  let original_log_content = model.log_content;
  // console.log('Current Event/Action Model:' + JSON.stringify(original_log_content));

            const log_type_id = model.log_type_id
            this._demoService.getSystemLogType(log_type_id).subscribe(
            data => { 
            this.system_log_type = data;
            const system_log_type_data = data;
            // create the file function -- first make sure that system automation array exists.// only run if required.
          
            const system_automation_array = JSON.parse(this.system_log_type[0].system_automation_array)
            const count_system_automation_array =system_automation_array.length;
            console.log('system Automation Array:', system_automation_array )


           
            // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
              for(let i=0;i < count_system_automation_array; i++) {

            //  setTimeout(() => {  console.log('delay Automation Loop stop 10000')   }, 10000); // was 4000
        setTimeout(() => {  console.log('delay Automation Loop stop 10000')   }, 10000); // was 4000

                this.false_count = 0;
                this.true_count = 0;
        

                setTimeout(() => {  console.log('delay Automation Loop') 
                        // updated to only retirn if active
                          this._demoService.getSystemAutomation(system_automation_array[i])
                          .subscribe(
                          res24 => {
                          this.system_automation = res24;
                          let data_s = res24[0]

                          // :: check if there is an actual return of data/ if not it is not active // october 2023
                          if (data_s.is_active == 1){


                          let current_automation =  JSON.stringify(data_s) // result from quiery above
                          this.run_automations_from_conditions = data_s.run_data_sector_conditions;
                          this.run_currnent_system_automation_name = data_s.system_automation_name;
                           console.log('Current Automation: ' + current_automation) // Full automation JSON results
                          // OK we have the automatino details as well as the / model - current log_model
                          // We can now get an array of files to loop.

                          // console.log('run_data_sector_conditions: ' +  res24[0].run_data_sector_conditions);

                          // I need to count the conditions a dn loop

                          // Run THE CONDITION CONDITIONING FIRST.
          //  if(res24[0].run_data_sector_conditions == 1 && res24[0].run_data_sector_conditions != null ) { // if checkbox checked create_document_file
            if(data_s.run_data_sector_conditions == 1 && data_s.run_data_sector_conditions != null ) { // if checkbox checked create_document_file

            
                          // let system_conditions_array = JSON.parse(res24[0].system_conditions_array);
                          let system_conditions_array = JSON.parse(data_s.system_conditions_array);
                          const count_system_conditions_array = system_conditions_array.length;
                          console.log('Count system conditions array: ' + count_system_conditions_array)
                       
                        console.log('System Condition Array: ' + system_conditions_array)
                       
             for(let z=0; z < count_system_conditions_array; z++) {
                          console.log("A : system_condition_array count:", z ); 
                          console.log('count system condition_arrau array log_type_data_sector_condition_id: '  + system_conditions_array[z]);
                          // now for each file/doc_id and the the full models we can create the files(s)
                        
                          //     /// New condition Checker Function
                           let condition_check_function = this.checkAutomationConditions(model, system_automation_array[i], system_conditions_array[z]);
                            console.log('NEW Condition Checker function: ' + condition_check_function );


                          // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                          // getSubjectTemplateDoc(doc_id) {}
      //                             this._demoService.getSystemLogTypeDataSectorCondition(system_conditions_array[z]).subscribe(
      //                               data55 => { 
      //                                 this.current_system_log_data_sector_condition = data55; // this could have been where the double up error occurns in other sections????? check later
      //                                 let res_condition = data55[0];
      //                                 // load the drop downs
      //                                 // this.getJobTypeLocations(res.job_type_id);
      //                                 // this.getJobTypeCourts(res.job_type_location_id);
      //                                 // this.getJobTypeDocumentTypes(res.job_type_court_id);
      //                                 // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      //                                 // // this.getJobTypes();

      //                           this.current_subject_com_type_id = data55[0].subject_com_type_id;
      //                           let condition_array = JSON.parse(data55[0].condition_array)
      //                           console.log('Condition Array to Check - Conditions: ', condition_array)
      //                           let current_log_content = JSON.parse(model.log_content);
      //                                 // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                                

      //                                 // Filters objects for nul and undefined values.
      //                                 // const obj = current_log_content;
      //                                 // const filteredObject = _.pickBy(obj, v => v !== null && v !== undefined);
      //                                 // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
      //                                 // console.log('FilteredObject', JSON.stringify(filteredObject));

      //                                   // let string_array = {"subject_id":"701","job_id":"1200","first_name": "r"}; // base condition_array - for comparison.
                                      
                                      
                                      
      //                                   // let string_array = JSON.parse(data55[0].condition_array); // base condition_array - for comparison.
      //                                   let string_array = JSON.parse(this.current_system_log_data_sector_condition[0].condition_array); // base condition_array - for comparison.
      //                                   let d: (string | any)[] = [string_array]


      //                                 let a = JSON.parse(model.log_content);
      //                                 let b = condition_array;
      //                                   let kv = [a];
      //                                   let l = new Set(Object.keys(string_array));
      //                                   console.log('ObjectKeys Condition Array: ', Object.keys(string_array));
      //                                   // #2 :: Filter throught A : the_log_content and remove anything not esisting int the log_content  array. [kv]
      //                                   for (let obj of kv) {
      //                                     for (let prop of Object.keys(obj)) {
      //                                       if (!l.has(prop)) {
      //                                           delete obj[prop];
      //                                       }
      //                                     }
      //                                   }
      //                                   console.log('Whats Left KV: ', kv);
      //                                   console.log('Condition Array to Compare log Content: ', kv)
      //                                  let compare_result = _.isEqual(_.sortBy(kv), _.sortBy(d))
      //                                  console.log('Condition ', z + ' ' + compare_result);
                                    
                                      
      //                                  if(compare_result == true){
      //                                   // return false;
      //                                   this.condition_compare_result = true;
      //                                   this.true_count = this.true_count + 1
      //                                  // return;
      //                                   }else if(compare_result == false) {
      //                                   this.condition_compare_result = false;
      //                                   this.false_count = this.false_count + 1
      //                                 //  return;
      //                                   }
                                    

      // // // October 2023 :: Try to put in here and validate from above.
      // //   // setTimeout(() => {  console.log('delay')  }, 8000); // was 4000
      // //   console.log('Condition Global All have to be TRUE: ', this.condition_compare_result)
      // //   console.log('True Count: ', this.true_count);
      // //   console.log('False Count ', this.false_count);

      // //         //   if (this.condition_compare_result == true){
      // //         //   this.runSystemAutomation('', model) 
      // //         // }
      // //         // if there are no false and some true.
      // // if (compare_result = true ){
      // // // October 2023 :: update to go through current condition rather than the glocbal condition compare above.
      // // // if (this.condition_compare_result = true ){ // Tring this to see if runs each individual automion condition instead of all having to be true.

                
        
      // //           // this.runSystemAutomation(model[0].log_content, model) // Added log model? October 2023 -- stopped trigger?
      // //           // this.runSystemAutomation('', model, system_automation_array[i]) // Added log model? October 2023
      // //           model.system_automation_name_test = "Condition Checker if conditions";
      // //           this.runSystemAutomation('', model, system_automation_array[i]) // Added log model? October 2023


      // //     console.log('Runnig runSystemAutomation after Conditions Check', res24[0].system_automation_name);
      // //         }



                                    
      //                                 // this.condition_compare_result = compare_result;
      //                                 // this.condition_compare_result = true;


      //                                 // works but runs loop on all conditions we just want it to all have to be true to run.
      //                                 // if (compare_result == true){
      //                                 //   this.runSystemAutomation('', model) 
      //                                 // }

      //                                 //  return compare_result;

      //                                 // systemConditionCompareFunction(a,b){
      //                                 //   const a_test: (string | any)[] = JSON.parse(this.log_content); // original log
      //                                 //   let string_array = {"subject_id":"701","job_id":"1200","first_name": "r"}; // base condition_array - for comparison.
      //                                 //   const d: (string | any)[] = [string_array]
      //                                 //   b=b;
      //                                 //   let kv = [a];
      //                                 //   const l = new Set(Object.keys(string_array));
      //                                 //   // #2 :: Filter throught A : the_log_content and remove anything not esisting int the log_content  array. [kv]
      //                                 //   for (let obj of kv) {
      //                                 //     for (let prop of Object.keys(obj)) {
      //                                 //       if (!l.has(prop)) {
      //                                 //           delete obj[prop];
      //                                 //       }
      //                                 //     }
      //                                 //   }
      //                                 //   console.log('Whats Left KV: ', kv);
      //                                 //  let compare_result = _.isEqual(_.sortBy(kv), _.sortBy(b))
      //                                 // this.condition_compare_result = compare_result;
      //                                 // }


                                                
      //                                   //             setTimeout(() => {  
      //                                   //               console.log("A Simple Pause! -- 6100 at count: ", ii); 
      //                                   //               let pushed_automation_file_model = {};
      //                                   //               //          ...current_log_content
      //                                   //                                 pushed_automation_file_model = {
      //                                   //                                 doc_id: system_file_array[ii],
      //                                   //                                 subject_id: current_log_content.subject_id,
      //                                   //                                 // model.brand_type_id = 3; // for agent
      //                                   //                                 // brand_type_id: model.brand_type_id, // 

      //                                   //                                 ...log_model,
      //                                   //                                 ...model,
      //                                   //                                 // ...this.system_log_type[0]
      //                                   //                                 // Mussin for file creation
      //                                   //                                 is_theme: '0',
      //                                   //                                 file_edit_level: data55[0].file_edit_level,
      //                                   //                                 file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)

      //                                   //                                 // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                                
      //                                   //                                 brand_type_id: data55[0].brand_type_id, 
      //                                   //                               //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
      //                                   //                               assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
      //                                   //                               allAttachments: [], // set so can fill if required by auto attach and send.
      //                                   //                               ...data55[0], // the comm model details.
      //                                   //                               // REMOVED AS ONLY REQUIRED FOR COMMUNICATION AND WAS STUFFING UP NOTES I THINK TESTING....
      //                                   //                                           brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
      //                                   //                                           brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
      //                                   //                                           brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
      //                                   //                                           message_subject_header: data55[0].message_subject_header,
      //                                   //                                           subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
      //                                   //                             }; // multidimentional array push

      //                                   //                             console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))

      //                                   //                   // See Global Function to See Vars
      //                                   //                   this.createDocumentFileViaAutomation(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.

      //                                   //                   // TESTING TO SEE IF STOPS DUPBLE UPS
      //                                   //                   this.allRecipients = [];
      //                                   //                   model.allRecipients = this.allRecipients; // reset the model as we.. so dont get duplicates....
                                                    
      //                                   // // this.createDocumentButtonAndSend_Automation(pushed_automation_file_model) // --- working but creating doubles 
      //                                   //                   // Mussing --- file_brand_id, file_edit_level


      //                                   //                 }, 0);



                                      
      //                               }
      //                               // ,
      //                               // err => console.error(err),
      //                               // () => console.log('')
      //                             );
                          // end second looup template doc.



                          

                    // Time out is crutial to setting the gloabal condition
              //       setTimeout(() => {  console.log('delay') 
              // console.log('Condition Global All have to be TRUE: ', this.condition_compare_result)
              // console.log('True Count: ', this.true_count);
              // console.log('False Count ', this.false_count);

              //       //   if (this.condition_compare_result == true){
              //       //   this.runSystemAutomation('', model) 
              //       // }
              //       // if there are no false and some true.
              //       if (this.false_count < 1 && this.true_count > 0 ){
              
              //         // this.runSystemAutomation(model[0].log_content, model) // Added log model? October 2023 -- stopped trigger?
              //         this.runSystemAutomation('', model) // Added log model? October 2023


              //   console.log('Runnig runSystemAutomation after Conditions Check', res24[0].system_automation_name);
              //       }



              //     }, 4000); // was 4000



                       // October 2023 :: Try inside condition Loop
                                            //                                  // Time out is crutial to setting the gloabal condition
                                            //                                  setTimeout(() => {  console.log('delay') 


                                            //                                  console.log('Condition Global All have to be TRUE: ', this.condition_compare_result)
                                            //                                  console.log('True Count: ', this.true_count);
                                            //                                  console.log('False Count ', this.false_count);
                             
                                            //                                        //   if (this.condition_compare_result == true){
                                            //                                        //   this.runSystemAutomation('', model) 
                                            //                                        // }
                                            //                                        // if there are no false and some true.
                                            // if (this.false_count < 1 && this.true_count > 0 ){
                                            //   // October 2023 :: update to go through current condition rather than the glocbal condition compare above.
                                            //   // if (this.condition_compare_result = true ){ // Tring this to see if runs each individual automion condition instead of all having to be true.
                                              
                                                                             
                                            //                                          // this.runSystemAutomation(model[0].log_content, model) // Added log model? October 2023 -- stopped trigger?
                                            //                                          // this.runSystemAutomation('', model, system_automation_array[i]) // Added log model? October 2023
                                            //                                          model.system_automation_name_test = "Condition Checker if conditions";
                                            //                                          console.log('Runnig runSystemAutomation after Conditions Check', res24[0].system_automation_name);
                                            //                                          this.runSystemAutomation('', model, system_automation_array[i]) // Added log model? October 2023
                             
                             
                                                                               
                                            //                                        }
                             
                                            //                                        //     // Cotoer 2023 :: Moved here to see if stops DUPLICATEes??????
                             
                                            //                                        // if( (this.run_automations_from_conditions == 0 || this.run_automations_from_conditions == null) && this.run_automations_from_conditions != 1 ) { 
                                            //                                        //   model.system_automation_name_test = 'Insdie Loop array - Insdie Conditions';
                                            //                                        //   this.runSystemAutomation('', model, system_automation_array[i])  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop
                                                               
                                                               
                                            //                                        //   console.log('Runnig runSystemAutomation NOT CONDITIONS: ', this.run_currnent_system_automation_name);
                                            //                                        //   }
                             
                             
                             
                                            //                                      }, 0); // was 4000
                             
                                              
                                                                                //  this.true_count = null;
                                                                                //  this.false_count = null;
                                                                                //  this.condition_compare_result = null;
            
            
            } // end conditions loop



                 


                          // if final is true then we can send.(Outside the conditions array loop)
                          // This should only send when the all conditions are true above.... now.... and run only once not on every condition if set above.
                                              
                                          //               // Time out is crutial to setting the gloabal condition
                                                        setTimeout(() => {  console.log('delay true of false')  
                                                  console.log('Condition Global All have to be TRUE: ', this.condition_compare_result)
                                                  console.log('True Count: ', this.true_count);
                                                  console.log('False Count ', this.false_count);

                                                        //   if (this.condition_compare_result == true){
                                                        //   this.runSystemAutomation('', model) 
                                                        // }
                                                        // if there are no false and some true.
                                          if (this.false_count < 1 && this.true_count > 0 ){
                                              // October 2023 :: update to go through current condition rather than the glocbal condition compare above.
                                              // if (this.condition_compare_result = true ){ // Tring this to see if runs each individual automion condition instead of all having to be true.
                                              
                                                          
                                                  
                                                          // this.runSystemAutomation(model[0].log_content, model) // Added log model? October 2023 -- stopped trigger?
                                                          // this.runSystemAutomation('', model, system_automation_array[i]) // Added log model? October 2023
                                                              // model.system_automation_name_test = "Condition Checker if conditions";
                                                              // console.log('Runnig runSystemAutomation after Conditions Check', res24[0].system_automation_name);
                                                              // this.runSystemAutomation('', model, system_automation_array[i]) // Added log model? October 2023


                                                    
                                                        }

                                                        //     // Cotoer 2023 :: Moved here to see if stops DUPLICATEes??????

                                                        // if( (this.run_automations_from_conditions == 0 || this.run_automations_from_conditions == null) && this.run_automations_from_conditions != 1 ) { 
                                                        //   model.system_automation_name_test = 'Insdie Loop array - Insdie Conditions';
                                                        //   this.runSystemAutomation('', model, system_automation_array[i])  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop
                                    
                                    
                                                        //   console.log('Runnig runSystemAutomation NOT CONDITIONS: ', this.run_currnent_system_automation_name);
                                                        //   }

                              }, 6000); // was 6000
                            // }, 0); // was 4000

                                                     

                            }else{
                              // Run automations if run_data_sector_conditions are not hecked.  
                              // if(res24[0].run_data_sector_conditions != 1) { 
                              // this.runSystemAutomation('', model)  // Run without trigger   // THIS IS WRONG AS RUNS TWICE
                              // console.log('Runnig runSystemAutomation NOT CONDITIONS');
                              // }
                                    // if( (res24[0].run_data_sector_conditions == 0 || res24[0].run_data_sector_conditions == null) && res24[0].run_data_sector_conditions != 1 ) { 
                                    //   this.runSystemAutomation('', model)  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop
                                    //   console.log('Runnig runSystemAutomation NOT CONDITIONS');
                                    //   }



                                              setTimeout(() => {  console.log('delay')  
                                              // if( (this.run_automations_from_conditions == 0 || this.run_automations_from_conditions == null) && this.run_automations_from_conditions != 1 ) { 

                                              // October removed this as this is aready checked above by else statement :: Monday 9 october 2023
                                              // if( (this.run_automations_from_conditions == 0 || this.run_automations_from_conditions == null) && this.run_automations_from_conditions != 1 ) { 
                                                model.system_automation_name_test = 'Insdie Loop array - Insdie Conditions';
                                                console.log('Runnig runSystemAutomation NOT CONDITIONS: ', this.run_currnent_system_automation_name);
                                                if (data_s.is_active == 1){
                                                this.runSystemAutomation('', model, system_automation_array[i])  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop
                                                // }

                                                } // end if active

                                              }, 20); // was 4000 20
                                            // }, 0); // was 4000


                            } // .. end if


                              // put end if statement here so that only will run if the item in the array is active
                          }


                          },
                          err => console.log(err.error)
                          );


                    //   // (THIS NEEDED TO BE OUTSIDE LOOP AS WELL AS BETTER IF STATEMENTS) !impoirtant!
                    // // Need to check if nulls or for conditions then run. (This does work here but moved back to loop to keep code consistant)     
                    // WORKING LOOP JUST TESTING ABOVE CAUSE CONDITIONS NO LONGER WORKING.....

                    // // Test to see if works when conditions are 
                            // if( (this.run_automations_from_conditions == 0 || this.run_automations_from_conditions == null) && this.run_automations_from_conditions != 1 ) { 
                            //   model.system_automation_name_test = 'Insdie Loop array';
                            //   // this.runSystemAutomation('', model, system_automation_array[i])  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop
                            //   this.runSystemAutomation('', model, system_automation_array[i])  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop


                            //   console.log('Runnig runSystemAutomation NOT CONDITIONS: ', this.run_currnent_system_automation_name);
                            //   }


            

            
            
            
            
                  }, 0); // was 4000
                // }, 4000); // was 4000
                
                  } // end auomtations array loop

        
      //    was active october 2024
                              // //   // (THIS NEEDED TO BE OUTSIDE LOOP AS WELL AS BETTER IF STATEMENTS) !impoirtant!
                              // // // Need to check if nulls or for conditions then run. (This does work here but moved back to loop to keep code consistant)
                              // if( (this.run_automations_from_conditions == 0 || this.run_automations_from_conditions == null) && this.run_automations_from_conditions != 1 ) { 

                              //   model.system_automation_name_test = 'outsdie Loop array';
                              //   this.runSystemAutomation('', model, system_automation_array[0])  // Run without trigger   // this is currently runnign twiic I think need to be taken outside the loop


                              //   console.log('Runnig runSystemAutomation NOT CONDITIONS: ', this.run_currnent_system_automation_name);
                              //   }

            },
            // err => console.error(err),
            // () => console.log('System Log Type')
            ); 

            // Get the conditions based on the lookup.

}



// New way of checking conditions
checkAutomationConditions(model, system_auotmation_id, sent_system_conditions_array){
  
  this._demoService.getSystemLogTypeDataSectorCondition(sent_system_conditions_array).subscribe(
    data55 => { 
      this.current_system_log_data_sector_condition = data55; // this could have been where the double up error occurns in other sections????? check later
      let res_condition = data55[0];
      // load the drop downs
      // this.getJobTypeLocations(res.job_type_id);
      // this.getJobTypeCourts(res.job_type_location_id);
      // this.getJobTypeDocumentTypes(res.job_type_court_id);
      // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      // // this.getJobTypes();

this.current_subject_com_type_id = data55[0].subject_com_type_id;
let condition_array = JSON.parse(data55[0].condition_array)
console.log('Condition Array to Check - Conditions: ', condition_array)
let current_log_content = JSON.parse(model.log_content);
      // let passed_current_log_content = JSON.parse(log_model[0].log_content))


      // Filters objects for nul and undefined values.
      // const obj = current_log_content;
      // const filteredObject = _.pickBy(obj, v => v !== null && v !== undefined);
      // console.log = (obj) => document.write(JSON.stringify(filteredObject, null, 2));
      // console.log('FilteredObject', JSON.stringify(filteredObject));

        // let string_array = {"subject_id":"701","job_id":"1200","first_name": "r"}; // base condition_array - for comparison.
       
       
       
        // let string_array = JSON.parse(data55[0].condition_array); // base condition_array - for comparison.
        let string_array = JSON.parse(this.current_system_log_data_sector_condition[0].condition_array); // base condition_array - for comparison.
        let d: (string | any)[] = [string_array]


      let a = JSON.parse(model.log_content);
      let b = condition_array;
        let kv = [a];
        let l = new Set(Object.keys(string_array));
        console.log('ObjectKeys Condition Array: ', Object.keys(string_array));
        // #2 :: Filter throught A : the_log_content and remove anything not esisting int the log_content  array. [kv]
        for (let obj of kv) {
          for (let prop of Object.keys(obj)) {
            if (!l.has(prop)) {
                delete obj[prop];
            }
          }
        }
        console.log('Whats Left KV: ', kv);
        console.log('Condition Array to Compare log Content: ', kv)
       let compare_result = _.isEqual(_.sortBy(kv), _.sortBy(d))
      //  console.log('Condition ', z + ' ' + compare_result);
    
      
       if(compare_result == true){
        // return false;
        this.condition_compare_result = true;
        this.true_count = this.true_count + 1

        // Try running here minday october 9th.
        // Trying to run here insidd the loop to do proper conditions checking.
        model.system_automation_name_test = "Condition Checker if conditions";
        console.log('Runnig runSystemAutomation after Conditions Check: Automation ID', system_auotmation_id);
        this.runSystemAutomation('', model, system_auotmation_id) // Added log model? October 2023

       return;
        }else if(compare_result == false) {
        this.condition_compare_result = false;
        this.false_count = this.false_count + 1
       return;
        }
     




      
    }
    // ,
    // err => console.error(err),
    // () => console.log('')
  );
return this.condition_compare_result;
}





// new function to create the file/setup the correct models. NOT FINISHED!!!!!! --- needs variable updates
runSystemAuomationCommunicationsCreation(log_model,model){
  console.log('Log Model2: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
  // Look Up the Automation From log model.
  const system_automation_array = JSON.parse(log_model[0].system_automation_array)
  console.log('PASSED: system_automation_array: ' + system_automation_array);
  const count_system_automation_array = system_automation_array.length;
  // this.getSystemAutomation(system_automation_id)
  console.log('Count system automation array: ' + count_system_automation_array)
  
  console.log("OWNER Trace CODE:", model.owner_trace_code);
  
// :: October 7 2024
  // Need to make new function that recieves the system_automation_id instead of the complete automation_arrray of ID's - this only needs to run once if placed in the correct place to run.
  
  // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
  for(let i=0;i < count_system_automation_array; i++) {
          // console.log('count_of_automations: '  + system_automation_array[i]);
   
    // setTimeout(() => {  
      console.log("A Simple Pause!2: system_automation_array count:", i ); 
            this._demoService.getSystemAutomation(system_automation_array[i])
            .subscribe(
              res2 => {
                this.system_automation = res2;
                let data = res2[0]
                  let current_automation =  JSON.stringify(data) // result from quiery above
                //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                  // OK we have the automatino details as well as the / model - current log_model
                  // We can now get an array of files to loop.
  
                console.log('run_subject_communitcation_create_file: ' +  res2[0].run_subject_communitcation_create_file);
  
                if(res2[0].run_subject_communitcation_create_file == 1) { // if checkbox checked create_document_file
                  let system_communication_array = JSON.parse(res2[0].system_communication_array);
                  const count_system_communication_array = system_communication_array.length;
                  console.log('Count system communication array: ' + count_system_communication_array)
                  for(let ii=0;ii < count_system_communication_array; ii++) {
                    console.log("A : system_communication_array count:", ii ); 
                    console.log('count system file array docID: '  + system_communication_array[ii]);
                    // now for each file/doc_id and the the full models we can create the files(s)
  
  
                    // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                    // getSubjectTemplateDoc(doc_id) {}
                      this._demoService.getSubjectTemplateDoc(system_communication_array[ii]).subscribe(
                        data55 => { 
                          this.current_subject_template_doc = data;
                          let res_doc = data55[0];
                          // load the drop downs
                          // this.getJobTypeLocations(res.job_type_id);
                          // this.getJobTypeCourts(res.job_type_location_id);
                          // this.getJobTypeDocumentTypes(res.job_type_court_id);
                          // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                          // // this.getJobTypes();
  
                    this.current_subject_com_type_id = data55[0].subject_com_type_id;
  
  
  
                          // setTimeout(() => {  
                          //   console.log("A Simple Pause! -- so to load above first?"); 
                          // }, 4000);
  
  
  
                          console.log('DOc Lookup subject com type id: ' + this.current_subject_com_type_id)
                          // let current_log_content = []; 
                          // let current_log_content = model.log_content;
                          let current_log_content = JSON.parse(model.log_content);
                          // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                     
                          // console.log('Model CurrentLogContent: ' + current_log_content);
  
   
  
  
        
                        
                                    // need to add the assiged to agent array in the process here? in on the function?
                                    // do it here so that I can set the exact agent ie, from the servers or who it is especially for.. like create a doc merge model.
                                    this.allAgentRecipients = [];
                                    if (data55[0].brand_type_id == 3) {
                                          // set the agent permissions
                                              // secuirty agents assign_to_agents
                                          // set the agent permissions
  
                                          
                                          this._demoService.getSubjectAgentBrandsAssigned(current_log_content.subject_id).subscribe(
                                             data => { 
                                               this.assignedAgentsList2 = data;
                                        
                                               let newArr = data;
                                               let  count_of_items = Object.keys(newArr).length;
                                                 // need to do a loop of subject_billing items (.length)
                                                 for(let i=0;i < count_of_items; i++) {
                                                 let res = newArr[i];
                                                 this.allAgentRecipients.push({
                                                   recipient_name: res.name + '',
                                                   recipient_email_address: res.email,
                                                   recipient_brand_id: res.brand_id,
                                                   recipient_subject_id: res.subject_id,
                                                   recipient_brand_type_id: res.brand_type_id,
                                                   recipient_user_id: null,
                                                   recipient_user_level_id: null,
                                                   recipient_type_name: 'Agent',
                                                 });
                                                 } // end for loop
  
                                               this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
  
  
                                      
  
                                               // set records to send to subject_notes data table
                                              //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                                          // this.allAgentRecipients.forEach((value, index) => {
                                                          //   if (value.recipient_brand_id !== this.sessionBrandId) {
                                                          //     this.allAgentRecipients.splice(index, 1);
                                                          //   }});
                                              // model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              // pushed_automation_file_model[0].assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              console.log('assigned_to_agents: ', JSON.stringify(this.allAgentRecipients));
                                        
                                            },
                                             err => console.error(err),
                                             // () => console.log('Loaded Assigned Agents Loaded.')
                                           );
  
  
                                    
                                        
                                    } // end if brand_type_id = agent.
  
  
  
  
                  
  
              
                  
                  
                                                   
                                    
                                                    setTimeout(() => {  
                                                      console.log("A Simple Pause! -- 6100 at count: ", ii); 
                                                      let pushed_automation_file_model = {};
                                                      //          ...current_log_content
                                                                       pushed_automation_file_model = {
                                                                        doc_id: system_communication_array[ii],
                                                                        subject_id: current_log_content.subject_id,
                                                                        // model.brand_type_id = 3; // for agent
                                                                        // brand_type_id: model.brand_type_id, // 
                              
                                                                        ...log_model,
                                                                        ...model,
                                                                        // ...this.system_log_type[0]
                                                                        // Mussin for file creation
                                                                        is_theme: '0',
                                                                        file_edit_level: data55[0].file_edit_level,
                                                                        file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)
                              
                                                                        // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                                
                                                                        brand_type_id: data55[0].brand_type_id, 
                                                                     //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
                                                                     assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
                                                                     allAttachments: [], // set so can fill if required by auto attach and send.
                                                                     ...data55[0], // the comm model details.
                                                                     brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
                                                                     brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
                                                                     brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
                                                                     message_subject_header: data55[0].message_subject_header,
                                                                     subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
                                                                     owner_trace_code: current_log_content.owner_trace_code // for email headers and subjects, now added to the log on subject update. Not on create etc...
                                                                    }; // multidimentional array push
  
                                                                    console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))
  
                                                          // See Global Function to See Vars
                                                          // this.createDocumentFileViaAutomation(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.
  
                                    
                                                   
                                                          this.createDocumentButtonAndSend_Automation(pushed_automation_file_model) // --- working but creating doubles 
                                                          // Mussing --- file_brand_id, file_edit_level
  
  
                                                       }, 0);
        
  
  
                         
                        },
                        err => console.error(err),
                        () => console.log('')
                      );
                    // end second looup template doc.
  
  
  
        
  
  
                  } // end document loop
  
                } // .. end idf create docuemnt file
              },
              err => console.error(err.status)
            );
  
  
  
  
    // }, 0000);
  
  
  
  
        
    } // end automation loop
  
  
  
  };
  


  // new function to create the file/setup the correct models. NOT FINISHED!!!!!! --- needs variable updates
  runSystemAuomationCommunicationsCreation_No_Loop_2(log_model,model, system_auotmation_id){
    // console.log('Log Model2: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
    // // Look Up the Automation From log model.
    // const system_automation_array = JSON.parse(log_model[0].system_automation_array)
    // console.log('PASSED: system_automation_array: ' + system_automation_array);
    // const count_system_automation_array = system_automation_array.length;
    // // this.getSystemAutomation(system_automation_id)
    // console.log('Count system automation array: ' + count_system_automation_array)
    
    // console.log("OWNER Trace CODE:", model.owner_trace_code);

    
  // this.toastr.info("Creating Comms 2.0 :AutomationID" + system_auotmation_id )
    
  // :: October 7 2024
    // Need to make new function that recieves the system_automation_id instead of the complete automation_arrray of ID's - this only needs to run once if placed in the correct place to run.
    
    // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
    // for(let i=0;i < count_system_automation_array; i++) {
            // console.log('count_of_automations: '  + system_automation_array[i]);
     
      // setTimeout(() => {  
        // console.log("A Simple Pause!2: system_automation_array count:", i ); 
  
              // this._demoService.getSystemAutomation(system_automation_array[i])
              this._demoService.getSystemAutomation(system_auotmation_id)
              .subscribe(
                res2 => {
                  this.system_automation = res2;
                  let data = res2[0]
                    let current_automation =  JSON.stringify(data) // result from quiery above
                  //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                    // OK we have the automatino details as well as the / model - current log_model
                    // We can now get an array of files to loop.
    
                  console.log('run_subject_communitcation_create_file: ' +  res2[0].run_subject_communitcation_2_create_file);


    
                  if(res2[0].run_subject_communitcation_2_create_file == 1) { // if checkbox checked create_document_file
                    let system_communication_array_2 = JSON.parse(res2[0].system_communication_array_2);
                    const count_system_communication_array_2 = system_communication_array_2.length;
                    console.log('Count system communication array: ' + count_system_communication_array_2)
                    for(let ii=0;ii < count_system_communication_array_2; ii++) {
                      console.log("A : system_communication_array count:", ii ); 
                      console.log('count system file array docID: '  + system_communication_array_2[ii]);
                      // now for each file/doc_id and the the full models we can create the files(s)
    
    
                      // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                      // getSubjectTemplateDoc(doc_id) {}
                        this._demoService.getSubjectTemplateDoc(system_communication_array_2[ii]).subscribe(
                          data55 => { 
                            this.current_subject_template_doc = data;
                            let res_doc = data55[0];
                            // load the drop downs
                            // this.getJobTypeLocations(res.job_type_id);
                            // this.getJobTypeCourts(res.job_type_location_id);
                            // this.getJobTypeDocumentTypes(res.job_type_court_id);
                            // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                            // // this.getJobTypes();
    
                      this.current_subject_com_type_id = data55[0].subject_com_type_id;
    











                            // setTimeout(() => {  
                            //   console.log("A Simple Pause! -- so to load above first?"); 
                            // }, 4000);
    
    
    
                            console.log('DOc Lookup subject com type id: ' + this.current_subject_com_type_id)
                            // let current_log_content = []; 
                            // let current_log_content = model.log_content;
                            let current_log_content = JSON.parse(model.log_content);
                            // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                       
                            // console.log('Model CurrentLogContent: ' + current_log_content);
    
     
    
    

    
                    
    
                
                    
                    
                                                     
                                      
                                                      setTimeout(() => {  
                                                        console.log("A Simple Pause! -- 6100 at count: ", ii); 
                                                        let pushed_automation_file_model = {};
                                                        //          ...current_log_content
                                                                         pushed_automation_file_model = {
                                                                          doc_id: system_communication_array_2[ii],
                                                                          subject_id: current_log_content.subject_id,
                                                                          // model.brand_type_id = 3; // for agent
                                                                          // brand_type_id: model.brand_type_id, // 
                                
                                                                          ...log_model,
                                                                          ...model,
                                                                          // ...this.system_log_type[0]
                                                                          // Mussin for file creation
                                                                          is_theme: '0',
                                                                          file_edit_level: data55[0].file_edit_level,
                                                                          file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)
                                
                                                                          // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                                  
                                                                          brand_type_id: data55[0].brand_type_id, 
                                                                       //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
                                                                       assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
                                                                       allAttachments: [], // set so can fill if required by auto attach and send.
                                                                       ...data55[0], // the comm model details.
                                                                       brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
                                                                       brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
                                                                       brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
                                                                       message_subject_header: data55[0].message_subject_header,
                                                                       subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
                                                                       owner_trace_code: current_log_content.owner_trace_code, // for email headers and subjects, now added to the log on subject update. Not on create etc...
                                                                       allRecipients: this.allRecipients // was missing 24 2.0
                                                                      }; // multidimentional array push
    
                                                                      console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))
    
                                                            // See Global Function to See Vars
                                                            // this.createDocumentFileViaAutomation(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.
    


                        
                          this.createDocumentButtonAndSend_Automation_2(pushed_automation_file_model) // --- working but creating doubles 
                                                            // Mussing --- file_brand_id, file_edit_level
    
    
                                                         }, 0);
          
    
    
                           
                          },
                          err => console.error(err),
                          () => console.log('')
                        );
                      // end second looup template doc.
    
    
    
          
    
    
                    } // end document loop
    
                  } // .. end idf create docuemnt file
                },
                err => console.error(err.status)
              );
    
    
    
    
      // }, 0000);
    
    
    
    
          
      // } // end automation loop
    
    
    
    };







  // new function to create the file/setup the correct models. NOT FINISHED!!!!!! --- needs variable updates
runSystemAuomationCommunicationsCreation_No_Loop(log_model,model, system_auotmation_id){
  console.log('Log Model2: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
  // Look Up the Automation From log model.
  const system_automation_array = JSON.parse(log_model[0].system_automation_array)
  console.log('PASSED: system_automation_array: ' + system_automation_array);
  const count_system_automation_array = system_automation_array.length;
  // this.getSystemAutomation(system_automation_id)
  console.log('Count system automation array: ' + count_system_automation_array)
  
  console.log("OWNER Trace CODE:", model.owner_trace_code);
  
// :: October 7 2024
  // Need to make new function that recieves the system_automation_id instead of the complete automation_arrray of ID's - this only needs to run once if placed in the correct place to run.
  
  // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
  // for(let i=0;i < count_system_automation_array; i++) {
          // console.log('count_of_automations: '  + system_automation_array[i]);
   
    // setTimeout(() => {  
      // console.log("A Simple Pause!2: system_automation_array count:", i ); 

            // this._demoService.getSystemAutomation(system_automation_array[i])
            this._demoService.getSystemAutomation(system_auotmation_id)
            .subscribe(
              res2 => {
                this.system_automation = res2;
                let data = res2[0]
                  let current_automation =  JSON.stringify(data) // result from quiery above
                //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                  // OK we have the automatino details as well as the / model - current log_model
                  // We can now get an array of files to loop.
  
                console.log('run_subject_communitcation_create_file: ' +  res2[0].run_subject_communitcation_create_file);
  
                if(res2[0].run_subject_communitcation_create_file == 1) { // if checkbox checked create_document_file
                  let system_communication_array = JSON.parse(res2[0].system_communication_array);
                  const count_system_communication_array = system_communication_array.length;
                  console.log('Count system communication array: ' + count_system_communication_array)
                  for(let ii=0;ii < count_system_communication_array; ii++) {
                    console.log("A : system_communication_array count:", ii ); 
                    console.log('count system file array docID: '  + system_communication_array[ii]);
                    // now for each file/doc_id and the the full models we can create the files(s)
  
  
                    // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                    // getSubjectTemplateDoc(doc_id) {}
                      this._demoService.getSubjectTemplateDoc(system_communication_array[ii]).subscribe(
                        data55 => { 
                          this.current_subject_template_doc = data;
                          let res_doc = data55[0];
                          // load the drop downs
                          // this.getJobTypeLocations(res.job_type_id);
                          // this.getJobTypeCourts(res.job_type_location_id);
                          // this.getJobTypeDocumentTypes(res.job_type_court_id);
                          // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                          // // this.getJobTypes();
  
                    this.current_subject_com_type_id = data55[0].subject_com_type_id;
  
  
  
                          // setTimeout(() => {  
                          //   console.log("A Simple Pause! -- so to load above first?"); 
                          // }, 4000);
  
  
  
                          console.log('DOc Lookup subject com type id: ' + this.current_subject_com_type_id)
                          // let current_log_content = []; 
                          // let current_log_content = model.log_content;
                          let current_log_content = JSON.parse(model.log_content);
                          // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                     
                          // console.log('Model CurrentLogContent: ' + current_log_content);
  
   
  
  
        
                        
                                    // need to add the assiged to agent array in the process here? in on the function?
                                    // do it here so that I can set the exact agent ie, from the servers or who it is especially for.. like create a doc merge model.
                                    this.allAgentRecipients = [];
                                    if (data55[0].brand_type_id == 3) {
                                          // set the agent permissions
                                              // secuirty agents assign_to_agents
                                          // set the agent permissions
  
                                          
                                          this._demoService.getSubjectAgentBrandsAssigned(current_log_content.subject_id).subscribe(
                                             data => { 
                                               this.assignedAgentsList2 = data;
                                        
                                               let newArr = data;
                                               let  count_of_items = Object.keys(newArr).length;
                                                 // need to do a loop of subject_billing items (.length)
                                                 for(let i=0;i < count_of_items; i++) {
                                                 let res = newArr[i];
                                                 this.allAgentRecipients.push({
                                                   recipient_name: res.name + '',
                                                   recipient_email_address: res.email,
                                                   recipient_brand_id: res.brand_id,
                                                   recipient_subject_id: res.subject_id,
                                                   recipient_brand_type_id: res.brand_type_id,
                                                   recipient_user_id: null,
                                                   recipient_user_level_id: null,
                                                   recipient_type_name: 'Agent',
                                                 });
                                                 } // end for loop
  
                                               this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
  
  
                                      
  
                                               // set records to send to subject_notes data table
                                              //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                                          // this.allAgentRecipients.forEach((value, index) => {
                                                          //   if (value.recipient_brand_id !== this.sessionBrandId) {
                                                          //     this.allAgentRecipients.splice(index, 1);
                                                          //   }});
                                              // model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              // pushed_automation_file_model[0].assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              console.log('assigned_to_agents: ', JSON.stringify(this.allAgentRecipients));
                                        
                                            },
                                             err => console.error(err),
                                             // () => console.log('Loaded Assigned Agents Loaded.')
                                           );
  
  
                                    
                                        
                                    } // end if brand_type_id = agent.
  
  
  
  
                  
  
              
                  
                  
                                                   
                                    
                                                    setTimeout(() => {  
                                                      console.log("A Simple Pause! -- 6100 at count: ", ii); 
                                                      let pushed_automation_file_model = {};
                                                      //          ...current_log_content
                                                                       pushed_automation_file_model = {
                                                                        doc_id: system_communication_array[ii],
                                                                        subject_id: current_log_content.subject_id,
                                                                        // model.brand_type_id = 3; // for agent
                                                                        // brand_type_id: model.brand_type_id, // 
                              
                                                                        ...log_model,
                                                                        ...model,
                                                                        // ...this.system_log_type[0]
                                                                        // Mussin for file creation
                                                                        is_theme: '0',
                                                                        file_edit_level: data55[0].file_edit_level,
                                                                        file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)
                              
                                                                        // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                                
                                                                        brand_type_id: data55[0].brand_type_id, 
                                                                     //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
                                                                     assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
                                                                     allAttachments: [], // set so can fill if required by auto attach and send.
                                                                     ...data55[0], // the comm model details.
                                                                     brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
                                                                     brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
                                                                     brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
                                                                     message_subject_header: data55[0].message_subject_header,
                                                                     subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
                                                                     owner_trace_code: current_log_content.owner_trace_code // for email headers and subjects, now added to the log on subject update. Not on create etc...
                                                                    }; // multidimentional array push
  
                                                                    console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))
  
                                                          // See Global Function to See Vars
                                                          // this.createDocumentFileViaAutomation(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.
  
                                    
                                                   
                                                          this.createDocumentButtonAndSend_Automation(pushed_automation_file_model) // --- working but creating doubles 
                                                          // Mussing --- file_brand_id, file_edit_level
  
  
                                                       }, 0);
        
  
  
                         
                        },
                        err => console.error(err),
                        () => console.log('')
                      );
                    // end second looup template doc.
  
  
  
        
  
  
                  } // end document loop
  
                } // .. end idf create docuemnt file
              },
              err => console.error(err.status)
            );
  
  
  
  
    // }, 0000);
  
  
  
  
        
    // } // end automation loop
  
  
  
  };
  

  
// new function to create the file/setup the correct models.
runSystemAuomationFileCreation(log_model,model){
console.log('Log Model2 System File.: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
// Look Up the Automation From log model.
const system_automation_array = JSON.parse(log_model[0].system_automation_array)
console.log('PASSED: system_automation_array: ' + system_automation_array);
const count_system_automation_array = system_automation_array.length;
// this.getSystemAutomation(system_automation_id)
console.log('Count system automation array: ' + count_system_automation_array)




// :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
for(let i=0;i < count_system_automation_array; i++) {
        // console.log('count_of_automations: '  + system_automation_array[i]);
 
  // setTimeout(() => {  
    console.log("A Simple Pause!2: system_automation_array count:", i ); 
          this._demoService.getSystemAutomation(system_automation_array[i])
          .subscribe(
            res2 => {
              this.system_automation = res2;
              let data_s = res2[0]
                let current_automation =  JSON.stringify(data_s) // result from quiery above
              //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                // OK we have the automatino details as well as the / model - current log_model
                // We can now get an array of files to loop.

              console.log('Create a file: ' +  res2[0].create_document_file);

              if(res2[0].create_document_file == 1) { // if checkbox checked create_document_file
                let system_file_array = JSON.parse(res2[0].system_file_array);
                const count_system_file_array = system_file_array.length;
                console.log('Count system file array: ' + count_system_file_array)
                for(let ii=0;ii < count_system_file_array; ii++) {
                  console.log("A : system_file_array count:", ii ); 
                  console.log('count system file array docID: '  + system_file_array[ii]);
                  // now for each file/doc_id and the the full models we can create the files(s)


                  // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                  // getSubjectTemplateDoc(doc_id) {}
                    this._demoService.getSubjectTemplateDoc(system_file_array[ii]).subscribe(
                      data55 => { 
                        this.current_subject_template_doc = data_s;
                        let res_doc = data55[0];
                        // load the drop downs
                        // this.getJobTypeLocations(res.job_type_id);
                        // this.getJobTypeCourts(res.job_type_location_id);
                        // this.getJobTypeDocumentTypes(res.job_type_court_id);
                        // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                        // // this.getJobTypes();

                  this.current_subject_com_type_id = data55[0].subject_com_type_id;



                        // setTimeout(() => {  
                        //   console.log("A Simple Pause! -- so to load above first?"); 
                        // }, 4000);



                        console.log('DOc Lookup subject com type id: ' + this.current_subject_com_type_id)
                        // let current_log_content = []; 
                        // let current_log_content = model.log_content;
                        let current_log_content = JSON.parse(model.log_content);
                        // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                   
                        // console.log('Model CurrentLogContent: ' + current_log_content);

 


      
                      
                                  // need to add the assiged to agent array in the process here? in on the function?
                                  // do it here so that I can set the exact agent ie, from the servers or who it is especially for.. like create a doc merge model.
                                  this.allAgentRecipients = [];
                                  if (data55[0].brand_type_id == 3) {
                                        // set the agent permissions
                                            // secuirty agents assign_to_agents
                                        // set the agent permissions

                                        
                                        this._demoService.getSubjectAgentBrandsAssigned(current_log_content.subject_id).subscribe(
                                           data => { 
                                             this.assignedAgentsList2 = data;
                                      
                                             let newArr = data;
                                             let  count_of_items = Object.keys(newArr).length;
                                               // need to do a loop of subject_billing items (.length)
                                               for(let i=0;i < count_of_items; i++) {
                                               let res = newArr[i];
                                               this.allAgentRecipients.push({
                                                 recipient_name: res.name + '',
                                                 recipient_email_address: res.email,
                                                 recipient_brand_id: res.brand_id,
                                                 recipient_subject_id: res.subject_id,
                                                 recipient_brand_type_id: res.brand_type_id,
                                                 recipient_user_id: null,
                                                 recipient_user_level_id: null,
                                                 recipient_type_name: 'Agent',
                                               });
                                               } // end for loop

                                             this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.


                                    

                                             // set records to send to subject_notes data table
                                            //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                                        // this.allAgentRecipients.forEach((value, index) => {
                                                        //   if (value.recipient_brand_id !== this.sessionBrandId) {
                                                        //     this.allAgentRecipients.splice(index, 1);
                                                        //   }});
                                            // model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                            // pushed_automation_file_model[0].assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                            console.log('assigned_to_agents: ', JSON.stringify(this.allAgentRecipients));
                                      
                                          },
                                           err => console.error(err),
                                           // () => console.log('Loaded Assigned Agents Loaded.')
                                         );


                                  
                                      
                                  } // end if brand_type_id = agent.




                

            
                
                
                                                 
                                  
                                                  setTimeout(() => {  
                                                    console.log("A Simple Pause! -- 6100 at count: ", ii); 
                                                    let pushed_automation_file_model = {};
                                                    //          ...current_log_content
                                                                     pushed_automation_file_model = {
                                                                      doc_id: system_file_array[ii],
                                                                      subject_id: current_log_content.subject_id,
                                                                      // model.brand_type_id = 3; // for agent
                                                                      // brand_type_id: model.brand_type_id, // 
                            
                                                                      ...log_model,
                                                                      ...model,
                                                                      // ...this.system_log_type[0]
                                                                      // Mussin for file creation
                                                                      is_theme: '0',
                                                                      file_edit_level: data55[0].file_edit_level,
                                                                      file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)
                            
                                                                      // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                              
                                                                      brand_type_id: data55[0].brand_type_id, 
                                                                   //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
                                                                   assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
                                                                   allAttachments: [], // set so can fill if required by auto attach and send.
                                                                    ...data55[0], // the comm model details.
                                                                   // REMOVED AS ONLY REQUIRED FOR COMMUNICATION AND WAS STUFFING UP NOTES I THINK TESTING....
                                                                               brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
                                                                               brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
                                                                               brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
                                                                               message_subject_header: data55[0].message_subject_header,
                                                                               subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
                                                                  }; // multidimentional array push

                                                                  console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))

                                                        // See Global Function to See Vars
               this.createDocumentFileViaAutomation(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.

                                                        // TESTING TO SEE IF STOPS DUPBLE UPS
                                                        this.allRecipients = [];
                                                        model.allRecipients = this.allRecipients; // reset the model as we.. so dont get duplicates....
                                                 
                                      // this.createDocumentButtonAndSend_Automation(pushed_automation_file_model) // --- working but creating doubles 
                                                        // Mussing --- file_brand_id, file_edit_level


                                        


                                                     }, 0);
      


                       
                      },
                      err => console.error(err),
                      () => console.log('')
                    );
                  // end second looup template doc.



      


                } // end document loop

              } // .. end idf create docuemnt file
            },
            err => console.error(err.status)
          );




  // }, 0000);




      
  }



};

runSystemAuomationDatesAndStatus_No_Loop(log_model,model, system_auotmation_id){
  // console.log('Log Model2 System File.: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
  // Look Up the Automation From log model.
  const system_automation_array = JSON.parse(log_model[0].system_automation_array)
  console.log('PASSED: system_automation_array: ' + system_automation_array);
  const count_system_automation_array = system_automation_array.length;
  // this.getSystemAutomation(system_automation_id)
  console.log('Count system automation array: ' + count_system_automation_array)




  this._demoService.getSystemAutomation(system_auotmation_id)
  .subscribe(
    res2 => {
      this.system_automation = res2;
      let data_s = res2[0]
        let current_automation =  JSON.stringify(data_s) // result from quiery above
      //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
        // OK we have the automatino details as well as the / model - current log_model
        // We can now get an array of files to loop.

      // console.log('Create a file: ' +  res2[0].create_document_file);

      if(res2[0].change_dates == 1) { // if checkbox checked create_document_file

        // this.toastr.info("Date Changes and Status are GO.")
        // console.log('Da Model: ' + JSON.stringify(model));
        // console.log('Da LOG Model: ' + JSON.stringify(log_model));

        // Need to determin weather or not to change the dates.... or leave as is.. ( Need this option hard coded into the template.)


  // this.updateSubjectStatusBulkAutomationBasic(model.subject_id, res2[0].job_status, model, res2[0].next_date, res2[0].final_date); // now just updates exacly what is sent. -- the dates are being updated here as well so check ....
 
 // this one uses the first date and status option -- no linger uses
  this.updateSubjectStatusONLYAutomationBasic(model.subject_id, res2[0].job_status, model, res2[0].next_date, res2[0].final_date); // now just updates exacly what is sent. -- the dates are being updated here as well so check ....
      }




        // this fix stops the system running if the status is blank.
      // if(res2[0].job_status && res2[0].change_job_status == 1){
      //   this.updateJobAndSubjectStatusAutomation(res2[0], res2[0].job_status, model, res2[0].next_date, res2[0].final_date);
      //   }

      //   if(res2[0].subject_status && res2[0].change_subject_status == 1){
      //     this.updateJobAndSubjectStatusAutomation(res2[0], res2[0].job_status, model, res2[0].next_date, res2[0].final_date);
      //     }

     
     
     
        if(res2[0].change_job_status == 1 || res2[0].change_subject_status == 1) { // if checkbox checked create_document_file
          // runs automation logic and changes stats frommodel.

                // There is no current user check for Change status if I set to anyone it stull changes... on file upload
                // MISSING WHO THE USER IS LOGIC.. so that it runs when it not supposed to

                // client
                if(this.sessionBrandTypeId == '2' && res2[0].current_user_client == 1){
                this.updateJobAndSubjectStatusAutomation(res2[0], res2[0].job_status, model, res2[0].next_date, res2[0].final_date);
                }
                // agent
                if(this.sessionBrandTypeId == '3' && res2[0].current_user_agent == 1){
                this.updateJobAndSubjectStatusAutomation(res2[0], res2[0].job_status, model, res2[0].next_date, res2[0].final_date);
                }
                // owner
                if(this.sessionBrandTypeId == '1' && res2[0].current_user_owner == 1){
                  this.updateJobAndSubjectStatusAutomation(res2[0], res2[0].job_status, model, res2[0].next_date, res2[0].final_date);
                  }

       }


  
    },
    err => console.error(err),
    () => console.log('')
  );

}



runSystemAuomationFileCreation_No_Loop_2(log_model,model, system_auotmation_id){
            console.log('Log Model2 System File.: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
            // Look Up the Automation From log model.
            const system_automation_array = JSON.parse(log_model[0].system_automation_array)
            console.log('PASSED: system_automation_array: ' + system_automation_array);
            const count_system_automation_array = system_automation_array.length;
            // this.getSystemAutomation(system_automation_id)
            console.log('Count system automation array: ' + count_system_automation_array)
  
  
  // this.toastr.info("Creating the file 2.0 file :AutomationID" + system_auotmation_id )


  // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
  // for(let i=0;i < count_system_automation_array; i++) {
          // console.log('count_of_automations: '  + system_automation_array[i]);
   
    // setTimeout(() => {  
      // console.log("A Simple Pause!2: system_automation_array count:", i ); 

            // this._demoService.getSystemAutomation(system_automation_array[i]) // removed loop October2023
            this._demoService.getSystemAutomation(system_auotmation_id)
            .subscribe(
              res2 => {
                this.system_automation = res2;
                let data_s = res2[0]
                  let current_automation =  JSON.stringify(data_s) // result from quiery above
                //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                  // OK we have the automatino details as well as the / model - current log_model
                  // We can now get an array of files to loop.
  
                console.log('Create a file: ' +  res2[0].create_document_file_2);

  // this.toastr.info('Create a file: ' +  res2[0].create_document_file_2)

  
                if(res2[0].create_document_file_2 == 1) { // if checkbox checked create_document_file
                  let system_file_array_2 = JSON.parse(res2[0].system_file_array_2);
                  const count_system_file_array_2 = system_file_array_2.length;
                  console.log('Count system file array: ' + count_system_file_array_2)
                  for(let ii=0;ii < count_system_file_array_2; ii++) {
                    console.log("A : system_file_array count:", ii ); 
                    console.log('count system file array docID: '  + system_file_array_2[ii]);
                    // now for each file/doc_id and the the full models we can create the files(s)
  

                    // this.toastr.info('lookup a file: ' +  system_file_array_2[ii])


  
                    // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                    // getSubjectTemplateDoc(doc_id) {}
                      this._demoService.getSubjectTemplateDoc(system_file_array_2[ii]).subscribe(
                        data55 => { 
                          this.current_subject_template_doc = data_s;
                          let res_doc = data55[0];
                          // load the drop downs
                          // this.getJobTypeLocations(res.job_type_id);
                          // this.getJobTypeCourts(res.job_type_location_id);
                          // this.getJobTypeDocumentTypes(res.job_type_court_id);
                          // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                          // // this.getJobTypes();
  
                    this.current_subject_com_type_id = data55[0].subject_com_type_id;
  
  
  
                          // setTimeout(() => {  
                          //   console.log("A Simple Pause! -- so to load above first?"); 
                          // }, 4000);
  
  
  
                          console.log('DOc Lookup subject com type id: ' + this.current_subject_com_type_id)
                          // let current_log_content = []; 
                          // let current_log_content = model.log_content;
                          let current_log_content = JSON.parse(model.log_content);
                          // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                     
                          // console.log('Model CurrentLogContent: ' + current_log_content);
  
   
  
  
        
                        
                                    // need to add the assiged to agent array in the process here? in on the function?
                                    // do it here so that I can set the exact agent ie, from the servers or who it is especially for.. like create a doc merge model.
                                    this.allAgentRecipients = [];
                                    if (data55[0].brand_type_id == 3) {
                                          // set the agent permissions
                                              // secuirty agents assign_to_agents
                                          // set the agent permissions
  
                                          
                                          this._demoService.getSubjectAgentBrandsAssigned(current_log_content.subject_id).subscribe(
                                             data => { 
                                               this.assignedAgentsList2 = data;
                                        
                                               let newArr = data;
                                               let  count_of_items = Object.keys(newArr).length;
                                                 // need to do a loop of subject_billing items (.length)
                                                 for(let i=0;i < count_of_items; i++) {
                                                 let res = newArr[i];
                                                 this.allAgentRecipients.push({
                                                   recipient_name: res.name + '',
                                                   recipient_email_address: res.email,
                                                   recipient_brand_id: res.brand_id,
                                                   recipient_subject_id: res.subject_id,
                                                   recipient_brand_type_id: res.brand_type_id,
                                                   recipient_user_id: null,
                                                   recipient_user_level_id: null,
                                                   recipient_type_name: 'Agent',
                                                 });
                                                 } // end for loop
  
                                               this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
  
  
                                      
  
                                               // set records to send to subject_notes data table
                                              //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                                          // this.allAgentRecipients.forEach((value, index) => {
                                                          //   if (value.recipient_brand_id !== this.sessionBrandId) {
                                                          //     this.allAgentRecipients.splice(index, 1);
                                                          //   }});
                                              // model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              // pushed_automation_file_model[0].assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              console.log('assigned_to_agents: ', JSON.stringify(this.allAgentRecipients));
                                        
                                            },
                                             err => console.error(err),
                                             // () => console.log('Loaded Assigned Agents Loaded.')
                                           );
  
  
                                    
                                        
                                    } // end if brand_type_id = agent.
  
  
  
  
                  
  
              
                  
                  
                                                   
                                    
                                                    setTimeout(() => {  
                                                      console.log("A Simple Pause! -- 6100 at count: ", ii); 
                                                      let pushed_automation_file_model = {};
                                                      //          ...current_log_content
                                                                       pushed_automation_file_model = {
                                                                        doc_id: system_file_array_2[ii],
                                                                        subject_id: current_log_content.subject_id,
                                                                        // model.brand_type_id = 3; // for agent
                                                                        // brand_type_id: model.brand_type_id, // 
                              
                                                                        ...log_model,
                                                                        ...model,
                                                                        // ...this.system_log_type[0]
                                                                        // Mussin for file creation
                                                                        is_theme: '0',
                                                                        file_edit_level: data55[0].file_edit_level,
                                                                        file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)
                              
                                                                        // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                                
                                                                        brand_type_id: data55[0].brand_type_id, 
                                                                     //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
                                                                     assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
                                                                     allAttachments: [], // set so can fill if required by auto attach and send.
                                                                      ...data55[0], // the comm model details.
                                                                     // REMOVED AS ONLY REQUIRED FOR COMMUNICATION AND WAS STUFFING UP NOTES I THINK TESTING....
                                                                         
                                                                     brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
                                                                                 brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
                                                                                 brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
                                                                                 message_subject_header: data55[0].message_subject_header,
                                                                                 subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
                                                                    }; // multidimentional array push
  
                                                                    console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))
  
                                                          // See Global Function to See Vars
                  this.createDocumentFileViaAutomation_2(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.
  
                                                          // TESTING TO SEE IF STOPS DUPBLE UPS
                                                          this.allRecipients = [];
                                                          model.allRecipients = this.allRecipients; // reset the model as we.. so dont get duplicates....
                                                   
                                        // this.createDocumentButtonAndSend_Automation(pushed_automation_file_model) // --- working but creating doubles 
                                                          // Mussing --- file_brand_id, file_edit_level
  
  
                                          
  
  
                                                       }, 0);
        
  
  
                         
                        },
                        err => console.error(err),
                        () => console.log('')
                      );
                    // end second looup template doc.
  
  
  
        
  
  
                  } // end document loop
  
                } // .. end idf create docuemnt file
              },
              err => console.error(err.status)
            );
  
  
  
  
    // }, 0000);
  
  
  
  
        
    // } // end loop
  
  
  
  };



runSystemAuomationFileCreation_No_Loop(log_model,model, system_auotmation_id){
  console.log('Log Model2 System File.: system_automation_array: ' + JSON.stringify(log_model[0].system_automation_array))
  // Look Up the Automation From log model.
  const system_automation_array = JSON.parse(log_model[0].system_automation_array)
  console.log('PASSED: system_automation_array: ' + system_automation_array);
  const count_system_automation_array = system_automation_array.length;
  // this.getSystemAutomation(system_automation_id)
  console.log('Count system automation array: ' + count_system_automation_array)
  
  
  
  
  // :: Step 1 :: Loop though automations array savfed int he truiggerd log trype
  // for(let i=0;i < count_system_automation_array; i++) {
          // console.log('count_of_automations: '  + system_automation_array[i]);
   
    // setTimeout(() => {  
      // console.log("A Simple Pause!2: system_automation_array count:", i ); 

            // this._demoService.getSystemAutomation(system_automation_array[i]) // removed loop October2023
            this._demoService.getSystemAutomation(system_auotmation_id)
            .subscribe(
              res2 => {
                this.system_automation = res2;
                let data_s = res2[0]
                  let current_automation =  JSON.stringify(data_s) // result from quiery above
                //  console.log('Current Automation: ' + current_automation) // Full automation JSON results
                  // OK we have the automatino details as well as the / model - current log_model
                  // We can now get an array of files to loop.
  
                console.log('Create a file: ' +  res2[0].create_document_file);
  
                if(res2[0].create_document_file == 1) { // if checkbox checked create_document_file
                  let system_file_array = JSON.parse(res2[0].system_file_array);
                  const count_system_file_array = system_file_array.length;
                  console.log('Count system file array: ' + count_system_file_array)
                  for(let ii=0;ii < count_system_file_array; ii++) {
                    console.log("A : system_file_array count:", ii ); 
                    console.log('count system file array docID: '  + system_file_array[ii]);
                    // now for each file/doc_id and the the full models we can create the files(s)
  
  
                    // Need the some of the original subject_template_docs doc_id fiiles like "subject_com_type_id" and all the file privilages... need to lookup subject_template_docs
                    // getSubjectTemplateDoc(doc_id) {}
                      this._demoService.getSubjectTemplateDoc(system_file_array[ii]).subscribe(
                        data55 => { 
                          this.current_subject_template_doc = data_s;
                          let res_doc = data55[0];
                          // load the drop downs
                          // this.getJobTypeLocations(res.job_type_id);
                          // this.getJobTypeCourts(res.job_type_location_id);
                          // this.getJobTypeDocumentTypes(res.job_type_court_id);
                          // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
                          // // this.getJobTypes();
  
                    this.current_subject_com_type_id = data55[0].subject_com_type_id;
  
  
  
                          // setTimeout(() => {  
                          //   console.log("A Simple Pause! -- so to load above first?"); 
                          // }, 4000);
  
  
  
                          console.log('DOc Lookup subject com type id: ' + this.current_subject_com_type_id)
                          // let current_log_content = []; 
                          // let current_log_content = model.log_content;
                          let current_log_content = JSON.parse(model.log_content);
                          // let passed_current_log_content = JSON.parse(log_model[0].log_content))
                     
                          // console.log('Model CurrentLogContent: ' + current_log_content);
  
   
  
  
        
                        
                                    // need to add the assiged to agent array in the process here? in on the function?
                                    // do it here so that I can set the exact agent ie, from the servers or who it is especially for.. like create a doc merge model.
                                    this.allAgentRecipients = [];
                                    if (data55[0].brand_type_id == 3) {
                                          // set the agent permissions
                                              // secuirty agents assign_to_agents
                                          // set the agent permissions
  
                                          
                                          this._demoService.getSubjectAgentBrandsAssigned(current_log_content.subject_id).subscribe(
                                             data => { 
                                               this.assignedAgentsList2 = data;
                                        
                                               let newArr = data;
                                               let  count_of_items = Object.keys(newArr).length;
                                                 // need to do a loop of subject_billing items (.length)
                                                 for(let i=0;i < count_of_items; i++) {
                                                 let res = newArr[i];
                                                 this.allAgentRecipients.push({
                                                   recipient_name: res.name + '',
                                                   recipient_email_address: res.email,
                                                   recipient_brand_id: res.brand_id,
                                                   recipient_subject_id: res.subject_id,
                                                   recipient_brand_type_id: res.brand_type_id,
                                                   recipient_user_id: null,
                                                   recipient_user_level_id: null,
                                                   recipient_type_name: 'Agent',
                                                 });
                                                 } // end for loop
  
                                               this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
  
  
                                      
  
                                               // set records to send to subject_notes data table
                                              //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                                          // this.allAgentRecipients.forEach((value, index) => {
                                                          //   if (value.recipient_brand_id !== this.sessionBrandId) {
                                                          //     this.allAgentRecipients.splice(index, 1);
                                                          //   }});
                                              // model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              // pushed_automation_file_model[0].assigned_to_agents = JSON.stringify(this.allAgentRecipients);
                                              console.log('assigned_to_agents: ', JSON.stringify(this.allAgentRecipients));
                                        
                                            },
                                             err => console.error(err),
                                             // () => console.log('Loaded Assigned Agents Loaded.')
                                           );
  
  
                                    
                                        
                                    } // end if brand_type_id = agent.
  
  
  
  
                  
  
              
                  
                  
                                                   
                                    
                                                    setTimeout(() => {  
                                                      console.log("A Simple Pause! -- 6100 at count: ", ii); 
                                                      let pushed_automation_file_model = {};
                                                      //          ...current_log_content
                                                                       pushed_automation_file_model = {
                                                                        doc_id: system_file_array[ii],
                                                                        subject_id: current_log_content.subject_id,
                                                                        // model.brand_type_id = 3; // for agent
                                                                        // brand_type_id: model.brand_type_id, // 
                              
                                                                        ...log_model,
                                                                        ...model,
                                                                        // ...this.system_log_type[0]
                                                                        // Mussin for file creation
                                                                        is_theme: '0',
                                                                        file_edit_level: data55[0].file_edit_level,
                                                                        file_brand_id: current_log_content.brand_report_id, // (set to the template or doc level)) // Default is for the brand_report_id ??? (what if agent and what if client... need a switch)
                              
                                                                        // file_brand_id: this.sessionBrandId, // the person who made the action.??????? who for or leave emty (We need to set this in the template Automation Template that is)
                                                                
                                                                        brand_type_id: data55[0].brand_type_id, 
                                                                     //   who_service: this.sessionBrandId, // for attendance/sercice -- set at the creator at the time of operation (actually the file_brand_id... when it saves).....(as this is in the file creation function and missing....)
                                                                     assigned_to_agents: JSON.stringify(this.allAgentRecipients),  // now set via the subject id and grabs the agents assigned
                                                                     allAttachments: [], // set so can fill if required by auto attach and send.
                                                                      ...data55[0], // the comm model details.
                                                                     // REMOVED AS ONLY REQUIRED FOR COMMUNICATION AND WAS STUFFING UP NOTES I THINK TESTING....
                                                                       updated_by: 0,            
                                                                     brand_report_user_id: current_log_content.brand_report_user_id, // required for Sending and Checking client comms on file generation
                                                                                 brand_report_id: current_log_content.brand_report_id, // required for Sending and Checking client comms on file generation
                                                                                 brand_invoice_id: current_log_content.brand_invoice_id, // required for Sending and Checking client comms on file generation
                                                                                 message_subject_header: data55[0].message_subject_header,
                                                                                 subject_com_type_id: data55[0].subject_com_type_id, // this activates a commuication note --- not file note... but is correct variable.
                                                                    }; // multidimentional array push
  
                                                                    console.log('CreateFile Model: ' + JSON.stringify(pushed_automation_file_model))
  
                                                          // See Global Function to See Vars
                                                          this.createDocumentFileViaAutomation(pushed_automation_file_model); // deactivated for testing must be active to create document. WORKing but need to remove subject_com_type_id from teh array for correct notes.
  
                                                          // TESTING TO SEE IF STOPS DUPBLE UPS
                                                          this.allRecipients = [];
                                                          model.allRecipients = this.allRecipients; // reset the model as we.. so dont get duplicates....
                                                   
                                        // this.createDocumentButtonAndSend_Automation(pushed_automation_file_model) // --- working but creating doubles 
                                                          // Mussing --- file_brand_id, file_edit_level
  
  
                                          
  
  
                                                       }, 0);
        
  
  
                         
                        },
                        err => console.error(err),
                        () => console.log('')
                      );
                    // end second looup template doc.
  
  
  
        
  
  
                  } // end document loop
  
                } // .. end idf create docuemnt file
              },
              err => console.error(err.status)
            );
  
  
  
  
    // }, 0000);
  
  
  
  
        
    // } // end loop
  
  
  
  };

/*

RemoveElementOthersFromAllAgentRecipients(key: number) {
  // test! -- load again an then filter and create the array again.
  // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.

  // delay load slightly so I can refresh the allRecpientList first.
  setTimeout(function() {   
}, 2000);
    console.log("Ready to clean array!")

  let array = this.allAgentRecipients;
  // removes all not matching
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
    this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_brand_id !== key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
  // console.log('allAgentRecipients after Removal Others: ', JSON.stringify(this.allAgentRecipients));

// ::@https://stackoverflow.com/questions/5310304/remove-json-element
// let json = this.allRecipients
// let id_key = "recipient_brand_id";
// delete json[id_key]; // Removes json.foo from the dictionary.



};



  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );


*/





  private getSystemAutomation(system_automation_id) {
    this._demoService.getSystemAutomation(system_automation_id)
      .subscribe(
        res => {
          this.system_automation = res;
          let data = res[0]
          // this.getSystemLogType(data.system_log_type_id);
        },
        err => console.error(err.status)
      );
  }




  // SYSTEM LOGGING
  createSystemLog(model) {
    const uploadDiagnostic = this.uploadDiagnostics.extractFromSystemLogModel(model);
    this.uploadDiagnostics.markSystemLogStage(uploadDiagnostic, 'system_log_create_request_start', {
      logTypeId: model ? model.log_type_id : null
    });
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data;
        this.uploadDiagnostics.markSystemLogStage(uploadDiagnostic, 'system_log_create_request_success', {
          response: data
        });
      
        // this.toastr.success('Created Log Successful')
 
 
        //  this.runSystemAutomation('', model)  // switched off to work onloine 

        // switched off for multiple subject testing october 2023
this.uploadDiagnostics.markSystemLogStage(uploadDiagnostic, 'system_automation_condition_checker_start');
this.systemAutomationConditionChecker(model); /// Need to incorporate this some how.....
this.uploadDiagnostics.markSystemLogStage(uploadDiagnostic, 'system_automation_condition_checker_dispatched');


         

      },
      err => {
        this.uploadDiagnostics.markSystemLogStage(uploadDiagnostic, 'system_log_create_request_error', {
          message: err && err.message ? err.message : String(err),
          status: err && err.status ? err.status : null
        });
        console.log(err);
      },
      // () => console.log('done loading Trace Types')
    );
  }


  

  // SYSTEM LOGGING
  createSystemLogNoSystemAutomations(model) {
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data;
      
      //  this.runSystemAutomation('', model)  // switched off to work onloine 
// this.systemAutomationConditionChecker(model); /// Need to incorporate this some how.....

      },
      err => console.log(err),
      // () => console.log('done loading Trace Types')
    );
  }





  // Insert Log on create company
  insertLog_CreateCompany(model) {
    // insert log
    const log_data = {
      log_id: null,
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
      log_name: 'New Company Created: ' + ' - ' + model.name,
      log_type_id: 7, // see datatable system_log_types (7 = company created)
      created_level: this.sessionUserLevel, // staff manager
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: null,
      job_id: null,
      job_reference_number: null,
      file_number: null,
      reference_number: null,
      subject_number: null,
       brand_type_id: this.sessionBrandTypeId,
      subject_com_type_id: null,
      subject_template_doc_id: null,
      file_id: null,
      brand_id: model.brand_id,
    };
    this.createSystemLog(log_data);
  }



// Insert Log on create company
insertLog_UpdateCompany(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    // log_name: 'Company Updated : ' + ' - ' + model.name,
    log_type_id: 8, // see datatable system_log_types (8 = company updated)
    created_level: this.sessionUserLevel, // staff manager
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: null,
    job_id: null,
    job_reference_number: null,
    file_number: null,
    reference_number: null,
    subject_number: null,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    file_id: null,
    brand_id: model.brand_id,
      // tslint:disable-next-line:max-line-length
      log_name: 'NOTICE: Company Profile Updated :'  + model.name  + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
      log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' Company: ' + model.name  + ' profle and details updated By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') Proile Type: ' + model.brand_brand_id +  '  - From: ' + ' (Company Profile Card). Login to view changes. ',

    };
    this.createSystemLog(log_data);
    model = {
      ...model,
      ...log_data
    }
        // only send if agent or client.
        if(this.sessionBrandTypeId != 1){
          // this.sendSimpleEmail(log_data, model); // notify sharmans
          }
}


insertLog_CreateUser(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_name: 'New User Created: ' + ' - ' + model.first_name + ' ' + model.surname,
    log_type_id: 9, // see datatable system_log_types (9 = user created)
    created_level: this.sessionUserLevel, // staff manager
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: null,
    job_id: null,
    job_reference_number: null,
    file_number: null,
    reference_number: null,
    subject_number: null,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    file_id: null,
    brand_id: model.brand_id,
    // brand_report_id: model.brand_report_id,
    brand_report_id: model.brand_id,
    brand_report_user_id: model.brand_report_user_id, // set at the function so we can run a personal email 
    user_id: model.last_insert_id,
    custom_run: 'user_created'
  };
  this.createSystemLog(log_data);
}


// august 2025
insertLog_CreateUserSendWelcomeEmail(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'sent', // automated / updated / created / uploaded / link_created / sent / accessed
    log_name: 'User Welcome Email Sent: ' + ' - ' + model.first_name + ' ' + model.surname,
    log_type_id: 87, // see datatable system_log_types (9 = user created)
    created_level: this.sessionUserLevel, // staff manager
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: null,
    job_id: null,
    job_reference_number: null,
    file_number: null,
    reference_number: null,
    subject_number: null,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    file_id: null,
    brand_id: model.brand_id,
    // brand_report_id: model.brand_report_id,
    brand_report_id: model.brand_id,
    brand_report_user_id: model.brand_report_user_id, // set at the function so we can run a personal email 
    user_id: model.last_insert_id,
    custom_run: 'user_welcome_email'
  };
  this.createSystemLog(log_data);
}



insertLog_UpdateUser(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    // log_name: 'User Updated: ' + ' - ' + model.first_name + ' ' + model.surname + ' ' + model.username,
    log_type_id: 10, // see datatable system_log_types (9 = user created)
    created_level: this.sessionUserLevel, // staff manager
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: null,
    job_id: null,
    job_reference_number: null,
    file_number: null,
    reference_number: null,
    subject_number: null,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    file_id: null,
    brand_id: model.brand_id,
    brand_report_id: model.brand_report_id,
    user_id: model.user_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: User Profile Updated :'  + model.first_name + ' ' + model.surname + ' ' + model.username  + ' By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' User: '  + model.first_name + ' ' + model.surname + ' ' + model.username  +  ' profle and details updated By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') Proile Type: ' + model.brand_brand_id +  '  - From: ' + ' (User Profile Card). Login to view changes. ',

  };
  this.createSystemLog(log_data);

  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}



insertLog_UpdateUserPassword(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'reset', // automated / updated / created / uploaded / link_created / sent / accessed
    // log_name: 'User Updated: ' + ' - ' + model.first_name + ' ' + model.surname + ' ' + model.username,
    log_type_id: 24, // see datatable system_log_types (9 = user created) was 10 but should have been.... 
    created_level: this.sessionUserLevel, // staff manager
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: null,
    job_id: null,
    job_reference_number: null,
    file_number: null,
    reference_number: null,
    subject_number: null,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    file_id: null,
    brand_id: model.brand_id,
    brand_report_id: model.brand_report_id,
    user_id: model.user_id,
    // tslint:disable-next-line:max-line-length
    // log_name: 'NOTICE: User PASSWORD changed! :'  + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') By: ' + this.sessionBrandName + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') ',
    // log_body: 'NOTICE:  On: ' + this.today_date_time_words + ' User: '  + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') PASSWORD was changed By: ' + this.sessionBrandName + ' - ' + this.sessionBrandTypeName  + ' ( ' + this.sessionUserName + ' - ' + this.sessionUserFullName + ') Proile Type: ' + model.brand_brand_id +  '  - From: ' + ' (User Profile Card). Passwords are automatically expiried periodically in the system. ',

    log_name: model.log_name,
    log_body: 'updated password success',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}


insertLog_UpdateUserPassword_FAIL(model) {
  // insert log
  const log_data = {
    log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'reset_FAIL', // automated / updated / created / uploaded / link_created / sent / accessed
    // log_name: 'User Updated: ' + ' - ' + model.first_name + ' ' + model.surname + ' ' + model.username,
    log_type_id: 85, // see datatable system_log_types (9 = user created) was 10 but should have been.... 
    created_level: this.sessionUserLevel, // staff manager
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: null,
    job_id: null,
    job_reference_number: null,
    file_number: null,
    reference_number: null,
    subject_number: null,
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: null,
    subject_template_doc_id: null,
    file_id: null,
    brand_id: model.brand_id,
    brand_report_id: model.brand_report_id,
    user_id: model.user_id,
    // tslint:disable-next-line:max-line-length
    log_name: model.log_name,
    log_body: 'updated password failed',

  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
      // only send if agent or client.
      if(this.sessionBrandTypeId != 1){
        // this.sendSimpleEmail(log_data, model); // notify sharmans
        }
}




resolveOwnerReference(model) {
  const jobModel = model && model.job_model ? model.job_model : {};
  const subjectModel = model && model.subject_model ? model.subject_model : {};
  return model.owner_trace_code || model.client_reference || jobModel.owner_trace_code || subjectModel.client_reference || model.job_reference_number || '';
}


insertLog_CreateSubjectAttempt(model) {
  const ownerReference = this.resolveOwnerReference(model);
  model.owner_trace_code = ownerReference;
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 12, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // created_level: model.user_level_id, // staff
    created_level: this.sessionUserLevel, // current user level
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    // log_name: model.note_content,
    file_id: null,
    // new additions to log
    subject_service_id: model.subeject_service_id,
    note_id: model.last_insert_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: Subject Attempt :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent entered a ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was created by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
    email_body: 'Service Notification : Your Ref: <b>' + ownerReference + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ ownerReference + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
    email_subject: 'Service Notification : Your Ref: ' + ownerReference + ' - Sharmans Ref  ' + model.subject_number + ' ',

  };
  // Switched off for 
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting over system auotmation id: 12
   // this.sendSimpleEmail(log_data, model); // notify sharmans
    }

// Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans

}


// creating for performance and benchmarking // automations and conditions are setup for above attemps for all services and attemdances tigger events.
insertLog_CreateSubjectAttempt_Attendance(model) {
  const ownerReference = this.resolveOwnerReference(model);
  model.owner_trace_code = ownerReference;
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 81, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // created_level: model.user_level_id, // staff
    created_level: this.sessionUserLevel, // current user level
    brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    // log_name: model.note_content,
    file_id: null,
    // new additions to log
    subject_service_id: model.subeject_service_id,
    note_id: model.last_insert_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: Subject Attempt - Attendance :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent entered a ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was created by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
    email_body: 'Service Notification : Your Ref: <b>' + ownerReference + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ ownerReference + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
    email_subject: 'Service Notification : Your Ref: ' + ownerReference + ' - Sharmans Ref  ' + model.subject_number + ' ',

  };
  // Switched off for 
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting over system auotmation id: 12
   // this.sendSimpleEmail(log_data, model); // notify sharmans
    }

// Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans

}















 getSubjectServiceOutcomeTemplate(ssot_id) {

  // if (confirm('Testing I got here? ')) {
  //               }   

  // this.get_system_log_type_id = null
  this._demoService.getSubjectServiceOutcomeTemplate(ssot_id)
    .subscribe(
      res => {
        this.ssot = res;
        let data = res[0]
        this.get_system_log_type_id = data.system_log_type_id

      },
      err => console.error(err.status)
    );
}



// Function runs All log types addtions for attempts sub groups.
// is a child of log_type_id = 81 attendance  and then a child of 12 total subject attempt
// only run this when running an attempt fom adding in subject card. - tested 
// each attendance will have have a new attendance log type so that entry and numbers on the spefioc attempt type can be calculated.

// 38 documnet filing ssot.

insertLog_CreateSubjectAttempt_Attendance_type(model) {
  const ownerReference = this.resolveOwnerReference(model);
  model.owner_trace_code = ownerReference;
  
  

// Implimented - All SSOT now have a system_log_type_id = Field that is added to the data
// Do a quick lookup for the id form the ssot_id and then we will have the (log trigger) to be dynamic for all SSOUT / Attempts outcomes
this.getSubjectServiceOutcomeTemplate(model.ssot_id)



  // 2026 - New Metrics Approach and Logging of data so that all attempt types and resolutions outcomes are reported as seperated events in the system.

  // Subject Services will require this logic as well now I think About it.. so it should be able to handle all attempt types and have an automated flow into the sysetm so that attemps, types and the creation of such is easier to manage and vaid. / down through the chain.

  // We can later use this logic for other areas we wean to gain more loging date and capture and classify the acual event. 

  // we also need to integrate the has a primary into the sysetm so that if it has the lower automations should be gated so that they cannot run unless the upper is disabled to truigger otherwise we could get loop ans sub loop events. ???? maybe before I let it loose and so I dont release an untested part of the system.

  // THIS ALSO WARRENTS PUTTING IN THE NEW SKIP /// NOT APPLICABLE FOR TEMPLATES TO OFFER THIS AT THE SSOT OR ATTEMPT OUTCOME TYPE LEVEL
  /// Depending what makes more sence, once the dates the type, is selcted, show Not Applicable, 
  // TO ALL BELOW and self enter nulls or 0 currect replacement for the reset of the form model and flow that down to all subjects, if its a multple subject selections etc... 

  // Update the attempt logging system to more granualar and idenfied by actual datbase and connect all the tables together so that renaming or removing the need for UI to work out all the logic for reporting this will strucure it much  more clearly and make this much easier to operate

  // first lookup or extract the attempt infomration form the (model)
  // Apped that information to the log
  // have this outcome ID trigger a matching Log type_id.
  
  // HOW DO AI GE THE LOG TYPE... id I need to build a table of all subject_service_outcome_id and thier SSOT_id, and there log_type_id, 
  // So if we link thk eht lig type to tsubject service type ID this should work,
  // In reality all subject service outcome id, should have thier ssot set in the database? (Dont worry about original service types yet but we really should make these as part of a data tree so that al line up in the flow....
  // attempt outcome ssot log type id, (kpi's), Automations, can be added if required but should load null and be inacive as trigger events so they dont run and cause load on the server. 
  

  // Also All Logs legacy will need to write a quiery to collect the attempt log, either subject service or etc. entered by anyone, to create the inserts of new log types and additional sub fields so that legacy data can still be used in the reporting maybe we try to go back to 12 months. that way we an then see real --- or we dont need this as we dont have the outcome results even colleing real data yes... we might as well not worry --- dont do this just make note of it..



    // Added deloay to allow for tother things to run first and not dump on the other three triggers....
    // Send when we have value.  // Just to makes sure we have time for the lookup
     setTimeout(() => {  console.log('delay Automation Loop stop 8000')  



              // insert log
              const log_data = {
              // log_id: null,
                log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
                log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
                // log_type_id: 81, // see datatable system_log_types (12 = subject_attempt)
                // log_type_id: 88, // see datatable system_log_types (12 = subject_attempt)
                log_type_id: this.get_system_log_type_id, // now set as a variable and retrived from SSOT
                ////
                // is_a_child_of: "81", // set to is_a_child_of to the log type parent of 81 // agent attempt entered. 
                created_by: model.created_by,
                created_date: this.today,
                subject_id: model.subject_id,
                job_id: model.job_id,
                job_reference_number: model.job_reference_number,
                file_number: model.file_number,
                reference_number: model.reference_number,
                subject_number: model.subject_number,
                // created_level: model.user_level_id, // staff
                created_level: this.sessionUserLevel, // current user level
                brand_type_id: this.sessionBrandTypeId,
                subject_com_type_id: model.subject_com_type_id,
                subject_template_doc_id: model.subject_template_doc_id,
                // log_name: model.note_content,
                file_id: null,
                // new additions to log
                subject_service_id: model.subeject_service_id,
                note_id: model.last_insert_id,
                // tslint:disable-next-line:max-line-length
                log_name: 'Subject Attempt - Attendance :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
                log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent entered a ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was created by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
                email_body: 'Service Notification : Your Ref: <b>' + ownerReference + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ ownerReference + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
                email_subject: 'Service Notification : Your Ref: ' + ownerReference + ' - Sharmans Ref  ' + model.subject_number + ' ',

              };

              if(this.get_system_log_type_id != null){
                    // Switched off for 
                    this.createSystemLog(log_data);
                    model = {
                      ...model,
                      ...log_data
                    } 
                }
      }, 8000); // was 4000



  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting over system auotmation id: 12
   // this.sendSimpleEmail(log_data, model); // notify sharmans
    }

// Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans

}





insertLog_CreateSubjectAttempt_Service(model) {
  const ownerReference = this.resolveOwnerReference(model);
  model.owner_trace_code = ownerReference;
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 82, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // created_level: model.user_level_id, // staff
    created_level: this.sessionUserLevel, // current user level
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    // log_name: model.note_content,
    file_id: null,
    // new additions to log
    subject_service_id: model.subeject_service_id,
    note_id: model.last_insert_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: Subject Attempt - Service :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent entered a ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was created by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
    email_body: 'Service Notification : Your Ref: <b>' + ownerReference + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ ownerReference + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
    email_subject: 'Service Notification : Your Ref: ' + ownerReference + ' - Sharmans Ref  ' + model.subject_number + ' ',

  };
  // Switched off for 
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting over system auotmation id: 12
   // this.sendSimpleEmail(log_data, model); // notify sharmans
    }

// Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans

}

insertLog_UpdateSubjectAttempt(model) {

  // model.owner_trace_code = 'qewe123';
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 27, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // created_level: model.user_level_id, // staff
    created_level: this.sessionUserLevel, // current user level
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    // log_name: model.note_content,
    file_id: null,
    // new additions to log
    subject_service_id: model.subeject_service_id,
    note_id: model.last_insert_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: Subject Attempt UPDATED :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent updated the ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was modified by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
     // client communication additions
     email_body: 'Service Notification : Your Ref: <b>' + model.owner_trace_code + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ model.owner_trace_code + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
     email_subject: 'Service Notification : Your Ref: ' + model.owner_trace_code + ' - Sharmans Ref  ' + model.subject_number + ' ',
  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting.  automation id 12
    // this.sendSimpleEmail(log_data, model); // notify sharmans
    }
    // Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans // NEED TO CHECK IF THIS SHOULD RUN WHEN AN ATTEMPT HAS BEEN EDITED.
}




insertLog_UpdateSubjectAttempt_Attendance(model) {

  // model.owner_trace_code = 'qewe123';
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 83, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // created_level: model.user_level_id, // staff
    created_level: this.sessionUserLevel, // current user level
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    // log_name: model.note_content,
    file_id: null,
    // new additions to log
    subject_service_id: model.subeject_service_id,
    note_id: model.last_insert_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: Subject Attendance UPDATED :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent updated the ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was modified by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
     // client communication additions
     email_body: 'Service Notification : Your Ref: <b>' + model.owner_trace_code + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ model.owner_trace_code + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
     email_subject: 'Service Notification : Your Ref: ' + model.owner_trace_code + ' - Sharmans Ref  ' + model.subject_number + ' ',
  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting.  automation id 12
    // this.sendSimpleEmail(log_data, model); // notify sharmans
    }
    // Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans // NEED TO CHECK IF THIS SHOULD RUN WHEN AN ATTEMPT HAS BEEN EDITED.
}





insertLog_UpdateSubjectAttempt_Service(model) {

  // model.owner_trace_code = 'qewe123';
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 84, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,
    // created_level: model.user_level_id, // staff
    created_level: this.sessionUserLevel, // current user level
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    // log_name: model.note_content,
    file_id: null,
    // new additions to log
    subject_service_id: model.subeject_service_id,
    note_id: model.last_insert_id,
    // tslint:disable-next-line:max-line-length
    log_name: 'NOTICE: Subject Service UPDATED :' + model.subject_attempt_type_name + ' ' + model.subject_number  + ' - ' + model.subject_name  + ' By' + ' : ' + this.sessionUserName + ' - ' + this.sessionUserFullName + '',
    log_body: 'NOTICE:  On: ' + this.today_date_time_words + '  Agent updated the ' + model.subject_attempt_type_name + ' upon Subject: ' +  model.subject_number + ' - ' + model.subject_name  + ' . It was modified by ' + ' ' + this.sessionUserName + ' : ' + ' - ' + this.sessionUserFullName + ' From: ' + ' (Subject Attempt Wizard - Subject Card). Please login to TSA to action, and view full details ',
     // client communication additions
     email_body: 'Service Notification : Your Ref: <b>' + model.owner_trace_code + '</b> - Sharmans Ref  <b>' + model.subject_number + '</b> <br><br> <p>On ' + this.today_date_time_words + ' (local time) service was effected upon subject '+ model.subject_number + ' under your matter '+ model.owner_trace_code + '. </p> <p>Please logon to Sharmans.Online to view the complete service details. Sharmans will email a service report through shortly.</p> <p>Names, addresses and other personally identifiable information (PII) have been redacted from this email to minimise privacy and security risks.</p> <p>If you do not have a Sharmans.Online account, please reply to this email requesting access.</p> <br><br>Regards, <br><b>Sharman Group Pty Ltd</b> <br> <b>tas Sharmans Investigations and Process Serving</b> <br><br>Office Locations: Brisbane/Melbourne/Sydney/Gold Coast/Sunshine Coast.<br> Australia-wide Services <br> T: 1300 717 330 <br> sharmans@sharmans.net.au ',
     email_subject: 'Service Notification : Your Ref: ' + model.owner_trace_code + ' - Sharmans Ref  ' + model.subject_number + ' ',
  };
  this.createSystemLog(log_data);
  model = {
    ...model,
    ...log_data
  }
  // only send if agent or client.
  if(this.sessionBrandTypeId != 1){
    // Currently Converting.  automation id 12
    // this.sendSimpleEmail(log_data, model); // notify sharmans
    }
    // Send To client Upon agent or staff entry. April 2023
// this.sendSimpleClientEmail(log_data, model); // notify sharmans // NEED TO CHECK IF THIS SHOULD RUN WHEN AN ATTEMPT HAS BEEN EDITED.
}



insertLog_CreateInvoice(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 17, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'A new client Invoice created for service subject: ' + model.subject_number + ' to: client by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  invoice_id: model.invoice_id,
  };
  this.createSystemLog(log_data);
}



insertLog_UpdateInvoice(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 18, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Invoice Updated: ' + model.subject_number + ' to: client by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  invoice_id: model.invoice_id,
  };
  this.createSystemLog(log_data);
}


insertLog_DeleteInvoice(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'deleted', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 18, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Invoice Deleted and Billing Items re-assigned active: ' + model.subject_number + ' to: client by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  invoice_id: model.invoice_id,
  };
  this.createSystemLog(log_data);
}



insertLog_createInvoicePayment(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 21, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Invoice Payment Entered: ' + model.subject_number + ' to: client by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  invoice_id: model.invoice_id,
  };
  this.createSystemLog(log_data);
}



insertLog_createInvoicePaymentBulk(model) {
  // insert log
  const log_data = {
   // log_id: null,


    // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    // log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    // log_type_id: 51, // see datatable system_log_types (12 = subject_attempt)
    // created_by: model.created_by,
    // created_date: this.today,
  
  
    // subject_id: model.workOrderPaymentItemsList[0].subject_id,
    // job_id: model.workOrderPaymentItemsList[0].job_id,
    // job_reference_number: model.workOrderPaymentItemsList[0].job_reference_number,
    // file_number: model.workOrderPaymentItemsList[0].file_number,
    // reference_number: model.workOrderPaymentItemsList[0].reference_number,
    // subject_number: model.workOrderPaymentItemsList[0].subject_number,

    // created_level: this.gfunc.sessionUserLevel, // staff
    //  brand_type_id: this.sessionBrandTypeId,
    // subject_com_type_id: model.workOrderPaymentItemsList[0].subject_com_type_id,
    // subject_template_doc_id: model.workOrderPaymentItemsList[0].subject_template_doc_id,
    // log_name: 'BULK Supplier Invoice Payment Entered: Starting from ' + model.workOrderPaymentItemsList[0].subject_number + ' to: Agent ' + model.workOrderPaymentItemsList[0].agent_full_name +  ' by: '
    // + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',


    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
   log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
   log_type_id: 52, // see datatable system_log_types (12 = subject_attempt)
   created_by: model.created_by,
   created_date: this.today,
   subject_id: model.subject_id,
   job_id: model.job_id,
   job_reference_number: model.job_reference_number,
   file_number: model.file_number,
   reference_number: model.reference_number,
   subject_number: model.subject_number,

   created_level: model.user_level_id, // staff
    brand_type_id: this.sessionBrandTypeId, //who
   subject_com_type_id: model.subject_com_type_id,
   subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'BULK Client Invoice Payment Entered: Starting at ' + model.subject_number  + ' to: Client by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',


  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}



insertLog_DeleteInvoicePayment(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'deleted', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 21, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Invoice Payment Removed: ' + model.subject_number + ' to: client by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  invoice_id: model.invoice_id,
  };
  this.createSystemLog(log_data);
}




insertLog_CreateWorkOrder(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 19, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'A new Supplier Invoice created for service subject: ' + model.subject_number + ' to: Agent by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}



insertLog_UpdateWorkOrder(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'updated', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 20, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'A Supplier Invoice was Upadated for service subject: ' + model.subject_number + ' to Agent by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}





insertLog_DeleteWorkOrder(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'deleted', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 20, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Supplier Invoice Deleted and Cost Items re-assigned active: ' + model.subject_number + ' to: Agent by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}



insertLog_createWorkOrderPayment(model) {
  // insert log
  const log_data = {
   // log_id: null,
   log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
   log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
   log_type_id: 22, // see datatable system_log_types (12 = subject_attempt)
   created_by: model.created_by,
   created_date: this.today,
   subject_id: model.subject_id,
   job_id: model.job_id,
   job_reference_number: model.job_reference_number,
   file_number: model.file_number,
   reference_number: model.reference_number,
   subject_number: model.subject_number,

   created_level: model.user_level_id, // staff
    brand_type_id: this.sessionBrandTypeId,
   subject_com_type_id: model.subject_com_type_id,
   subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Supplier Invoice Payment Entered: ' + model.subject_number + ' to: Agent by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}




insertLog_createWorkOrderPaymentBulk(model) {
  // insert log
  const log_data = {
   // log_id: null,


    // log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    // log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
    // log_type_id: 51, // see datatable system_log_types (12 = subject_attempt)
    // created_by: model.created_by,
    // created_date: this.today,
  
  
    // subject_id: model.workOrderPaymentItemsList[0].subject_id,
    // job_id: model.workOrderPaymentItemsList[0].job_id,
    // job_reference_number: model.workOrderPaymentItemsList[0].job_reference_number,
    // file_number: model.workOrderPaymentItemsList[0].file_number,
    // reference_number: model.workOrderPaymentItemsList[0].reference_number,
    // subject_number: model.workOrderPaymentItemsList[0].subject_number,

    // created_level: this.gfunc.sessionUserLevel, // staff
    //  brand_type_id: this.sessionBrandTypeId,
    // subject_com_type_id: model.workOrderPaymentItemsList[0].subject_com_type_id,
    // subject_template_doc_id: model.workOrderPaymentItemsList[0].subject_template_doc_id,
    // log_name: 'BULK Supplier Invoice Payment Entered: Starting from ' + model.workOrderPaymentItemsList[0].subject_number + ' to: Agent ' + model.workOrderPaymentItemsList[0].agent_full_name +  ' by: '
    // + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',


    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
   log_action: 'created', // automated / updated / created / uploaded / link_created / sent / accessed
   log_type_id: 51, // see datatable system_log_types (12 = subject_attempt)
   created_by: model.created_by,
   created_date: this.today,
   subject_id: model.subject_id,
   job_id: model.job_id,
   job_reference_number: model.job_reference_number,
   file_number: model.file_number,
   reference_number: model.reference_number,
   subject_number: model.subject_number,

   created_level: model.user_level_id, // staff
    brand_type_id: this.sessionBrandTypeId, //who
   subject_com_type_id: model.subject_com_type_id,
   subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'BULK Supplier Invoice Payment Entered: Starting at ' + model.SupplierInvoiceNumber  + ' to: Agent by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',


  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}



insertLog_DeletWorkOrderPayment(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'deleted', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 22, // see datatable system_log_types (12 = subject_attempt)
    created_by: model.created_by,
    created_date: this.today,
    subject_id: model.subject_id,
    job_id: model.job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.subject_number,

    created_level: model.user_level_id, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'Supplier Invoice Payment Removed: ' + model.subject_number + ' to: Agent by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: null,
  agent_id: model.agent_id,
  work_order_id: model.work_order_id,
  };
  this.createSystemLog(log_data);
}




insertLog_DeleteSystemFile(model) {
  // insert log
  const log_data = {
   // log_id: null,
    log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
    log_action: 'deleted', // automated / updated / created / uploaded / link_created / sent / accessed
    log_type_id: 23, // see datatable system_log_types (12 = subject_attempt)
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.file_subject_id,
    job_id: model.file_job_id,
    job_reference_number: model.job_reference_number,
    file_number: model.file_number,
    reference_number: model.reference_number,
    subject_number: model.file_subject_number,
    brand_id: model.file_brand_id,

    created_level: model.created_level, // staff
     brand_type_id: this.sessionBrandTypeId,
    subject_com_type_id: model.subject_com_type_id,
    subject_template_doc_id: model.subject_template_doc_id,
    log_name: 'System File Deleted and Datas Removed: ' + model.full_file_name + ' by: '
    + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ',
  file_id: model.file_id,
  agent_id: null,
  invoice_id: null,
  };
  this.createSystemLog(log_data);
}







// ... Notes
// Create New Type of note:
insertNote_CreateInvoice(model) {
//   model.subject_id = this.subject_id;
//   model.job_id = this.job_id;
//   model.created_by = this.gfunc.sessionUserId;
//   model.note_type_id = 8; // is note added.
//   model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
//   // model.brand_type_id = this.gfunc.sessionBrandTypeId;

//  model.subject_com_type_id = null;
//  model.subject_template_doc_id = null;
//  model.file_id = null;
//  model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
//  model.brand_id = this.gfunc.sessionBrandId;

//  model.subject_number = this.model.subject_number;
//  model.reference_number = this.model.reference_number;
//  model.job_reference_number = '1'; // will always be one as there are not job stages.
//  model.file_number = this.model.file_number;


   // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
   model.created_by = this.sessionUserId;
   model.note_content =
     'A new client Invoice created for service subject: ' + model.subject_number + ' to: client by: '
     + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ';
  //  model.note_type_id = '8';

  model = {
  note_content: model.note_content, // the message that appears in the note
  created_by: this.sessionUserId,
  created_date: this.today,
  subject_id: model.subject_id, // who the note was specifically created for subject
  job_id: model.job_id, // job note was created for
  job_reference_number: model.job_reference_number, // job reference number eg. 100.1
  file_number: model.file_number, // the file number for the stage system eg. 1
  reference_number: model.reference_number, // the subject reference number - last number in subject number .4
  subject_number: model.subject_number, // exact subject number eg 1001.2.1
  note_type_id: 5, // see database table for subject_note_types
  user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
  brand_type_id: 2, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
  subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
  subject_template_doc_id: model.subject_template_doc_id, // if a template was used
  file_id: model.file_id,
  brand_id: model.brand_id, // the brand ofd the company who created the note
  invoice_id: model.invoice_id,
  // work_order_id: model.work_order_id
  assigned_to_agents: '[]'
};

// :: !!! @ log is also inserted now when we insert the note function
  // if (result.job_status === 'OPEN'){
  this._demoService.createSubjectNote(model).subscribe(
    (data) => {
      this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
      let res2 = data[0];
      // set the note_id to insert into the log.
      model.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
      // :: Insert the LOG in same step.
      // this.insertLog_CreateSubjectAttempt(model);
    },
    (error) => {
    //  console.log(Observable.throw(error));
     throwError(() => new Error(error));
      throwError(() => new Error(error));
    }
  );
  // } // end if  open
}





insertNote_CreateSupplierInvoice(model) {
  //   model.subject_id = this.subject_id;
  //   model.job_id = this.job_id;
  //   model.created_by = this.gfunc.sessionUserId;
  //   model.note_type_id = 8; // is note added.
  //   model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
  //   // model.brand_type_id = this.gfunc.sessionBrandTypeId;
  
  //  model.subject_com_type_id = null;
  //  model.subject_template_doc_id = null;
  //  model.file_id = null;
  //  model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
  //  model.brand_id = this.gfunc.sessionBrandId;
  
  //  model.subject_number = this.model.subject_number;
  //  model.reference_number = this.model.reference_number;
  //  model.job_reference_number = '1'; // will always be one as there are not job stages.
  //  model.file_number = this.model.file_number;
  
  
     // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
     model.created_by = this.sessionUserId;
     model.note_content =
       'A new Supplier Invoice created for service subject: ' + model.subject_number + ' to: Agent by: '
       + ' - ' + this.sessionUserFullName + ' (' + this.sessionUserName + ') ';
    //  model.note_type_id = '8';
  
    model = {
    note_content: model.note_content, // the message that appears in the note
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id, // who the note was specifically created for subject
    job_id: model.job_id, // job note was created for
    job_reference_number: model.job_reference_number, // job reference number eg. 100.1
    file_number: model.file_number, // the file number for the stage system eg. 1
    reference_number: model.reference_number, // the subject reference number - last number in subject number .4
    subject_number: model.subject_number, // exact subject number eg 1001.2.1
    note_type_id: 5, // see database table for subject_note_types
    user_level_id: 5, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
    brand_type_id: 3, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
    subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
    subject_template_doc_id: model.subject_template_doc_id, // if a template was used
    file_id: model.file_id,
    brand_id: model.brand_id, // the brand ofd the company who created the note
    // invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
    assigned_to_agents: '[]'
  };
  
  // :: !!! @ log is also inserted now when we insert the note function
    // if (result.job_status === 'OPEN'){
    this._demoService.createSubjectNote(model).subscribe(
      (data) => {
        this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
        let res2 = data[0];
        // set the note_id to insert into the log.
        model.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
        // :: Insert the LOG in same step.
        // this.insertLog_CreateSubjectAttempt(model);
      },
      (error) => {
    //    console.log(Observable.throw(error));
        throwError(() => new Error(error));
      }
    );
    // } // end if  open
  }




// ... Notes
// Create New Type of note: - client
insertNote_CreateFileButton(model, file_name) {
  //   model.subject_id = this.subject_id;
  //   model.job_id = this.job_id;
  //   model.created_by = this.gfunc.sessionUserId;
  //   model.note_type_id = 8; // is note added.
  //   model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
  //   // model.brand_type_id = this.gfunc.sessionBrandTypeId;
  
  //  model.subject_com_type_id = null;
  //  model.subject_template_doc_id = null;
  //  model.file_id = null;
  //  model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
  //  model.brand_id = this.gfunc.sessionBrandId;
  
  //  model.subject_number = this.model.subject_number;
  //  model.reference_number = this.model.reference_number;
  //  model.job_reference_number = '1'; // will always be one as there are not job stages.
  //  model.file_number = this.model.file_number;
  
// console.log('FIle Insert Note Model: ', JSON.stringify(model));

  
     // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
     model.created_by = this.sessionUserId;
     model.note_content =
       // tslint:disable-next-line:max-line-length
       'A new file created ' + ' ' + file_name + ' ' + ' for subject: ' + model.subject_number + ' - ' + this.sessionUserFullName + ' - ' + this.sessionBrandName;
    //  model.note_type_id = '8';
  
    model = {
    note_content: model.note_content, // the message that appears in the note
    created_by: this.sessionUserId,
    created_date: this.today,
    subject_id: model.subject_id, // who the note was specifically created for subject
    job_id: model.job_id, // job note was created for
    job_reference_number: model.job_reference_number, // job reference number eg. 100.1
    file_number: model.file_number, // the file number for the stage system eg. 1
    reference_number: model.reference_number, // the subject reference number - last number in subject number .4
    subject_number: model.subject_number, // exact subject number eg 1001.2.1
    note_type_id: 5, // see database table for subject_note_types
    user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
    brand_type_id: model.brand_type_id, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
    subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
    subject_template_doc_id: model.subject_template_doc_id, // if a template was used
    file_id: model.file_id,
    // brand_id: model.brand_id, // the brand ofd the company who created the note
    brand_id: model.file_brand_id, // the brand ofd the company who created the note -- file brand id of the file just created -- works for auotomations notes.
    // brand_id: this.sessionBrandId, // the brand ofd the company who created the note
    invoice_id: model.invoice_id,
    work_order_id: model.work_order_id,
    assigned_to_agents: model.assigned_to_agents,
    doc_id: model.doc_id, // Added to Auto Create the Note content on insert PHP script
  };
  
  // :: !!! @ log is also inserted now when we insert the note function
    // if (result.job_status === 'OPEN'){
    this._demoService.createSubjectNote(model).subscribe(
      (data) => {
        this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
        let res2 = data[0];
        // set the note_id to insert into the log.
        model.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
        // :: Insert the LOG in same step.
        // this.insertLog_CreateSubjectAttempt(model);
      },
      (error) => {
    //    console.log(Observable.throw(error));
        throwError(() => new Error(error));
      }
    );
    // } // end if  open
  }


  insertNote_CreateFileButton2(model, file_name) {
    //   model.subject_id = this.subject_id;
    //   model.job_id = this.job_id;
    //   model.created_by = this.gfunc.sessionUserId;
    //   model.note_type_id = 8; // is note added.
    //   model.user_level_id = 9; // client 9 | Agent 5 | Staff 4
    //   // model.brand_type_id = this.gfunc.sessionBrandTypeId;
    
    //  model.subject_com_type_id = null;
    //  model.subject_template_doc_id = null;
    //  model.file_id = null;
    //  model.brand_type_id = 2; // client 2 | Agent 3 | owwner/staff 4
    //  model.brand_id = this.gfunc.sessionBrandId;
    
    //  model.subject_number = this.model.subject_number;
    //  model.reference_number = this.model.reference_number;
    //  model.job_reference_number = '1'; // will always be one as there are not job stages.
    //  model.file_number = this.model.file_number;
    
  // console.log('FIle Insert Note Model: ', JSON.stringify(model));
  
    
       // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
       model.created_by = this.sessionUserId;
       model.note_content =
         // tslint:disable-next-line:max-line-length
         'A new 2.0 Rendering file created ' + ' ' + file_name + ' ' + ' for subject: ' + model.subject_number + ' - ' + this.sessionUserFullName + ' - ' + this.sessionBrandName;
      //  model.note_type_id = '8';
    
      model = {
      note_content: model.note_content, // the message that appears in the note
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: model.subject_id, // who the note was specifically created for subject
      job_id: model.job_id, // job note was created for
      job_reference_number: model.job_reference_number, // job reference number eg. 100.1
      file_number: model.file_number, // the file number for the stage system eg. 1
      reference_number: model.reference_number, // the subject reference number - last number in subject number .4
      subject_number: model.subject_number, // exact subject number eg 1001.2.1
      note_type_id: 5, // see database table for subject_note_types
      user_level_id: 9, // created for user levels in and  below... // client 9 | Agent 5 | Staff 4
      brand_type_id: model.brand_type_id, // the type of brand that has accesss to this file. (1 Owner | 2 Client | 3 Agent)
      subject_com_type_id: model.subject_com_type_id, // set if inserted as a function of communication
      subject_template_doc_id: model.subject_template_doc_id, // if a template was used
      file_id: model.file_id,
      // brand_id: model.brand_id, // the brand ofd the company who created the note
      brand_id: model.file_brand_id, // the brand ofd the company who created the note -- file brand id of the file just created -- works for auotomations notes.
      // brand_id: this.sessionBrandId, // the brand ofd the company who created the note
      invoice_id: model.invoice_id,
      work_order_id: model.work_order_id,
      assigned_to_agents: JSON.parse(model.assigned_to_agents), // so array() is not inserted [] must be set as anobject
      doc_id: model.doc_id, // Added to Auto Create the Note content on insert PHP script
    };
    
    // :: !!! @ log is also inserted now when we insert the note function
      // if (result.job_status === 'OPEN'){
      this._demoService.createSubjectNote(model).subscribe(
        (data) => {
          this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
          let res2 = data[0];
          // set the note_id to insert into the log.
          model.last_insert_id = this.get_latest_subject_note_id.last_insert_id;
          // :: Insert the LOG in same step.
          // this.insertLog_CreateSubjectAttempt(model);
        },
        (error) => {
      //    console.log(Observable.throw(error));
          throwError(() => new Error(error));
        }
      );
      // } // end if  open
    }


  createSubjectCommunicationHistory(model){
    this._demoService.createSubjectCommunicationHistory(model).subscribe(
      data => { 
        this.subject_communication_history_created_response = data;
      // this.toastr.success('Communication History Created')
      // console.log('Comms History Model: ' + JSON.stringify(model))
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }








  getIPAddress() {
    {
      return this.http.get("http://api.ipify.org/?format=json").subscribe((res: any) => {
        this.ipAddress = res.ip;
      });
    }
  }





  // ::  Router Functions  ::
  // to router navigate back
  public goBack() {
    this._location.back();
  }
  
  public logout() {
    this.router.navigate(['/logout']); // this makes  user press logout properly // by directing the to URL not a route.
  }

  public login() {
    this.router.navigate(['/login']);
  }


  // gets the base route
  getCurrentBaseRoute(level: number) {
    return this.router.url.split('/')[level];
    //eg retunrs client at level 1
    // returns client/jobs at level 2
  }

  // :: Client / Router Funtions
  clientJobView(job_id: number) { this.router.navigate(['/client/jobs/view-job/' + job_id]); };
  clientJobSubjectView(subject_id: string) { this.router.navigate(['/client/jobs/subject/' + subject_id]); }
  clientJobSubjectViewSkipRoute(subject_id) {
    // :: New Way
    this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/client/jobs/subject/' + subject_id + ''])
      );
  }




  // :: GLOBAL ROUTER FUNCTIONS


  globalTFA_setup() {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/tfa_setup']);
    }
    if (this.sessionBrandTypeId === '3') { // agent
    this.router.navigate(['/agent/tfa_setup']);
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
     if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/tfa_setup']);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/tfa_setup']);}
    };
  };

  
  globalTFA_enter_code() {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/tfa_enter_code']);
    }
    if (this.sessionBrandTypeId === '3') { // agent
    this.router.navigate(['/agent/tfa_enter_code']);
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
     if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/tfa_enter_code']);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/tfa_enter_code']);}
    };
  };



  // :: Subjects


  globalJobSubjectView(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/subject/' + subject_id]);
    }
    if (this.sessionBrandTypeId === '3') { // agent
    this.router.navigate(['/agent/jobs/subject/' + subject_id]);
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
     if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/subject/edit/' + subject_id]);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/jobs/subject/edit/' + subject_id]);}
      
    
    };

  };


  globalJobSubjectViewSkipRoute(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/client/jobs/subject/' + subject_id + ''])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/agent/jobs/subject/' + subject_id + ''])
      );
    }
    if (this.sessionBrandTypeId === '1') { // admin actually edits + staff
     if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs' + subject_id + ''], { skipLocationChange: true })
     .then(() => this.router.navigate(['/staff/jobs/subject/edit/' + subject_id + ''])
     );}
      // if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs' + subject_id + ''], { skipLocationChange: true })
      // .then(() => this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + ''])
      if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/card/' + subject_id + ''])
      );}
     
    }
  }


// new subject card August 2022
  globalJobSubjectCardSkipRoute(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/client/jobs/subject/' + subject_id + ''])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/agent/jobs/subject/' + subject_id + ''])
      );
    }

// testing new subject card for admin. load Times and Views
    if (this.sessionBrandTypeId === '1') { // admin actually edits + staff
     if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs' + subject_id + ''], { skipLocationChange: true })
     .then(() => this.router.navigate(['/staff/jobs/subject/edit/' + subject_id + ''])
     );}
      if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + ''])
      );}
     
    }
  }



  globalDashboardSkipRoute(){



    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j'], { skipLocationChange: true })
        .then(() => this.router.navigate(['client/dashboard'])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['agent/dashboard'])
      );
    }
    if (this.sessionBrandTypeId === '1') { // admin
    
      if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs/j'], { skipLocationChange: true })
        .then(() => this.router.navigate(['/staff/dashboard' ])
        );}
         if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
         .then(() => this.router.navigate(['/admin/jobs/dashboard'])
         );}
        }
  
  }



// new subject card August 2022
globalJobSubjectCardLayoutsDashboardSkipRoute(subject_id) {
  if (this.sessionBrandTypeId === '2') { // client
    // :: New Way
    this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/client/jobs/subject/' + subject_id + ''])
      );
  }
  if (this.sessionBrandTypeId === '3') { // agent
    this.router.navigate(['/agent/jobs/j' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/agent/jobs/subject/' + subject_id + ''])
    );
  }

// testing new subject card for admin. load Times and Views
  if (this.sessionBrandTypeId === '1') { // admin actually edits + staff
   if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs/j' + subject_id + ''], { skipLocationChange: true })
   .then(() => this.router.navigate(['/staff/jobs/subject/edit/dashboard/' + subject_id + ''])
   );}
    if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs/j' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/admin/jobs/subject/edit/dashboard/' + subject_id + ''])
    );}
   
  }
}







// links ot agent invoices page.
  globalJobSubjectBillingView(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/subject/billing/' + subject_id]);
    }
    if (this.sessionBrandTypeId === '3') { // agent
    this.router.navigate(['/agent/jobs/subject/billing/' + subject_id]);
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/subject/billing/' + subject_id]);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/jobs/subject/billing/' + subject_id]);}
      
    };

  };


  globalJobSubjectBillingViewSkipRoute(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/client/jobs/subject/billing/' + subject_id + ''])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/agent/jobs/subject/billing/' + subject_id + ''])
      );
    }
    if (this.sessionBrandTypeId === '1') { // admin actually edits
    if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/staff/jobs/subject/billing/' + subject_id + '']));}
    if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/jobs' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));}
    }
  }


// link to subject agent supplier inoices bills page
globalJobSubjectCostView(subject_id) {
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/client/jobs/subject/cost/' + subject_id]);
  }
  if (this.sessionBrandTypeId === '3') { // agent
  this.router.navigate(['/agent/jobs/subject/cost/' + subject_id]);
  };
  if (this.sessionBrandTypeId === '1') { // admin + staff
      if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs/subject/cost/' + subject_id]);}
      if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs/subject/cost/' + subject_id]);}
  };

};


globalJobSubjectCostViewSkipRoute(subject_id) {
  if (this.sessionBrandTypeId === '2') { // client
    // :: New Way
    this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/client/jobs/subject/cost/' + subject_id + ''])
      );
  }
  if (this.sessionBrandTypeId === '3') { // agent
    this.router.navigate(['/agent/jobs/j' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/agent/jobs/subject/cost/' + subject_id + ''])
    );
  }
  if (this.sessionBrandTypeId === '1') { // admin actually edits + staff
      if(this.sessionUserLevel >= 3){    this.router.navigate(['/staff' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/jobs/subject/cost/' + subject_id + '']));}
      if(this.sessionUserLevel <= 2){    this.router.navigate(['/admin' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']));}
  }
}




  globalAccountsClientInvoiceBulkPaymentViewSkipRoute(brand_to_id) {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/admin/accounting/payments-bulk'])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/client/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/admin/accounting/payments-bulk'])
        );
    }
    if (this.sessionBrandTypeId === '1') { // admin actually edits
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/accounting/payments-bulk']));}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/client/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/accounting/payments-bulk']));}
    }
  }



  globalAccountsAgentInvoiceBulkPaymentViewSkipRoute(brand_to_id) {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/admin/accounting/agent/paymentbulk'])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/client/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/admin/accounting/agent/paymentbulk'])
        );
    }
    if (this.sessionBrandTypeId === '1') { // admin actually edits
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/accounting/agent/paymentbulk']));}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/client/jobs/j' + brand_to_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/accounting/agent/paymentbulk']));}
    }
  }



  globalJobSubjectCommunicationViewSkipRoute(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() =>
      this.router.navigate(['/client/jobs/subject/communication/' + subject_id])
      );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() =>
    this.router.navigate(['/agent/jobs/subject/communication/' + subject_id])
    );
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
      if(this.sessionUserLevel >= 3){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
     .then(() => this.router.navigate(['/staff/jobs/subject/communication/' + subject_id]));}

      if(this.sessionUserLevel <= 2){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/communication/' + subject_id]));}
    };
  }



  globalJobSubjectCommunicationWithVarsViewSkipRoute(subject_id) {
        // if (this.sessionBrandTypeId === '2') { // client
        //   this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
        //   .then(() =>
        //   this.router.navigate(['/client/jobs/subject/communication/' + subject_id])
        //   );
        // }
        // if (this.sessionBrandTypeId === '3') { // agent
        //   this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
        //   .then(() =>
        // this.router.navigate(['/agent/jobs/subject/communication/' + subject_id])
        // );
        // };
    if (this.sessionBrandTypeId === '1') { // admin + staff
      if(this.sessionUserLevel >= 3){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
     .then(() => this.router.navigate(['/staff/jobs/subject/communication-with-vars/' + subject_id]));}

      if(this.sessionUserLevel <= 2){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/communication-with-vars/' + subject_id]));}
    };
  }


  globalJobSubjectDocumentsViewSkipRoute(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() =>
      this.router.navigate(['/client/jobs/subject/documents/' + subject_id])
      );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() =>
    this.router.navigate(['/agent/jobs/subject/documents/' + subject_id])
      );
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
      if(this.sessionUserLevel >= 3){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/jobs/subject/documents/' + subject_id]));}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/documents/' + subject_id]));}
    };
  }


  globalJobSubjectNotesViewSkipRoute(subject_id) {
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() =>
      this.router.navigate(['/client/jobs/subject/notes/' + subject_id])
      );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() =>
    this.router.navigate(['/agent/jobs/subject/notes/' + subject_id])
      );
    };
    if (this.sessionBrandTypeId === '1') { // admin + staff
      if(this.sessionUserLevel >= 3){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/jobs/subject/notes/' + subject_id]));}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/subject/notes/' + subject_id]));}
    };
  }



  globalRouteViewSkipRoute(routerLink) {
    this.router.navigate(['/client/jobs/j' + '' + ''], { skipLocationChange: true })
      .then(() =>
      this.router.navigate([routerLink])
      );
  }


  // :: jobs (adding staff validations for routes 2020)


  globalJobsView() {
    if (this.sessionBrandTypeId === '1') { // owner
      if(this.sessionUserLevel >= 3){
        this.router.navigate(['/staff/jobs/home']);
      }
      if(this.sessionUserLevel <= 2){
        this.router.navigate(['/admin/jobs/home']);
      }

    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/my-jobs']);
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs']);
    };
  };


  globalJobView(job_id) {
    // may need to introduce a sysetm based on session Login; Admin can 
    // only be accesses by a user assiciated with the owner
    if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
      if(this.sessionUserLevel >= 3){
        this.router.navigate(['/staff/jobs/view/' + job_id]);
      };
      if(this.sessionUserLevel <= 2){
        this.router.navigate(['/admin/jobs/view/' + job_id]);
      };
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/view-job/' + job_id]);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
      this.router.navigate(['/agent/jobs/view-job/' + job_id]);
    };

  };

  globalJobViewSkipRoute(job_id) {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way
      this.router.navigate(['/client/jobs/j' + job_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/client/jobs/view-job/' + job_id + ''])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs/j' + job_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/agent/jobs/view-job/' + job_id + ''])
      );
    }
    if (this.sessionBrandTypeId === '1') { // admin and staff + Manager
      // if(this.sessionUserLevel >= 3){}
      // if(this.sessionUserLevel <= 2){}
      if(this.sessionUserLevel >= 3) {
        this.router.navigate(['/staff/jobs/j' + job_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/staff/jobs/view/' + job_id + ''])
        );
      }
      if(this.sessionUserLevel <= 2) {
        this.router.navigate(['/client/jobs/j' + job_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/admin/jobs/view/' + job_id + ''])
        );
      }

    }
  }

  globalJobEditStep3(job_id) {
    // only be accesses by a user assiciated with the owner
    if (this.sessionBrandTypeId === '1') { // admin / owner
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/create-job-3/' + job_id]);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/jobs/create-job-3/' + job_id]);}
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/create-job-wizard-step-3/' + job_id]);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
    };

  };


  globalJobEditStep2(job_id) {
    // only be accesses by a user assiciated with the owner
    if (this.sessionBrandTypeId === '1') { // admin / owner
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/create-job-2/' + job_id]);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/jobs/create-job-2/' + job_id]);}
    };
    if (this.sessionBrandTypeId === '2') { // client
      // this.router.navigate(['/client/jobs/create-job-step-3/' + job_id]);
      this.router.navigate(['/client/jobs/create-job-2/' + job_id]);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
    };

  };







  globalJobEdit(job_id) {
    // only be accesses by a user assiciated with the owner
    if (this.sessionBrandTypeId === '1') { // admin / owner / staff / manager
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/jobs/edit/' + job_id + '']);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/jobs/edit/' + job_id + '']);}
    };
    if (this.sessionBrandTypeId === '2') { // client
     // this.router.navigate(['/client/jobs/create-job-step-3/' + job_id]);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
     
    };

  };


  globalJobEditStep3SkipRoute(job_id) {
    // only be accesses by a user assiciated with the owner
    if (this.sessionBrandTypeId === '1') { // admin / owner / staff / manger
      if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs/j' + job_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/jobs/create-job-3/' + job_id + ''])
      );}
      if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs/j' + job_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/create-job-3/' + job_id + ''])
      );}
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/j' + job_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/client/jobs/create-job-wizard-step-3/' + job_id + '']) // new page April 30 2023
        // .then(() => this.router.navigate(['/client/jobs/create-job-step-3/' + job_id + ''])
        );
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
    };

  };


    globalJobEditStep2SkipRoute(job_id) {
    // only be accesses by a user assiciated with the owner
    if (this.sessionBrandTypeId === '1') { // admin / owner / staff / manger
      if(this.sessionUserLevel >= 3){ this.router.navigate(['/staff/jobs/j' + job_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/jobs/create-job-2/' + job_id + ''])
      );}
      if(this.sessionUserLevel <= 2){ this.router.navigate(['/admin/jobs/j' + job_id + ''], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/jobs/create-job-2/' + job_id + ''])
      );}
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/jobs/j' + job_id + ''], { skipLocationChange: true })
        .then(() => this.router.navigate(['/client/jobs/create-job-wizard-step-2/' + job_id + '']) // new page April 30 2023
        // .then(() => this.router.navigate(['/client/jobs/create-job-step-3/' + job_id + ''])
        );
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
    };

  };





// fixed for staff accounting.
  globalMyobLoginSkipRoute() {
    if (this.sessionBrandTypeId === '2') { // client
      // :: New Way


      this.router.navigate(['/client/jobs/j'], { skipLocationChange: true })
        .then(() => this.router.navigate(['admin/accounting/myob-login'])
        );
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['admin/accounting/myob-login'])
      );
    }
    if (this.sessionBrandTypeId === '1') { // admin

  
      if(this.sessionUserLevel >= 3){
        // this.router.navigate(['/staff/accounting/myob-login' ]);
           this.router.navigate(['/staff/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['staff/accounting/myob-login'])
      );
      }

      if(this.sessionUserLevel <= 2){
        // this.router.navigate(['admin/accounting/myob-login' ]);
         this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['admin/accounting/myob-login'])
      );
      }
   
    };
  }


  globalLostPasswordView() {
      this.router.navigate(['/lost-password']);
  }


  globalBrandView(brand_id) {
    if (this.sessionBrandTypeId === '1') { // admin / owner
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/brands/company/view/' + brand_id + '']);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);}
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/profile/' + brand_id + '']);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
      this.router.navigate(['/agent/profile/' + brand_id + '']);
    };
  }



  globalBrandViewSkipRoute(brand_id) {

    if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
      if(this.sessionUserLevel >= 3){
        this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
        .then(() => this.router.navigate(['/staff/brands/company/view/' + brand_id + '']));
      
      };
      if(this.sessionUserLevel <= 2){
        this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
        .then(() => this.router.navigate(['/admin/brands/company/view/' + brand_id + '']));
      };
      
    };
    if (this.sessionBrandTypeId === '2') {  // admin and staff + Manager
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/client/profile/' + brand_id + '']));
    }

    if (this.sessionBrandTypeId === '3') {  // admin and staff + Manager
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/agent/profile/' + brand_id + '']));
    }



  }
  

  // viewBrandUsers(brand_id){
  //    this.router.navigate(['../brand-user-manager', brand_id], { relativeTo: this.route });
  //    if (this.sessionBrandTypeId === '1') { // admin / owner
  //     if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/brands/company/view/' + brand_id + '']);}
  //     if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);}
  //   };
  //   if (this.sessionBrandTypeId === '2') { // client
  //     this.router.navigate(['/client/profile/' + brand_id + '']);
  //   }
  //   // an agent wil only have jobs allocated to them via the system owner brand
  //   if (this.sessionBrandTypeId === '3') { // agent
  //     // not yet built
  //   };
  // }  



  globalbrandEdit(brand_id) {
    if (this.sessionBrandTypeId === '1') { // admin / owner
      if(this.sessionUserLevel >= 3){this.router.navigate(['/staff/brands/company/edit/' + brand_id + '']);}
      if(this.sessionUserLevel <= 2){this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);}
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/profile/edit/' + brand_id + '']);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      // not yet built
      this.router.navigate(['/agent/profile/edit/' + brand_id + '']);
    };

  }

  globalUserView(user_id) {
    if (this.sessionBrandTypeId === '1') { // admin / owner
      if(this.sessionUserLevel >= 3){
        this.router.navigate(['/staff/brands/users/view/' + user_id]);
      };
      if(this.sessionUserLevel <= 2){
        this.router.navigate(['/admin/brands/users/view/' + user_id]);
      };
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/user/profile/' + user_id + '']);
    }
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/user/profile/' + user_id + '']);
    };

  }

  globalUserEdit(user_id) {
    if (this.sessionBrandTypeId === '1') { // admin / owner
      if(this.sessionUserLevel >= 3){
        this.router.navigate(['/staff/brands/users/edit/' + user_id + '']);
      };
      if(this.sessionUserLevel <= 2){
        this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
      };
    };
    if (this.sessionBrandTypeId === '2') { // client
      this.router.navigate(['/client/user/profile/edit/' + user_id + '']);
    }
    // an agent wil only have jobs allocated to them via the system owner brand
    if (this.sessionBrandTypeId === '3') { // agent
      this.router.navigate(['/agent/user/profile/edit/' + user_id + '']);
    };
  }


//...files

globalViewSystemFile(file_id){
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/staff/system-file-manager/system-file/' + file_id + '']);
    };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/client/system-file-manager/system-file/' + file_id + '']);
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    this.router.navigate(['/agent/system-file-manager/system-file/' + file_id + '']);
  };
}


globalEditSystemFile(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/staff/system-file-manager/system-file-edit/' + file_id + '']);
    };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    // this.router.navigate(['/client/system-file-manager/system-file-edit/' + file_id + '']);
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    // this.router.navigate(['/agent/system-file-manager/system-file-edit/' + file_id + '']);
  };

}


globalEditSystemFileSkipRoute(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/system-file-manager/system-file-edit/' + file_id + '']));
    
    };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']));
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    // this.router.navigate(['/client/system-file-manager/system-file-edit/' + file_id + '']);
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    // this.router.navigate(['/agent/system-file-manager/system-file-edit/' + file_id + '']);
  };

}

globalEditDocFile(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/staff/system-file-manager/system-doc-edit/' + file_id + '']);
    };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/client/system-file-manager/system-doc-edit/' + file_id + '']);
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    this.router.navigate(['/agent/system-file-manager/system-doc-edit/' + file_id + '']);
  };
}



globalViewDocxSystemFile(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/staff/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
    };
    if(this.sessionUserLevel <= 2) {
      this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/client/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    this.router.navigate(['/agent/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  };
}



globalViewDocxSystemFileSkipRoute(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/system-file-manager/system-doc-edit/docx-view/' + file_id + '']));
    };
    if(this.sessionUserLevel <= 2) {
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']));
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['/client/system-file-manager/system-doc-edit/docx-view/' + file_id + '']));
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['/agent/system-file-manager/system-doc-edit/docx-view/' + file_id + '']));
  };
}


globalEditDocxSystemFile(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['/staff/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']));
    };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() =>  this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']));
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['/client/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']));
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['/agent/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']));
  };
}


globalEditDocxSystemFileSkipRoute(file_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    if(this.sessionUserLevel >= 3){
      this.router.navigate(['/staff/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
    };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
    };
  };
  if (this.sessionBrandTypeId === '2') { // client
    this.router.navigate(['/client/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  }
  // an agent wil only have jobs allocated to them via the system owner brand
  if (this.sessionBrandTypeId === '3') { // agent
    // not yet built
    this.router.navigate(['/agent/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  };
}




globalSystemThemeFileManager() {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    // if(this.sessionUserLevel >= 3){
    //   this.router.navigate(['/staff/system-theme-file-manager']);
    // };
    if(this.sessionUserLevel <= 2){
      this.router.navigate(['/admin/system-theme-file-manager']);
    };
  };
      // if (this.sessionBrandTypeId === '2') { // client
      //   this.router.navigate(['/client/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
      // }
      // // an agent wil only have jobs allocated to them via the system owner brand
      // if (this.sessionBrandTypeId === '3') { // agent
      //   // not yet built
      //   this.router.navigate(['/agent/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
      // };
}


globalSystemThemeFileManageSkipRoute() {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    // if(this.sessionUserLevel >= 3){
    //   this.router.navigate(['/staff/system-theme-file-manager']);
    // };
    if (this.sessionUserLevel <= 2) {
      // this.router.navigate(['/admin/system-theme-file-manager']);
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['admin/system-theme-file-manager']));

    };
  };
}

// shows template gird
globalSystemSubjectTemplateDocsSkipRoute(subject_com_type_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    // if(this.sessionUserLevel >= 3){
    //   this.router.navigate(['/staff/system-theme-file-manager']);
    // };
    if (this.sessionUserLevel <= 2) {
      // this.router.navigate(['/admin/system-theme-file-manager']);
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['admin/communication/com_type_view/' + subject_com_type_id]));

    };
  };
}




// shows template gird
globalSystemSubjectTemplateDocViewSkipRoute(doc_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    // if(this.sessionUserLevel >= 3){
    //   this.router.navigate(['/staff/system-theme-file-manager']);
    // };
    if (this.sessionUserLevel <= 2) {
      // this.router.navigate(['/admin/system-theme-file-manager']);
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['admin/communication/com_type_template_doc_view/' + doc_id]));

    };
  };
}

// shows template gird
globalSystemSubjectTemplateDocUpdateSkipRoute(doc_id) {
  if (this.sessionBrandTypeId === '1') {  // admin and staff + Manager
    // if(this.sessionUserLevel >= 3){
    //   this.router.navigate(['/staff/system-theme-file-manager']);
    // };
    if (this.sessionUserLevel <= 2) {
      // this.router.navigate(['/admin/system-theme-file-manager']);
      this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
      .then(() => this.router.navigate(['admin/communication/com_type_template_doc_edit/' + doc_id]));

    };
  };
}


// Update May 20 2023
public globalppsViewActionListSkipRoute(id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-investigation/system-action-list/' + id]));
}

public globalppsViewActionListsSkipRoute(id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-investigation/system-action-lists']));
}




public globalViewSystemReportAgentMatricsSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-reports/agent-performance-metrics']));
}




// Logs
public globalViewSystemLogSkipRoute(log_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-reports/system-log/' + log_id]));
}


// data sectpr types
public globalViewSystemLogTypeDataSectorTypeUpdateSkipRoute(log_type_data_sector_type_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/system-log-type-data-sector-types/update/' + log_type_data_sector_type_id]));
}
public globalViewSystemLogTypeDataSectorTypeSkipRoute(log_type_data_sector_type_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/system-log-type-data-sector-types/' + log_type_data_sector_type_id]));
}

public globalViewSystemLogTypeDataSectorTypesSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/system-log-type-data-sector-types/view']));
}


// Log Types Edit
public globalViewSystemLogTypeEditSkipRoute(log_type_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-types/edit/' + log_type_id]));
}

public globalViewSystemLogTypeDataSectorConditionUpdateSkipRoute(log_type_data_sector_condition_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions/update/' + log_type_data_sector_condition_id]));
}


public globalViewSystemLogTypeDataSectorConditionSkipRoute(log_type_data_sector_condition_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions/' + log_type_data_sector_condition_id]));
}


public globalViewSystemLogTypeDataSectorUpdateSkipRoute(log_type_data_sector_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/update/' + log_type_data_sector_id]));
}


public globalViewSubjectServiceOutcomeTemplateUpdateSkipRoute(ssot_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/service-outcome-templates/update/' + ssot_id]));
}

public globalSubjectUrgentOutcomeTemplateUpdateSkipRoute(suot_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/subject-urgent-outcome-templates/update/' + suot_id]));
}

public globalViewSystemLogTypesSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-types/view']));
}


public globalViewSystemLogTypeSkipRoute(log_type_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-types/' + log_type_id]));
}

public globalViewSystemLogTypeDataSectorSkipRoute(log_type_data_sector_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/' + log_type_data_sector_id]));
}


public globalViewSubjectServiceOutcomeTemplatekipRoute(ssot_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  // .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/' + log_type_data_sector_id]));
  .then(() => this.router.navigate(['admin/system-automations/service-outcome-templates/' + ssot_id]));
}

public globalViewSubjectUrgentOutcomeTemplatekipRoute(suot_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  // .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/' + log_type_data_sector_id]));
  .then(() => this.router.navigate(['admin/system-automations/subject-urgent-outcome-templates/' + suot_id]));
}


public globalViewSystemLogTypeDataSectorConditionsSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/system-log-type-data-sector-conditions/view']));
}


public globalViewSystemLogTypeDataSectorsSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/system-log-type-data-sectors/view']));
}




public globalViewSubjectServiceOutcomeTemplatesSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/service-outcome-templates']));
}


public globalViewSubjectUrgentOutcomeTemplatesSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/subject-urgent-outcome-templates/view']));
}



public globalSystemAutomationsSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/view']));
}

public globalSystemAutomationCreateSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/create']));
}


public globalSystemAutomationUpdateSkipRoute(system_automation_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/update/' + system_automation_id]));
}

public globalSystemAutomationViewSkipRoute(system_automation_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-automations/view/' + system_automation_id]));
}






public globalppsDistroHubVariableCodeBlocksSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/ppsdistrohub/dashboard'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-variables/variable-code-blocks/home']));
}

public globalppsDistroHubVariableCodeBlockCreateSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/ppsdistrohub/dashboard'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-variables/variable-code-blocks/create']));
}


public globalppsDistroHubVariableCodeBlockUpdateSkipRoute(variable_block_code_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);

  // this.router.navigate(['/ppsdistrohub/dashboard/j'], { skipLocationChange: true })
  // .then(() => this.router.navigate(['ppsdistrohub/variable-code-blocks/update/' + variable_block_code_id]));


  this.router.navigate(['admin/system-variables/variable-code-blocks/update/' + variable_block_code_id + '']);
}








  // :: END GLOBAL ROUTER


// :: Global Document Viewer FUnctions



// :: end Document Viewer




  // :: Global Hide Columns in Sync Grid Functions
  // :: returns false - to hide the column 'false' on the [visablitity]= 'gfunc.gridHideColByBrandType();'
  // :: this hides the column for display or shows.

  // :: Use to either hide a colum.

  gridHideColByBrandType(owner, agent, client) // true or false. values
  {
    if (this.sessionBrandTypeId === '2') { // client
      return client;
    }
    // an agent 
    if (this.sessionBrandTypeId === '3') { // agent
      return agent;
    };
    if (this.sessionBrandTypeId === '1') { // admin / owner
      return owner;
    };
  };




  // :: GLOBAL FORMS


  // run function to make form to be required // true or false
  formValidateCell(owner, agent, client) {
    if (this.sessionBrandTypeId === '2') { // client
      return client;
    }
    // an agent 
    if (this.sessionBrandTypeId === '3') { // agent
      return agent;
    };
    if (this.sessionBrandTypeId === '1') { // admin / owner
      return owner;
    };
  };


  // run function to make form to be required // true or false
  formDisableCell(owner, agent, client) {
    if (this.sessionBrandTypeId === '2') { // client
      return client;
    }
    // an agent 
    if (this.sessionBrandTypeId === '3') { // agent
      return agent;
    };
    if (this.sessionBrandTypeId === '1') { // admin / owner
      return owner;
    };
  };






// GLOBAL Calculations

  // roundTo(123.456, 2);  // 123.46
  roundTo(num: number, places: number) {
    // let factor = 10 ** places;
    // return Math.round(num * factor) / factor;
    return num.toFixed(places);
  };

// ::@https://bobbyhadz.com/blog/javascript-convert-milliseconds-to-hours-and-minutes
  padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  
  convertMsToHM(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
  
    seconds = seconds % 60;
    // ðŸ‘‡ï¸ if seconds are greater than 30, round minutes up (optional)
    minutes = seconds >= 30 ? minutes + 1 : minutes;
  
    minutes = minutes % 60;
  
    // ðŸ‘‡ï¸ If you don't want to roll hours over, e.g. 24 to 00
    // ðŸ‘‡ï¸ comment (or remove) the line below
    // commenting next line gets you `24:00:00` instead of `00:00:00`
    // or `36:15:31` instead of `12:15:31`, etc.
   // hours = hours % 24;
  console.log(`${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}`);
  // changed to dot to come as a percentage to load in graphs?

  // added additional check so that nulls and NaN's are not returned
  if (minutes > 0) {
    return `${this.padTo2Digits(hours)}.${this.padTo2Digits(minutes)}`;
  }else {
    return null;
  }
  }
	  

// ::@https://stackoverflow.com/questions/8528382/javascript-show-milliseconds-as-dayshoursmins-without-seconds
dhm (ms) {
  const days = Math.floor(ms / (24*60*60*1000));
  const daysms = ms % (24*60*60*1000);
  const hours = Math.floor(daysms / (60*60*1000));
  const hoursms = ms % (60*60*1000);
  const minutes = Math.floor(hoursms / (60*1000));
  const minutesms = ms % (60*1000);
  const sec = Math.floor(minutesms / 1000);
//  let days_words;
//  let hours_words;
//  let minutes_words;
//  let sec_words;
//   if (days) {  days_words = days + " DAYS, "; };
//   if (hours) {  hours_words = hours + " HOURS, "; };
//   if (minutes) {  minutes_words = minutes + " MINS, "; };
//   if (sec) {  sec_words = sec + " SECS."; };
  return days + " DAYS : " + hours + " HRS : " + minutes + " MINS : " + sec +" SECS";
  // return days_words  + hours_words + minutes_words + sec_words;



}





deleteSubjectNote(note_id) {
  if (confirm('Are you sure you want to delete this note? ')) {
    this._demoService.deleteSubjectNote(note_id).subscribe(
       data => {
       // this.refreshGrid();
       },
       error => {
         console.error('Error deleting Trace Candidate Note!');
        return console.log(error);
       }
    );
  }   
}

deleteSystemNote(note_id, assinged_from_note_id) {
  if (confirm('Are you sure you want to delete this note? ')) {
    this._demoService.deleteSystemNote(note_id, assinged_from_note_id).subscribe(
       data => {
       // this.refreshGrid();
       },
       error => {
         console.error('Error deleting Trace Candidate Note!');
        return console.log(error);
       }
    );
  }   
}





// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allRecipients = this.allRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
      //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



// copy to clipbard button
// ::@ https://stackoverflow.com/questions/49102724/angular-5-copy-to-clipboard
copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.toastr.success(val + '');
}






getTimezoneName() {
  const today = new Date();
  const short = today.toLocaleDateString(undefined);
  const full = today.toLocaleDateString(undefined, { timeZoneName: 'short' });

  // Trying to remove date from the string in a locale-agnostic way
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
    
    // by this time `trimmed` should be the timezone's name with some punctuation -
    // trim it from both sides
    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');

  } else {
    // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
    return full;
  }
}




public globalppsDistroHubAppRoutesSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-routes/app-routes']));
}
public globalppsDistroHubAppRouteCreateSkipRoute() {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-routes/app-routes/create']));
}

public globalppsDistroHubAppRouteUpdateSkipRoute(app_route_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);

  // this.router.navigate(['/ppsdistrohub/dashboard/j'], { skipLocationChange: true })
  // .then(() => this.router.navigate(['ppsdistrohub/variable-code-blocks/update/' + variable_block_code_id]));

  if(this.sessionUserLevel >= 999){
    // this.router.navigate(['/ppsdistrohub/dashboard'], { skipLocationChange: true })
    // .then(() => this.router.navigate(['ppsdistrohub/app-routes/update/' + app_route_id + '']));
  };
  if(this.sessionUserLevel <= 2){
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-routes/app-routes/update/' + app_route_id + '']));
  };

}
 


public globalProjectViewSkipRoute(project_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['/admin/projects/project/' + project_id]));
}

public globalViewAppRouteSkipRoute(app_route_id) {
  // this.router.navigate(['/admin/system-theme-file-manager']);
  this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
  .then(() => this.router.navigate(['admin/system-routes/app-routes/view/' + app_route_id]));
}


makeDuplicateAppRoute(mode__ppl){
  if (confirm('We are about duplicate this item, Are you Sure?')) {
  // post a new With this model. & Name as copuy
  mode__ppl.app_route_name =  mode__ppl.app_route_name + '_COPY'
  if (mode__ppl.app_route_description != null){mode__ppl.app_route_description = '_COPY **** of **** ' + mode__ppl.app_route_description}
  if (mode__ppl.app_route_notes != null){mode__ppl.app_route_notes = '_COPY **** of **** ' + mode__ppl.app_route_notes}
  if (mode__ppl.app_route_as_actual_NAME != null){mode__ppl.app_route_as_actual_NAME = mode__ppl.app_route_as_actual_NAME + '_COPY'}
  if (mode__ppl.app_route_as_variable != null){ mode__ppl.app_route_as_variable = mode__ppl.app_route_as_variable + '_COPY'}
  if (mode__ppl.app_route_as_variable_NAME != null){mode__ppl.app_route_as_variable_NAME = mode__ppl.app_route_as_variable_NAME + '_COPY'}
  if (mode__ppl.routerLink != null){mode__ppl.routerLink = '_COPY **** of **** ' + mode__ppl.routerLink}
  if (mode__ppl.routerLinkGeneral != null){mode__ppl.routerLinkGeneral = '_COPY **** of **** ' + mode__ppl.routerLinkGeneral}
  if (mode__ppl.help_content != null){mode__ppl.help_content = '_COPY **** of **** ' + mode__ppl.help_content}
  if (mode__ppl.help_content_HTML != null){mode__ppl.help_content_HTML = '_COPY **** of **** ' + mode__ppl.help_content_HTML}
  if (mode__ppl.video_content != null){mode__ppl.video_content = '_COPY **** of **** ' + mode__ppl.video_content}
  if (mode__ppl.guided_tour_content != null){mode__ppl.guided_tour_content = '_COPY **** of **** ' + mode__ppl.guided_tour_content}

  // model.is_active = '';
  this.createAppRoute(mode__ppl);
  // this.refreshGrid();
  }
}


createAppRoute(mode__ppl) {
  // console.log(mode__ppl);
    this._demoService.createAppRoute(mode__ppl).subscribe(
          data => {  this.get_latest_app_route_id = data; // this is the retuned json upon creation.

          this.toastr.success('App Route Added!');
           
  /*
          // tslint:disable-next-line:max-line-length
          this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
          this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
  */
          // this.closeParentModel.emit();
        //   CreateJobTypeComponent.returned.next(false);
            //  return true;
          },
          error => {
            this.toastr.error('Adding App Route Failed :: Please try again!');
            // console.log(Observable.throw(error));
            // return Observable.throw(error);
          console.error(error);
          }
    );
    }








  // :: GLOBAL ROUTER FUNCTIONS

  // :: Projects

  globalProjectEdit(project_id) {
    this.router.navigate(['/admin/projects/projects-edit/' + project_id]);
  }

  globalProjectView(project_id) {
    this.router.navigate(['/admin/projects/project/' + project_id]);
  }



  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }








// QuickVariable Functions
  

  
     
getSubjectServiceType_Q(subject_service_type_id) {
  this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
     data => { 
      // this.subject_service_type = data;
      let res = data[0]
      this.subject_service_type = DataUtil.parse.parseJson(res);
   


      
      // return res.subject_service_type_name
      // if ( subject_service_type_id <= 0 ){
      //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
      //   this.selected_subject_service_type_description = '';
      //   this.selected_subject_service_type_instructions = '';
      //   this.selected_subject_service_type_staff_instructions = '';

      // } else{
      // this.selected_subject_service_type_description = res.subject_service_type_description;
      // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
      // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
      // }

      // // initiate the change of service rule if different or select from drop down.
      // if (subject_service_type_id > 1) {
      // this.setJobServiceRule(res.job_service_rule_id_change_to);
      // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
      // }

    },
     err => console.log(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobServiceRule_Q(job_service_rule_id) {
  this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
     data => { this.job_service_rule_paragraphs = data; 
      let res = data[0];
      if (job_service_rule_id <= 0 ){
        this.selected_job_service_rule_description = 'Not Applicable';
      };
      if (job_service_rule_id >= 1 ){
      this.selected_job_service_rule_description = res.job_service_rule_description;
      }
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getSubjectServiceOutcome_Q(subject_service_outcome_id) {
  this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subjectServiceOutcome = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }

  
 getSubjectLocationStatus_Q(subject_location_status_id) {
  this._demoService.getSubjectLocationStatus(subject_location_status_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subjectLocationStatus = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }


  getSubjectLocationStatusFound_Q(subject_location_status_found_id) {
    this._demoService.getSubjectLocationStatusFound(subject_location_status_found_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectLocationStatusFound = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }


  getSubjectExactServiceMethod_Q(exact_service_method_id) {
    this._demoService.getExactServiceMethod(exact_service_method_id).subscribe(
      data => { 
        // this.subjectAttemptType = data;
      let res = data[0]
      this.subjectExactServiceMethod = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }
  



 getSubjectAttemptType_Q(subject_service_type_id) {
  this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
    data => { 
      // this.subjectAttemptType = data;
    let res = data[0]
    this.subject_attempt_type = DataUtil.parse.parseJson(res);
    },
    err => console.error(err),
  );
  }

  getSubjectRelationship_Q(subject_relationship_id) {
    this._demoService.getSubjectRelationship(subject_relationship_id).subscribe(
      data => { 
        let res = data[0]
        this.serviceFellowRelationship = data;
        this.subject_service_fellow_relationship = DataUtil.parse.parseJson(res);
      },
      err => console.error(err),
    );
    }


    // Look up Subject Service Agent
 getBrand_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          // this.subject_service_agent = DataUtil.parse.parseJson(res);
          this.subject_service_agent = res;
          // this.allClientEmailRecipients = data;
  
this.toastr.success('Subject Service Agent Details Q')

          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand Loaded.')
      );
    }

    getBrand_report_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.job_report_client = DataUtil.parse.parseJson(data);
          // this.allClientEmailRecipients = data;
  
          // let newArr = data
          // let  count_of_items = Object.keys(newArr).length;
          //   // need to do a loop of subject_billing items (.length)
          //   for (let i = 0; i < count_of_items; i++) {
          //   let res = newArr[i];
          //   this.allRecipients.push({
          //     recipient_name: res.name + ' - Client Report',
          //     recipient_email_address: res.email,
          //     recipient_brand_id: res.brand_id,
          //     recipient_brand_type_id: res.brand_type_id,
          //     recipient_user_id: null,
          //     recipient_user_level_id: null,
          //     recipient_type_name: 'Client Report',
          //   });
          //   } // end for loop
          // this.allRecipients = this.allRecipients; // ?? this may be causing errors.
  
        },
        (err) => console.error(err),
        () => console.log('Brand report Client Loaded.')
      );
    }




    getBrand_invoice_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          // this.job_invoice_client_paragraphs = DataUtil.parse.parseJson(data);
          this.job_invoice_client_paragraphs = data;
  
        },
        (err) => console.error(err),
        () => console.log('Brand Invoice Loaded.')
      );
    }

    getBrand_owner_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.job_owner_client_paragraphs = DataUtil.parse.parseJson(data);
  
        },
        (err) => console.error(err),
        () => console.log('Brand Owner Loaded.')
      );
    }


    getUserBrand_Q(brand_id) {
      this._demoService.getBrandById(brand_id).subscribe(
        (data) => {
          // this.brand_data = data;
  
          let res = data[0];
          this.user_brand_paragraphs = DataUtil.parse.parseJson(data);
  
        },
        (err) => console.error(err),
        () => console.log('Brand Owner Loaded.')
      );
    }

    getServiceMethod_Q(subject_service_method_id) {
      this._demoService.getServiceMethod(subject_service_method_id).subscribe(
        data => { 
          let res = data[0]
          this.serviceMethod = data;
          this.subject_service_method = DataUtil.parse.parseJson(res);
        },
        err => console.error(err),
      );
      }



// Subject Type Name Lookup
getJobSubjectType_Q(job_subject_type_id) {
this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
   data => { 
    let res = data[0]
    this.job_subject_type = data;
    this.subject_job_subject_type = DataUtil.parse.parseJson(res);

  
  },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}



    //   // get job and brands for paragraph - job Details.
    //   getJob_and_brands_Q(job_id, model) {
    //     this._demoService.getJobID(job_id).subscribe(
    //       (data) => {
    //         // this.job_data = data;
    //         let res = data[0];
    //         this.job_data_paragraphs = DataUtil.parse.parseJson(res);
    //         // this.job_data_paragraphs = data;


    // //
    //   // Need to load the drop downs (only if a process is selected.)

    //                           // this.getJobType_Q(res.job_type_id)

    //                           // this.getJobTypeLocation_Q(res.job_type_location_id); // 
    //                           // this.getJobTypeCourt_Q(res.job_type_court_id);       // 

    //                           // this.getJobTypeDocumentType_Q(res.job_type_document_type_id)
    //                           // this.getJobTypeAffidavitType_Q(res.job_type_affidavit_type_id);
                              
    //                           // this.getBrand_invoice_Q(res.brand_id) 
    //                           // this.getBrand_owner_Q('94'); // sharmans id in the database as the app owner SO.
    //                           // this.getJobReportUserContact_Q(res.brand_report_user_id)

    //                           // this.getCurrentUser_Q(this.gfunc.sessionUserId);
                              
    //                           //   // Get Subject Agent - F_agent
    //                           //   this.getSubjectAgentBrandsAssigned_Q(this.subject_id) // get the first agent ID.????
    //                           //   this.getJobServiceRule_Q(model.job_service_rule_id) //? -- from the send comms model
    //                           //   this.getJobServiceTimeframe_Q(model.job_service_timeframe_id)
    //                           //   this.getSubjectServiceType_model_Q(model.subject_service_type_id);

    //                           //   this.getSubjectContactNumbers_Q(model.subject_id)
    //                           //   this.getSubjectContactEmails_Q(model.subject_id)



    //       // this.getJobTypeDocumentTypes(res.job_type_court_id);
    //       // this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
    //       // // need to load client contact
    //       // this.getClientContactsSharmans_Q(res.client_id);
          
    //       // this.getBrandUsers(res.brand_report_id);


    //         this.toastr.success('Job Data Loaded For Vars')

    //         // lookup the brand to get the contact details to send to
    //             // this.recipient_brand_id = res.brand_report_id;
    //             // this.recipient_report_id = res.brand_report_id;
    //             // this.accounts_brand_id = res.brand_invoice_id;
    //             // this.getBrand(res.brand_report_id);
    //             // this.getBrandAccount(res.brand_invoice_id);
    //             // this.getBrandUsers(res.brand_report_id);
    //             // this.getBrandPrimaryContact(this.recipient_report_id);
    //             // this.getJobReportUserContact(res.brand_report_user_id);

    //             // this.brand_report_id = res.brand_report_id;
    //             // this.brand_invoice_id = res.brand_invoice_id;
    //             // this.brand_report_user_id = res.brand_report_user_id;

    //             // this.client_reference = res.owner_trace_code;

    //         // this.next_date = res.next_date;
    //         // this.final_date = res.final_date;
    //         // this.job_stati

    //         //this.model.brand_id = this.recipient_brand_id;
    //         ///console.log('check brand' + this.recipient_brand_id);
    //       },
    //       (err) => {
    //         this.toastr.error('Job Data NOT Loaded For Vars')
    
    //       }
    //       // () => console.log('done loading Trace Types')
    //     );
    //   }



  getJob_and_brands_Q(job_id, model) {
    this._demoService.getJobID(job_id).subscribe(
      (data) => {
        // this.job_data = data;
        let res = data[0];
        // this.job_data_paragraphs = DataUtil.parse.parseJson(data); // changed this to get job datas loading 24 BIG ISSUE FIX !!!!!!!!!! dont use ituol for merge functions
        this.toastr.success('Job Data Loaded For Vars')

        this.job_data_paragraphs = data;
        // if (job_service_timeframe_id <= 0 ){
        //   this.selected_job_service_timeframe_description = 'Not Applicable';
        // };
        // this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;

        // added hete to stop errors.
        this.getJobReportUserContact_Q(res.brand_report_user_id)




      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



  getJobServiceTimeframe_Q(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe_paragraphs = data; 
        let res = data[0];
        // if (job_service_timeframe_id <= 0 ){
        //   this.selected_job_service_timeframe_description = 'Not Applicable';
        // };
        // this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

  getClientContactsSharmans_Q(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
       data => { 
        this.client_contacts = data;
       },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
// Job Variables.
   getJobTypeLocations_Q(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      (data) => {
        this.job_type_locations_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeLocation_Q(job_type_location_id) {
    this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
      (data) => {
        this.job_type_location_paragraphs = data;
        // this.toastr.success('Locations loaded')
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }


  getJobType_Q(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
      (data) => {
        this.job_type_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeCourts_Q(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      (data) => {
        this.job_type_courts_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }


  
  getJobTypeCourt_Q(job_type_court_id) {
    this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
      (data) => {
        this.job_type_court_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }



  getJobTypeDocumentType_Q(job_type_document_type_id) {
    this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
      (data) => {
        this.job_type_document_type_paragraphs = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }




  getJobTypeAffidavitType_Q(job_type_affidavit_type_id) {
    this._demoService
      .getJobTypeAffidavit(job_type_affidavit_type_id)
      .subscribe(
        (data) => {
          this.job_type_affidavit_type_paragraphs = data;
        },
        (err) => console.error(err)
        // () => console.log('done loading Trace Types')
      );
  }


  getJobReportUserContact_Q(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
       data => { 
            this.job_report_client_user_paragraphs = data;


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getCurrentUser_Q(user_id) {
    this._demoService.getUsersById(user_id).subscribe(
       data => { 
            this.current_user_paragraphs = data;


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getSubjectAgentBrandsAssigned_Q(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
      (data) => {
        this.assignedBrandList_paragraphs = data;
// console.log(this.assignedBrandList_paragraphs)

        // this.allEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Agent',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Agent',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }



  getSubjectServiceType_model_Q(subject_service_type_id) {
    this._demoService.getSubjectServiceType(subject_service_type_id).subscribe(
       data => { 
        this.subject_service_type_model_paragraphs = data;
        // let res = data[0];
        // if ( subject_service_type_id <= 0 ){
        //   this.selected_subject_service_type_description = 'Please Set to default Individual Above';
        //   this.selected_subject_service_type_description = '';
        //   this.selected_subject_service_type_instructions = '';
        //   this.selected_subject_service_type_staff_instructions = '';
  
        // } 
        // this.selected_subject_service_type_description = res.subject_service_type_description;
        // this.selected_subject_service_type_instructions = res.subject_service_type_instructions;
        // this.selected_subject_service_type_staff_instructions = res.subject_service_type_staff_instructions;
  
        // // initiate the change of service rule if different or select from drop down.
        // if (subject_service_type_id > 1) {
        // this.setJobServiceRule(res.job_service_rule_id_change_to);
        // this.getJobServiceRule(res.job_service_rule_id_change_to); // sets the descruption information on change.
        // }
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getSubjectContactNumbers_Q(subject_id) {
    this._demoService.getSubjectContactNumbers(subject_id).subscribe(
       data => { this.subject_contact_numbers_paragraphs = data;
      
        let count_of_items = this.subject_contact_numbers_paragraphs.length
        let c = 0; // count
        this.subject_contact_numbers = '';
        while (c < count_of_items) {
          this.subject_contact_numbers += this.subject_contact_numbers_paragraphs[c].subject_contact_phone_number + ', '
          c++;
        }


      },
       err => console.error(err),
        () => {
          // console.log('done loading SCN');
                      }
          );
   }



   getSubjectContactEmails_Q(subject_id) {
    this._demoService.getSubjectContactEmails(subject_id).subscribe(
       data => { this.subject_contact_emails_paragraphs = data; 
        let count_of_items = this.subject_contact_emails_paragraphs.length
        let c = 0; // count
        this.subject_contact_emails = '';
        while (c < count_of_items) {
          this.subject_contact_emails += this.subject_contact_emails_paragraphs[c].subject_contact_email_address + ', '
          c++;
        }
      
      },
       err => console.error(err),
        () => {
          // console.log('done loading SR');
                      }
          );
   }




// Start of Javascript Ordinaals -- First Second third etc - only goes to 10 so far
// :: @https://stackoverflow.com/questions/15998005/ordinals-in-words-javascript
ordinalInWord( cardinal ) {
  var ordinals = [ 'Zeroth', 'First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Nineth', 'Tenth' /* and so on up to "twentieth" */ ];
  var tens = {
      20: 'twenty',
      30: 'thirty',
      40: 'forty' /* and so on up to 90 */
  };
  var ordinalTens = {
      30: 'thirtieth',
      40: 'fortieth',
      50: 'fiftieth' /* and so on */
  };

  if( cardinal <= 20 ) {                    
      return ordinals[ cardinal ];
  }

  if( cardinal % 10 === 0 ) {
      return ordinalTens[ cardinal ];
  }

  return tens[ cardinal - ( cardinal % 10 ) ] + ordinals[ cardinal % 10 ];
}

// end of Javascript Ordinals


// Start Javascript Number to Text Function
// @:// https://stackoverflow.com/questions/5529934/javascript-numbers-to-words

number2text(value) {
  var fraction = Math.round(this.frac(value)*100);
  var f_text  = "";

  if(fraction > 0) {
      f_text = "AND "+this.convert_number(fraction)+" PAISE";
  }

  return this.convert_number(value)+" RUPEE "+f_text+" ONLY";
}

frac(f) {
  return f % 1;
}

convert_number(number)
{
  if ((number < 0) || (number > 999999999)) 
  { 
      return "NUMBER OUT OF RANGE!";
  }
  var Gn = Math.floor(number / 10000000);  /* Crore */ 
  number -= Gn * 10000000; 
  var kn = Math.floor(number / 100000);     /* lakhs */ 
  number -= kn * 100000; 
  var Hn = Math.floor(number / 1000);      /* thousand */ 
  number -= Hn * 1000; 
  var Dn = Math.floor(number / 100);       /* Tens (deca) */ 
  number = number % 100;               /* Ones */ 
  var tn= Math.floor(number / 10); 
  var one=Math.floor(number % 10); 
  var res = ""; 

  if (Gn>0) 
  { 
      res += (this.convert_number(Gn) + " CRORE"); 
  } 
  if (kn>0) 
  { 
          res += (((res=="") ? "" : " ") + 
          this.convert_number(kn) + " LAKH"); 
  } 
  if (Hn>0) 
  { 
      res += (((res=="") ? "" : " ") +
          this.convert_number(Hn) + " THOUSAND"); 
  } 

  if (Dn) 
  { 
      res += (((res=="") ? "" : " ") + 
          this.convert_number(Dn) + " HUNDRED"); 
  } 


  var ones = Array("", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX","SEVEN", "EIGHT", "NINE", "TEN", "ELEVEN", "TWELVE", "THIRTEEN","FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN","NINETEEN"); 
var tens = Array("", "", "TWENTY", "THIRTY", "FOURTY", "FIFTY", "SIXTY","SEVENTY", "EIGHTY", "NINETY"); 

  if (tn>0 || one>0) 
  { 
      if (!(res=="")) 
      { 
          res += " AND "; 
      } 
      if (tn < 2) 
      { 
          res += ones[tn * 10 + one]; 
      } 
      else 
      { 

          res += tens[tn];
          if (one>0) 
          { 
              res += ("-" + ones[one]); 
          } 
      } 
  }

  if (res=="")
  { 
      res = "zero"; 
  } 
  return res;
}

// end number to text fucntions

 // gets the list of users assiciated for drop down.
getSubjectServicesOnly_Q(subject_id) {
  this._demoService.getSubjectServicesOnly(subject_id).subscribe(
     data => { 
      // this.subject_service_list_paragraphs = data;
      this.service_paragraphs_model = data[0] // single record

      if(this.service_paragraphs_model != '[]' && this.service_paragraphs_model != null && this.service_paragraphs_model != '' && data){
      //  this.getBrand_Q(this.service_paragraphs_model.who_service_id);
       }

    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }



 
// gets the list of users assiciated for drop down.
getSubjectAttemptsAll_Q(subject_id) {
  this._demoService.getSubjectServiceAll(subject_id).subscribe(
     data => { 
      this.subject_service_list_paragraphs = data;
      this.attempts_paragraphs_model = data[0] // single record

      if(this.attempts_paragraphs_model != '[]' && this.attempts_paragraphs_model != null && this.attempts_paragraphs_model != '' && data ){
      //  this.getBrand_Q(this.attempts_paragraphs_model.who_service_id);
       }

    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }




  // end quick variables functions


// THIS LOADS THE CLIENT REPORT RECIPIENT FOR MERGE PARAGRAPHS
  private getBrand_Q_2(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_data = data;
      //  this.job_data_paragraphs = data; // set here for the variables/paragraphs ?? uncommented jan 11 why is this setting the job_data_paragraphs... -- 
      // Solution I had this not loading the job variables, now loading job variables with a seperated function -- to load the job_data_paragraphs

        this.allClientEmailRecipients = data;

        

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Report',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Report',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }



  // myobChecker() {
  //   this._demoService.myobChecker()
  //   // .pipe(
  //   //   this.toastr.observe({
  //   //     loading: 'Myob Handshake...',
  //   //     success: 'ðŸš€',
  //   //     error: 'ðŸ˜¡... MYOB not Taklking...Please Login or try again.'
  //   //  })
  //   //  )
  //   .pipe(
  //     retry(1), // you retry 3 times
  //     delay(2500) // each retry will start after 1 second,
  //  )
  //   .subscribe(
  //      data => { this.myob_checker = data;
  //       let res = data[0];
  //       // this.toastr.success('Myob Connections Active!... functions allowed');
  // // console.log('Connected: ', JSON.stringify(this.myob_checker));
  //             // if (res){    
  //             // this.myob_response = true
  //             // }
  //     },
  //      err => (
  //       // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
  //       this.myob_response = false,
  //       console.error(err)
  //      ),
  //      // () => console.log('done loading Trace Types')
  //    );
  //  }



 

   myobChecker() {
    this._demoService.myobChecker().subscribe(
       data => { this.myob_checker = data;
        // let res = data[0];
        // this.toastr.success('Myob Connections Active!... functions allowed');
  // console.log('Connected: ', JSON.stringify(this.myob_checker));
  this.myob_response = true;
      },
       err => (
        // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
        this.myob_response = false,
        console.error(err)
       ),
       // () => console.log('done loading Trace Types')
     );
   }




// open the box via button
openIbox(app_route_id){
  let check_style = document.getElementById(`box_${app_route_id}`);
  // console.log( 'check_syle_ ' + JSON.stringify(check_style) )
  const exampleAttr = check_style.getAttribute("style");
  console.log('exampleAttr ' + exampleAttr)
  
  
  if (exampleAttr == "display: none;"){
    document.getElementById(`box_${app_route_id}`).style.display='block';
  }else{
    document.getElementById(`box_${app_route_id}`).style.display='none';
  }
  
  //  document.getElementById(`box_${app_route_id}`).style.display='block';
  }

 



  public globalViewSystemLogTypeBenchmarksSkipRoute() {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-reports/activity/benchmarks']));
  }
  public globalViewSystemLogTypeBenchmarkUpdateSkipRoute(log_type_benchmark_id) {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-reports/activity/benchmarks/update/' + log_type_benchmark_id]));
  }
  public globalViewSystemLogTypeBenchmarkSkipRoute(log_type_benchmark_id) {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-reports/activity/benchmarks/view/' + log_type_benchmark_id]));
  }
  

  public globalViewBenchmarkKpiGroupSkipRoute(benchmark_kpi_group_id) {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-reports/activity/kpi/group/view/' + benchmark_kpi_group_id]));
  }

  public globalViewBenchmarksKpiGroupsSkipRoute() {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-reports/activity/kpi/groups']));
  }

  public globalUpdateBenchmarkKpiGroupSkipRoute(benchmark_kpi_group_id) {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-reports/activity/kpi/group/update/' + benchmark_kpi_group_id]));
  }









  // system Notices
  public globalSystemNoticesSkipRoute() {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-notices/home']));
  }
  
  public globalSystemNoticeCreateSkipRoute() {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-notices/create']));
  }
  
  
  public globalSystemNoticeUpdateSkipRoute(id) {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-notices/update/' + id]));
  }
  
  public globalSystemNoticeBannerSkipRoute(id) {
    // this.router.navigate(['/admin/system-theme-file-manager']);
    this.router.navigate(['/admin/jobs/j'], { skipLocationChange: true })
    .then(() => this.router.navigate(['admin/system-notices/banner/' + id]));
  }
  
  
  
  getNoticeStatus(item: any): string {
    const now = moment();
    const start = item.start_datetime ? moment(item.start_datetime) : null;
    const end = item.end_datetime ? moment(item.end_datetime) : null;
  
    if (start && now.isBefore(start)) return `⏳ Pending – starts ${start.fromNow()}`;
    if (end && now.isAfter(end)) return `❌ Expired – ended ${end.fromNow()}`;
    if ((!start || now.isSameOrAfter(start)) && (!end || now.isSameOrBefore(end)))
      return `✅ Active Now – ends ${end ? end.fromNow() : 'ongoing'}`;
  
    return `❔ Unknown`;
  }





// test function to :: MYOB returns dates like 2023-02-21T10:41:03.143 — no Z.
// duplicated function exists in NOODE JS AS WELL changing the created date and due date of invoice when sync accross
parseMyobDate(dateStr) {
  if(!dateStr){return;} // just bail out if no date?
return dateStr.split('.')[0]; // Just return "YYYY-MM-DDTHH:mm:ss"
}



// new Client Code Generation

 createBrandClientCode(brand_id){
  if (confirm('Warning this will recreate and reset current client code' )) {

         this._demoService.createBrandClientCode(brand_id).subscribe(
              data => {  this.brand_client_code_ = data; // this is the retuned json upon creation.
          this.toastr.success('Company Client Code Created.' + this.brand_client_code_);
             
              },
              error => {
                this.toastr.error('There was an issue creating the cleint code.!');
                console.log(error);
                               // return Observable.throw(error);
              }
         );
        }
  }



createBrandClientCodesAll(){
  if (confirm('DANGER: this will recreate ALL and reset ALL current client codes for ALL clients' )) {

           this._demoService.createBrandClientCodesAll().subscribe(
              data => {  this.brand_client_code_ALL = data; // this is the retuned json upon creation.
          this.toastr.success('All Company Client Codes Created.');
             
              },
              error => {
                this.toastr.error('There was an issue creating the client codes.!');
                console.log(error);
                               // return Observable.throw(error);
              }
         );
        }
}








} // end export component/service





























/* Add This file to any .ts constructor and use functions globally across system.  */

/*


// your path may different
Import { GlobalFunctionsService } from './../../../services/global-functions.service';
//...
constructor(
   private gfunc: GlobalFunctionsService
) {}
ngOnInit(): void {
   let x = 1;
   myResult = this.gfunc.myGlobalAddFunction(x);
   // Then you are expecting 2 for return value
}



*/



